// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.35.0
// source: algo.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire'

import {
  AssetRef,
  Denomination,
  denominationFromJSON,
  denominationToJSON,
  OrderSide,
  orderSideFromJSON,
  orderSideToJSON,
} from './common/trading'
import {
  Exchange,
  exchangeFromJSON,
  exchangeToJSON,
  TradeVenue,
  tradeVenueFromJSON,
  tradeVenueToJSON,
} from './common/types'
import { RelativeLimitPrice } from './execution'
import {
  AutoApprove,
  AutoRetry,
  RfqAcceptIntentState,
  rfqAcceptIntentStateFromJSON,
  rfqAcceptIntentStateToJSON,
  RfqHedgeLeg,
  RfqLeg,
  RfqNetwork,
  rfqNetworkFromJSON,
  rfqNetworkToJSON,
} from './rfq'
import { Trigger } from './triggers'

export const protobufPackage = 'algo'

export enum SpreaderLegRole {
  SPREADER_LEG_ROLE_UNSPECIFIED = 0,
  SPREADER_LEG_ROLE_QUOTING = 1,
  SPREADER_LEG_ROLE_TAKING = 2,
  UNRECOGNIZED = -1,
}

export function spreaderLegRoleFromJSON(object: any): SpreaderLegRole {
  switch (object) {
    case 0:
    case 'SPREADER_LEG_ROLE_UNSPECIFIED':
      return SpreaderLegRole.SPREADER_LEG_ROLE_UNSPECIFIED
    case 1:
    case 'SPREADER_LEG_ROLE_QUOTING':
      return SpreaderLegRole.SPREADER_LEG_ROLE_QUOTING
    case 2:
    case 'SPREADER_LEG_ROLE_TAKING':
      return SpreaderLegRole.SPREADER_LEG_ROLE_TAKING
    case -1:
    case 'UNRECOGNIZED':
    default:
      return SpreaderLegRole.UNRECOGNIZED
  }
}

export function spreaderLegRoleToJSON(object: SpreaderLegRole): string {
  switch (object) {
    case SpreaderLegRole.SPREADER_LEG_ROLE_UNSPECIFIED:
      return 'SPREADER_LEG_ROLE_UNSPECIFIED'
    case SpreaderLegRole.SPREADER_LEG_ROLE_QUOTING:
      return 'SPREADER_LEG_ROLE_QUOTING'
    case SpreaderLegRole.SPREADER_LEG_ROLE_TAKING:
      return 'SPREADER_LEG_ROLE_TAKING'
    case SpreaderLegRole.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum SpreaderPhase {
  SPREADER_PHASE_UNSPECIFIED = 0,
  SPREADER_PHASE_QUOTING = 1,
  SPREADER_PHASE_DRAINING = 2,
  SPREADER_PHASE_COMPLETE = 3,
  UNRECOGNIZED = -1,
}

export function spreaderPhaseFromJSON(object: any): SpreaderPhase {
  switch (object) {
    case 0:
    case 'SPREADER_PHASE_UNSPECIFIED':
      return SpreaderPhase.SPREADER_PHASE_UNSPECIFIED
    case 1:
    case 'SPREADER_PHASE_QUOTING':
      return SpreaderPhase.SPREADER_PHASE_QUOTING
    case 2:
    case 'SPREADER_PHASE_DRAINING':
      return SpreaderPhase.SPREADER_PHASE_DRAINING
    case 3:
    case 'SPREADER_PHASE_COMPLETE':
      return SpreaderPhase.SPREADER_PHASE_COMPLETE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return SpreaderPhase.UNRECOGNIZED
  }
}

export function spreaderPhaseToJSON(object: SpreaderPhase): string {
  switch (object) {
    case SpreaderPhase.SPREADER_PHASE_UNSPECIFIED:
      return 'SPREADER_PHASE_UNSPECIFIED'
    case SpreaderPhase.SPREADER_PHASE_QUOTING:
      return 'SPREADER_PHASE_QUOTING'
    case SpreaderPhase.SPREADER_PHASE_DRAINING:
      return 'SPREADER_PHASE_DRAINING'
    case SpreaderPhase.SPREADER_PHASE_COMPLETE:
      return 'SPREADER_PHASE_COMPLETE'
    case SpreaderPhase.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum ArbFillMode {
  ARB_FILL_MODE_UNSPECIFIED = 0,
  /** ARB_FILL_MODE_DIRECTIONAL - A fill moves inventory; the resting quotes work it back off. */
  ARB_FILL_MODE_DIRECTIONAL = 1,
  /** ARB_FILL_MODE_HEDGE - A settled fill immediately fires a taker on the opposite leg. */
  ARB_FILL_MODE_HEDGE = 2,
  UNRECOGNIZED = -1,
}

export function arbFillModeFromJSON(object: any): ArbFillMode {
  switch (object) {
    case 0:
    case 'ARB_FILL_MODE_UNSPECIFIED':
      return ArbFillMode.ARB_FILL_MODE_UNSPECIFIED
    case 1:
    case 'ARB_FILL_MODE_DIRECTIONAL':
      return ArbFillMode.ARB_FILL_MODE_DIRECTIONAL
    case 2:
    case 'ARB_FILL_MODE_HEDGE':
      return ArbFillMode.ARB_FILL_MODE_HEDGE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ArbFillMode.UNRECOGNIZED
  }
}

export function arbFillModeToJSON(object: ArbFillMode): string {
  switch (object) {
    case ArbFillMode.ARB_FILL_MODE_UNSPECIFIED:
      return 'ARB_FILL_MODE_UNSPECIFIED'
    case ArbFillMode.ARB_FILL_MODE_DIRECTIONAL:
      return 'ARB_FILL_MODE_DIRECTIONAL'
    case ArbFillMode.ARB_FILL_MODE_HEDGE:
      return 'ARB_FILL_MODE_HEDGE'
    case ArbFillMode.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum TriggerDispatchKind {
  TRIGGER_DISPATCH_KIND_UNSPECIFIED = 0,
  TRIGGER_DISPATCH_KIND_EXECUTION_COMMAND = 1,
  TRIGGER_DISPATCH_KIND_ALGO_COMMAND = 2,
  UNRECOGNIZED = -1,
}

export function triggerDispatchKindFromJSON(object: any): TriggerDispatchKind {
  switch (object) {
    case 0:
    case 'TRIGGER_DISPATCH_KIND_UNSPECIFIED':
      return TriggerDispatchKind.TRIGGER_DISPATCH_KIND_UNSPECIFIED
    case 1:
    case 'TRIGGER_DISPATCH_KIND_EXECUTION_COMMAND':
      return TriggerDispatchKind.TRIGGER_DISPATCH_KIND_EXECUTION_COMMAND
    case 2:
    case 'TRIGGER_DISPATCH_KIND_ALGO_COMMAND':
      return TriggerDispatchKind.TRIGGER_DISPATCH_KIND_ALGO_COMMAND
    case -1:
    case 'UNRECOGNIZED':
    default:
      return TriggerDispatchKind.UNRECOGNIZED
  }
}

export function triggerDispatchKindToJSON(object: TriggerDispatchKind): string {
  switch (object) {
    case TriggerDispatchKind.TRIGGER_DISPATCH_KIND_UNSPECIFIED:
      return 'TRIGGER_DISPATCH_KIND_UNSPECIFIED'
    case TriggerDispatchKind.TRIGGER_DISPATCH_KIND_EXECUTION_COMMAND:
      return 'TRIGGER_DISPATCH_KIND_EXECUTION_COMMAND'
    case TriggerDispatchKind.TRIGGER_DISPATCH_KIND_ALGO_COMMAND:
      return 'TRIGGER_DISPATCH_KIND_ALGO_COMMAND'
    case TriggerDispatchKind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum AlgoType {
  ALGO_TYPE_UNSPECIFIED = 0,
  ALGO_TYPE_MARKET = 1,
  ALGO_TYPE_LIMIT = 2,
  ALGO_TYPE_TWAP = 3,
  ALGO_TYPE_LIMIT_CHASE = 5,
  ALGO_TYPE_HEDGE = 6,
  ALGO_TYPE_TRIGGER = 7,
  ALGO_TYPE_RFQ = 8,
  ALGO_TYPE_ADVANCED_TWAP = 9,
  ALGO_TYPE_SPREADER = 10,
  ALGO_TYPE_CROSS_EXCHANGE_ARB = 11,
  ALGO_TYPE_SINGLE_HEDGE = 12,
  ALGO_TYPE_SCALE = 13,
  ALGO_TYPE_OPTIONS_MM = 14,
  UNRECOGNIZED = -1,
}

export function algoTypeFromJSON(object: any): AlgoType {
  switch (object) {
    case 0:
    case 'ALGO_TYPE_UNSPECIFIED':
      return AlgoType.ALGO_TYPE_UNSPECIFIED
    case 1:
    case 'ALGO_TYPE_MARKET':
      return AlgoType.ALGO_TYPE_MARKET
    case 2:
    case 'ALGO_TYPE_LIMIT':
      return AlgoType.ALGO_TYPE_LIMIT
    case 3:
    case 'ALGO_TYPE_TWAP':
      return AlgoType.ALGO_TYPE_TWAP
    case 5:
    case 'ALGO_TYPE_LIMIT_CHASE':
      return AlgoType.ALGO_TYPE_LIMIT_CHASE
    case 6:
    case 'ALGO_TYPE_HEDGE':
      return AlgoType.ALGO_TYPE_HEDGE
    case 7:
    case 'ALGO_TYPE_TRIGGER':
      return AlgoType.ALGO_TYPE_TRIGGER
    case 8:
    case 'ALGO_TYPE_RFQ':
      return AlgoType.ALGO_TYPE_RFQ
    case 9:
    case 'ALGO_TYPE_ADVANCED_TWAP':
      return AlgoType.ALGO_TYPE_ADVANCED_TWAP
    case 10:
    case 'ALGO_TYPE_SPREADER':
      return AlgoType.ALGO_TYPE_SPREADER
    case 11:
    case 'ALGO_TYPE_CROSS_EXCHANGE_ARB':
      return AlgoType.ALGO_TYPE_CROSS_EXCHANGE_ARB
    case 12:
    case 'ALGO_TYPE_SINGLE_HEDGE':
      return AlgoType.ALGO_TYPE_SINGLE_HEDGE
    case 13:
    case 'ALGO_TYPE_SCALE':
      return AlgoType.ALGO_TYPE_SCALE
    case 14:
    case 'ALGO_TYPE_OPTIONS_MM':
      return AlgoType.ALGO_TYPE_OPTIONS_MM
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AlgoType.UNRECOGNIZED
  }
}

export function algoTypeToJSON(object: AlgoType): string {
  switch (object) {
    case AlgoType.ALGO_TYPE_UNSPECIFIED:
      return 'ALGO_TYPE_UNSPECIFIED'
    case AlgoType.ALGO_TYPE_MARKET:
      return 'ALGO_TYPE_MARKET'
    case AlgoType.ALGO_TYPE_LIMIT:
      return 'ALGO_TYPE_LIMIT'
    case AlgoType.ALGO_TYPE_TWAP:
      return 'ALGO_TYPE_TWAP'
    case AlgoType.ALGO_TYPE_LIMIT_CHASE:
      return 'ALGO_TYPE_LIMIT_CHASE'
    case AlgoType.ALGO_TYPE_HEDGE:
      return 'ALGO_TYPE_HEDGE'
    case AlgoType.ALGO_TYPE_TRIGGER:
      return 'ALGO_TYPE_TRIGGER'
    case AlgoType.ALGO_TYPE_RFQ:
      return 'ALGO_TYPE_RFQ'
    case AlgoType.ALGO_TYPE_ADVANCED_TWAP:
      return 'ALGO_TYPE_ADVANCED_TWAP'
    case AlgoType.ALGO_TYPE_SPREADER:
      return 'ALGO_TYPE_SPREADER'
    case AlgoType.ALGO_TYPE_CROSS_EXCHANGE_ARB:
      return 'ALGO_TYPE_CROSS_EXCHANGE_ARB'
    case AlgoType.ALGO_TYPE_SINGLE_HEDGE:
      return 'ALGO_TYPE_SINGLE_HEDGE'
    case AlgoType.ALGO_TYPE_SCALE:
      return 'ALGO_TYPE_SCALE'
    case AlgoType.ALGO_TYPE_OPTIONS_MM:
      return 'ALGO_TYPE_OPTIONS_MM'
    case AlgoType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Mechanism used to execute a band-breach rehedge. POST_ONLY_LIMIT rests a
 * passive maker order at the touch; LIMIT_CHASE and TWAP spawn the matching
 * child algo. A TWAP whose size is one slice or less is auto-executed as a
 * single market order. Plain immediate market is intentionally NOT a
 * user-facing mechanism (tag 1 reserved from the dropped MARKET value).
 */
export enum HedgeMechanism {
  HEDGE_MECHANISM_UNSPECIFIED = 0,
  HEDGE_MECHANISM_LIMIT_CHASE = 2,
  HEDGE_MECHANISM_POST_ONLY_LIMIT = 3,
  HEDGE_MECHANISM_TWAP = 4,
  UNRECOGNIZED = -1,
}

export function hedgeMechanismFromJSON(object: any): HedgeMechanism {
  switch (object) {
    case 0:
    case 'HEDGE_MECHANISM_UNSPECIFIED':
      return HedgeMechanism.HEDGE_MECHANISM_UNSPECIFIED
    case 2:
    case 'HEDGE_MECHANISM_LIMIT_CHASE':
      return HedgeMechanism.HEDGE_MECHANISM_LIMIT_CHASE
    case 3:
    case 'HEDGE_MECHANISM_POST_ONLY_LIMIT':
      return HedgeMechanism.HEDGE_MECHANISM_POST_ONLY_LIMIT
    case 4:
    case 'HEDGE_MECHANISM_TWAP':
      return HedgeMechanism.HEDGE_MECHANISM_TWAP
    case -1:
    case 'UNRECOGNIZED':
    default:
      return HedgeMechanism.UNRECOGNIZED
  }
}

export function hedgeMechanismToJSON(object: HedgeMechanism): string {
  switch (object) {
    case HedgeMechanism.HEDGE_MECHANISM_UNSPECIFIED:
      return 'HEDGE_MECHANISM_UNSPECIFIED'
    case HedgeMechanism.HEDGE_MECHANISM_LIMIT_CHASE:
      return 'HEDGE_MECHANISM_LIMIT_CHASE'
    case HedgeMechanism.HEDGE_MECHANISM_POST_ONLY_LIMIT:
      return 'HEDGE_MECHANISM_POST_ONLY_LIMIT'
    case HedgeMechanism.HEDGE_MECHANISM_TWAP:
      return 'HEDGE_MECHANISM_TWAP'
    case HedgeMechanism.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum HedgeDeltaDenomination {
  HEDGE_DELTA_DENOMINATION_UNSPECIFIED = 0,
  HEDGE_DELTA_DENOMINATION_UNDERLYING_UNITS = 1,
  HEDGE_DELTA_DENOMINATION_USD = 2,
  UNRECOGNIZED = -1,
}

export function hedgeDeltaDenominationFromJSON(object: any): HedgeDeltaDenomination {
  switch (object) {
    case 0:
    case 'HEDGE_DELTA_DENOMINATION_UNSPECIFIED':
      return HedgeDeltaDenomination.HEDGE_DELTA_DENOMINATION_UNSPECIFIED
    case 1:
    case 'HEDGE_DELTA_DENOMINATION_UNDERLYING_UNITS':
      return HedgeDeltaDenomination.HEDGE_DELTA_DENOMINATION_UNDERLYING_UNITS
    case 2:
    case 'HEDGE_DELTA_DENOMINATION_USD':
      return HedgeDeltaDenomination.HEDGE_DELTA_DENOMINATION_USD
    case -1:
    case 'UNRECOGNIZED':
    default:
      return HedgeDeltaDenomination.UNRECOGNIZED
  }
}

export function hedgeDeltaDenominationToJSON(object: HedgeDeltaDenomination): string {
  switch (object) {
    case HedgeDeltaDenomination.HEDGE_DELTA_DENOMINATION_UNSPECIFIED:
      return 'HEDGE_DELTA_DENOMINATION_UNSPECIFIED'
    case HedgeDeltaDenomination.HEDGE_DELTA_DENOMINATION_UNDERLYING_UNITS:
      return 'HEDGE_DELTA_DENOMINATION_UNDERLYING_UNITS'
    case HedgeDeltaDenomination.HEDGE_DELTA_DENOMINATION_USD:
      return 'HEDGE_DELTA_DENOMINATION_USD'
    case HedgeDeltaDenomination.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum AlgoStatus {
  ALGO_STATUS_COMPLETED = 0,
  ALGO_STATUS_PENDING = 1,
  ALGO_STATUS_IN_PROGRESS = 2,
  ALGO_STATUS_CANCELLED = 3,
  ALGO_STATUS_CANCELLING = 4,
  ALGO_STATUS_CANCEL_REQUESTED = 5,
  ALGO_STATUS_FAILED = 6,
  ALGO_STATUS_TRANSITIONING = 7,
  ALGO_STATUS_UNTRIGGERED = 8,
  /**
   * ALGO_STATUS_INTERRUPTED - Non-terminal: the service suspended this algo on graceful shutdown and it
   * is pending resume. Excluded from terminal checks; included in the
   * restart resume set. Distinct from CANCELLED (user-initiated, terminal).
   */
  ALGO_STATUS_INTERRUPTED = 9,
  UNRECOGNIZED = -1,
}

export function algoStatusFromJSON(object: any): AlgoStatus {
  switch (object) {
    case 0:
    case 'ALGO_STATUS_COMPLETED':
      return AlgoStatus.ALGO_STATUS_COMPLETED
    case 1:
    case 'ALGO_STATUS_PENDING':
      return AlgoStatus.ALGO_STATUS_PENDING
    case 2:
    case 'ALGO_STATUS_IN_PROGRESS':
      return AlgoStatus.ALGO_STATUS_IN_PROGRESS
    case 3:
    case 'ALGO_STATUS_CANCELLED':
      return AlgoStatus.ALGO_STATUS_CANCELLED
    case 4:
    case 'ALGO_STATUS_CANCELLING':
      return AlgoStatus.ALGO_STATUS_CANCELLING
    case 5:
    case 'ALGO_STATUS_CANCEL_REQUESTED':
      return AlgoStatus.ALGO_STATUS_CANCEL_REQUESTED
    case 6:
    case 'ALGO_STATUS_FAILED':
      return AlgoStatus.ALGO_STATUS_FAILED
    case 7:
    case 'ALGO_STATUS_TRANSITIONING':
      return AlgoStatus.ALGO_STATUS_TRANSITIONING
    case 8:
    case 'ALGO_STATUS_UNTRIGGERED':
      return AlgoStatus.ALGO_STATUS_UNTRIGGERED
    case 9:
    case 'ALGO_STATUS_INTERRUPTED':
      return AlgoStatus.ALGO_STATUS_INTERRUPTED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AlgoStatus.UNRECOGNIZED
  }
}

export function algoStatusToJSON(object: AlgoStatus): string {
  switch (object) {
    case AlgoStatus.ALGO_STATUS_COMPLETED:
      return 'ALGO_STATUS_COMPLETED'
    case AlgoStatus.ALGO_STATUS_PENDING:
      return 'ALGO_STATUS_PENDING'
    case AlgoStatus.ALGO_STATUS_IN_PROGRESS:
      return 'ALGO_STATUS_IN_PROGRESS'
    case AlgoStatus.ALGO_STATUS_CANCELLED:
      return 'ALGO_STATUS_CANCELLED'
    case AlgoStatus.ALGO_STATUS_CANCELLING:
      return 'ALGO_STATUS_CANCELLING'
    case AlgoStatus.ALGO_STATUS_CANCEL_REQUESTED:
      return 'ALGO_STATUS_CANCEL_REQUESTED'
    case AlgoStatus.ALGO_STATUS_FAILED:
      return 'ALGO_STATUS_FAILED'
    case AlgoStatus.ALGO_STATUS_TRANSITIONING:
      return 'ALGO_STATUS_TRANSITIONING'
    case AlgoStatus.ALGO_STATUS_UNTRIGGERED:
      return 'ALGO_STATUS_UNTRIGGERED'
    case AlgoStatus.ALGO_STATUS_INTERRUPTED:
      return 'ALGO_STATUS_INTERRUPTED'
    case AlgoStatus.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum TriggerDispatchStatus {
  TRIGGER_DISPATCH_STATUS_UNSPECIFIED = 0,
  TRIGGER_DISPATCH_STATUS_WAITING = 1,
  TRIGGER_DISPATCH_STATUS_FIRED = 2,
  TRIGGER_DISPATCH_STATUS_DISPATCHING = 3,
  TRIGGER_DISPATCH_STATUS_DISPATCHED = 4,
  TRIGGER_DISPATCH_STATUS_FAILED = 5,
  UNRECOGNIZED = -1,
}

export function triggerDispatchStatusFromJSON(object: any): TriggerDispatchStatus {
  switch (object) {
    case 0:
    case 'TRIGGER_DISPATCH_STATUS_UNSPECIFIED':
      return TriggerDispatchStatus.TRIGGER_DISPATCH_STATUS_UNSPECIFIED
    case 1:
    case 'TRIGGER_DISPATCH_STATUS_WAITING':
      return TriggerDispatchStatus.TRIGGER_DISPATCH_STATUS_WAITING
    case 2:
    case 'TRIGGER_DISPATCH_STATUS_FIRED':
      return TriggerDispatchStatus.TRIGGER_DISPATCH_STATUS_FIRED
    case 3:
    case 'TRIGGER_DISPATCH_STATUS_DISPATCHING':
      return TriggerDispatchStatus.TRIGGER_DISPATCH_STATUS_DISPATCHING
    case 4:
    case 'TRIGGER_DISPATCH_STATUS_DISPATCHED':
      return TriggerDispatchStatus.TRIGGER_DISPATCH_STATUS_DISPATCHED
    case 5:
    case 'TRIGGER_DISPATCH_STATUS_FAILED':
      return TriggerDispatchStatus.TRIGGER_DISPATCH_STATUS_FAILED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return TriggerDispatchStatus.UNRECOGNIZED
  }
}

export function triggerDispatchStatusToJSON(object: TriggerDispatchStatus): string {
  switch (object) {
    case TriggerDispatchStatus.TRIGGER_DISPATCH_STATUS_UNSPECIFIED:
      return 'TRIGGER_DISPATCH_STATUS_UNSPECIFIED'
    case TriggerDispatchStatus.TRIGGER_DISPATCH_STATUS_WAITING:
      return 'TRIGGER_DISPATCH_STATUS_WAITING'
    case TriggerDispatchStatus.TRIGGER_DISPATCH_STATUS_FIRED:
      return 'TRIGGER_DISPATCH_STATUS_FIRED'
    case TriggerDispatchStatus.TRIGGER_DISPATCH_STATUS_DISPATCHING:
      return 'TRIGGER_DISPATCH_STATUS_DISPATCHING'
    case TriggerDispatchStatus.TRIGGER_DISPATCH_STATUS_DISPATCHED:
      return 'TRIGGER_DISPATCH_STATUS_DISPATCHED'
    case TriggerDispatchStatus.TRIGGER_DISPATCH_STATUS_FAILED:
      return 'TRIGGER_DISPATCH_STATUS_FAILED'
    case TriggerDispatchStatus.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum SingleHedgeExecution {
  SINGLE_HEDGE_EXECUTION_UNSPECIFIED = 0,
  SINGLE_HEDGE_EXECUTION_MARKET = 1,
  SINGLE_HEDGE_EXECUTION_TWAP = 2,
  SINGLE_HEDGE_EXECUTION_LIMIT_CHASE = 3,
  UNRECOGNIZED = -1,
}

export function singleHedgeExecutionFromJSON(object: any): SingleHedgeExecution {
  switch (object) {
    case 0:
    case 'SINGLE_HEDGE_EXECUTION_UNSPECIFIED':
      return SingleHedgeExecution.SINGLE_HEDGE_EXECUTION_UNSPECIFIED
    case 1:
    case 'SINGLE_HEDGE_EXECUTION_MARKET':
      return SingleHedgeExecution.SINGLE_HEDGE_EXECUTION_MARKET
    case 2:
    case 'SINGLE_HEDGE_EXECUTION_TWAP':
      return SingleHedgeExecution.SINGLE_HEDGE_EXECUTION_TWAP
    case 3:
    case 'SINGLE_HEDGE_EXECUTION_LIMIT_CHASE':
      return SingleHedgeExecution.SINGLE_HEDGE_EXECUTION_LIMIT_CHASE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return SingleHedgeExecution.UNRECOGNIZED
  }
}

export function singleHedgeExecutionToJSON(object: SingleHedgeExecution): string {
  switch (object) {
    case SingleHedgeExecution.SINGLE_HEDGE_EXECUTION_UNSPECIFIED:
      return 'SINGLE_HEDGE_EXECUTION_UNSPECIFIED'
    case SingleHedgeExecution.SINGLE_HEDGE_EXECUTION_MARKET:
      return 'SINGLE_HEDGE_EXECUTION_MARKET'
    case SingleHedgeExecution.SINGLE_HEDGE_EXECUTION_TWAP:
      return 'SINGLE_HEDGE_EXECUTION_TWAP'
    case SingleHedgeExecution.SINGLE_HEDGE_EXECUTION_LIMIT_CHASE:
      return 'SINGLE_HEDGE_EXECUTION_LIMIT_CHASE'
    case SingleHedgeExecution.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum SingleHedgeLegStatus {
  SINGLE_HEDGE_LEG_STATUS_UNSPECIFIED = 0,
  SINGLE_HEDGE_LEG_STATUS_PENDING = 1,
  SINGLE_HEDGE_LEG_STATUS_DISPATCHED = 2,
  SINGLE_HEDGE_LEG_STATUS_DONE = 3,
  SINGLE_HEDGE_LEG_STATUS_SKIPPED = 4,
  SINGLE_HEDGE_LEG_STATUS_FAILED = 5,
  /**
   * SINGLE_HEDGE_LEG_STATUS_TIMED_OUT - Inline MARKET leg: the venue never acknowledged the order within the ack
   * timeout, including after the bounded retry.
   */
  SINGLE_HEDGE_LEG_STATUS_TIMED_OUT = 6,
  UNRECOGNIZED = -1,
}

export function singleHedgeLegStatusFromJSON(object: any): SingleHedgeLegStatus {
  switch (object) {
    case 0:
    case 'SINGLE_HEDGE_LEG_STATUS_UNSPECIFIED':
      return SingleHedgeLegStatus.SINGLE_HEDGE_LEG_STATUS_UNSPECIFIED
    case 1:
    case 'SINGLE_HEDGE_LEG_STATUS_PENDING':
      return SingleHedgeLegStatus.SINGLE_HEDGE_LEG_STATUS_PENDING
    case 2:
    case 'SINGLE_HEDGE_LEG_STATUS_DISPATCHED':
      return SingleHedgeLegStatus.SINGLE_HEDGE_LEG_STATUS_DISPATCHED
    case 3:
    case 'SINGLE_HEDGE_LEG_STATUS_DONE':
      return SingleHedgeLegStatus.SINGLE_HEDGE_LEG_STATUS_DONE
    case 4:
    case 'SINGLE_HEDGE_LEG_STATUS_SKIPPED':
      return SingleHedgeLegStatus.SINGLE_HEDGE_LEG_STATUS_SKIPPED
    case 5:
    case 'SINGLE_HEDGE_LEG_STATUS_FAILED':
      return SingleHedgeLegStatus.SINGLE_HEDGE_LEG_STATUS_FAILED
    case 6:
    case 'SINGLE_HEDGE_LEG_STATUS_TIMED_OUT':
      return SingleHedgeLegStatus.SINGLE_HEDGE_LEG_STATUS_TIMED_OUT
    case -1:
    case 'UNRECOGNIZED':
    default:
      return SingleHedgeLegStatus.UNRECOGNIZED
  }
}

export function singleHedgeLegStatusToJSON(object: SingleHedgeLegStatus): string {
  switch (object) {
    case SingleHedgeLegStatus.SINGLE_HEDGE_LEG_STATUS_UNSPECIFIED:
      return 'SINGLE_HEDGE_LEG_STATUS_UNSPECIFIED'
    case SingleHedgeLegStatus.SINGLE_HEDGE_LEG_STATUS_PENDING:
      return 'SINGLE_HEDGE_LEG_STATUS_PENDING'
    case SingleHedgeLegStatus.SINGLE_HEDGE_LEG_STATUS_DISPATCHED:
      return 'SINGLE_HEDGE_LEG_STATUS_DISPATCHED'
    case SingleHedgeLegStatus.SINGLE_HEDGE_LEG_STATUS_DONE:
      return 'SINGLE_HEDGE_LEG_STATUS_DONE'
    case SingleHedgeLegStatus.SINGLE_HEDGE_LEG_STATUS_SKIPPED:
      return 'SINGLE_HEDGE_LEG_STATUS_SKIPPED'
    case SingleHedgeLegStatus.SINGLE_HEDGE_LEG_STATUS_FAILED:
      return 'SINGLE_HEDGE_LEG_STATUS_FAILED'
    case SingleHedgeLegStatus.SINGLE_HEDGE_LEG_STATUS_TIMED_OUT:
      return 'SINGLE_HEDGE_LEG_STATUS_TIMED_OUT'
    case SingleHedgeLegStatus.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum ScaleLevelStatus {
  SCALE_LEVEL_STATUS_UNSPECIFIED = 0,
  /** SCALE_LEVEL_STATUS_PENDING - not yet sent */
  SCALE_LEVEL_STATUS_PENDING = 1,
  /** SCALE_LEVEL_STATUS_WORKING - sent; resting or partially filled */
  SCALE_LEVEL_STATUS_WORKING = 2,
  SCALE_LEVEL_STATUS_FILLED = 3,
  SCALE_LEVEL_STATUS_CANCELLED = 4,
  SCALE_LEVEL_STATUS_REJECTED = 5,
  UNRECOGNIZED = -1,
}

export function scaleLevelStatusFromJSON(object: any): ScaleLevelStatus {
  switch (object) {
    case 0:
    case 'SCALE_LEVEL_STATUS_UNSPECIFIED':
      return ScaleLevelStatus.SCALE_LEVEL_STATUS_UNSPECIFIED
    case 1:
    case 'SCALE_LEVEL_STATUS_PENDING':
      return ScaleLevelStatus.SCALE_LEVEL_STATUS_PENDING
    case 2:
    case 'SCALE_LEVEL_STATUS_WORKING':
      return ScaleLevelStatus.SCALE_LEVEL_STATUS_WORKING
    case 3:
    case 'SCALE_LEVEL_STATUS_FILLED':
      return ScaleLevelStatus.SCALE_LEVEL_STATUS_FILLED
    case 4:
    case 'SCALE_LEVEL_STATUS_CANCELLED':
      return ScaleLevelStatus.SCALE_LEVEL_STATUS_CANCELLED
    case 5:
    case 'SCALE_LEVEL_STATUS_REJECTED':
      return ScaleLevelStatus.SCALE_LEVEL_STATUS_REJECTED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ScaleLevelStatus.UNRECOGNIZED
  }
}

export function scaleLevelStatusToJSON(object: ScaleLevelStatus): string {
  switch (object) {
    case ScaleLevelStatus.SCALE_LEVEL_STATUS_UNSPECIFIED:
      return 'SCALE_LEVEL_STATUS_UNSPECIFIED'
    case ScaleLevelStatus.SCALE_LEVEL_STATUS_PENDING:
      return 'SCALE_LEVEL_STATUS_PENDING'
    case ScaleLevelStatus.SCALE_LEVEL_STATUS_WORKING:
      return 'SCALE_LEVEL_STATUS_WORKING'
    case ScaleLevelStatus.SCALE_LEVEL_STATUS_FILLED:
      return 'SCALE_LEVEL_STATUS_FILLED'
    case ScaleLevelStatus.SCALE_LEVEL_STATUS_CANCELLED:
      return 'SCALE_LEVEL_STATUS_CANCELLED'
    case ScaleLevelStatus.SCALE_LEVEL_STATUS_REJECTED:
      return 'SCALE_LEVEL_STATUS_REJECTED'
    case ScaleLevelStatus.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum OptionsMmMode {
  OPTIONS_MM_MODE_UNSPECIFIED = 0,
  OPTIONS_MM_MODE_SHADOW = 1,
  OPTIONS_MM_MODE_LIVE = 2,
  UNRECOGNIZED = -1,
}

export function optionsMmModeFromJSON(object: any): OptionsMmMode {
  switch (object) {
    case 0:
    case 'OPTIONS_MM_MODE_UNSPECIFIED':
      return OptionsMmMode.OPTIONS_MM_MODE_UNSPECIFIED
    case 1:
    case 'OPTIONS_MM_MODE_SHADOW':
      return OptionsMmMode.OPTIONS_MM_MODE_SHADOW
    case 2:
    case 'OPTIONS_MM_MODE_LIVE':
      return OptionsMmMode.OPTIONS_MM_MODE_LIVE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OptionsMmMode.UNRECOGNIZED
  }
}

export function optionsMmModeToJSON(object: OptionsMmMode): string {
  switch (object) {
    case OptionsMmMode.OPTIONS_MM_MODE_UNSPECIFIED:
      return 'OPTIONS_MM_MODE_UNSPECIFIED'
    case OptionsMmMode.OPTIONS_MM_MODE_SHADOW:
      return 'OPTIONS_MM_MODE_SHADOW'
    case OptionsMmMode.OPTIONS_MM_MODE_LIVE:
      return 'OPTIONS_MM_MODE_LIVE'
    case OptionsMmMode.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum OptionsMmExpiriesMode {
  OPTIONS_MM_EXPIRIES_MODE_UNSPECIFIED = 0,
  OPTIONS_MM_EXPIRIES_MODE_ALL = 1,
  OPTIONS_MM_EXPIRIES_MODE_WHITELIST = 2,
  UNRECOGNIZED = -1,
}

export function optionsMmExpiriesModeFromJSON(object: any): OptionsMmExpiriesMode {
  switch (object) {
    case 0:
    case 'OPTIONS_MM_EXPIRIES_MODE_UNSPECIFIED':
      return OptionsMmExpiriesMode.OPTIONS_MM_EXPIRIES_MODE_UNSPECIFIED
    case 1:
    case 'OPTIONS_MM_EXPIRIES_MODE_ALL':
      return OptionsMmExpiriesMode.OPTIONS_MM_EXPIRIES_MODE_ALL
    case 2:
    case 'OPTIONS_MM_EXPIRIES_MODE_WHITELIST':
      return OptionsMmExpiriesMode.OPTIONS_MM_EXPIRIES_MODE_WHITELIST
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OptionsMmExpiriesMode.UNRECOGNIZED
  }
}

export function optionsMmExpiriesModeToJSON(object: OptionsMmExpiriesMode): string {
  switch (object) {
    case OptionsMmExpiriesMode.OPTIONS_MM_EXPIRIES_MODE_UNSPECIFIED:
      return 'OPTIONS_MM_EXPIRIES_MODE_UNSPECIFIED'
    case OptionsMmExpiriesMode.OPTIONS_MM_EXPIRIES_MODE_ALL:
      return 'OPTIONS_MM_EXPIRIES_MODE_ALL'
    case OptionsMmExpiriesMode.OPTIONS_MM_EXPIRIES_MODE_WHITELIST:
      return 'OPTIONS_MM_EXPIRIES_MODE_WHITELIST'
    case OptionsMmExpiriesMode.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum OptionsMmSizeMode {
  OPTIONS_MM_SIZE_MODE_UNSPECIFIED = 0,
  OPTIONS_MM_SIZE_MODE_VEGA_BUDGET = 1,
  UNRECOGNIZED = -1,
}

export function optionsMmSizeModeFromJSON(object: any): OptionsMmSizeMode {
  switch (object) {
    case 0:
    case 'OPTIONS_MM_SIZE_MODE_UNSPECIFIED':
      return OptionsMmSizeMode.OPTIONS_MM_SIZE_MODE_UNSPECIFIED
    case 1:
    case 'OPTIONS_MM_SIZE_MODE_VEGA_BUDGET':
      return OptionsMmSizeMode.OPTIONS_MM_SIZE_MODE_VEGA_BUDGET
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OptionsMmSizeMode.UNRECOGNIZED
  }
}

export function optionsMmSizeModeToJSON(object: OptionsMmSizeMode): string {
  switch (object) {
    case OptionsMmSizeMode.OPTIONS_MM_SIZE_MODE_UNSPECIFIED:
      return 'OPTIONS_MM_SIZE_MODE_UNSPECIFIED'
    case OptionsMmSizeMode.OPTIONS_MM_SIZE_MODE_VEGA_BUDGET:
      return 'OPTIONS_MM_SIZE_MODE_VEGA_BUDGET'
    case OptionsMmSizeMode.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum OptionsMmLifecycle {
  OPTIONS_MM_LIFECYCLE_UNSPECIFIED = 0,
  OPTIONS_MM_LIFECYCLE_INIT = 1,
  OPTIONS_MM_LIFECYCLE_WARMUP = 2,
  OPTIONS_MM_LIFECYCLE_RUNNING = 3,
  OPTIONS_MM_LIFECYCLE_PAUSED = 4,
  OPTIONS_MM_LIFECYCLE_HALTED = 5,
  UNRECOGNIZED = -1,
}

export function optionsMmLifecycleFromJSON(object: any): OptionsMmLifecycle {
  switch (object) {
    case 0:
    case 'OPTIONS_MM_LIFECYCLE_UNSPECIFIED':
      return OptionsMmLifecycle.OPTIONS_MM_LIFECYCLE_UNSPECIFIED
    case 1:
    case 'OPTIONS_MM_LIFECYCLE_INIT':
      return OptionsMmLifecycle.OPTIONS_MM_LIFECYCLE_INIT
    case 2:
    case 'OPTIONS_MM_LIFECYCLE_WARMUP':
      return OptionsMmLifecycle.OPTIONS_MM_LIFECYCLE_WARMUP
    case 3:
    case 'OPTIONS_MM_LIFECYCLE_RUNNING':
      return OptionsMmLifecycle.OPTIONS_MM_LIFECYCLE_RUNNING
    case 4:
    case 'OPTIONS_MM_LIFECYCLE_PAUSED':
      return OptionsMmLifecycle.OPTIONS_MM_LIFECYCLE_PAUSED
    case 5:
    case 'OPTIONS_MM_LIFECYCLE_HALTED':
      return OptionsMmLifecycle.OPTIONS_MM_LIFECYCLE_HALTED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OptionsMmLifecycle.UNRECOGNIZED
  }
}

export function optionsMmLifecycleToJSON(object: OptionsMmLifecycle): string {
  switch (object) {
    case OptionsMmLifecycle.OPTIONS_MM_LIFECYCLE_UNSPECIFIED:
      return 'OPTIONS_MM_LIFECYCLE_UNSPECIFIED'
    case OptionsMmLifecycle.OPTIONS_MM_LIFECYCLE_INIT:
      return 'OPTIONS_MM_LIFECYCLE_INIT'
    case OptionsMmLifecycle.OPTIONS_MM_LIFECYCLE_WARMUP:
      return 'OPTIONS_MM_LIFECYCLE_WARMUP'
    case OptionsMmLifecycle.OPTIONS_MM_LIFECYCLE_RUNNING:
      return 'OPTIONS_MM_LIFECYCLE_RUNNING'
    case OptionsMmLifecycle.OPTIONS_MM_LIFECYCLE_PAUSED:
      return 'OPTIONS_MM_LIFECYCLE_PAUSED'
    case OptionsMmLifecycle.OPTIONS_MM_LIFECYCLE_HALTED:
      return 'OPTIONS_MM_LIFECYCLE_HALTED'
    case OptionsMmLifecycle.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** The user picks the class; no asset-to-class map exists anywhere. */
export enum OptionsMmAssetClass {
  OPTIONS_MM_ASSET_CLASS_UNSPECIFIED = 0,
  OPTIONS_MM_ASSET_CLASS_MAJORS = 1,
  OPTIONS_MM_ASSET_CLASS_ALTS = 2,
  OPTIONS_MM_ASSET_CLASS_COMMODITIES = 3,
  OPTIONS_MM_ASSET_CLASS_LONG_TAIL = 4,
  UNRECOGNIZED = -1,
}

export function optionsMmAssetClassFromJSON(object: any): OptionsMmAssetClass {
  switch (object) {
    case 0:
    case 'OPTIONS_MM_ASSET_CLASS_UNSPECIFIED':
      return OptionsMmAssetClass.OPTIONS_MM_ASSET_CLASS_UNSPECIFIED
    case 1:
    case 'OPTIONS_MM_ASSET_CLASS_MAJORS':
      return OptionsMmAssetClass.OPTIONS_MM_ASSET_CLASS_MAJORS
    case 2:
    case 'OPTIONS_MM_ASSET_CLASS_ALTS':
      return OptionsMmAssetClass.OPTIONS_MM_ASSET_CLASS_ALTS
    case 3:
    case 'OPTIONS_MM_ASSET_CLASS_COMMODITIES':
      return OptionsMmAssetClass.OPTIONS_MM_ASSET_CLASS_COMMODITIES
    case 4:
    case 'OPTIONS_MM_ASSET_CLASS_LONG_TAIL':
      return OptionsMmAssetClass.OPTIONS_MM_ASSET_CLASS_LONG_TAIL
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OptionsMmAssetClass.UNRECOGNIZED
  }
}

export function optionsMmAssetClassToJSON(object: OptionsMmAssetClass): string {
  switch (object) {
    case OptionsMmAssetClass.OPTIONS_MM_ASSET_CLASS_UNSPECIFIED:
      return 'OPTIONS_MM_ASSET_CLASS_UNSPECIFIED'
    case OptionsMmAssetClass.OPTIONS_MM_ASSET_CLASS_MAJORS:
      return 'OPTIONS_MM_ASSET_CLASS_MAJORS'
    case OptionsMmAssetClass.OPTIONS_MM_ASSET_CLASS_ALTS:
      return 'OPTIONS_MM_ASSET_CLASS_ALTS'
    case OptionsMmAssetClass.OPTIONS_MM_ASSET_CLASS_COMMODITIES:
      return 'OPTIONS_MM_ASSET_CLASS_COMMODITIES'
    case OptionsMmAssetClass.OPTIONS_MM_ASSET_CLASS_LONG_TAIL:
      return 'OPTIONS_MM_ASSET_CLASS_LONG_TAIL'
    case OptionsMmAssetClass.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum OptionsMmFillModel {
  OPTIONS_MM_FILL_MODEL_UNSPECIFIED = 0,
  OPTIONS_MM_FILL_MODEL_CONSERVATIVE = 1,
  OPTIONS_MM_FILL_MODEL_QUEUE = 2,
  OPTIONS_MM_FILL_MODEL_TOP_OF_BOOK = 3,
  UNRECOGNIZED = -1,
}

export function optionsMmFillModelFromJSON(object: any): OptionsMmFillModel {
  switch (object) {
    case 0:
    case 'OPTIONS_MM_FILL_MODEL_UNSPECIFIED':
      return OptionsMmFillModel.OPTIONS_MM_FILL_MODEL_UNSPECIFIED
    case 1:
    case 'OPTIONS_MM_FILL_MODEL_CONSERVATIVE':
      return OptionsMmFillModel.OPTIONS_MM_FILL_MODEL_CONSERVATIVE
    case 2:
    case 'OPTIONS_MM_FILL_MODEL_QUEUE':
      return OptionsMmFillModel.OPTIONS_MM_FILL_MODEL_QUEUE
    case 3:
    case 'OPTIONS_MM_FILL_MODEL_TOP_OF_BOOK':
      return OptionsMmFillModel.OPTIONS_MM_FILL_MODEL_TOP_OF_BOOK
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OptionsMmFillModel.UNRECOGNIZED
  }
}

export function optionsMmFillModelToJSON(object: OptionsMmFillModel): string {
  switch (object) {
    case OptionsMmFillModel.OPTIONS_MM_FILL_MODEL_UNSPECIFIED:
      return 'OPTIONS_MM_FILL_MODEL_UNSPECIFIED'
    case OptionsMmFillModel.OPTIONS_MM_FILL_MODEL_CONSERVATIVE:
      return 'OPTIONS_MM_FILL_MODEL_CONSERVATIVE'
    case OptionsMmFillModel.OPTIONS_MM_FILL_MODEL_QUEUE:
      return 'OPTIONS_MM_FILL_MODEL_QUEUE'
    case OptionsMmFillModel.OPTIONS_MM_FILL_MODEL_TOP_OF_BOOK:
      return 'OPTIONS_MM_FILL_MODEL_TOP_OF_BOOK'
    case OptionsMmFillModel.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum OptionsMmProfile {
  OPTIONS_MM_PROFILE_UNSPECIFIED = 0,
  OPTIONS_MM_PROFILE_MM = 1,
  OPTIONS_MM_PROFILE_STANDARD = 2,
  UNRECOGNIZED = -1,
}

export function optionsMmProfileFromJSON(object: any): OptionsMmProfile {
  switch (object) {
    case 0:
    case 'OPTIONS_MM_PROFILE_UNSPECIFIED':
      return OptionsMmProfile.OPTIONS_MM_PROFILE_UNSPECIFIED
    case 1:
    case 'OPTIONS_MM_PROFILE_MM':
      return OptionsMmProfile.OPTIONS_MM_PROFILE_MM
    case 2:
    case 'OPTIONS_MM_PROFILE_STANDARD':
      return OptionsMmProfile.OPTIONS_MM_PROFILE_STANDARD
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OptionsMmProfile.UNRECOGNIZED
  }
}

export function optionsMmProfileToJSON(object: OptionsMmProfile): string {
  switch (object) {
    case OptionsMmProfile.OPTIONS_MM_PROFILE_UNSPECIFIED:
      return 'OPTIONS_MM_PROFILE_UNSPECIFIED'
    case OptionsMmProfile.OPTIONS_MM_PROFILE_MM:
      return 'OPTIONS_MM_PROFILE_MM'
    case OptionsMmProfile.OPTIONS_MM_PROFILE_STANDARD:
      return 'OPTIONS_MM_PROFILE_STANDARD'
    case OptionsMmProfile.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export interface AlgoServiceCommandList {
  commands: AlgoServiceCommand[]
}

export interface AlgoServiceCommand {
  startAlgo?: StartAlgo | undefined
  stopAlgo?: StopAlgo | undefined
  resumeAlgo?: ResumeAlgo | undefined
  rfqAcceptQuote?: RfqAcceptQuote | undefined
  rfqCancel?: RfqCancel | undefined
  updateAlgo?: UpdateAlgo | undefined
}

export interface StopAlgo {
  accountId: string
  algoId: string
  /**
   * Opaque frontend-owned correlation id, echoed back on any resulting
   * notification so the UI can map it to the originating action. Optional.
   */
  correlationId?: string | undefined
}

/**
 * Durable handoff published on graceful shutdown for each suspended algo: a
 * live peer (or the restarted instance) loads the persisted AlgoState and
 * resumes it. Idempotent — deduped by the in-process registry and the
 * per-algo single-active claim.
 */
export interface ResumeAlgo {
  accountId: string
  algoId: string
}

/**
 * Route a user-initiated accept into the RFQ algo that owns `rfq_id`.
 *
 * Manual RFQs are algo-orchestrated (the algo creates on every network the
 * degradation matrix allows, then cancels the loser on fill), so a manual
 * accept MUST go through the same serialization every other accept does:
 * `RfqService::fire_accept` arms and persists an accept intent BEFORE
 * publishing, and refuses a second accept while one is in flight. Publishing
 * straight to the venue would bypass that and let two accepts on two networks
 * execute the structure twice.
 *
 * Broadcast on `algo.{account_id}`; the owning algo matches on `rfq_id` and
 * every other instance ignores it. Addressed by `rfq_id` rather than
 * `algo_id` because the caller (public-api, and the UI behind it) holds the
 * RFQ's id and never the algo's.
 *
 * 🚨 There is deliberately NO network field. The algo resolves the network
 * from the quote it is already holding, so a client cannot route an accept to
 * a network the quote never came from — the mismatch is unrepresentable
 * rather than merely validated.
 */
export interface RfqAcceptQuote {
  accountId: string
  rfqId: string
  /** OrderX handle from RfqQuote.quote_id */
  quoteId: string
  /** package price the user saw; venue rejects on mismatch */
  price: string
  correlationId?: string | undefined
}

/**
 * Cancel every live leg of an algo-orchestrated RFQ and end the algo.
 * Addressed by `rfq_id` for the same reason as RfqAcceptQuote. Distinct from
 * StopAlgo, which needs the algo_id the caller does not have.
 */
export interface RfqCancel {
  accountId: string
  rfqId: string
  correlationId?: string | undefined
}

export interface StartAlgo {
  accountId: string
  twap?: TwapAlgoParams | undefined
  limitChase?: LimitChaseAlgoParams | undefined
  hedge?: HedgeAlgoParams | undefined
  trigger?: TriggerAlgoParams | undefined
  /**
   * SimpleOrderParams simple_order = 8;
   *  BlackScholesDeltaHedgePortfolioParams bs_delta_hedge = 9;
   *  MultiLegAlgoParams multi_leg = 10;
   */
  advancedTwap?: AdvancedTwapAlgoParams | undefined
  rfq?: RfqAlgoParams | undefined
  spreader?: SpreaderAlgoParams | undefined
  crossExchangeArb?: CrossExchangeArbParams | undefined
  singleHedge?: SingleHedgeAlgoParams | undefined
  scale?: ScaleAlgoParams | undefined
  optionsMm?: OptionsMmAlgoParams | undefined
  /** present iff this algo came from an order preset */
  presetId?: string | undefined
  /** server-owned; present when spawned by another algo */
  parentId?: string | undefined
  /** server-owned; true for root algos and trigger-spawned children */
  visibleInHistory?: boolean | undefined
  /**
   * Opaque frontend-owned correlation id, echoed back on any algo-start
   * refusal/failure notification so the UI can map it to the originating
   * action. Optional; server assigns no semantics to it.
   */
  correlationId?: string | undefined
}

/**
 * Routing identity (trade_venue, exchange) is server-attached at the
 * public-api boundary from the account record. Clients send account_id +
 * symbol + algo shape; the api fills in trade_venue/exchange before
 * publishing to NATS so downstream services don't need DDB.
 */
export interface LimitChaseAlgoParams {
  symbol: string
  quantity: string
  orderSide: OrderSide
  accountId: string
  exchange: Exchange
  denomination: Denomination
  tradeVenue: TradeVenue
  /**
   * Optional explicit starting price (decimal string). When absent the algo
   * anchors to the live best bid/ask at start time.
   */
  startingPrice?: string | undefined
  /**
   * Set by intent-compiler for reduce flows so every child order preserves
   * derivatives reduce-only behavior.
   */
  reduceOnly?: boolean | undefined
  /**
   * ── Advanced-TWAP per-slice knobs. Absent for a standalone limit-chase,
   * which preserves today's behaviour exactly.
   * Wall-clock budget for this chase. On expiry the algo stops chasing and
   * terminates with whatever it filled; it does not fail.
   */
  validForSeconds?: string | undefined
  /**
   * When set, remaining resting size converts to aggressive orders at this
   * cadence, starting late enough to finish by `valid_for_seconds`.
   */
  catchup: TwapCadence | undefined
}

/**
 * TWAP Algo Parameters.
 *
 * Routing identity (trade_venue, exchange) is server-attached at the
 * public-api boundary (see LimitChaseAlgoParams).
 */
export interface TwapAlgoParams {
  symbol: string
  quantity: string
  cadence?: TwapCadence | undefined
  durationSeconds?: string | undefined
  orderSide: OrderSide
  accountId: string
  denomination: Denomination
  exchange: Exchange
  tradeVenue: TradeVenue
  /**
   * Optional limit price (decimal string). When set, individual slices are
   * priced no worse than this; absent = each slice goes out at market.
   */
  limitPrice?: string | undefined
  /**
   * Set by intent-compiler for reduce flows so every child order preserves
   * derivatives reduce-only behavior.
   */
  reduceOnly?: boolean | undefined
}

export interface OrderSize {
  fixed?: string | undefined
  random?: Range | undefined
}

export interface TwapCadence {
  frequency: Frequency | undefined
  orderSize: OrderSize | undefined
}

/** Frequency configuration */
export interface Frequency {
  fixed?: string | undefined
  random?: Range | undefined
}

/**
 * Advanced TWAP parameters.
 *
 * Routing identity (trade_venue, exchange) is server-attached at the public-api
 * boundary, as with TWAP/LimitChase/Hedge.
 */
export interface AdvancedTwapAlgoParams {
  symbol: string
  quantity: string
  orderSide: OrderSide
  accountId: string
  exchange: Exchange
  denomination: Denomination
  tradeVenue: TradeVenue
  /**
   * Total wall-clock the user asked for. Slice count is derived from this
   * under a 10s-per-slice floor. A pause extends the real elapsed time beyond
   * this value; it is a schedule length, not a deadline.
   */
  durationSeconds: string
  /**
   * Requested slice count. Absent means the server default; either way the
   * 10s floor wins and the effective count may be lower than requested.
   */
  totalSlices?: number | undefined
  /**
   * Optional price band, as a fraction of arrival price. Both must be set for
   * the band to be active. The band widens by one multiple of these per slice
   * (slice 0 uses 1x, slice 1 uses 2x, ...). On breach the schedule pauses and
   * resumes when price re-enters; it does not fail and accrues no backlog.
   */
  upperBoundPct?: string | undefined
  lowerBoundPct?: string | undefined
  /** Cadence and size of the aggressive catchup leg at the end of each slice. */
  catchup: TwapCadence | undefined
  reduceOnly?: boolean | undefined
}

/** Advanced TWAP state. Persisted per update; the resume source of truth. */
export interface AdvancedTwapState {
  id: string
  accountId: string
  symbol: string
  totalQuantity: string
  executedQuantity: string
  direction: OrderSide
  denomination: Denomination
  exchange: Exchange
  tradeVenue: TradeVenue
  /** Resolved (post-floor) slicing, not the raw request. */
  sliceDurationS: string
  totalSlices: number
  currentSliceNumber: number
  /** Captured once at start; anchors the band for the whole run. */
  arrivalPrice: string
  upperBoundPct?: string | undefined
  lowerBoundPct?: string | undefined
  catchup: TwapCadence | undefined
  reduceOnly?: boolean | undefined
  /** Unix ms the in-flight slice began. Reset when a pause ends. */
  sliceStartedAt: string
  /**
   * Set while the band is breached; cleared on re-entry. Its presence is what
   * makes a paused run resumable as paused rather than silently restarting.
   */
  pausedAt?: string | undefined
  /**
   * Filled within the in-flight slice, so a pause mid-slice re-spawns only the
   * unfilled remainder rather than the whole slice target.
   */
  currentSliceFilled: string
  /** Every child limit-chase spawned so far, oldest first (v1's `algo_list`). */
  childAlgoIds: string[]
}

export interface SpreaderLeg {
  symbol: string
  quantity: string
  denomination: Denomination
  accountId: string
  exchange: Exchange
  tradeVenue: TradeVenue
  reduceOnly?: boolean | undefined
  role: SpreaderLegRole
  side: OrderSide
}

export interface SpreaderAlgoParams {
  legs: SpreaderLeg[]
  /** Fraction of the quoting leg worked per slice, (0, 1]. */
  slicePct: string
  /** Never post better than this on the quoting leg. Absent = unbounded. */
  limitPrice?: string | undefined
  /** quoting leg's venue; routing convenience */
  tradeVenue: TradeVenue
}

export interface SpreaderPersistedLeg {
  symbol: string
  accountId: string
  exchange: Exchange
  tradeVenue: TradeVenue
  side: OrderSide
  total: string
  denomination: Denomination
  nativeQuote: boolean
  reduceOnly?: boolean | undefined
  role: SpreaderLegRole
  executed: string
  unfilledResidual: string
  /**
   * Clips this leg fired that the venue never reported terminal, so the run
   * stopped waiting on them. Distinct from `unfilled_residual` and NOT covered
   * by it: an abandoned clip may still be resting at the venue, which makes
   * both this leg's `executed` and its residual a lower bound rather than a
   * settled figure. Zero on every clean run.
   */
  unaccountedClips: number
}

export interface SpreaderState {
  legs: SpreaderPersistedLeg[]
  slicePct: string
  limitPrice?: string | undefined
  quotingExecuted: string
  sliceIndex: number
  sliceTotal: string
  sliceFilled: string
  nextCounter: number
  phase: SpreaderPhase
}

/**
 * An instrument whose mid IS the multiplier. Read through the same order-book
 * subscription the trading legs use, so it adds no new data plumbing and
 * inherits the same staleness rail.
 */
export interface ArbMultiplierInstrument {
  exchange: Exchange
  symbol: string
}

export interface ArbMultiplier {
  /**
   * Constant ratio. Correct for a contract-size spec (IBIT's 0.0005662
   * BTC/share never changes), wrong for a currency pair — a hardcoded rate
   * keeps quoting as though nothing moved, which shows up as a slow bleed
   * rather than an error.
   */
  fixed?: string | undefined
  instrument?: ArbMultiplierInstrument | undefined
  /**
   * Use the reciprocal. Lets the operator enter 1766.16 regardless of which leg
   * they listed first, and turns Upbit's KRW-per-USDT mark into USD-per-KRW.
   */
  invert: boolean
}

export interface CrossExchangeArbLeg {
  symbol: string
  accountId: string
  exchange: Exchange
  tradeVenue: TradeVenue
  /**
   * Max absolute position on this instrument, in the run's REFERENCE unit
   * (leg 1's base) — NOT this instrument's native unit. An inverse position of
   * 100,000 USD contracts is a base exposure that drifts with price, so the
   * venue figure is converted at the current mark before it is compared.
   */
  maxPosition: string
}

export interface CrossExchangeArbParams {
  /**
   * Exactly two. Order is significant: leg 1's base is the reference unit, and
   * the multiplier is defined by `price_leg2 = price_leg1 × multiplier`.
   */
  legs: CrossExchangeArbLeg[]
  /** Quoted edge on each side, as a fraction — "0.01" is 1%. */
  spread: string
  multiplier: ArbMultiplier | undefined
  /** Clip size per quote, in the reference unit. */
  quoteSize: string
  /**
   * Absent = maker-only. Present = cross both books when the observable gap
   * clears this, sized to the touch.
   */
  takerSpread?: string | undefined
  fillMode: ArbFillMode
  /**
   * Cumulative loss floor in the REFERENCE unit (leg 1's base), net of fees —
   * the same unit as `quote_size` and each leg's `max_position`. Absent = no
   * loss halt.
   *
   * Deliberately not a currency. Each leg's PnL is computed in its own quote
   * currency and then divided by that leg's mark to reach base units, so legs
   * quoted in different currencies (Upbit KRW against a USDT venue) sum without
   * an FX rate and without restricting which pairs may run.
   */
  maxLoss?: string | undefined
  /** Absolute epoch-ms deadline. Absent = runs indefinitely. */
  expiresAt?: string | undefined
}

export interface CrossExchangeArbPersistedLeg {
  symbol: string
  accountId: string
  exchange: Exchange
  tradeVenue: TradeVenue
  maxPosition: string
  /** This instrument reports quantity in quote units (inverse contracts). */
  nativeQuote: boolean
  /**
   * Reference-unit position last observed on the account stream. Re-seeded from
   * the live stream on resume rather than trusted from here, so a position that
   * moved during downtime is seen correctly.
   */
  position: string
}

export interface CrossExchangeArbState {
  legs: CrossExchangeArbPersistedLeg[]
  spread: string
  quoteSize: string
  takerSpread?: string | undefined
  fillMode: ArbFillMode
  multiplier: ArbMultiplier | undefined
  /** Cumulative PnL in the reference unit (leg 1's base), net of fees. */
  realizedPnl: string
  /**
   * Monotonic; drives the 4-char label suffix so labels never collide across
   * the four resting orders.
   */
  nextCounter: number
  maxLoss?: string | undefined
  expiresAt?: string | undefined
}

export interface TriggerAlgoParams {
  accountId: string
  exchange: Exchange
  tradeVenue: TradeVenue
  trigger: Trigger | undefined
  /**
   * Server-prepared dispatch envelopes. Public-api prepares subject + encoded
   * internal payloads after authorization; trigger-algo only publishes them.
   */
  dispatch: TriggerDispatchEnvelope[]
}

export interface TriggerDispatchEnvelope {
  subject: string
  payload: Uint8Array
  kind: TriggerDispatchKind
}

/**
 * Routing identity (trade_venue, exchange) is server-attached at the public-api
 * boundary — same as TWAP/LimitChase/Hedge. `exchange` is REQUIRED: the algo
 * subscribes to MarketDataStream tickers (which need common.types.Exchange) to
 * compute the package mark.
 */
export interface RfqAlgoParams {
  accountId: string
  tradeVenue: TradeVenue
  legs: RfqLeg[]
  hedge?: RfqHedgeLeg | undefined
  makerIds: string[]
  disclosed: boolean
  autoApprove?: AutoApprove | undefined
  /** both unset = a manual RFQ: the algo orchestrates but never self-accepts */
  autoRetry?: AutoRetry | undefined
  /** server-attached; needed for ticker subscriptions */
  exchange: Exchange
  /**
   * Caller-supplied id for the FIRST attempt. public-api mints one so the UI
   * gets an rfq_id back from `create_rfq` and can accept or cancel immediately,
   * instead of waiting for the algo to publish state to learn it. Absent = the
   * algo mints its own. A retry always mints a fresh id regardless: a retry is
   * a new venue RFQ, and reusing the id would make the cancelled attempt and
   * its replacement indistinguishable on the wire.
   */
  rfqId?: string | undefined
}

/**
 * Tracks a single in-flight cross-network accept so a crash mid-accept can't
 * let the resumed algo accept a second network for the same RFQ.
 */
export interface RfqAcceptIntent {
  network: RfqNetwork
  correlationId: string
  sentAtMs: string
  state: RfqAcceptIntentState
}

/**
 * Resume-critical state for the RFQ algo. current_rfq_id is the in-flight
 * attempt's OrderX id (also the venue label); retries_used counts EXPIRED
 * re-creations so far.
 */
export interface RfqAlgoState {
  params: RfqAlgoParams | undefined
  currentRfqId: string
  retriesUsed: number
  /** for retry_until_ms enforcement across restarts */
  firstAttemptAtMs: string
  /**
   * Written BEFORE an accept is published, cleared only on a terminal outcome
   * for that network. Phase is transient and resume() restarts in Watching, so
   * without this a crash mid-accept lets the resumed algo accept the other
   * network while the first accept is still in flight — both legs execute.
   */
  acceptIntent?: RfqAcceptIntent | undefined
}

export interface CreateAlgoResponse {
  success: boolean
  strategyId: string
  message: string
  error?: string | undefined
}

/** Cancel strategy request */
export interface CancelAlgoRequest {
  strategyId: string
}

export interface CancelAlgoResponse {
  success: boolean
  message: string
}

export interface Range {
  min: string
  max: string
}

/** Core strategy state (union of all strategy states) */
export interface AlgoState {
  id: string
  parentId?: string | undefined
  accountIds: string[]
  algoType: AlgoType
  status: AlgoStatus
  createdAt: string
  updatedAt: string
  algoData: AlgoData | undefined
  /** present iff this algo came from an order preset */
  presetId?: string | undefined
  /**
   * Latest venue-reject reason for this algo, if any. Set on Failed (LimitChase,
   * TWAP, Trigger), on the still-InProgress state after a rejected attempt
   * (Hedge), or on a Completed-unfilled terminal state (RFQ). Cleared (None) on
   * the next successful placement for algo types that keep running (Hedge).
   */
  failureReason?: string | undefined
  /**
   * Server-owned, mirrors `StartAlgo.visible_in_history`: true for root algos
   * and trigger-spawned children, false for internal children (an Advanced TWAP
   * slice chase, a hedge's child). Carried on the wire because the live state
   * fan-out is necessarily ungated — a parent algo discovers its child's
   * server-minted id by observing that child's AlgoState on the account stream —
   * so public-api needs the flag to keep internal children out of a client's
   * order history, which the persisted history query already filters on.
   * `parent_id` alone cannot stand in: trigger children carry one and are
   * visible. Absent on frames from a pre-2026-10 algo service; treat absent as
   * visible, which is that binary's existing behaviour.
   */
  visibleInHistory?: boolean | undefined
}

export interface AlgoStateList {
  algoStates: AlgoState[]
}

export interface AlgoData {
  twap?: TwapState | undefined
  limitChase?: LimitChaseState | undefined
  trigger?: TriggerState | undefined
  hedge?: HedgeState | undefined
  rfq?: RfqAlgoState | undefined
  advancedTwap?: AdvancedTwapState | undefined
  spreader?: SpreaderState | undefined
  crossExchangeArb?: CrossExchangeArbState | undefined
  singleHedge?: SingleHedgeState | undefined
  scale?: ScaleState | undefined
  optionsMm?: OptionsMmState | undefined
}

/**
 * Hedge algo parameters. Sourced from `intent_compiler.HedgeSubscription`;
 * the compiler resolves AI-supplied position/asset scopes into the concrete
 * shape below before publishing.
 *
 * Routing identity (trade_venue, exchange) is server-attached at the
 * public-api boundary, same as the other algo params.
 */
export interface HedgeAlgoParams {
  accountId: string
  exchange: Exchange
  tradeVenue: TradeVenue
  scope: HedgeScopeResolved | undefined
  deltaBands: HedgeDeltaBandsResolved | undefined
  positiveGammaTreatment?: boolean | undefined
  /**
   * Concrete venue symbol the algo trades to neutralise delta (e.g.
   * "BTC-PERPETUAL"). Optional on requests; when omitted, the compiler/service
   * derives the default perp for the resolved single underlying.
   */
  hedgeInstrument?: string | undefined
  /**
   * When set, replace any active hedge on this account whose delta book overlaps
   * this one: the algo service stops the old hedge, awaits its teardown, then
   * starts this one (never two overlapping hedges live). Unset/false => refuse to
   * start when an overlapping hedge is already running.
   */
  replaceOverlapping?: boolean | undefined
  /**
   * passive_then_cross: how long the passive hedge order rests before the
   * child cancels it and crosses. Absent = passive only.
   */
  passiveTtlMs?: string | undefined
  /** Cap on the crossing price, bp from mid. Required when passive_ttl_ms is set. */
  maxSlippageBp?: string | undefined
  /**
   * 8h-normalised funding (bp) of the hedge perpetual above which a hedge that
   * would pay funding routes to the chain's spot pair instead. Inert when the
   * venue lists no spot pair for the base. Absent = perpetual only.
   */
  fundingSwitchBp?: string | undefined
  deltaStream?: DeltaStreamHedgeMode | undefined
  interval?: IntervalHedgeMode | undefined
}

/**
 * React to streamed deltas. `min_reeval_ms` throttles how often a breach is
 * re-evaluated/acted on (absent = 1000ms default).
 */
export interface DeltaStreamHedgeMode {
  minReevalMs?: string | undefined
}

/**
 * Re-check delta only every `interval_seconds`. positive_gamma_treatment is
 * ignored in this mode.
 */
export interface IntervalHedgeMode {
  intervalSeconds: string
}

/** Resolved hedge scope. Empty `scope` oneof = whole portfolio. */
export interface HedgeScopeResolved {
  portfolioUnderlying?: AssetRef | undefined
  positionGroup?: HedgePositionGroupResolved | undefined
}

export interface HedgePositionGroupResolved {
  /**
   * Concrete venue instrument symbols (e.g. "BTC-PERPETUAL"), matched exactly
   * against Position.symbol — NOT opaque position ids. The compiler resolves
   * AI-supplied instrument/symbol references to symbols; direct callers send
   * each in-scope position's symbol verbatim.
   */
  positionSymbols: string[]
  /** Telemetry/UX only. */
  label?: string | undefined
}

export interface HedgeDeltaBandsResolved {
  acceptable: HedgeBand | undefined
  maxLowPriority?: HedgePriorityBand | undefined
  maxMediumPriority?: HedgePriorityBand | undefined
  maxHighPriority?: HedgePriorityBand | undefined
  minLowPriority?: HedgePriorityBand | undefined
  minMediumPriority?: HedgePriorityBand | undefined
  minHighPriority?: HedgePriorityBand | undefined
  denomination: HedgeDeltaDenomination
}

export interface HedgeBand {
  from: string
  to: string
  target: string
}

export interface HedgePriorityBand {
  from: string
  to: string
  target: string
  mechanism: HedgeMechanism
  /**
   * Required when mechanism = TWAP; the algo derives slice cadence from it and
   * degrades to a single market order when the size is one slice or less.
   */
  twapDurationSeconds?: string | undefined
}

/**
 * Live hedge telemetry persisted via AlgoStateWriter (mirrors TwapState /
 * LimitChaseState). `exchange` / `trade_venue` are server-derived from the
 * account at start time so UIs can label the running algo without a lookup.
 */
export interface HedgeState {
  id: string
  accountId: string
  hedgeInstrument: string
  scope: HedgeScopeResolved | undefined
  deltaBands: HedgeDeltaBandsResolved | undefined
  denomination: HedgeDeltaDenomination
  /** Aggregate signed delta/gamma over scope, in `denomination` units. */
  currentDelta: string
  currentGamma: string
  /**
   * Human label of the band the latest evaluation classified, e.g.
   * "ACCEPTABLE", "MAX_LOW", "MIN_HIGH".
   */
  activeBand: string
  /** In-flight hedge child algo id, when one is running. */
  activeChildAlgoId?: string | undefined
  positiveGammaTreatment: boolean
  createdAt: string
  updatedAt: string
  exchange: Exchange
  tradeVenue: TradeVenue
  /**
   * Next inline/gamma order-label counter. Persisted so a resumed hedge keeps
   * generating unique order labels (no collision with pre-crash labels) and can
   * backstop-cancel its most-recent labels for orders that never reached the DB.
   */
  inlineCounter: number
  deltaStream?: DeltaStreamHedgeMode | undefined
  interval?: IntervalHedgeMode | undefined
}

export interface TriggerState {
  id: string
  accountId: string
  triggerId: string
  registrationId: string
  trigger: Trigger | undefined
  dispatch: TriggerDispatchEnvelope[]
  dispatchStatus: TriggerDispatchStatus
  createdAt: string
  updatedAt: string
  firedAtMs?: string | undefined
  lastError?: string | undefined
  exchange: Exchange
  tradeVenue: TradeVenue
}

/**
 * LimitChase State.
 *
 * `exchange` and `trade_venue` are server-derived from the account at start
 * time and propagated here so client UIs can label the running algo without
 * a separate account lookup.
 */
export interface LimitChaseState {
  id: string
  accountId: string
  symbol: string
  totalQuantity: string
  filledQuantity: string
  direction: OrderSide
  denomination: Denomination
  exchange: Exchange
  activeOrderId?: string | undefined
  activePrice?: string | undefined
  tradeVenue: TradeVenue
  /** Mirrors LimitChaseAlgoParams.reduce_only; load-bearing for resume. */
  reduceOnly?: boolean | undefined
  validForSeconds?: string | undefined
  catchup: TwapCadence | undefined
  /** Absolute deadline, so a resumed chase does not restart its budget. */
  expiresAt?: string | undefined
  /**
   * Next `append_counter` suffix for the per-order label. Venues such as
   * Bybit refuse a reused orderLinkId, so every create needs a fresh label;
   * persisted so a resume never re-mints one the venue has already seen.
   */
  nextCounter: number
}

/**
 * TWAP State.
 *
 * `exchange` and `trade_venue` are server-derived (see LimitChaseState).
 */
export interface TwapState {
  symbol: string
  remainingQuantity: string
  frequency: Frequency | undefined
  orderSize: OrderSize | undefined
  direction: OrderSide
  /** Unix timestamp */
  nextExecutionTime: string
  totalQuantity: string
  accountId: string
  id: string
  denomination: Denomination
  orderCounter: number
  exchange: Exchange
  tradeVenue: TradeVenue
  /** Mirrors TwapAlgoParams.limit_price; needed to resume slice pricing. */
  limitPrice?: string | undefined
  /**
   * Mirrors TwapAlgoParams.reduce_only; resuming without it could flip a
   * position-closing trade into a position-opening one.
   */
  reduceOnly?: boolean | undefined
}

/** One-shot hedge to a delta target, sized when it runs (never at draft). */
export interface SingleHedgeAlgoParams {
  accountId: string
  /** server-attached */
  exchange: Exchange
  /** server-attached */
  tradeVenue: TradeVenue
  /** empty = whole portfolio */
  scope: HedgeScopeResolved | undefined
  /** concrete symbol; absent = default perp per underlying */
  hedgeInstrument?: string | undefined
  /** signed decimal; absent = 0 (flat) */
  target?: string | undefined
  /** required when target is set */
  denomination: HedgeDeltaDenomination
  /** UNSPECIFIED = auto-pick when it runs */
  execution: SingleHedgeExecution
  /** Draft-time estimate for display only. The algo never reads it. */
  preview: SingleHedgeLegPreview[]
  /** any TWAP leg (explicit or auto-picked); absent = 60 */
  twapDurationSeconds?: string | undefined
  /**
   * Auto-pick (execution UNSPECIFIED): TWAP when a leg's base qty or USD notional
   * exceeds these. Decimal strings; "0" disables that check; absent = 0 / 100000.
   */
  autoTwapBaseThreshold?: string | undefined
  autoTwapQuoteThreshold?: string | undefined
}

export interface SingleHedgeLegPreview {
  underlying: string
  hedgeInstrument: string
  /** in `denomination` */
  delta: string
  side: OrderSide
  /** venue base units */
  quantity: string
  execution: SingleHedgeExecution
  computedAtMs: string
}

export interface SingleHedgeState {
  /** echoed so resume can route and re-read settings */
  params: SingleHedgeAlgoParams | undefined
  legs: SingleHedgeLeg[]
}

export interface SingleHedgeLeg {
  underlying: string
  hedgeInstrument: string
  /** at fire time, in params.denomination */
  deltaBefore: string
  side: OrderSide
  /** venue base units actually sent */
  quantity: string
  execution: SingleHedgeExecution
  childAlgoId?: string | undefined
  /** inline MARKET */
  orderLabel?: string | undefined
  /** inline only; child legs leave it empty */
  filled: string
  /** recomputed once all legs terminal */
  deltaAfter?: string | undefined
  status: SingleHedgeLegStatus
  /** skip / fail reason */
  reason?: string | undefined
}

/**
 * Scale: N limit orders laddered across a price range, placed once and then
 * only tracked. Routing identity (trade_venue, exchange) is server-stamped at
 * the public-api boundary, as for every other algo.
 */
export interface ScaleAlgoParams {
  accountId: string
  symbol: string
  orderSide: OrderSide
  /** total, in `denomination` */
  quantity: string
  denomination: Denomination
  exchange: Exchange
  tradeVenue: TradeVenue
  /** 2..=50 */
  orderCount: number
  /**
   * The two ends of the ladder, in either order: which end is nearest the
   * touch is derived from the side. Relative bounds resolve once, at start.
   */
  startPrice: ScalePriceBound | undefined
  endPrice: ScalePriceBound | undefined
  /** Far level's size divided by the near level's, > 0. Absent = 1 (equal). */
  sizeRatio?: string | undefined
  reduceOnly?: boolean | undefined
  postOnly?: boolean | undefined
}

export interface ScalePriceBound {
  absolute?: string | undefined
  relative?: RelativeLimitPrice | undefined
}

export interface ScaleState {
  /** echoed so resume can route and re-read settings */
  params: ScaleAlgoParams | undefined
  /** index 0 is nearest the touch */
  levels: ScaleLevel[]
  /** mid at start; what relative bounds resolved against */
  referencePrice: string
  /** sum of level fills, in params.denomination */
  executedQuantity: string
}

export interface ScaleLevel {
  index: number
  price: string
  /** in params.denomination */
  quantity: string
  /** deterministic: append_counter(algo_id, index) */
  label: string
  status: ScaleLevelStatus
  filledQuantity: string
  /** rejection reason */
  reason?: string | undefined
}

export interface UpdateAlgo {
  accountId: string
  algoId: string
  optionsMm?: OptionsMmAlgoParams | undefined
  /**
   * Parent → hedge child only (the spec's `hedge.scope` row: the parent
   * rewrites the child's position group by UpdateAlgo). public-api refuses it.
   */
  hedge?: HedgeAlgoParams | undefined
  confirmLoosening?: boolean | undefined
  correlationId?: string | undefined
}

/** Per tenor bucket W1 / M1 / M3 / LONG. */
export interface OptionsMmTenorValues {
  w1: string
  m1: string
  m3: string
  long: string
}

/**
 * A labelled 1-D curve. Keys are tenor labels (1D 1W 2W 1M 2M 3M 6M) or
 * call-delta labels (5 10 25 50 75 90 95).
 */
export interface OptionsMmCurvePoint {
  key: string
  value: string
}

export interface OptionsMmCurve {
  points: OptionsMmCurvePoint[]
}

/** Tenor x call-delta matrix (spread.base_volpts). */
export interface OptionsMmMatrixCell {
  deltaBucket: string
  value: string
}

export interface OptionsMmMatrixRow {
  tenor: string
  cells: OptionsMmMatrixCell[]
}

export interface OptionsMmMatrix {
  rows: OptionsMmMatrixRow[]
}

/** [E] knobs: a default plus per-expiry overrides keyed by expiration_ts_ms. */
export interface OptionsMmExpiryValue {
  expirationTsMs: string
  value: string
}

export interface OptionsMmPerExpiry {
  defaultValue: string
  overrides: OptionsMmExpiryValue[]
}

export interface OptionsMmRange {
  min: string
  max: string
}

export interface OptionsMmExpiryRange {
  expirationTsMs: string
  range: OptionsMmRange | undefined
}

export interface OptionsMmPerExpiryRange {
  defaultRange: OptionsMmRange | undefined
  overrides: OptionsMmExpiryRange[]
}

/** A bound applied per expiry and to the whole book, as a percentage of capital. */
export interface OptionsMmScoped {
  perExpiry: string
  total: string
}

/** Not hot. The surface (exchange, chain, source_kind) the instance prices off. */
export interface OptionsMmReference {
  venue: Exchange
  chain: string
  /** book | marks | analytics */
  sourceKind: string
}

/** venue and chain are not hot; the rest are the spec's quote.* rows. */
export interface OptionsMmQuote {
  venue: Exchange
  chain: string
  expiriesMode: OptionsMmExpiriesMode
  /** expiration_ts_ms */
  expiryWhitelist: string[]
  autoQuoteNewExpiries: boolean
  newExpiryWarmupMin: number
  minTenorH: string
  maxTenorD: string
  stopBeforeExpiryH: OptionsMmPerExpiry | undefined
  settlementDaySizeMult: string
  callDeltaRange: OptionsMmPerExpiryRange | undefined
  putDeltaRange: OptionsMmPerExpiryRange | undefined
  /** volpts over the maker fee */
  minEdgeAfterFee: string
  layeringLevels: number
  layerStepVolpts: string
  layerSizeMult: string
}

export interface OptionsMmCapital {
  allocatedUsd: string
  /** not hot */
  assetClass: OptionsMmAssetClass
  /**
   * When true, the IM cap and MM buffer read only the IM/MM of the
   * instance's own position rows (its universe and hedge instrument). The
   * venue's account IM is ignored, so collateral, spot holdings, borrows and
   * other positions never restrict the instance. The open-order margin of
   * its own quotes is not counted here: per-order capital reservations bound
   * it, and the venue rejects any order it cannot fund. false (default)
   * caps on the whole account. Hot; turning it on is a loosening.
   */
  imOwnBookOnly: boolean
}

export interface OptionsMmMapping {
  /** enforce | report */
  validate: string
  volBasisVolpts: OptionsMmTenorValues | undefined
  skewTiltVolpts: string
  volBiasVolpts: OptionsMmExpiryValue[]
  /** sticky_delta | sticky_strike | sticky_moneyness; not hot */
  moneynessMode: string
  /** clock.weekend_variance_weight */
  weekendVarianceWeight: string
  /** marks.extra_edge_volpts */
  marksExtraEdgeVolpts: string
}

export interface OptionsMmFx {
  maxAgeS: number
  volWindowD: number
  corrWindowD: number
}

export interface OptionsMmClosedHours {
  /** calendar_with_heartbeat */
  detection: string
  /** hold_sticky_delta */
  surfaceMode: string
  /** by tenor label */
  spreadMult: OptionsMmCurve | undefined
  stalenessWidenPerH: string
  spreadMultCap: string
  sizeMult: string
  maxSurfaceAgeH: string
  reopenBlendS: string
  reopenWarmupS: string
}

export interface OptionsMmUniverse {
  minLiveInstruments: number
}

export interface OptionsMmSpreads {
  /** full bid-ask width in vol points */
  baseVolpts: OptionsMmMatrix | undefined
  /** by call-delta label */
  deltaMult: OptionsMmCurve | undefined
  /** native ticks */
  minPremiumTicks: number
  maxVolpts: string
  feeFloor: boolean
}

export interface OptionsMmSizing {
  mode: OptionsMmSizeMode
  /** $/volpt per 1 $ capital, x1e4 */
  vegaPerQuotePct: string
  /** by call-delta label */
  deltaMult: OptionsMmCurve | undefined
  /** % of risk.delta_max total */
  quoteDeltaMaxPct: OptionsMmPerExpiry | undefined
  inventoryAsym: boolean
}

export interface OptionsMmOms {
  makerOnly: boolean
  requoteTolVolpts: string
  requoteTolTicks: number
  requoteTolSizePct: string
  minRequoteIntervalMs: number
  jitterPct: string
  /** absent = universe cap x 2 x layers + 2 */
  maxOpenOrders?: number | undefined
  /** absent = max(5000, 3 x min_requote_interval_ms) */
  deadmanTtlMs?: number | undefined
  deadmanArmTimeoutMs: number
  fullRequoteMaxS: string
  /** absent = max_open_orders + 64 */
  outboundQueueDepth?: number | undefined
  publishRetries: number
  publishTimeoutMs: number
  journalDir: string
  journalRetentionDays: number
}

export interface OptionsMmMmp {
  intervalMs: number
  frozenMs: number
  /** x the universe's per-side max size */
  qtyLimitMult: string
  /** % of risk.delta_max total */
  deltaLimitPct: string
}

export interface OptionsMmSkew {
  gainVolpts: string
  /** by call-delta label */
  microGain: OptionsMmCurve | undefined
  microCapVolpts: string
  markoutThresholdBp: string
  markoutWidenVolpts: string
}

export interface OptionsMmProtection {
  movePct: string
  moveWindowMin: number
  pauseMin: number
  rvolVolpts: string
  rvolWindowMin: number
  rvolWiden: string
  latencyP99Ms: number
  latencyWiden: string
  latencyMaxMs: number
  refSpreadRatio: string
  fitDivergenceVolpts: string
  fitDivergencePersistS: number
  /** 0 = the quote venue's feed heartbeat timeout */
  hedgeFeedTimeoutS: number
  fundingAbsBp8h: string
}

export interface OptionsMmFlow {
  maxFillsWindow: number
  maxFillsInstrument: number
  windowMin: number
  sameSideGuard: number
  markoutWindowsS: number[]
  markoutPauseBp: string
  markoutPauseFills: number
}

/** Every limit is a percentage of capital.allocated_usd (USD through fx). */
export interface OptionsMmRisk {
  scaleWithEquity: boolean
  deltaMaxPct: OptionsMmScoped | undefined
  deltaMinPct: OptionsMmScoped | undefined
  gammaMaxPct: OptionsMmScoped | undefined
  gammaMinPct: OptionsMmScoped | undefined
  /** x1e4 */
  vegaMaxPct: OptionsMmScoped | undefined
  /** x1e4 */
  vegaMinPct: OptionsMmScoped | undefined
  thetaMaxPct: OptionsMmScoped | undefined
  thetaMinPct: OptionsMmScoped | undefined
  notionalMaxMult: OptionsMmScoped | undefined
  imMaxPct: string
  mmBufferPct: string
  stressLossMaxPct: string
  stressSpotShockPct: string
  stressVolShockVolpts: string
  softPct: string
  killPct: string
  breachGraceS: number
  dailyLossMaxPct: string
  derateLossPct: string
  stuckOrderS: number
  reconMismatchFrames: number
  /** % of delta_max total */
  deltaGapMaxPct: string
  deltaGapPersistS: number
}

/**
 * scope (position_group), style (passive_then_cross), on_halt
 * (hedge_if_inputs_healthy) and replace_overlapping (false) are constants.
 */
export interface OptionsMmHedge {
  /** not hot */
  enabled: boolean
  /** override; empty = catalogue resolver; not hot */
  instrument: string
  /** % of risk.delta_max total */
  bandDeltaPct: string
  targetRatio: string
  minIntervalS: number
  passiveTtlS: number
  maxSlippageBp: string
  maxFillToDecisionMs: number
  fundingSwitchBp: string
}

/** Pause offsets are minutes relative to the event time; both absent = no pause. */
export interface OptionsMmEventWindow {
  name: string
  /** manual */
  source: string
  tier: number
  startMs: string
  endMs: string
  rampInMin: number
  pauseStartMin?: number | undefined
  pauseEndMin?: number | undefined
  spreadMult: string
  sizeMult: string
  rampOutMin: number
}

export interface OptionsMmEventTierDefault {
  tier: number
  spreadMult: string
  sizeMult: string
  pauseStartMin?: number | undefined
  pauseEndMin?: number | undefined
  rampInMin: number
  rampOutMin: number
}

export interface OptionsMmEvents {
  windows: OptionsMmEventWindow[]
  tierDefaults: OptionsMmEventTierDefault[]
  autoEvents: string[]
  calendarPollMin: number
  closedHoursTier1Pause: boolean
}

export interface OptionsMmModeParams {
  /** not hot */
  mode: OptionsMmMode
  warmupMinS: number
  /** state.config_history_max */
  configHistoryMax: number
}

export interface OptionsMmAlgoParams {
  reference: OptionsMmReference | undefined
  quote: OptionsMmQuote | undefined
  capital: OptionsMmCapital | undefined
  mapping: OptionsMmMapping | undefined
  fx: OptionsMmFx | undefined
  closed: OptionsMmClosedHours | undefined
  universe: OptionsMmUniverse | undefined
  spreads: OptionsMmSpreads | undefined
  sizing: OptionsMmSizing | undefined
  oms: OptionsMmOms | undefined
  mmp: OptionsMmMmp | undefined
  skew: OptionsMmSkew | undefined
  protection: OptionsMmProtection | undefined
  flow: OptionsMmFlow | undefined
  risk: OptionsMmRisk | undefined
  hedge: OptionsMmHedge | undefined
  events: OptionsMmEvents | undefined
  mode: OptionsMmModeParams | undefined
  /** attached server-side */
  accountId: string
  /** attached server-side */
  tradeVenue: TradeVenue
}

export interface OptionsMmSides {
  expirationTsMs: string
  /** BOTH | BID | ASK | NONE */
  sides: string
}

export interface OptionsMmRestrictions {
  closedMarket: boolean
  /** only expiries that are not BOTH */
  sides: OptionsMmSides[]
  sizeMult: string
  spreadMult: string
  /** "total" or an expiration_ts_ms */
  reduceOnly: string[]
}

export interface OptionsMmQuoteRow {
  symbol: string
  strike: string
  /** C | P */
  right: string
  fairIv: string
  bidIv?: string | undefined
  askIv?: string | undefined
  /** strike currency */
  bidPrice?: string | undefined
  askPrice?: string | undefined
  /** venue units */
  bidSize?: string | undefined
  askSize?: string | undefined
  workingBidOrderId?: string | undefined
  workingAskOrderId?: string | undefined
  level: number
}

export interface OptionsMmExpiryQuoteState {
  expirationTsMs: string
  /** the quote venue's own forward */
  forward?: string | undefined
  /** no_forward | no_reference_bracket | validation | stale */
  unquotableReason?: string | undefined
  sides: string
  quotes: OptionsMmQuoteRow[]
}

export interface OptionsMmGreeks {
  /** "total" or an expiration_ts_ms */
  scope: string
  /** ours | venue */
  source: string
  deltaUsd: string
  gammaUsd: string
  vegaUsd: string
  thetaUsd: string
  notionalUsd: string
}

export interface OptionsMmUtilisation {
  greek: string
  scope: string
  position: string
  reserved: string
}

export interface OptionsMmMargin {
  equityUsd: string
  imUsd: string
  mmUsd: string
  imPctOfCapital: string
  readAtMs: string
}

export interface OptionsMmMarkout {
  windowS: number
  bp: string
  fills: number
}

export interface OptionsMmFlowSummary {
  fillsInWindow: number
  markouts: OptionsMmMarkout[]
  dailyPnlUsd: string
}

export interface OptionsMmSurfaceHealth {
  inputsNewestTsMs?: string | undefined
  fittedAtMs?: string | undefined
  anchorMs?: string | undefined
  inputAgeS: string
  closedMarket: boolean
  expiries: number
  sourceKind: string
  rvGuardVolpts?: string | undefined
}

export interface OptionsMmFieldChange {
  name: string
  previous: string
  new: string
  loosening: boolean
}

export interface OptionsMmConfigHistoryEntry {
  version: string
  appliedAtMs: string
  changes: OptionsMmFieldChange[]
}

export interface OptionsMmTransition {
  atMs: string
  from: OptionsMmLifecycle
  to: OptionsMmLifecycle
  cause: string
}

/**
 * Mirror of the last notifications.VenueCapabilities for this account
 * (algo.proto cannot import notifications.proto).
 */
export interface OptionsMmCapabilities {
  amendKeepsPriorityOnSizeDown: boolean
  hasInPlaceAmend: boolean
  hasCancelOnDisconnect: boolean
  hasDcp: boolean
  hasMmp: boolean
  mmpEnabled: boolean
  hasStp: boolean
  /** label | client_id_prefix */
  ownerTag: string
  maxOwnerTagLen: number
  openOrderCap: number
  /** introspected | configured */
  openOrderCapSource: string
  perInstrumentTps: string
  perInstrumentBurst: number
  isMarketMakerTier: boolean
  hasMarginSimulation: boolean
  batchMax: number
  receivedAtMs: string
}

export interface OptionsMmShadowSummary {
  fillModel: OptionsMmFillModel
  fills: string
  edgeUsd: string
  markouts: OptionsMmMarkout[]
}

/** Session PnL, USD. edge + vol + delta + theta + fx - fees - funding = net. */
export interface OptionsMmPnl {
  netUsd: string
  edgeUsd: string
  volUsd: string
  deltaUsd: string
  thetaUsd: string
  feesUsd: string
  fundingUsd: string
  fxUsd: string
  inventoryDeltaUsd: string
  asOfMs: string
}

export interface OptionsMmState {
  lifecycle: OptionsMmLifecycle
  /** NONE | WIDENED | CLOSED_HOURS | REDUCE_ONLY */
  derivedLabel: string
  restrictions: OptionsMmRestrictions | undefined
  sinceMs: string
  sessionGeneration: string
  expiries: OptionsMmExpiryQuoteState[]
  greeks: OptionsMmGreeks[]
  utilisation: OptionsMmUtilisation[]
  margin: OptionsMmMargin | undefined
  stressWorstLossUsd: string
  flow: OptionsMmFlowSummary | undefined
  surface: OptionsMmSurfaceHealth | undefined
  hedgeChildId?: string | undefined
  haltedResidualGreeks: OptionsMmGreeks | undefined
  configVersion: string
  params: OptionsMmAlgoParams | undefined
  configHistory: OptionsMmConfigHistoryEntry[]
  mode: OptionsMmMode
  blockedReason?: string | undefined
  outboundQueueDepth: number
  causes: string[]
  foreignOrders: number
  transitions: OptionsMmTransition[]
  profile: OptionsMmProfile
  /** matching requests/s this instance may spend */
  budgetShare: string
  openOrdersReserved: number
  capabilities: OptionsMmCapabilities | undefined
  shadow: OptionsMmShadowSummary[]
  capitalUsedUsd: string
  returnOnAllocated: string
  pnl: OptionsMmPnl | undefined
  /** as resolved (D22) */
  hedgeInstrument?: string | undefined
  /** matching requests spent in the last second, against budget_share */
  budgetUsedLastS: number
  /**
   * Internal resume state; clients should ignore it. A Shadow instance's
   * virtual book (positions, hedges, cash, fees) and its held options' terms,
   * as the algo service's own serde JSON, so a restart resumes the book
   * instead of starting flat (the day's loss rides on flow.daily_pnl_usd). Set only on the durable frames of a Shadow instance (the
   * rows that are persisted); empty on per-tick frames, and always empty in
   * Live, whose positions come from the venue.
   */
  shadowResume: Uint8Array
}

function createBaseAlgoServiceCommandList(): AlgoServiceCommandList {
  return { commands: [] }
}

export const AlgoServiceCommandList: MessageFns<AlgoServiceCommandList> = {
  encode(message: AlgoServiceCommandList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.commands) {
      AlgoServiceCommand.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlgoServiceCommandList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAlgoServiceCommandList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.commands.push(AlgoServiceCommand.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AlgoServiceCommandList {
    return {
      commands: globalThis.Array.isArray(object?.commands)
        ? object.commands.map((e: any) => AlgoServiceCommand.fromJSON(e))
        : [],
    }
  },

  toJSON(message: AlgoServiceCommandList): unknown {
    const obj: any = {}
    if (message.commands?.length) {
      obj.commands = message.commands.map((e) => AlgoServiceCommand.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AlgoServiceCommandList>, I>>(
    base?: I
  ): AlgoServiceCommandList {
    return AlgoServiceCommandList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AlgoServiceCommandList>, I>>(
    object: I
  ): AlgoServiceCommandList {
    const message = createBaseAlgoServiceCommandList()
    message.commands = object.commands?.map((e) => AlgoServiceCommand.fromPartial(e)) || []
    return message
  },
}

function createBaseAlgoServiceCommand(): AlgoServiceCommand {
  return {
    startAlgo: undefined,
    stopAlgo: undefined,
    resumeAlgo: undefined,
    rfqAcceptQuote: undefined,
    rfqCancel: undefined,
    updateAlgo: undefined,
  }
}

export const AlgoServiceCommand: MessageFns<AlgoServiceCommand> = {
  encode(message: AlgoServiceCommand, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startAlgo !== undefined) {
      StartAlgo.encode(message.startAlgo, writer.uint32(10).fork()).join()
    }
    if (message.stopAlgo !== undefined) {
      StopAlgo.encode(message.stopAlgo, writer.uint32(18).fork()).join()
    }
    if (message.resumeAlgo !== undefined) {
      ResumeAlgo.encode(message.resumeAlgo, writer.uint32(26).fork()).join()
    }
    if (message.rfqAcceptQuote !== undefined) {
      RfqAcceptQuote.encode(message.rfqAcceptQuote, writer.uint32(34).fork()).join()
    }
    if (message.rfqCancel !== undefined) {
      RfqCancel.encode(message.rfqCancel, writer.uint32(42).fork()).join()
    }
    if (message.updateAlgo !== undefined) {
      UpdateAlgo.encode(message.updateAlgo, writer.uint32(50).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlgoServiceCommand {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAlgoServiceCommand()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.startAlgo = StartAlgo.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.stopAlgo = StopAlgo.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.resumeAlgo = ResumeAlgo.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.rfqAcceptQuote = RfqAcceptQuote.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.rfqCancel = RfqCancel.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.updateAlgo = UpdateAlgo.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AlgoServiceCommand {
    return {
      startAlgo: isSet(object.startAlgo)
        ? StartAlgo.fromJSON(object.startAlgo)
        : isSet(object.start_algo)
          ? StartAlgo.fromJSON(object.start_algo)
          : undefined,
      stopAlgo: isSet(object.stopAlgo)
        ? StopAlgo.fromJSON(object.stopAlgo)
        : isSet(object.stop_algo)
          ? StopAlgo.fromJSON(object.stop_algo)
          : undefined,
      resumeAlgo: isSet(object.resumeAlgo)
        ? ResumeAlgo.fromJSON(object.resumeAlgo)
        : isSet(object.resume_algo)
          ? ResumeAlgo.fromJSON(object.resume_algo)
          : undefined,
      rfqAcceptQuote: isSet(object.rfqAcceptQuote)
        ? RfqAcceptQuote.fromJSON(object.rfqAcceptQuote)
        : isSet(object.rfq_accept_quote)
          ? RfqAcceptQuote.fromJSON(object.rfq_accept_quote)
          : undefined,
      rfqCancel: isSet(object.rfqCancel)
        ? RfqCancel.fromJSON(object.rfqCancel)
        : isSet(object.rfq_cancel)
          ? RfqCancel.fromJSON(object.rfq_cancel)
          : undefined,
      updateAlgo: isSet(object.updateAlgo)
        ? UpdateAlgo.fromJSON(object.updateAlgo)
        : isSet(object.update_algo)
          ? UpdateAlgo.fromJSON(object.update_algo)
          : undefined,
    }
  },

  toJSON(message: AlgoServiceCommand): unknown {
    const obj: any = {}
    if (message.startAlgo !== undefined) {
      obj.startAlgo = StartAlgo.toJSON(message.startAlgo)
    }
    if (message.stopAlgo !== undefined) {
      obj.stopAlgo = StopAlgo.toJSON(message.stopAlgo)
    }
    if (message.resumeAlgo !== undefined) {
      obj.resumeAlgo = ResumeAlgo.toJSON(message.resumeAlgo)
    }
    if (message.rfqAcceptQuote !== undefined) {
      obj.rfqAcceptQuote = RfqAcceptQuote.toJSON(message.rfqAcceptQuote)
    }
    if (message.rfqCancel !== undefined) {
      obj.rfqCancel = RfqCancel.toJSON(message.rfqCancel)
    }
    if (message.updateAlgo !== undefined) {
      obj.updateAlgo = UpdateAlgo.toJSON(message.updateAlgo)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AlgoServiceCommand>, I>>(base?: I): AlgoServiceCommand {
    return AlgoServiceCommand.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AlgoServiceCommand>, I>>(object: I): AlgoServiceCommand {
    const message = createBaseAlgoServiceCommand()
    message.startAlgo =
      object.startAlgo !== undefined && object.startAlgo !== null
        ? StartAlgo.fromPartial(object.startAlgo)
        : undefined
    message.stopAlgo =
      object.stopAlgo !== undefined && object.stopAlgo !== null
        ? StopAlgo.fromPartial(object.stopAlgo)
        : undefined
    message.resumeAlgo =
      object.resumeAlgo !== undefined && object.resumeAlgo !== null
        ? ResumeAlgo.fromPartial(object.resumeAlgo)
        : undefined
    message.rfqAcceptQuote =
      object.rfqAcceptQuote !== undefined && object.rfqAcceptQuote !== null
        ? RfqAcceptQuote.fromPartial(object.rfqAcceptQuote)
        : undefined
    message.rfqCancel =
      object.rfqCancel !== undefined && object.rfqCancel !== null
        ? RfqCancel.fromPartial(object.rfqCancel)
        : undefined
    message.updateAlgo =
      object.updateAlgo !== undefined && object.updateAlgo !== null
        ? UpdateAlgo.fromPartial(object.updateAlgo)
        : undefined
    return message
  },
}

function createBaseStopAlgo(): StopAlgo {
  return { accountId: '', algoId: '', correlationId: undefined }
}

export const StopAlgo: MessageFns<StopAlgo> = {
  encode(message: StopAlgo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.algoId !== '') {
      writer.uint32(18).string(message.algoId)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(26).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopAlgo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseStopAlgo()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.algoId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): StopAlgo {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      algoId: isSet(object.algoId)
        ? globalThis.String(object.algoId)
        : isSet(object.algo_id)
          ? globalThis.String(object.algo_id)
          : '',
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: StopAlgo): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.algoId !== '') {
      obj.algoId = message.algoId
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<StopAlgo>, I>>(base?: I): StopAlgo {
    return StopAlgo.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<StopAlgo>, I>>(object: I): StopAlgo {
    const message = createBaseStopAlgo()
    message.accountId = object.accountId ?? ''
    message.algoId = object.algoId ?? ''
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseResumeAlgo(): ResumeAlgo {
  return { accountId: '', algoId: '' }
}

export const ResumeAlgo: MessageFns<ResumeAlgo> = {
  encode(message: ResumeAlgo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.algoId !== '') {
      writer.uint32(18).string(message.algoId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResumeAlgo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResumeAlgo()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.algoId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResumeAlgo {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      algoId: isSet(object.algoId)
        ? globalThis.String(object.algoId)
        : isSet(object.algo_id)
          ? globalThis.String(object.algo_id)
          : '',
    }
  },

  toJSON(message: ResumeAlgo): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.algoId !== '') {
      obj.algoId = message.algoId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResumeAlgo>, I>>(base?: I): ResumeAlgo {
    return ResumeAlgo.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResumeAlgo>, I>>(object: I): ResumeAlgo {
    const message = createBaseResumeAlgo()
    message.accountId = object.accountId ?? ''
    message.algoId = object.algoId ?? ''
    return message
  },
}

function createBaseRfqAcceptQuote(): RfqAcceptQuote {
  return { accountId: '', rfqId: '', quoteId: '', price: '', correlationId: undefined }
}

export const RfqAcceptQuote: MessageFns<RfqAcceptQuote> = {
  encode(message: RfqAcceptQuote, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.rfqId !== '') {
      writer.uint32(18).string(message.rfqId)
    }
    if (message.quoteId !== '') {
      writer.uint32(26).string(message.quoteId)
    }
    if (message.price !== '') {
      writer.uint32(34).string(message.price)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(42).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqAcceptQuote {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqAcceptQuote()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.quoteId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqAcceptQuote {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
      quoteId: isSet(object.quoteId)
        ? globalThis.String(object.quoteId)
        : isSet(object.quote_id)
          ? globalThis.String(object.quote_id)
          : '',
      price: isSet(object.price) ? globalThis.String(object.price) : '',
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: RfqAcceptQuote): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    if (message.quoteId !== '') {
      obj.quoteId = message.quoteId
    }
    if (message.price !== '') {
      obj.price = message.price
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqAcceptQuote>, I>>(base?: I): RfqAcceptQuote {
    return RfqAcceptQuote.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqAcceptQuote>, I>>(object: I): RfqAcceptQuote {
    const message = createBaseRfqAcceptQuote()
    message.accountId = object.accountId ?? ''
    message.rfqId = object.rfqId ?? ''
    message.quoteId = object.quoteId ?? ''
    message.price = object.price ?? ''
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseRfqCancel(): RfqCancel {
  return { accountId: '', rfqId: '', correlationId: undefined }
}

export const RfqCancel: MessageFns<RfqCancel> = {
  encode(message: RfqCancel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.rfqId !== '') {
      writer.uint32(18).string(message.rfqId)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(26).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqCancel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqCancel()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqCancel {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: RfqCancel): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqCancel>, I>>(base?: I): RfqCancel {
    return RfqCancel.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqCancel>, I>>(object: I): RfqCancel {
    const message = createBaseRfqCancel()
    message.accountId = object.accountId ?? ''
    message.rfqId = object.rfqId ?? ''
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseStartAlgo(): StartAlgo {
  return {
    accountId: '',
    twap: undefined,
    limitChase: undefined,
    hedge: undefined,
    trigger: undefined,
    advancedTwap: undefined,
    rfq: undefined,
    spreader: undefined,
    crossExchangeArb: undefined,
    singleHedge: undefined,
    scale: undefined,
    optionsMm: undefined,
    presetId: undefined,
    parentId: undefined,
    visibleInHistory: undefined,
    correlationId: undefined,
  }
}

export const StartAlgo: MessageFns<StartAlgo> = {
  encode(message: StartAlgo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.twap !== undefined) {
      TwapAlgoParams.encode(message.twap, writer.uint32(26).fork()).join()
    }
    if (message.limitChase !== undefined) {
      LimitChaseAlgoParams.encode(message.limitChase, writer.uint32(42).fork()).join()
    }
    if (message.hedge !== undefined) {
      HedgeAlgoParams.encode(message.hedge, writer.uint32(50).fork()).join()
    }
    if (message.trigger !== undefined) {
      TriggerAlgoParams.encode(message.trigger, writer.uint32(58).fork()).join()
    }
    if (message.advancedTwap !== undefined) {
      AdvancedTwapAlgoParams.encode(message.advancedTwap, writer.uint32(90).fork()).join()
    }
    if (message.rfq !== undefined) {
      RfqAlgoParams.encode(message.rfq, writer.uint32(130).fork()).join()
    }
    if (message.spreader !== undefined) {
      SpreaderAlgoParams.encode(message.spreader, writer.uint32(138).fork()).join()
    }
    if (message.crossExchangeArb !== undefined) {
      CrossExchangeArbParams.encode(message.crossExchangeArb, writer.uint32(146).fork()).join()
    }
    if (message.singleHedge !== undefined) {
      SingleHedgeAlgoParams.encode(message.singleHedge, writer.uint32(154).fork()).join()
    }
    if (message.scale !== undefined) {
      ScaleAlgoParams.encode(message.scale, writer.uint32(162).fork()).join()
    }
    if (message.optionsMm !== undefined) {
      OptionsMmAlgoParams.encode(message.optionsMm, writer.uint32(170).fork()).join()
    }
    if (message.presetId !== undefined) {
      writer.uint32(98).string(message.presetId)
    }
    if (message.parentId !== undefined) {
      writer.uint32(106).string(message.parentId)
    }
    if (message.visibleInHistory !== undefined) {
      writer.uint32(112).bool(message.visibleInHistory)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(122).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartAlgo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseStartAlgo()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.twap = TwapAlgoParams.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.limitChase = LimitChaseAlgoParams.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.hedge = HedgeAlgoParams.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.trigger = TriggerAlgoParams.decode(reader, reader.uint32())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.advancedTwap = AdvancedTwapAlgoParams.decode(reader, reader.uint32())
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.rfq = RfqAlgoParams.decode(reader, reader.uint32())
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.spreader = SpreaderAlgoParams.decode(reader, reader.uint32())
          continue
        }
        case 18: {
          if (tag !== 146) {
            break
          }

          message.crossExchangeArb = CrossExchangeArbParams.decode(reader, reader.uint32())
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.singleHedge = SingleHedgeAlgoParams.decode(reader, reader.uint32())
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.scale = ScaleAlgoParams.decode(reader, reader.uint32())
          continue
        }
        case 21: {
          if (tag !== 170) {
            break
          }

          message.optionsMm = OptionsMmAlgoParams.decode(reader, reader.uint32())
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.presetId = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.parentId = reader.string()
          continue
        }
        case 14: {
          if (tag !== 112) {
            break
          }

          message.visibleInHistory = reader.bool()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): StartAlgo {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      twap: isSet(object.twap) ? TwapAlgoParams.fromJSON(object.twap) : undefined,
      limitChase: isSet(object.limitChase)
        ? LimitChaseAlgoParams.fromJSON(object.limitChase)
        : isSet(object.limit_chase)
          ? LimitChaseAlgoParams.fromJSON(object.limit_chase)
          : undefined,
      hedge: isSet(object.hedge) ? HedgeAlgoParams.fromJSON(object.hedge) : undefined,
      trigger: isSet(object.trigger) ? TriggerAlgoParams.fromJSON(object.trigger) : undefined,
      advancedTwap: isSet(object.advancedTwap)
        ? AdvancedTwapAlgoParams.fromJSON(object.advancedTwap)
        : isSet(object.advanced_twap)
          ? AdvancedTwapAlgoParams.fromJSON(object.advanced_twap)
          : undefined,
      rfq: isSet(object.rfq) ? RfqAlgoParams.fromJSON(object.rfq) : undefined,
      spreader: isSet(object.spreader) ? SpreaderAlgoParams.fromJSON(object.spreader) : undefined,
      crossExchangeArb: isSet(object.crossExchangeArb)
        ? CrossExchangeArbParams.fromJSON(object.crossExchangeArb)
        : isSet(object.cross_exchange_arb)
          ? CrossExchangeArbParams.fromJSON(object.cross_exchange_arb)
          : undefined,
      singleHedge: isSet(object.singleHedge)
        ? SingleHedgeAlgoParams.fromJSON(object.singleHedge)
        : isSet(object.single_hedge)
          ? SingleHedgeAlgoParams.fromJSON(object.single_hedge)
          : undefined,
      scale: isSet(object.scale) ? ScaleAlgoParams.fromJSON(object.scale) : undefined,
      optionsMm: isSet(object.optionsMm)
        ? OptionsMmAlgoParams.fromJSON(object.optionsMm)
        : isSet(object.options_mm)
          ? OptionsMmAlgoParams.fromJSON(object.options_mm)
          : undefined,
      presetId: isSet(object.presetId)
        ? globalThis.String(object.presetId)
        : isSet(object.preset_id)
          ? globalThis.String(object.preset_id)
          : undefined,
      parentId: isSet(object.parentId)
        ? globalThis.String(object.parentId)
        : isSet(object.parent_id)
          ? globalThis.String(object.parent_id)
          : undefined,
      visibleInHistory: isSet(object.visibleInHistory)
        ? globalThis.Boolean(object.visibleInHistory)
        : isSet(object.visible_in_history)
          ? globalThis.Boolean(object.visible_in_history)
          : undefined,
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: StartAlgo): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.twap !== undefined) {
      obj.twap = TwapAlgoParams.toJSON(message.twap)
    }
    if (message.limitChase !== undefined) {
      obj.limitChase = LimitChaseAlgoParams.toJSON(message.limitChase)
    }
    if (message.hedge !== undefined) {
      obj.hedge = HedgeAlgoParams.toJSON(message.hedge)
    }
    if (message.trigger !== undefined) {
      obj.trigger = TriggerAlgoParams.toJSON(message.trigger)
    }
    if (message.advancedTwap !== undefined) {
      obj.advancedTwap = AdvancedTwapAlgoParams.toJSON(message.advancedTwap)
    }
    if (message.rfq !== undefined) {
      obj.rfq = RfqAlgoParams.toJSON(message.rfq)
    }
    if (message.spreader !== undefined) {
      obj.spreader = SpreaderAlgoParams.toJSON(message.spreader)
    }
    if (message.crossExchangeArb !== undefined) {
      obj.crossExchangeArb = CrossExchangeArbParams.toJSON(message.crossExchangeArb)
    }
    if (message.singleHedge !== undefined) {
      obj.singleHedge = SingleHedgeAlgoParams.toJSON(message.singleHedge)
    }
    if (message.scale !== undefined) {
      obj.scale = ScaleAlgoParams.toJSON(message.scale)
    }
    if (message.optionsMm !== undefined) {
      obj.optionsMm = OptionsMmAlgoParams.toJSON(message.optionsMm)
    }
    if (message.presetId !== undefined) {
      obj.presetId = message.presetId
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId
    }
    if (message.visibleInHistory !== undefined) {
      obj.visibleInHistory = message.visibleInHistory
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<StartAlgo>, I>>(base?: I): StartAlgo {
    return StartAlgo.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<StartAlgo>, I>>(object: I): StartAlgo {
    const message = createBaseStartAlgo()
    message.accountId = object.accountId ?? ''
    message.twap =
      object.twap !== undefined && object.twap !== null
        ? TwapAlgoParams.fromPartial(object.twap)
        : undefined
    message.limitChase =
      object.limitChase !== undefined && object.limitChase !== null
        ? LimitChaseAlgoParams.fromPartial(object.limitChase)
        : undefined
    message.hedge =
      object.hedge !== undefined && object.hedge !== null
        ? HedgeAlgoParams.fromPartial(object.hedge)
        : undefined
    message.trigger =
      object.trigger !== undefined && object.trigger !== null
        ? TriggerAlgoParams.fromPartial(object.trigger)
        : undefined
    message.advancedTwap =
      object.advancedTwap !== undefined && object.advancedTwap !== null
        ? AdvancedTwapAlgoParams.fromPartial(object.advancedTwap)
        : undefined
    message.rfq =
      object.rfq !== undefined && object.rfq !== null
        ? RfqAlgoParams.fromPartial(object.rfq)
        : undefined
    message.spreader =
      object.spreader !== undefined && object.spreader !== null
        ? SpreaderAlgoParams.fromPartial(object.spreader)
        : undefined
    message.crossExchangeArb =
      object.crossExchangeArb !== undefined && object.crossExchangeArb !== null
        ? CrossExchangeArbParams.fromPartial(object.crossExchangeArb)
        : undefined
    message.singleHedge =
      object.singleHedge !== undefined && object.singleHedge !== null
        ? SingleHedgeAlgoParams.fromPartial(object.singleHedge)
        : undefined
    message.scale =
      object.scale !== undefined && object.scale !== null
        ? ScaleAlgoParams.fromPartial(object.scale)
        : undefined
    message.optionsMm =
      object.optionsMm !== undefined && object.optionsMm !== null
        ? OptionsMmAlgoParams.fromPartial(object.optionsMm)
        : undefined
    message.presetId = object.presetId ?? undefined
    message.parentId = object.parentId ?? undefined
    message.visibleInHistory = object.visibleInHistory ?? undefined
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseLimitChaseAlgoParams(): LimitChaseAlgoParams {
  return {
    symbol: '',
    quantity: '',
    orderSide: 0,
    accountId: '',
    exchange: 0,
    denomination: 0,
    tradeVenue: 0,
    startingPrice: undefined,
    reduceOnly: undefined,
    validForSeconds: undefined,
    catchup: undefined,
  }
}

export const LimitChaseAlgoParams: MessageFns<LimitChaseAlgoParams> = {
  encode(message: LimitChaseAlgoParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.quantity !== '') {
      writer.uint32(18).string(message.quantity)
    }
    if (message.orderSide !== 0) {
      writer.uint32(24).int32(message.orderSide)
    }
    if (message.accountId !== '') {
      writer.uint32(34).string(message.accountId)
    }
    if (message.exchange !== 0) {
      writer.uint32(40).int32(message.exchange)
    }
    if (message.denomination !== 0) {
      writer.uint32(48).int32(message.denomination)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(56).int32(message.tradeVenue)
    }
    if (message.startingPrice !== undefined) {
      writer.uint32(66).string(message.startingPrice)
    }
    if (message.reduceOnly !== undefined) {
      writer.uint32(72).bool(message.reduceOnly)
    }
    if (message.validForSeconds !== undefined) {
      writer.uint32(80).int64(message.validForSeconds)
    }
    if (message.catchup !== undefined) {
      TwapCadence.encode(message.catchup, writer.uint32(90).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LimitChaseAlgoParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLimitChaseAlgoParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.orderSide = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.startingPrice = reader.string()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.reduceOnly = reader.bool()
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.validForSeconds = reader.int64().toString()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.catchup = TwapCadence.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LimitChaseAlgoParams {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      orderSide: isSet(object.orderSide)
        ? orderSideFromJSON(object.orderSide)
        : isSet(object.order_side)
          ? orderSideFromJSON(object.order_side)
          : 0,
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      denomination: isSet(object.denomination) ? denominationFromJSON(object.denomination) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      startingPrice: isSet(object.startingPrice)
        ? globalThis.String(object.startingPrice)
        : isSet(object.starting_price)
          ? globalThis.String(object.starting_price)
          : undefined,
      reduceOnly: isSet(object.reduceOnly)
        ? globalThis.Boolean(object.reduceOnly)
        : isSet(object.reduce_only)
          ? globalThis.Boolean(object.reduce_only)
          : undefined,
      validForSeconds: isSet(object.validForSeconds)
        ? globalThis.String(object.validForSeconds)
        : isSet(object.valid_for_seconds)
          ? globalThis.String(object.valid_for_seconds)
          : undefined,
      catchup: isSet(object.catchup) ? TwapCadence.fromJSON(object.catchup) : undefined,
    }
  },

  toJSON(message: LimitChaseAlgoParams): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.orderSide !== 0) {
      obj.orderSide = orderSideToJSON(message.orderSide)
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.denomination !== 0) {
      obj.denomination = denominationToJSON(message.denomination)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.startingPrice !== undefined) {
      obj.startingPrice = message.startingPrice
    }
    if (message.reduceOnly !== undefined) {
      obj.reduceOnly = message.reduceOnly
    }
    if (message.validForSeconds !== undefined) {
      obj.validForSeconds = message.validForSeconds
    }
    if (message.catchup !== undefined) {
      obj.catchup = TwapCadence.toJSON(message.catchup)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LimitChaseAlgoParams>, I>>(base?: I): LimitChaseAlgoParams {
    return LimitChaseAlgoParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LimitChaseAlgoParams>, I>>(
    object: I
  ): LimitChaseAlgoParams {
    const message = createBaseLimitChaseAlgoParams()
    message.symbol = object.symbol ?? ''
    message.quantity = object.quantity ?? ''
    message.orderSide = object.orderSide ?? 0
    message.accountId = object.accountId ?? ''
    message.exchange = object.exchange ?? 0
    message.denomination = object.denomination ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.startingPrice = object.startingPrice ?? undefined
    message.reduceOnly = object.reduceOnly ?? undefined
    message.validForSeconds = object.validForSeconds ?? undefined
    message.catchup =
      object.catchup !== undefined && object.catchup !== null
        ? TwapCadence.fromPartial(object.catchup)
        : undefined
    return message
  },
}

function createBaseTwapAlgoParams(): TwapAlgoParams {
  return {
    symbol: '',
    quantity: '',
    cadence: undefined,
    durationSeconds: undefined,
    orderSide: 0,
    accountId: '',
    denomination: 0,
    exchange: 0,
    tradeVenue: 0,
    limitPrice: undefined,
    reduceOnly: undefined,
  }
}

export const TwapAlgoParams: MessageFns<TwapAlgoParams> = {
  encode(message: TwapAlgoParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.quantity !== '') {
      writer.uint32(18).string(message.quantity)
    }
    if (message.cadence !== undefined) {
      TwapCadence.encode(message.cadence, writer.uint32(26).fork()).join()
    }
    if (message.durationSeconds !== undefined) {
      writer.uint32(32).int64(message.durationSeconds)
    }
    if (message.orderSide !== 0) {
      writer.uint32(40).int32(message.orderSide)
    }
    if (message.accountId !== '') {
      writer.uint32(50).string(message.accountId)
    }
    if (message.denomination !== 0) {
      writer.uint32(56).int32(message.denomination)
    }
    if (message.exchange !== 0) {
      writer.uint32(64).int32(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(72).int32(message.tradeVenue)
    }
    if (message.limitPrice !== undefined) {
      writer.uint32(82).string(message.limitPrice)
    }
    if (message.reduceOnly !== undefined) {
      writer.uint32(88).bool(message.reduceOnly)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TwapAlgoParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTwapAlgoParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.cadence = TwapCadence.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.durationSeconds = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.orderSide = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.limitPrice = reader.string()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.reduceOnly = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TwapAlgoParams {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      cadence: isSet(object.cadence) ? TwapCadence.fromJSON(object.cadence) : undefined,
      durationSeconds: isSet(object.durationSeconds)
        ? globalThis.String(object.durationSeconds)
        : isSet(object.duration_seconds)
          ? globalThis.String(object.duration_seconds)
          : undefined,
      orderSide: isSet(object.orderSide)
        ? orderSideFromJSON(object.orderSide)
        : isSet(object.order_side)
          ? orderSideFromJSON(object.order_side)
          : 0,
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      denomination: isSet(object.denomination) ? denominationFromJSON(object.denomination) : 0,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      limitPrice: isSet(object.limitPrice)
        ? globalThis.String(object.limitPrice)
        : isSet(object.limit_price)
          ? globalThis.String(object.limit_price)
          : undefined,
      reduceOnly: isSet(object.reduceOnly)
        ? globalThis.Boolean(object.reduceOnly)
        : isSet(object.reduce_only)
          ? globalThis.Boolean(object.reduce_only)
          : undefined,
    }
  },

  toJSON(message: TwapAlgoParams): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.cadence !== undefined) {
      obj.cadence = TwapCadence.toJSON(message.cadence)
    }
    if (message.durationSeconds !== undefined) {
      obj.durationSeconds = message.durationSeconds
    }
    if (message.orderSide !== 0) {
      obj.orderSide = orderSideToJSON(message.orderSide)
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.denomination !== 0) {
      obj.denomination = denominationToJSON(message.denomination)
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.limitPrice !== undefined) {
      obj.limitPrice = message.limitPrice
    }
    if (message.reduceOnly !== undefined) {
      obj.reduceOnly = message.reduceOnly
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TwapAlgoParams>, I>>(base?: I): TwapAlgoParams {
    return TwapAlgoParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TwapAlgoParams>, I>>(object: I): TwapAlgoParams {
    const message = createBaseTwapAlgoParams()
    message.symbol = object.symbol ?? ''
    message.quantity = object.quantity ?? ''
    message.cadence =
      object.cadence !== undefined && object.cadence !== null
        ? TwapCadence.fromPartial(object.cadence)
        : undefined
    message.durationSeconds = object.durationSeconds ?? undefined
    message.orderSide = object.orderSide ?? 0
    message.accountId = object.accountId ?? ''
    message.denomination = object.denomination ?? 0
    message.exchange = object.exchange ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.limitPrice = object.limitPrice ?? undefined
    message.reduceOnly = object.reduceOnly ?? undefined
    return message
  },
}

function createBaseOrderSize(): OrderSize {
  return { fixed: undefined, random: undefined }
}

export const OrderSize: MessageFns<OrderSize> = {
  encode(message: OrderSize, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fixed !== undefined) {
      writer.uint32(10).string(message.fixed)
    }
    if (message.random !== undefined) {
      Range.encode(message.random, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderSize {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderSize()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.fixed = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.random = Range.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderSize {
    return {
      fixed: isSet(object.fixed) ? globalThis.String(object.fixed) : undefined,
      random: isSet(object.random) ? Range.fromJSON(object.random) : undefined,
    }
  },

  toJSON(message: OrderSize): unknown {
    const obj: any = {}
    if (message.fixed !== undefined) {
      obj.fixed = message.fixed
    }
    if (message.random !== undefined) {
      obj.random = Range.toJSON(message.random)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderSize>, I>>(base?: I): OrderSize {
    return OrderSize.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderSize>, I>>(object: I): OrderSize {
    const message = createBaseOrderSize()
    message.fixed = object.fixed ?? undefined
    message.random =
      object.random !== undefined && object.random !== null
        ? Range.fromPartial(object.random)
        : undefined
    return message
  },
}

function createBaseTwapCadence(): TwapCadence {
  return { frequency: undefined, orderSize: undefined }
}

export const TwapCadence: MessageFns<TwapCadence> = {
  encode(message: TwapCadence, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.frequency !== undefined) {
      Frequency.encode(message.frequency, writer.uint32(10).fork()).join()
    }
    if (message.orderSize !== undefined) {
      OrderSize.encode(message.orderSize, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TwapCadence {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTwapCadence()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.frequency = Frequency.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.orderSize = OrderSize.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TwapCadence {
    return {
      frequency: isSet(object.frequency) ? Frequency.fromJSON(object.frequency) : undefined,
      orderSize: isSet(object.orderSize)
        ? OrderSize.fromJSON(object.orderSize)
        : isSet(object.order_size)
          ? OrderSize.fromJSON(object.order_size)
          : undefined,
    }
  },

  toJSON(message: TwapCadence): unknown {
    const obj: any = {}
    if (message.frequency !== undefined) {
      obj.frequency = Frequency.toJSON(message.frequency)
    }
    if (message.orderSize !== undefined) {
      obj.orderSize = OrderSize.toJSON(message.orderSize)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TwapCadence>, I>>(base?: I): TwapCadence {
    return TwapCadence.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TwapCadence>, I>>(object: I): TwapCadence {
    const message = createBaseTwapCadence()
    message.frequency =
      object.frequency !== undefined && object.frequency !== null
        ? Frequency.fromPartial(object.frequency)
        : undefined
    message.orderSize =
      object.orderSize !== undefined && object.orderSize !== null
        ? OrderSize.fromPartial(object.orderSize)
        : undefined
    return message
  },
}

function createBaseFrequency(): Frequency {
  return { fixed: undefined, random: undefined }
}

export const Frequency: MessageFns<Frequency> = {
  encode(message: Frequency, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fixed !== undefined) {
      writer.uint32(10).string(message.fixed)
    }
    if (message.random !== undefined) {
      Range.encode(message.random, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Frequency {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseFrequency()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.fixed = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.random = Range.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Frequency {
    return {
      fixed: isSet(object.fixed) ? globalThis.String(object.fixed) : undefined,
      random: isSet(object.random) ? Range.fromJSON(object.random) : undefined,
    }
  },

  toJSON(message: Frequency): unknown {
    const obj: any = {}
    if (message.fixed !== undefined) {
      obj.fixed = message.fixed
    }
    if (message.random !== undefined) {
      obj.random = Range.toJSON(message.random)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Frequency>, I>>(base?: I): Frequency {
    return Frequency.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Frequency>, I>>(object: I): Frequency {
    const message = createBaseFrequency()
    message.fixed = object.fixed ?? undefined
    message.random =
      object.random !== undefined && object.random !== null
        ? Range.fromPartial(object.random)
        : undefined
    return message
  },
}

function createBaseAdvancedTwapAlgoParams(): AdvancedTwapAlgoParams {
  return {
    symbol: '',
    quantity: '',
    orderSide: 0,
    accountId: '',
    exchange: 0,
    denomination: 0,
    tradeVenue: 0,
    durationSeconds: '0',
    totalSlices: undefined,
    upperBoundPct: undefined,
    lowerBoundPct: undefined,
    catchup: undefined,
    reduceOnly: undefined,
  }
}

export const AdvancedTwapAlgoParams: MessageFns<AdvancedTwapAlgoParams> = {
  encode(message: AdvancedTwapAlgoParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.quantity !== '') {
      writer.uint32(18).string(message.quantity)
    }
    if (message.orderSide !== 0) {
      writer.uint32(24).int32(message.orderSide)
    }
    if (message.accountId !== '') {
      writer.uint32(34).string(message.accountId)
    }
    if (message.exchange !== 0) {
      writer.uint32(40).int32(message.exchange)
    }
    if (message.denomination !== 0) {
      writer.uint32(48).int32(message.denomination)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(56).int32(message.tradeVenue)
    }
    if (message.durationSeconds !== '0') {
      writer.uint32(64).int64(message.durationSeconds)
    }
    if (message.totalSlices !== undefined) {
      writer.uint32(72).uint32(message.totalSlices)
    }
    if (message.upperBoundPct !== undefined) {
      writer.uint32(82).string(message.upperBoundPct)
    }
    if (message.lowerBoundPct !== undefined) {
      writer.uint32(90).string(message.lowerBoundPct)
    }
    if (message.catchup !== undefined) {
      TwapCadence.encode(message.catchup, writer.uint32(98).fork()).join()
    }
    if (message.reduceOnly !== undefined) {
      writer.uint32(104).bool(message.reduceOnly)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdvancedTwapAlgoParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAdvancedTwapAlgoParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.orderSide = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.durationSeconds = reader.int64().toString()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.totalSlices = reader.uint32()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.upperBoundPct = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.lowerBoundPct = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.catchup = TwapCadence.decode(reader, reader.uint32())
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.reduceOnly = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AdvancedTwapAlgoParams {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      orderSide: isSet(object.orderSide)
        ? orderSideFromJSON(object.orderSide)
        : isSet(object.order_side)
          ? orderSideFromJSON(object.order_side)
          : 0,
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      denomination: isSet(object.denomination) ? denominationFromJSON(object.denomination) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      durationSeconds: isSet(object.durationSeconds)
        ? globalThis.String(object.durationSeconds)
        : isSet(object.duration_seconds)
          ? globalThis.String(object.duration_seconds)
          : '0',
      totalSlices: isSet(object.totalSlices)
        ? globalThis.Number(object.totalSlices)
        : isSet(object.total_slices)
          ? globalThis.Number(object.total_slices)
          : undefined,
      upperBoundPct: isSet(object.upperBoundPct)
        ? globalThis.String(object.upperBoundPct)
        : isSet(object.upper_bound_pct)
          ? globalThis.String(object.upper_bound_pct)
          : undefined,
      lowerBoundPct: isSet(object.lowerBoundPct)
        ? globalThis.String(object.lowerBoundPct)
        : isSet(object.lower_bound_pct)
          ? globalThis.String(object.lower_bound_pct)
          : undefined,
      catchup: isSet(object.catchup) ? TwapCadence.fromJSON(object.catchup) : undefined,
      reduceOnly: isSet(object.reduceOnly)
        ? globalThis.Boolean(object.reduceOnly)
        : isSet(object.reduce_only)
          ? globalThis.Boolean(object.reduce_only)
          : undefined,
    }
  },

  toJSON(message: AdvancedTwapAlgoParams): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.orderSide !== 0) {
      obj.orderSide = orderSideToJSON(message.orderSide)
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.denomination !== 0) {
      obj.denomination = denominationToJSON(message.denomination)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.durationSeconds !== '0') {
      obj.durationSeconds = message.durationSeconds
    }
    if (message.totalSlices !== undefined) {
      obj.totalSlices = Math.round(message.totalSlices)
    }
    if (message.upperBoundPct !== undefined) {
      obj.upperBoundPct = message.upperBoundPct
    }
    if (message.lowerBoundPct !== undefined) {
      obj.lowerBoundPct = message.lowerBoundPct
    }
    if (message.catchup !== undefined) {
      obj.catchup = TwapCadence.toJSON(message.catchup)
    }
    if (message.reduceOnly !== undefined) {
      obj.reduceOnly = message.reduceOnly
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AdvancedTwapAlgoParams>, I>>(
    base?: I
  ): AdvancedTwapAlgoParams {
    return AdvancedTwapAlgoParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AdvancedTwapAlgoParams>, I>>(
    object: I
  ): AdvancedTwapAlgoParams {
    const message = createBaseAdvancedTwapAlgoParams()
    message.symbol = object.symbol ?? ''
    message.quantity = object.quantity ?? ''
    message.orderSide = object.orderSide ?? 0
    message.accountId = object.accountId ?? ''
    message.exchange = object.exchange ?? 0
    message.denomination = object.denomination ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.durationSeconds = object.durationSeconds ?? '0'
    message.totalSlices = object.totalSlices ?? undefined
    message.upperBoundPct = object.upperBoundPct ?? undefined
    message.lowerBoundPct = object.lowerBoundPct ?? undefined
    message.catchup =
      object.catchup !== undefined && object.catchup !== null
        ? TwapCadence.fromPartial(object.catchup)
        : undefined
    message.reduceOnly = object.reduceOnly ?? undefined
    return message
  },
}

function createBaseAdvancedTwapState(): AdvancedTwapState {
  return {
    id: '',
    accountId: '',
    symbol: '',
    totalQuantity: '',
    executedQuantity: '',
    direction: 0,
    denomination: 0,
    exchange: 0,
    tradeVenue: 0,
    sliceDurationS: '0',
    totalSlices: 0,
    currentSliceNumber: 0,
    arrivalPrice: '',
    upperBoundPct: undefined,
    lowerBoundPct: undefined,
    catchup: undefined,
    reduceOnly: undefined,
    sliceStartedAt: '0',
    pausedAt: undefined,
    currentSliceFilled: '',
    childAlgoIds: [],
  }
}

export const AdvancedTwapState: MessageFns<AdvancedTwapState> = {
  encode(message: AdvancedTwapState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== '') {
      writer.uint32(10).string(message.id)
    }
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    if (message.symbol !== '') {
      writer.uint32(26).string(message.symbol)
    }
    if (message.totalQuantity !== '') {
      writer.uint32(34).string(message.totalQuantity)
    }
    if (message.executedQuantity !== '') {
      writer.uint32(42).string(message.executedQuantity)
    }
    if (message.direction !== 0) {
      writer.uint32(48).int32(message.direction)
    }
    if (message.denomination !== 0) {
      writer.uint32(56).int32(message.denomination)
    }
    if (message.exchange !== 0) {
      writer.uint32(64).int32(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(72).int32(message.tradeVenue)
    }
    if (message.sliceDurationS !== '0') {
      writer.uint32(80).int64(message.sliceDurationS)
    }
    if (message.totalSlices !== 0) {
      writer.uint32(88).uint32(message.totalSlices)
    }
    if (message.currentSliceNumber !== 0) {
      writer.uint32(96).uint32(message.currentSliceNumber)
    }
    if (message.arrivalPrice !== '') {
      writer.uint32(106).string(message.arrivalPrice)
    }
    if (message.upperBoundPct !== undefined) {
      writer.uint32(114).string(message.upperBoundPct)
    }
    if (message.lowerBoundPct !== undefined) {
      writer.uint32(122).string(message.lowerBoundPct)
    }
    if (message.catchup !== undefined) {
      TwapCadence.encode(message.catchup, writer.uint32(130).fork()).join()
    }
    if (message.reduceOnly !== undefined) {
      writer.uint32(136).bool(message.reduceOnly)
    }
    if (message.sliceStartedAt !== '0') {
      writer.uint32(144).int64(message.sliceStartedAt)
    }
    if (message.pausedAt !== undefined) {
      writer.uint32(152).int64(message.pausedAt)
    }
    if (message.currentSliceFilled !== '') {
      writer.uint32(162).string(message.currentSliceFilled)
    }
    for (const v of message.childAlgoIds) {
      writer.uint32(170).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdvancedTwapState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAdvancedTwapState()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.totalQuantity = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.executedQuantity = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.direction = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.sliceDurationS = reader.int64().toString()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.totalSlices = reader.uint32()
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.currentSliceNumber = reader.uint32()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.arrivalPrice = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.upperBoundPct = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.lowerBoundPct = reader.string()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.catchup = TwapCadence.decode(reader, reader.uint32())
          continue
        }
        case 17: {
          if (tag !== 136) {
            break
          }

          message.reduceOnly = reader.bool()
          continue
        }
        case 18: {
          if (tag !== 144) {
            break
          }

          message.sliceStartedAt = reader.int64().toString()
          continue
        }
        case 19: {
          if (tag !== 152) {
            break
          }

          message.pausedAt = reader.int64().toString()
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.currentSliceFilled = reader.string()
          continue
        }
        case 21: {
          if (tag !== 170) {
            break
          }

          message.childAlgoIds.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AdvancedTwapState {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      totalQuantity: isSet(object.totalQuantity)
        ? globalThis.String(object.totalQuantity)
        : isSet(object.total_quantity)
          ? globalThis.String(object.total_quantity)
          : '',
      executedQuantity: isSet(object.executedQuantity)
        ? globalThis.String(object.executedQuantity)
        : isSet(object.executed_quantity)
          ? globalThis.String(object.executed_quantity)
          : '',
      direction: isSet(object.direction) ? orderSideFromJSON(object.direction) : 0,
      denomination: isSet(object.denomination) ? denominationFromJSON(object.denomination) : 0,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      sliceDurationS: isSet(object.sliceDurationS)
        ? globalThis.String(object.sliceDurationS)
        : isSet(object.slice_duration_s)
          ? globalThis.String(object.slice_duration_s)
          : '0',
      totalSlices: isSet(object.totalSlices)
        ? globalThis.Number(object.totalSlices)
        : isSet(object.total_slices)
          ? globalThis.Number(object.total_slices)
          : 0,
      currentSliceNumber: isSet(object.currentSliceNumber)
        ? globalThis.Number(object.currentSliceNumber)
        : isSet(object.current_slice_number)
          ? globalThis.Number(object.current_slice_number)
          : 0,
      arrivalPrice: isSet(object.arrivalPrice)
        ? globalThis.String(object.arrivalPrice)
        : isSet(object.arrival_price)
          ? globalThis.String(object.arrival_price)
          : '',
      upperBoundPct: isSet(object.upperBoundPct)
        ? globalThis.String(object.upperBoundPct)
        : isSet(object.upper_bound_pct)
          ? globalThis.String(object.upper_bound_pct)
          : undefined,
      lowerBoundPct: isSet(object.lowerBoundPct)
        ? globalThis.String(object.lowerBoundPct)
        : isSet(object.lower_bound_pct)
          ? globalThis.String(object.lower_bound_pct)
          : undefined,
      catchup: isSet(object.catchup) ? TwapCadence.fromJSON(object.catchup) : undefined,
      reduceOnly: isSet(object.reduceOnly)
        ? globalThis.Boolean(object.reduceOnly)
        : isSet(object.reduce_only)
          ? globalThis.Boolean(object.reduce_only)
          : undefined,
      sliceStartedAt: isSet(object.sliceStartedAt)
        ? globalThis.String(object.sliceStartedAt)
        : isSet(object.slice_started_at)
          ? globalThis.String(object.slice_started_at)
          : '0',
      pausedAt: isSet(object.pausedAt)
        ? globalThis.String(object.pausedAt)
        : isSet(object.paused_at)
          ? globalThis.String(object.paused_at)
          : undefined,
      currentSliceFilled: isSet(object.currentSliceFilled)
        ? globalThis.String(object.currentSliceFilled)
        : isSet(object.current_slice_filled)
          ? globalThis.String(object.current_slice_filled)
          : '',
      childAlgoIds: globalThis.Array.isArray(object?.childAlgoIds)
        ? object.childAlgoIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.child_algo_ids)
          ? object.child_algo_ids.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: AdvancedTwapState): unknown {
    const obj: any = {}
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.totalQuantity !== '') {
      obj.totalQuantity = message.totalQuantity
    }
    if (message.executedQuantity !== '') {
      obj.executedQuantity = message.executedQuantity
    }
    if (message.direction !== 0) {
      obj.direction = orderSideToJSON(message.direction)
    }
    if (message.denomination !== 0) {
      obj.denomination = denominationToJSON(message.denomination)
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.sliceDurationS !== '0') {
      obj.sliceDurationS = message.sliceDurationS
    }
    if (message.totalSlices !== 0) {
      obj.totalSlices = Math.round(message.totalSlices)
    }
    if (message.currentSliceNumber !== 0) {
      obj.currentSliceNumber = Math.round(message.currentSliceNumber)
    }
    if (message.arrivalPrice !== '') {
      obj.arrivalPrice = message.arrivalPrice
    }
    if (message.upperBoundPct !== undefined) {
      obj.upperBoundPct = message.upperBoundPct
    }
    if (message.lowerBoundPct !== undefined) {
      obj.lowerBoundPct = message.lowerBoundPct
    }
    if (message.catchup !== undefined) {
      obj.catchup = TwapCadence.toJSON(message.catchup)
    }
    if (message.reduceOnly !== undefined) {
      obj.reduceOnly = message.reduceOnly
    }
    if (message.sliceStartedAt !== '0') {
      obj.sliceStartedAt = message.sliceStartedAt
    }
    if (message.pausedAt !== undefined) {
      obj.pausedAt = message.pausedAt
    }
    if (message.currentSliceFilled !== '') {
      obj.currentSliceFilled = message.currentSliceFilled
    }
    if (message.childAlgoIds?.length) {
      obj.childAlgoIds = message.childAlgoIds
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AdvancedTwapState>, I>>(base?: I): AdvancedTwapState {
    return AdvancedTwapState.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AdvancedTwapState>, I>>(object: I): AdvancedTwapState {
    const message = createBaseAdvancedTwapState()
    message.id = object.id ?? ''
    message.accountId = object.accountId ?? ''
    message.symbol = object.symbol ?? ''
    message.totalQuantity = object.totalQuantity ?? ''
    message.executedQuantity = object.executedQuantity ?? ''
    message.direction = object.direction ?? 0
    message.denomination = object.denomination ?? 0
    message.exchange = object.exchange ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.sliceDurationS = object.sliceDurationS ?? '0'
    message.totalSlices = object.totalSlices ?? 0
    message.currentSliceNumber = object.currentSliceNumber ?? 0
    message.arrivalPrice = object.arrivalPrice ?? ''
    message.upperBoundPct = object.upperBoundPct ?? undefined
    message.lowerBoundPct = object.lowerBoundPct ?? undefined
    message.catchup =
      object.catchup !== undefined && object.catchup !== null
        ? TwapCadence.fromPartial(object.catchup)
        : undefined
    message.reduceOnly = object.reduceOnly ?? undefined
    message.sliceStartedAt = object.sliceStartedAt ?? '0'
    message.pausedAt = object.pausedAt ?? undefined
    message.currentSliceFilled = object.currentSliceFilled ?? ''
    message.childAlgoIds = object.childAlgoIds?.map((e) => e) || []
    return message
  },
}

function createBaseSpreaderLeg(): SpreaderLeg {
  return {
    symbol: '',
    quantity: '',
    denomination: 0,
    accountId: '',
    exchange: 0,
    tradeVenue: 0,
    reduceOnly: undefined,
    role: 0,
    side: 0,
  }
}

export const SpreaderLeg: MessageFns<SpreaderLeg> = {
  encode(message: SpreaderLeg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.quantity !== '') {
      writer.uint32(18).string(message.quantity)
    }
    if (message.denomination !== 0) {
      writer.uint32(24).int32(message.denomination)
    }
    if (message.accountId !== '') {
      writer.uint32(34).string(message.accountId)
    }
    if (message.exchange !== 0) {
      writer.uint32(40).int32(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(48).int32(message.tradeVenue)
    }
    if (message.reduceOnly !== undefined) {
      writer.uint32(56).bool(message.reduceOnly)
    }
    if (message.role !== 0) {
      writer.uint32(64).int32(message.role)
    }
    if (message.side !== 0) {
      writer.uint32(72).int32(message.side)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpreaderLeg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSpreaderLeg()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.reduceOnly = reader.bool()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.role = reader.int32() as any
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SpreaderLeg {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      denomination: isSet(object.denomination) ? denominationFromJSON(object.denomination) : 0,
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      reduceOnly: isSet(object.reduceOnly)
        ? globalThis.Boolean(object.reduceOnly)
        : isSet(object.reduce_only)
          ? globalThis.Boolean(object.reduce_only)
          : undefined,
      role: isSet(object.role) ? spreaderLegRoleFromJSON(object.role) : 0,
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
    }
  },

  toJSON(message: SpreaderLeg): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.denomination !== 0) {
      obj.denomination = denominationToJSON(message.denomination)
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.reduceOnly !== undefined) {
      obj.reduceOnly = message.reduceOnly
    }
    if (message.role !== 0) {
      obj.role = spreaderLegRoleToJSON(message.role)
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SpreaderLeg>, I>>(base?: I): SpreaderLeg {
    return SpreaderLeg.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SpreaderLeg>, I>>(object: I): SpreaderLeg {
    const message = createBaseSpreaderLeg()
    message.symbol = object.symbol ?? ''
    message.quantity = object.quantity ?? ''
    message.denomination = object.denomination ?? 0
    message.accountId = object.accountId ?? ''
    message.exchange = object.exchange ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.reduceOnly = object.reduceOnly ?? undefined
    message.role = object.role ?? 0
    message.side = object.side ?? 0
    return message
  },
}

function createBaseSpreaderAlgoParams(): SpreaderAlgoParams {
  return { legs: [], slicePct: '', limitPrice: undefined, tradeVenue: 0 }
}

export const SpreaderAlgoParams: MessageFns<SpreaderAlgoParams> = {
  encode(message: SpreaderAlgoParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.legs) {
      SpreaderLeg.encode(v!, writer.uint32(10).fork()).join()
    }
    if (message.slicePct !== '') {
      writer.uint32(18).string(message.slicePct)
    }
    if (message.limitPrice !== undefined) {
      writer.uint32(26).string(message.limitPrice)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(32).int32(message.tradeVenue)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpreaderAlgoParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSpreaderAlgoParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.legs.push(SpreaderLeg.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.slicePct = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.limitPrice = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SpreaderAlgoParams {
    return {
      legs: globalThis.Array.isArray(object?.legs)
        ? object.legs.map((e: any) => SpreaderLeg.fromJSON(e))
        : [],
      slicePct: isSet(object.slicePct)
        ? globalThis.String(object.slicePct)
        : isSet(object.slice_pct)
          ? globalThis.String(object.slice_pct)
          : '',
      limitPrice: isSet(object.limitPrice)
        ? globalThis.String(object.limitPrice)
        : isSet(object.limit_price)
          ? globalThis.String(object.limit_price)
          : undefined,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
    }
  },

  toJSON(message: SpreaderAlgoParams): unknown {
    const obj: any = {}
    if (message.legs?.length) {
      obj.legs = message.legs.map((e) => SpreaderLeg.toJSON(e))
    }
    if (message.slicePct !== '') {
      obj.slicePct = message.slicePct
    }
    if (message.limitPrice !== undefined) {
      obj.limitPrice = message.limitPrice
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SpreaderAlgoParams>, I>>(base?: I): SpreaderAlgoParams {
    return SpreaderAlgoParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SpreaderAlgoParams>, I>>(object: I): SpreaderAlgoParams {
    const message = createBaseSpreaderAlgoParams()
    message.legs = object.legs?.map((e) => SpreaderLeg.fromPartial(e)) || []
    message.slicePct = object.slicePct ?? ''
    message.limitPrice = object.limitPrice ?? undefined
    message.tradeVenue = object.tradeVenue ?? 0
    return message
  },
}

function createBaseSpreaderPersistedLeg(): SpreaderPersistedLeg {
  return {
    symbol: '',
    accountId: '',
    exchange: 0,
    tradeVenue: 0,
    side: 0,
    total: '',
    denomination: 0,
    nativeQuote: false,
    reduceOnly: undefined,
    role: 0,
    executed: '',
    unfilledResidual: '',
    unaccountedClips: 0,
  }
}

export const SpreaderPersistedLeg: MessageFns<SpreaderPersistedLeg> = {
  encode(message: SpreaderPersistedLeg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    if (message.exchange !== 0) {
      writer.uint32(24).int32(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(32).int32(message.tradeVenue)
    }
    if (message.side !== 0) {
      writer.uint32(40).int32(message.side)
    }
    if (message.total !== '') {
      writer.uint32(50).string(message.total)
    }
    if (message.denomination !== 0) {
      writer.uint32(56).int32(message.denomination)
    }
    if (message.nativeQuote !== false) {
      writer.uint32(64).bool(message.nativeQuote)
    }
    if (message.reduceOnly !== undefined) {
      writer.uint32(72).bool(message.reduceOnly)
    }
    if (message.role !== 0) {
      writer.uint32(80).int32(message.role)
    }
    if (message.executed !== '') {
      writer.uint32(90).string(message.executed)
    }
    if (message.unfilledResidual !== '') {
      writer.uint32(98).string(message.unfilledResidual)
    }
    if (message.unaccountedClips !== 0) {
      writer.uint32(104).int32(message.unaccountedClips)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpreaderPersistedLeg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSpreaderPersistedLeg()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.total = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.nativeQuote = reader.bool()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.reduceOnly = reader.bool()
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.role = reader.int32() as any
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.executed = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.unfilledResidual = reader.string()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.unaccountedClips = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SpreaderPersistedLeg {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
      total: isSet(object.total) ? globalThis.String(object.total) : '',
      denomination: isSet(object.denomination) ? denominationFromJSON(object.denomination) : 0,
      nativeQuote: isSet(object.nativeQuote)
        ? globalThis.Boolean(object.nativeQuote)
        : isSet(object.native_quote)
          ? globalThis.Boolean(object.native_quote)
          : false,
      reduceOnly: isSet(object.reduceOnly)
        ? globalThis.Boolean(object.reduceOnly)
        : isSet(object.reduce_only)
          ? globalThis.Boolean(object.reduce_only)
          : undefined,
      role: isSet(object.role) ? spreaderLegRoleFromJSON(object.role) : 0,
      executed: isSet(object.executed) ? globalThis.String(object.executed) : '',
      unfilledResidual: isSet(object.unfilledResidual)
        ? globalThis.String(object.unfilledResidual)
        : isSet(object.unfilled_residual)
          ? globalThis.String(object.unfilled_residual)
          : '',
      unaccountedClips: isSet(object.unaccountedClips)
        ? globalThis.Number(object.unaccountedClips)
        : isSet(object.unaccounted_clips)
          ? globalThis.Number(object.unaccounted_clips)
          : 0,
    }
  },

  toJSON(message: SpreaderPersistedLeg): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.total !== '') {
      obj.total = message.total
    }
    if (message.denomination !== 0) {
      obj.denomination = denominationToJSON(message.denomination)
    }
    if (message.nativeQuote !== false) {
      obj.nativeQuote = message.nativeQuote
    }
    if (message.reduceOnly !== undefined) {
      obj.reduceOnly = message.reduceOnly
    }
    if (message.role !== 0) {
      obj.role = spreaderLegRoleToJSON(message.role)
    }
    if (message.executed !== '') {
      obj.executed = message.executed
    }
    if (message.unfilledResidual !== '') {
      obj.unfilledResidual = message.unfilledResidual
    }
    if (message.unaccountedClips !== 0) {
      obj.unaccountedClips = Math.round(message.unaccountedClips)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SpreaderPersistedLeg>, I>>(base?: I): SpreaderPersistedLeg {
    return SpreaderPersistedLeg.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SpreaderPersistedLeg>, I>>(
    object: I
  ): SpreaderPersistedLeg {
    const message = createBaseSpreaderPersistedLeg()
    message.symbol = object.symbol ?? ''
    message.accountId = object.accountId ?? ''
    message.exchange = object.exchange ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.side = object.side ?? 0
    message.total = object.total ?? ''
    message.denomination = object.denomination ?? 0
    message.nativeQuote = object.nativeQuote ?? false
    message.reduceOnly = object.reduceOnly ?? undefined
    message.role = object.role ?? 0
    message.executed = object.executed ?? ''
    message.unfilledResidual = object.unfilledResidual ?? ''
    message.unaccountedClips = object.unaccountedClips ?? 0
    return message
  },
}

function createBaseSpreaderState(): SpreaderState {
  return {
    legs: [],
    slicePct: '',
    limitPrice: undefined,
    quotingExecuted: '',
    sliceIndex: 0,
    sliceTotal: '',
    sliceFilled: '',
    nextCounter: 0,
    phase: 0,
  }
}

export const SpreaderState: MessageFns<SpreaderState> = {
  encode(message: SpreaderState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.legs) {
      SpreaderPersistedLeg.encode(v!, writer.uint32(10).fork()).join()
    }
    if (message.slicePct !== '') {
      writer.uint32(18).string(message.slicePct)
    }
    if (message.limitPrice !== undefined) {
      writer.uint32(26).string(message.limitPrice)
    }
    if (message.quotingExecuted !== '') {
      writer.uint32(34).string(message.quotingExecuted)
    }
    if (message.sliceIndex !== 0) {
      writer.uint32(40).int32(message.sliceIndex)
    }
    if (message.sliceTotal !== '') {
      writer.uint32(50).string(message.sliceTotal)
    }
    if (message.sliceFilled !== '') {
      writer.uint32(58).string(message.sliceFilled)
    }
    if (message.nextCounter !== 0) {
      writer.uint32(64).int32(message.nextCounter)
    }
    if (message.phase !== 0) {
      writer.uint32(72).int32(message.phase)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpreaderState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSpreaderState()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.legs.push(SpreaderPersistedLeg.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.slicePct = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.limitPrice = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.quotingExecuted = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.sliceIndex = reader.int32()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.sliceTotal = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.sliceFilled = reader.string()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.nextCounter = reader.int32()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.phase = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SpreaderState {
    return {
      legs: globalThis.Array.isArray(object?.legs)
        ? object.legs.map((e: any) => SpreaderPersistedLeg.fromJSON(e))
        : [],
      slicePct: isSet(object.slicePct)
        ? globalThis.String(object.slicePct)
        : isSet(object.slice_pct)
          ? globalThis.String(object.slice_pct)
          : '',
      limitPrice: isSet(object.limitPrice)
        ? globalThis.String(object.limitPrice)
        : isSet(object.limit_price)
          ? globalThis.String(object.limit_price)
          : undefined,
      quotingExecuted: isSet(object.quotingExecuted)
        ? globalThis.String(object.quotingExecuted)
        : isSet(object.quoting_executed)
          ? globalThis.String(object.quoting_executed)
          : '',
      sliceIndex: isSet(object.sliceIndex)
        ? globalThis.Number(object.sliceIndex)
        : isSet(object.slice_index)
          ? globalThis.Number(object.slice_index)
          : 0,
      sliceTotal: isSet(object.sliceTotal)
        ? globalThis.String(object.sliceTotal)
        : isSet(object.slice_total)
          ? globalThis.String(object.slice_total)
          : '',
      sliceFilled: isSet(object.sliceFilled)
        ? globalThis.String(object.sliceFilled)
        : isSet(object.slice_filled)
          ? globalThis.String(object.slice_filled)
          : '',
      nextCounter: isSet(object.nextCounter)
        ? globalThis.Number(object.nextCounter)
        : isSet(object.next_counter)
          ? globalThis.Number(object.next_counter)
          : 0,
      phase: isSet(object.phase) ? spreaderPhaseFromJSON(object.phase) : 0,
    }
  },

  toJSON(message: SpreaderState): unknown {
    const obj: any = {}
    if (message.legs?.length) {
      obj.legs = message.legs.map((e) => SpreaderPersistedLeg.toJSON(e))
    }
    if (message.slicePct !== '') {
      obj.slicePct = message.slicePct
    }
    if (message.limitPrice !== undefined) {
      obj.limitPrice = message.limitPrice
    }
    if (message.quotingExecuted !== '') {
      obj.quotingExecuted = message.quotingExecuted
    }
    if (message.sliceIndex !== 0) {
      obj.sliceIndex = Math.round(message.sliceIndex)
    }
    if (message.sliceTotal !== '') {
      obj.sliceTotal = message.sliceTotal
    }
    if (message.sliceFilled !== '') {
      obj.sliceFilled = message.sliceFilled
    }
    if (message.nextCounter !== 0) {
      obj.nextCounter = Math.round(message.nextCounter)
    }
    if (message.phase !== 0) {
      obj.phase = spreaderPhaseToJSON(message.phase)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SpreaderState>, I>>(base?: I): SpreaderState {
    return SpreaderState.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SpreaderState>, I>>(object: I): SpreaderState {
    const message = createBaseSpreaderState()
    message.legs = object.legs?.map((e) => SpreaderPersistedLeg.fromPartial(e)) || []
    message.slicePct = object.slicePct ?? ''
    message.limitPrice = object.limitPrice ?? undefined
    message.quotingExecuted = object.quotingExecuted ?? ''
    message.sliceIndex = object.sliceIndex ?? 0
    message.sliceTotal = object.sliceTotal ?? ''
    message.sliceFilled = object.sliceFilled ?? ''
    message.nextCounter = object.nextCounter ?? 0
    message.phase = object.phase ?? 0
    return message
  },
}

function createBaseArbMultiplierInstrument(): ArbMultiplierInstrument {
  return { exchange: 0, symbol: '' }
}

export const ArbMultiplierInstrument: MessageFns<ArbMultiplierInstrument> = {
  encode(
    message: ArbMultiplierInstrument,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArbMultiplierInstrument {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseArbMultiplierInstrument()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ArbMultiplierInstrument {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
    }
  },

  toJSON(message: ArbMultiplierInstrument): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ArbMultiplierInstrument>, I>>(
    base?: I
  ): ArbMultiplierInstrument {
    return ArbMultiplierInstrument.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ArbMultiplierInstrument>, I>>(
    object: I
  ): ArbMultiplierInstrument {
    const message = createBaseArbMultiplierInstrument()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    return message
  },
}

function createBaseArbMultiplier(): ArbMultiplier {
  return { fixed: undefined, instrument: undefined, invert: false }
}

export const ArbMultiplier: MessageFns<ArbMultiplier> = {
  encode(message: ArbMultiplier, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fixed !== undefined) {
      writer.uint32(10).string(message.fixed)
    }
    if (message.instrument !== undefined) {
      ArbMultiplierInstrument.encode(message.instrument, writer.uint32(18).fork()).join()
    }
    if (message.invert !== false) {
      writer.uint32(24).bool(message.invert)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArbMultiplier {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseArbMultiplier()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.fixed = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.instrument = ArbMultiplierInstrument.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.invert = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ArbMultiplier {
    return {
      fixed: isSet(object.fixed) ? globalThis.String(object.fixed) : undefined,
      instrument: isSet(object.instrument)
        ? ArbMultiplierInstrument.fromJSON(object.instrument)
        : undefined,
      invert: isSet(object.invert) ? globalThis.Boolean(object.invert) : false,
    }
  },

  toJSON(message: ArbMultiplier): unknown {
    const obj: any = {}
    if (message.fixed !== undefined) {
      obj.fixed = message.fixed
    }
    if (message.instrument !== undefined) {
      obj.instrument = ArbMultiplierInstrument.toJSON(message.instrument)
    }
    if (message.invert !== false) {
      obj.invert = message.invert
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ArbMultiplier>, I>>(base?: I): ArbMultiplier {
    return ArbMultiplier.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ArbMultiplier>, I>>(object: I): ArbMultiplier {
    const message = createBaseArbMultiplier()
    message.fixed = object.fixed ?? undefined
    message.instrument =
      object.instrument !== undefined && object.instrument !== null
        ? ArbMultiplierInstrument.fromPartial(object.instrument)
        : undefined
    message.invert = object.invert ?? false
    return message
  },
}

function createBaseCrossExchangeArbLeg(): CrossExchangeArbLeg {
  return { symbol: '', accountId: '', exchange: 0, tradeVenue: 0, maxPosition: '' }
}

export const CrossExchangeArbLeg: MessageFns<CrossExchangeArbLeg> = {
  encode(message: CrossExchangeArbLeg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    if (message.exchange !== 0) {
      writer.uint32(24).int32(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(32).int32(message.tradeVenue)
    }
    if (message.maxPosition !== '') {
      writer.uint32(42).string(message.maxPosition)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CrossExchangeArbLeg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCrossExchangeArbLeg()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.maxPosition = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CrossExchangeArbLeg {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      maxPosition: isSet(object.maxPosition)
        ? globalThis.String(object.maxPosition)
        : isSet(object.max_position)
          ? globalThis.String(object.max_position)
          : '',
    }
  },

  toJSON(message: CrossExchangeArbLeg): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.maxPosition !== '') {
      obj.maxPosition = message.maxPosition
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CrossExchangeArbLeg>, I>>(base?: I): CrossExchangeArbLeg {
    return CrossExchangeArbLeg.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CrossExchangeArbLeg>, I>>(
    object: I
  ): CrossExchangeArbLeg {
    const message = createBaseCrossExchangeArbLeg()
    message.symbol = object.symbol ?? ''
    message.accountId = object.accountId ?? ''
    message.exchange = object.exchange ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.maxPosition = object.maxPosition ?? ''
    return message
  },
}

function createBaseCrossExchangeArbParams(): CrossExchangeArbParams {
  return {
    legs: [],
    spread: '',
    multiplier: undefined,
    quoteSize: '',
    takerSpread: undefined,
    fillMode: 0,
    maxLoss: undefined,
    expiresAt: undefined,
  }
}

export const CrossExchangeArbParams: MessageFns<CrossExchangeArbParams> = {
  encode(message: CrossExchangeArbParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.legs) {
      CrossExchangeArbLeg.encode(v!, writer.uint32(10).fork()).join()
    }
    if (message.spread !== '') {
      writer.uint32(18).string(message.spread)
    }
    if (message.multiplier !== undefined) {
      ArbMultiplier.encode(message.multiplier, writer.uint32(26).fork()).join()
    }
    if (message.quoteSize !== '') {
      writer.uint32(34).string(message.quoteSize)
    }
    if (message.takerSpread !== undefined) {
      writer.uint32(42).string(message.takerSpread)
    }
    if (message.fillMode !== 0) {
      writer.uint32(48).int32(message.fillMode)
    }
    if (message.maxLoss !== undefined) {
      writer.uint32(58).string(message.maxLoss)
    }
    if (message.expiresAt !== undefined) {
      writer.uint32(64).int64(message.expiresAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CrossExchangeArbParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCrossExchangeArbParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.legs.push(CrossExchangeArbLeg.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.spread = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.multiplier = ArbMultiplier.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.quoteSize = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.takerSpread = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.fillMode = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.maxLoss = reader.string()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.expiresAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CrossExchangeArbParams {
    return {
      legs: globalThis.Array.isArray(object?.legs)
        ? object.legs.map((e: any) => CrossExchangeArbLeg.fromJSON(e))
        : [],
      spread: isSet(object.spread) ? globalThis.String(object.spread) : '',
      multiplier: isSet(object.multiplier) ? ArbMultiplier.fromJSON(object.multiplier) : undefined,
      quoteSize: isSet(object.quoteSize)
        ? globalThis.String(object.quoteSize)
        : isSet(object.quote_size)
          ? globalThis.String(object.quote_size)
          : '',
      takerSpread: isSet(object.takerSpread)
        ? globalThis.String(object.takerSpread)
        : isSet(object.taker_spread)
          ? globalThis.String(object.taker_spread)
          : undefined,
      fillMode: isSet(object.fillMode)
        ? arbFillModeFromJSON(object.fillMode)
        : isSet(object.fill_mode)
          ? arbFillModeFromJSON(object.fill_mode)
          : 0,
      maxLoss: isSet(object.maxLoss)
        ? globalThis.String(object.maxLoss)
        : isSet(object.max_loss)
          ? globalThis.String(object.max_loss)
          : undefined,
      expiresAt: isSet(object.expiresAt)
        ? globalThis.String(object.expiresAt)
        : isSet(object.expires_at)
          ? globalThis.String(object.expires_at)
          : undefined,
    }
  },

  toJSON(message: CrossExchangeArbParams): unknown {
    const obj: any = {}
    if (message.legs?.length) {
      obj.legs = message.legs.map((e) => CrossExchangeArbLeg.toJSON(e))
    }
    if (message.spread !== '') {
      obj.spread = message.spread
    }
    if (message.multiplier !== undefined) {
      obj.multiplier = ArbMultiplier.toJSON(message.multiplier)
    }
    if (message.quoteSize !== '') {
      obj.quoteSize = message.quoteSize
    }
    if (message.takerSpread !== undefined) {
      obj.takerSpread = message.takerSpread
    }
    if (message.fillMode !== 0) {
      obj.fillMode = arbFillModeToJSON(message.fillMode)
    }
    if (message.maxLoss !== undefined) {
      obj.maxLoss = message.maxLoss
    }
    if (message.expiresAt !== undefined) {
      obj.expiresAt = message.expiresAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CrossExchangeArbParams>, I>>(
    base?: I
  ): CrossExchangeArbParams {
    return CrossExchangeArbParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CrossExchangeArbParams>, I>>(
    object: I
  ): CrossExchangeArbParams {
    const message = createBaseCrossExchangeArbParams()
    message.legs = object.legs?.map((e) => CrossExchangeArbLeg.fromPartial(e)) || []
    message.spread = object.spread ?? ''
    message.multiplier =
      object.multiplier !== undefined && object.multiplier !== null
        ? ArbMultiplier.fromPartial(object.multiplier)
        : undefined
    message.quoteSize = object.quoteSize ?? ''
    message.takerSpread = object.takerSpread ?? undefined
    message.fillMode = object.fillMode ?? 0
    message.maxLoss = object.maxLoss ?? undefined
    message.expiresAt = object.expiresAt ?? undefined
    return message
  },
}

function createBaseCrossExchangeArbPersistedLeg(): CrossExchangeArbPersistedLeg {
  return {
    symbol: '',
    accountId: '',
    exchange: 0,
    tradeVenue: 0,
    maxPosition: '',
    nativeQuote: false,
    position: '',
  }
}

export const CrossExchangeArbPersistedLeg: MessageFns<CrossExchangeArbPersistedLeg> = {
  encode(
    message: CrossExchangeArbPersistedLeg,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    if (message.exchange !== 0) {
      writer.uint32(24).int32(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(32).int32(message.tradeVenue)
    }
    if (message.maxPosition !== '') {
      writer.uint32(42).string(message.maxPosition)
    }
    if (message.nativeQuote !== false) {
      writer.uint32(48).bool(message.nativeQuote)
    }
    if (message.position !== '') {
      writer.uint32(58).string(message.position)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CrossExchangeArbPersistedLeg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCrossExchangeArbPersistedLeg()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.maxPosition = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.nativeQuote = reader.bool()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.position = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CrossExchangeArbPersistedLeg {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      maxPosition: isSet(object.maxPosition)
        ? globalThis.String(object.maxPosition)
        : isSet(object.max_position)
          ? globalThis.String(object.max_position)
          : '',
      nativeQuote: isSet(object.nativeQuote)
        ? globalThis.Boolean(object.nativeQuote)
        : isSet(object.native_quote)
          ? globalThis.Boolean(object.native_quote)
          : false,
      position: isSet(object.position) ? globalThis.String(object.position) : '',
    }
  },

  toJSON(message: CrossExchangeArbPersistedLeg): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.maxPosition !== '') {
      obj.maxPosition = message.maxPosition
    }
    if (message.nativeQuote !== false) {
      obj.nativeQuote = message.nativeQuote
    }
    if (message.position !== '') {
      obj.position = message.position
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CrossExchangeArbPersistedLeg>, I>>(
    base?: I
  ): CrossExchangeArbPersistedLeg {
    return CrossExchangeArbPersistedLeg.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CrossExchangeArbPersistedLeg>, I>>(
    object: I
  ): CrossExchangeArbPersistedLeg {
    const message = createBaseCrossExchangeArbPersistedLeg()
    message.symbol = object.symbol ?? ''
    message.accountId = object.accountId ?? ''
    message.exchange = object.exchange ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.maxPosition = object.maxPosition ?? ''
    message.nativeQuote = object.nativeQuote ?? false
    message.position = object.position ?? ''
    return message
  },
}

function createBaseCrossExchangeArbState(): CrossExchangeArbState {
  return {
    legs: [],
    spread: '',
    quoteSize: '',
    takerSpread: undefined,
    fillMode: 0,
    multiplier: undefined,
    realizedPnl: '',
    nextCounter: 0,
    maxLoss: undefined,
    expiresAt: undefined,
  }
}

export const CrossExchangeArbState: MessageFns<CrossExchangeArbState> = {
  encode(message: CrossExchangeArbState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.legs) {
      CrossExchangeArbPersistedLeg.encode(v!, writer.uint32(10).fork()).join()
    }
    if (message.spread !== '') {
      writer.uint32(18).string(message.spread)
    }
    if (message.quoteSize !== '') {
      writer.uint32(26).string(message.quoteSize)
    }
    if (message.takerSpread !== undefined) {
      writer.uint32(34).string(message.takerSpread)
    }
    if (message.fillMode !== 0) {
      writer.uint32(40).int32(message.fillMode)
    }
    if (message.multiplier !== undefined) {
      ArbMultiplier.encode(message.multiplier, writer.uint32(50).fork()).join()
    }
    if (message.realizedPnl !== '') {
      writer.uint32(58).string(message.realizedPnl)
    }
    if (message.nextCounter !== 0) {
      writer.uint32(64).int32(message.nextCounter)
    }
    if (message.maxLoss !== undefined) {
      writer.uint32(74).string(message.maxLoss)
    }
    if (message.expiresAt !== undefined) {
      writer.uint32(80).int64(message.expiresAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CrossExchangeArbState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCrossExchangeArbState()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.legs.push(CrossExchangeArbPersistedLeg.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.spread = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.quoteSize = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.takerSpread = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.fillMode = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.multiplier = ArbMultiplier.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.realizedPnl = reader.string()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.nextCounter = reader.int32()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.maxLoss = reader.string()
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.expiresAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CrossExchangeArbState {
    return {
      legs: globalThis.Array.isArray(object?.legs)
        ? object.legs.map((e: any) => CrossExchangeArbPersistedLeg.fromJSON(e))
        : [],
      spread: isSet(object.spread) ? globalThis.String(object.spread) : '',
      quoteSize: isSet(object.quoteSize)
        ? globalThis.String(object.quoteSize)
        : isSet(object.quote_size)
          ? globalThis.String(object.quote_size)
          : '',
      takerSpread: isSet(object.takerSpread)
        ? globalThis.String(object.takerSpread)
        : isSet(object.taker_spread)
          ? globalThis.String(object.taker_spread)
          : undefined,
      fillMode: isSet(object.fillMode)
        ? arbFillModeFromJSON(object.fillMode)
        : isSet(object.fill_mode)
          ? arbFillModeFromJSON(object.fill_mode)
          : 0,
      multiplier: isSet(object.multiplier) ? ArbMultiplier.fromJSON(object.multiplier) : undefined,
      realizedPnl: isSet(object.realizedPnl)
        ? globalThis.String(object.realizedPnl)
        : isSet(object.realized_pnl)
          ? globalThis.String(object.realized_pnl)
          : '',
      nextCounter: isSet(object.nextCounter)
        ? globalThis.Number(object.nextCounter)
        : isSet(object.next_counter)
          ? globalThis.Number(object.next_counter)
          : 0,
      maxLoss: isSet(object.maxLoss)
        ? globalThis.String(object.maxLoss)
        : isSet(object.max_loss)
          ? globalThis.String(object.max_loss)
          : undefined,
      expiresAt: isSet(object.expiresAt)
        ? globalThis.String(object.expiresAt)
        : isSet(object.expires_at)
          ? globalThis.String(object.expires_at)
          : undefined,
    }
  },

  toJSON(message: CrossExchangeArbState): unknown {
    const obj: any = {}
    if (message.legs?.length) {
      obj.legs = message.legs.map((e) => CrossExchangeArbPersistedLeg.toJSON(e))
    }
    if (message.spread !== '') {
      obj.spread = message.spread
    }
    if (message.quoteSize !== '') {
      obj.quoteSize = message.quoteSize
    }
    if (message.takerSpread !== undefined) {
      obj.takerSpread = message.takerSpread
    }
    if (message.fillMode !== 0) {
      obj.fillMode = arbFillModeToJSON(message.fillMode)
    }
    if (message.multiplier !== undefined) {
      obj.multiplier = ArbMultiplier.toJSON(message.multiplier)
    }
    if (message.realizedPnl !== '') {
      obj.realizedPnl = message.realizedPnl
    }
    if (message.nextCounter !== 0) {
      obj.nextCounter = Math.round(message.nextCounter)
    }
    if (message.maxLoss !== undefined) {
      obj.maxLoss = message.maxLoss
    }
    if (message.expiresAt !== undefined) {
      obj.expiresAt = message.expiresAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CrossExchangeArbState>, I>>(base?: I): CrossExchangeArbState {
    return CrossExchangeArbState.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CrossExchangeArbState>, I>>(
    object: I
  ): CrossExchangeArbState {
    const message = createBaseCrossExchangeArbState()
    message.legs = object.legs?.map((e) => CrossExchangeArbPersistedLeg.fromPartial(e)) || []
    message.spread = object.spread ?? ''
    message.quoteSize = object.quoteSize ?? ''
    message.takerSpread = object.takerSpread ?? undefined
    message.fillMode = object.fillMode ?? 0
    message.multiplier =
      object.multiplier !== undefined && object.multiplier !== null
        ? ArbMultiplier.fromPartial(object.multiplier)
        : undefined
    message.realizedPnl = object.realizedPnl ?? ''
    message.nextCounter = object.nextCounter ?? 0
    message.maxLoss = object.maxLoss ?? undefined
    message.expiresAt = object.expiresAt ?? undefined
    return message
  },
}

function createBaseTriggerAlgoParams(): TriggerAlgoParams {
  return { accountId: '', exchange: 0, tradeVenue: 0, trigger: undefined, dispatch: [] }
}

export const TriggerAlgoParams: MessageFns<TriggerAlgoParams> = {
  encode(message: TriggerAlgoParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(24).int32(message.tradeVenue)
    }
    if (message.trigger !== undefined) {
      Trigger.encode(message.trigger, writer.uint32(34).fork()).join()
    }
    for (const v of message.dispatch) {
      TriggerDispatchEnvelope.encode(v!, writer.uint32(42).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TriggerAlgoParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTriggerAlgoParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.trigger = Trigger.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.dispatch.push(TriggerDispatchEnvelope.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TriggerAlgoParams {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      trigger: isSet(object.trigger) ? Trigger.fromJSON(object.trigger) : undefined,
      dispatch: globalThis.Array.isArray(object?.dispatch)
        ? object.dispatch.map((e: any) => TriggerDispatchEnvelope.fromJSON(e))
        : [],
    }
  },

  toJSON(message: TriggerAlgoParams): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.trigger !== undefined) {
      obj.trigger = Trigger.toJSON(message.trigger)
    }
    if (message.dispatch?.length) {
      obj.dispatch = message.dispatch.map((e) => TriggerDispatchEnvelope.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TriggerAlgoParams>, I>>(base?: I): TriggerAlgoParams {
    return TriggerAlgoParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TriggerAlgoParams>, I>>(object: I): TriggerAlgoParams {
    const message = createBaseTriggerAlgoParams()
    message.accountId = object.accountId ?? ''
    message.exchange = object.exchange ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.trigger =
      object.trigger !== undefined && object.trigger !== null
        ? Trigger.fromPartial(object.trigger)
        : undefined
    message.dispatch = object.dispatch?.map((e) => TriggerDispatchEnvelope.fromPartial(e)) || []
    return message
  },
}

function createBaseTriggerDispatchEnvelope(): TriggerDispatchEnvelope {
  return { subject: '', payload: new Uint8Array(0), kind: 0 }
}

export const TriggerDispatchEnvelope: MessageFns<TriggerDispatchEnvelope> = {
  encode(
    message: TriggerDispatchEnvelope,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.subject !== '') {
      writer.uint32(10).string(message.subject)
    }
    if (message.payload.length !== 0) {
      writer.uint32(18).bytes(message.payload)
    }
    if (message.kind !== 0) {
      writer.uint32(24).int32(message.kind)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TriggerDispatchEnvelope {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTriggerDispatchEnvelope()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.subject = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.payload = reader.bytes()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.kind = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TriggerDispatchEnvelope {
    return {
      subject: isSet(object.subject) ? globalThis.String(object.subject) : '',
      payload: isSet(object.payload) ? bytesFromBase64(object.payload) : new Uint8Array(0),
      kind: isSet(object.kind) ? triggerDispatchKindFromJSON(object.kind) : 0,
    }
  },

  toJSON(message: TriggerDispatchEnvelope): unknown {
    const obj: any = {}
    if (message.subject !== '') {
      obj.subject = message.subject
    }
    if (message.payload.length !== 0) {
      obj.payload = base64FromBytes(message.payload)
    }
    if (message.kind !== 0) {
      obj.kind = triggerDispatchKindToJSON(message.kind)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TriggerDispatchEnvelope>, I>>(
    base?: I
  ): TriggerDispatchEnvelope {
    return TriggerDispatchEnvelope.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TriggerDispatchEnvelope>, I>>(
    object: I
  ): TriggerDispatchEnvelope {
    const message = createBaseTriggerDispatchEnvelope()
    message.subject = object.subject ?? ''
    message.payload = object.payload ?? new Uint8Array(0)
    message.kind = object.kind ?? 0
    return message
  },
}

function createBaseRfqAlgoParams(): RfqAlgoParams {
  return {
    accountId: '',
    tradeVenue: 0,
    legs: [],
    hedge: undefined,
    makerIds: [],
    disclosed: false,
    autoApprove: undefined,
    autoRetry: undefined,
    exchange: 0,
    rfqId: undefined,
  }
}

export const RfqAlgoParams: MessageFns<RfqAlgoParams> = {
  encode(message: RfqAlgoParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(16).int32(message.tradeVenue)
    }
    for (const v of message.legs) {
      RfqLeg.encode(v!, writer.uint32(26).fork()).join()
    }
    if (message.hedge !== undefined) {
      RfqHedgeLeg.encode(message.hedge, writer.uint32(34).fork()).join()
    }
    for (const v of message.makerIds) {
      writer.uint32(42).string(v!)
    }
    if (message.disclosed !== false) {
      writer.uint32(48).bool(message.disclosed)
    }
    if (message.autoApprove !== undefined) {
      AutoApprove.encode(message.autoApprove, writer.uint32(58).fork()).join()
    }
    if (message.autoRetry !== undefined) {
      AutoRetry.encode(message.autoRetry, writer.uint32(66).fork()).join()
    }
    if (message.exchange !== 0) {
      writer.uint32(72).int32(message.exchange)
    }
    if (message.rfqId !== undefined) {
      writer.uint32(82).string(message.rfqId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqAlgoParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqAlgoParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.legs.push(RfqLeg.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.hedge = RfqHedgeLeg.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.makerIds.push(reader.string())
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.disclosed = reader.bool()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.autoApprove = AutoApprove.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.autoRetry = AutoRetry.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqAlgoParams {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      legs: globalThis.Array.isArray(object?.legs)
        ? object.legs.map((e: any) => RfqLeg.fromJSON(e))
        : [],
      hedge: isSet(object.hedge) ? RfqHedgeLeg.fromJSON(object.hedge) : undefined,
      makerIds: globalThis.Array.isArray(object?.makerIds)
        ? object.makerIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.maker_ids)
          ? object.maker_ids.map((e: any) => globalThis.String(e))
          : [],
      disclosed: isSet(object.disclosed) ? globalThis.Boolean(object.disclosed) : false,
      autoApprove: isSet(object.autoApprove)
        ? AutoApprove.fromJSON(object.autoApprove)
        : isSet(object.auto_approve)
          ? AutoApprove.fromJSON(object.auto_approve)
          : undefined,
      autoRetry: isSet(object.autoRetry)
        ? AutoRetry.fromJSON(object.autoRetry)
        : isSet(object.auto_retry)
          ? AutoRetry.fromJSON(object.auto_retry)
          : undefined,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : undefined,
    }
  },

  toJSON(message: RfqAlgoParams): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.legs?.length) {
      obj.legs = message.legs.map((e) => RfqLeg.toJSON(e))
    }
    if (message.hedge !== undefined) {
      obj.hedge = RfqHedgeLeg.toJSON(message.hedge)
    }
    if (message.makerIds?.length) {
      obj.makerIds = message.makerIds
    }
    if (message.disclosed !== false) {
      obj.disclosed = message.disclosed
    }
    if (message.autoApprove !== undefined) {
      obj.autoApprove = AutoApprove.toJSON(message.autoApprove)
    }
    if (message.autoRetry !== undefined) {
      obj.autoRetry = AutoRetry.toJSON(message.autoRetry)
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.rfqId !== undefined) {
      obj.rfqId = message.rfqId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqAlgoParams>, I>>(base?: I): RfqAlgoParams {
    return RfqAlgoParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqAlgoParams>, I>>(object: I): RfqAlgoParams {
    const message = createBaseRfqAlgoParams()
    message.accountId = object.accountId ?? ''
    message.tradeVenue = object.tradeVenue ?? 0
    message.legs = object.legs?.map((e) => RfqLeg.fromPartial(e)) || []
    message.hedge =
      object.hedge !== undefined && object.hedge !== null
        ? RfqHedgeLeg.fromPartial(object.hedge)
        : undefined
    message.makerIds = object.makerIds?.map((e) => e) || []
    message.disclosed = object.disclosed ?? false
    message.autoApprove =
      object.autoApprove !== undefined && object.autoApprove !== null
        ? AutoApprove.fromPartial(object.autoApprove)
        : undefined
    message.autoRetry =
      object.autoRetry !== undefined && object.autoRetry !== null
        ? AutoRetry.fromPartial(object.autoRetry)
        : undefined
    message.exchange = object.exchange ?? 0
    message.rfqId = object.rfqId ?? undefined
    return message
  },
}

function createBaseRfqAcceptIntent(): RfqAcceptIntent {
  return { network: 0, correlationId: '', sentAtMs: '0', state: 0 }
}

export const RfqAcceptIntent: MessageFns<RfqAcceptIntent> = {
  encode(message: RfqAcceptIntent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.network !== 0) {
      writer.uint32(8).int32(message.network)
    }
    if (message.correlationId !== '') {
      writer.uint32(18).string(message.correlationId)
    }
    if (message.sentAtMs !== '0') {
      writer.uint32(24).int64(message.sentAtMs)
    }
    if (message.state !== 0) {
      writer.uint32(32).int32(message.state)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqAcceptIntent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqAcceptIntent()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.network = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.sentAtMs = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.state = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqAcceptIntent {
    return {
      network: isSet(object.network) ? rfqNetworkFromJSON(object.network) : 0,
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : '',
      sentAtMs: isSet(object.sentAtMs)
        ? globalThis.String(object.sentAtMs)
        : isSet(object.sent_at_ms)
          ? globalThis.String(object.sent_at_ms)
          : '0',
      state: isSet(object.state) ? rfqAcceptIntentStateFromJSON(object.state) : 0,
    }
  },

  toJSON(message: RfqAcceptIntent): unknown {
    const obj: any = {}
    if (message.network !== 0) {
      obj.network = rfqNetworkToJSON(message.network)
    }
    if (message.correlationId !== '') {
      obj.correlationId = message.correlationId
    }
    if (message.sentAtMs !== '0') {
      obj.sentAtMs = message.sentAtMs
    }
    if (message.state !== 0) {
      obj.state = rfqAcceptIntentStateToJSON(message.state)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqAcceptIntent>, I>>(base?: I): RfqAcceptIntent {
    return RfqAcceptIntent.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqAcceptIntent>, I>>(object: I): RfqAcceptIntent {
    const message = createBaseRfqAcceptIntent()
    message.network = object.network ?? 0
    message.correlationId = object.correlationId ?? ''
    message.sentAtMs = object.sentAtMs ?? '0'
    message.state = object.state ?? 0
    return message
  },
}

function createBaseRfqAlgoState(): RfqAlgoState {
  return {
    params: undefined,
    currentRfqId: '',
    retriesUsed: 0,
    firstAttemptAtMs: '0',
    acceptIntent: undefined,
  }
}

export const RfqAlgoState: MessageFns<RfqAlgoState> = {
  encode(message: RfqAlgoState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.params !== undefined) {
      RfqAlgoParams.encode(message.params, writer.uint32(10).fork()).join()
    }
    if (message.currentRfqId !== '') {
      writer.uint32(18).string(message.currentRfqId)
    }
    if (message.retriesUsed !== 0) {
      writer.uint32(24).int32(message.retriesUsed)
    }
    if (message.firstAttemptAtMs !== '0') {
      writer.uint32(32).int64(message.firstAttemptAtMs)
    }
    if (message.acceptIntent !== undefined) {
      RfqAcceptIntent.encode(message.acceptIntent, writer.uint32(42).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqAlgoState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqAlgoState()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.params = RfqAlgoParams.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.currentRfqId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.retriesUsed = reader.int32()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.firstAttemptAtMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.acceptIntent = RfqAcceptIntent.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqAlgoState {
    return {
      params: isSet(object.params) ? RfqAlgoParams.fromJSON(object.params) : undefined,
      currentRfqId: isSet(object.currentRfqId)
        ? globalThis.String(object.currentRfqId)
        : isSet(object.current_rfq_id)
          ? globalThis.String(object.current_rfq_id)
          : '',
      retriesUsed: isSet(object.retriesUsed)
        ? globalThis.Number(object.retriesUsed)
        : isSet(object.retries_used)
          ? globalThis.Number(object.retries_used)
          : 0,
      firstAttemptAtMs: isSet(object.firstAttemptAtMs)
        ? globalThis.String(object.firstAttemptAtMs)
        : isSet(object.first_attempt_at_ms)
          ? globalThis.String(object.first_attempt_at_ms)
          : '0',
      acceptIntent: isSet(object.acceptIntent)
        ? RfqAcceptIntent.fromJSON(object.acceptIntent)
        : isSet(object.accept_intent)
          ? RfqAcceptIntent.fromJSON(object.accept_intent)
          : undefined,
    }
  },

  toJSON(message: RfqAlgoState): unknown {
    const obj: any = {}
    if (message.params !== undefined) {
      obj.params = RfqAlgoParams.toJSON(message.params)
    }
    if (message.currentRfqId !== '') {
      obj.currentRfqId = message.currentRfqId
    }
    if (message.retriesUsed !== 0) {
      obj.retriesUsed = Math.round(message.retriesUsed)
    }
    if (message.firstAttemptAtMs !== '0') {
      obj.firstAttemptAtMs = message.firstAttemptAtMs
    }
    if (message.acceptIntent !== undefined) {
      obj.acceptIntent = RfqAcceptIntent.toJSON(message.acceptIntent)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqAlgoState>, I>>(base?: I): RfqAlgoState {
    return RfqAlgoState.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqAlgoState>, I>>(object: I): RfqAlgoState {
    const message = createBaseRfqAlgoState()
    message.params =
      object.params !== undefined && object.params !== null
        ? RfqAlgoParams.fromPartial(object.params)
        : undefined
    message.currentRfqId = object.currentRfqId ?? ''
    message.retriesUsed = object.retriesUsed ?? 0
    message.firstAttemptAtMs = object.firstAttemptAtMs ?? '0'
    message.acceptIntent =
      object.acceptIntent !== undefined && object.acceptIntent !== null
        ? RfqAcceptIntent.fromPartial(object.acceptIntent)
        : undefined
    return message
  },
}

function createBaseCreateAlgoResponse(): CreateAlgoResponse {
  return { success: false, strategyId: '', message: '', error: undefined }
}

export const CreateAlgoResponse: MessageFns<CreateAlgoResponse> = {
  encode(message: CreateAlgoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.strategyId !== '') {
      writer.uint32(18).string(message.strategyId)
    }
    if (message.message !== '') {
      writer.uint32(26).string(message.message)
    }
    if (message.error !== undefined) {
      writer.uint32(34).string(message.error)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateAlgoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreateAlgoResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.strategyId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.message = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.error = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreateAlgoResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      strategyId: isSet(object.strategyId)
        ? globalThis.String(object.strategyId)
        : isSet(object.strategy_id)
          ? globalThis.String(object.strategy_id)
          : '',
      message: isSet(object.message) ? globalThis.String(object.message) : '',
      error: isSet(object.error) ? globalThis.String(object.error) : undefined,
    }
  },

  toJSON(message: CreateAlgoResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.strategyId !== '') {
      obj.strategyId = message.strategyId
    }
    if (message.message !== '') {
      obj.message = message.message
    }
    if (message.error !== undefined) {
      obj.error = message.error
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreateAlgoResponse>, I>>(base?: I): CreateAlgoResponse {
    return CreateAlgoResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreateAlgoResponse>, I>>(object: I): CreateAlgoResponse {
    const message = createBaseCreateAlgoResponse()
    message.success = object.success ?? false
    message.strategyId = object.strategyId ?? ''
    message.message = object.message ?? ''
    message.error = object.error ?? undefined
    return message
  },
}

function createBaseCancelAlgoRequest(): CancelAlgoRequest {
  return { strategyId: '' }
}

export const CancelAlgoRequest: MessageFns<CancelAlgoRequest> = {
  encode(message: CancelAlgoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.strategyId !== '') {
      writer.uint32(10).string(message.strategyId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelAlgoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelAlgoRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.strategyId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelAlgoRequest {
    return {
      strategyId: isSet(object.strategyId)
        ? globalThis.String(object.strategyId)
        : isSet(object.strategy_id)
          ? globalThis.String(object.strategy_id)
          : '',
    }
  },

  toJSON(message: CancelAlgoRequest): unknown {
    const obj: any = {}
    if (message.strategyId !== '') {
      obj.strategyId = message.strategyId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelAlgoRequest>, I>>(base?: I): CancelAlgoRequest {
    return CancelAlgoRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelAlgoRequest>, I>>(object: I): CancelAlgoRequest {
    const message = createBaseCancelAlgoRequest()
    message.strategyId = object.strategyId ?? ''
    return message
  },
}

function createBaseCancelAlgoResponse(): CancelAlgoResponse {
  return { success: false, message: '' }
}

export const CancelAlgoResponse: MessageFns<CancelAlgoResponse> = {
  encode(message: CancelAlgoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.message !== '') {
      writer.uint32(18).string(message.message)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelAlgoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelAlgoResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.message = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelAlgoResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : '',
    }
  },

  toJSON(message: CancelAlgoResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.message !== '') {
      obj.message = message.message
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelAlgoResponse>, I>>(base?: I): CancelAlgoResponse {
    return CancelAlgoResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelAlgoResponse>, I>>(object: I): CancelAlgoResponse {
    const message = createBaseCancelAlgoResponse()
    message.success = object.success ?? false
    message.message = object.message ?? ''
    return message
  },
}

function createBaseRange(): Range {
  return { min: '', max: '' }
}

export const Range: MessageFns<Range> = {
  encode(message: Range, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.min !== '') {
      writer.uint32(10).string(message.min)
    }
    if (message.max !== '') {
      writer.uint32(18).string(message.max)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Range {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRange()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.min = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.max = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Range {
    return {
      min: isSet(object.min) ? globalThis.String(object.min) : '',
      max: isSet(object.max) ? globalThis.String(object.max) : '',
    }
  },

  toJSON(message: Range): unknown {
    const obj: any = {}
    if (message.min !== '') {
      obj.min = message.min
    }
    if (message.max !== '') {
      obj.max = message.max
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Range>, I>>(base?: I): Range {
    return Range.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Range>, I>>(object: I): Range {
    const message = createBaseRange()
    message.min = object.min ?? ''
    message.max = object.max ?? ''
    return message
  },
}

function createBaseAlgoState(): AlgoState {
  return {
    id: '',
    parentId: undefined,
    accountIds: [],
    algoType: 0,
    status: 0,
    createdAt: '0',
    updatedAt: '0',
    algoData: undefined,
    presetId: undefined,
    failureReason: undefined,
    visibleInHistory: undefined,
  }
}

export const AlgoState: MessageFns<AlgoState> = {
  encode(message: AlgoState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== '') {
      writer.uint32(10).string(message.id)
    }
    if (message.parentId !== undefined) {
      writer.uint32(18).string(message.parentId)
    }
    for (const v of message.accountIds) {
      writer.uint32(26).string(v!)
    }
    if (message.algoType !== 0) {
      writer.uint32(32).int32(message.algoType)
    }
    if (message.status !== 0) {
      writer.uint32(40).int32(message.status)
    }
    if (message.createdAt !== '0') {
      writer.uint32(48).int64(message.createdAt)
    }
    if (message.updatedAt !== '0') {
      writer.uint32(56).int64(message.updatedAt)
    }
    if (message.algoData !== undefined) {
      AlgoData.encode(message.algoData, writer.uint32(66).fork()).join()
    }
    if (message.presetId !== undefined) {
      writer.uint32(74).string(message.presetId)
    }
    if (message.failureReason !== undefined) {
      writer.uint32(82).string(message.failureReason)
    }
    if (message.visibleInHistory !== undefined) {
      writer.uint32(88).bool(message.visibleInHistory)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlgoState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAlgoState()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.parentId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.accountIds.push(reader.string())
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.algoType = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.status = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.updatedAt = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.algoData = AlgoData.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.presetId = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.failureReason = reader.string()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.visibleInHistory = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AlgoState {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      parentId: isSet(object.parentId)
        ? globalThis.String(object.parentId)
        : isSet(object.parent_id)
          ? globalThis.String(object.parent_id)
          : undefined,
      accountIds: globalThis.Array.isArray(object?.accountIds)
        ? object.accountIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.account_ids)
          ? object.account_ids.map((e: any) => globalThis.String(e))
          : [],
      algoType: isSet(object.algoType)
        ? algoTypeFromJSON(object.algoType)
        : isSet(object.algo_type)
          ? algoTypeFromJSON(object.algo_type)
          : 0,
      status: isSet(object.status) ? algoStatusFromJSON(object.status) : 0,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : '0',
      algoData: isSet(object.algoData)
        ? AlgoData.fromJSON(object.algoData)
        : isSet(object.algo_data)
          ? AlgoData.fromJSON(object.algo_data)
          : undefined,
      presetId: isSet(object.presetId)
        ? globalThis.String(object.presetId)
        : isSet(object.preset_id)
          ? globalThis.String(object.preset_id)
          : undefined,
      failureReason: isSet(object.failureReason)
        ? globalThis.String(object.failureReason)
        : isSet(object.failure_reason)
          ? globalThis.String(object.failure_reason)
          : undefined,
      visibleInHistory: isSet(object.visibleInHistory)
        ? globalThis.Boolean(object.visibleInHistory)
        : isSet(object.visible_in_history)
          ? globalThis.Boolean(object.visible_in_history)
          : undefined,
    }
  },

  toJSON(message: AlgoState): unknown {
    const obj: any = {}
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId
    }
    if (message.accountIds?.length) {
      obj.accountIds = message.accountIds
    }
    if (message.algoType !== 0) {
      obj.algoType = algoTypeToJSON(message.algoType)
    }
    if (message.status !== 0) {
      obj.status = algoStatusToJSON(message.status)
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.updatedAt !== '0') {
      obj.updatedAt = message.updatedAt
    }
    if (message.algoData !== undefined) {
      obj.algoData = AlgoData.toJSON(message.algoData)
    }
    if (message.presetId !== undefined) {
      obj.presetId = message.presetId
    }
    if (message.failureReason !== undefined) {
      obj.failureReason = message.failureReason
    }
    if (message.visibleInHistory !== undefined) {
      obj.visibleInHistory = message.visibleInHistory
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AlgoState>, I>>(base?: I): AlgoState {
    return AlgoState.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AlgoState>, I>>(object: I): AlgoState {
    const message = createBaseAlgoState()
    message.id = object.id ?? ''
    message.parentId = object.parentId ?? undefined
    message.accountIds = object.accountIds?.map((e) => e) || []
    message.algoType = object.algoType ?? 0
    message.status = object.status ?? 0
    message.createdAt = object.createdAt ?? '0'
    message.updatedAt = object.updatedAt ?? '0'
    message.algoData =
      object.algoData !== undefined && object.algoData !== null
        ? AlgoData.fromPartial(object.algoData)
        : undefined
    message.presetId = object.presetId ?? undefined
    message.failureReason = object.failureReason ?? undefined
    message.visibleInHistory = object.visibleInHistory ?? undefined
    return message
  },
}

function createBaseAlgoStateList(): AlgoStateList {
  return { algoStates: [] }
}

export const AlgoStateList: MessageFns<AlgoStateList> = {
  encode(message: AlgoStateList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.algoStates) {
      AlgoState.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlgoStateList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAlgoStateList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.algoStates.push(AlgoState.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AlgoStateList {
    return {
      algoStates: globalThis.Array.isArray(object?.algoStates)
        ? object.algoStates.map((e: any) => AlgoState.fromJSON(e))
        : globalThis.Array.isArray(object?.algo_states)
          ? object.algo_states.map((e: any) => AlgoState.fromJSON(e))
          : [],
    }
  },

  toJSON(message: AlgoStateList): unknown {
    const obj: any = {}
    if (message.algoStates?.length) {
      obj.algoStates = message.algoStates.map((e) => AlgoState.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AlgoStateList>, I>>(base?: I): AlgoStateList {
    return AlgoStateList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AlgoStateList>, I>>(object: I): AlgoStateList {
    const message = createBaseAlgoStateList()
    message.algoStates = object.algoStates?.map((e) => AlgoState.fromPartial(e)) || []
    return message
  },
}

function createBaseAlgoData(): AlgoData {
  return {
    twap: undefined,
    limitChase: undefined,
    trigger: undefined,
    hedge: undefined,
    rfq: undefined,
    advancedTwap: undefined,
    spreader: undefined,
    crossExchangeArb: undefined,
    singleHedge: undefined,
    scale: undefined,
    optionsMm: undefined,
  }
}

export const AlgoData: MessageFns<AlgoData> = {
  encode(message: AlgoData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.twap !== undefined) {
      TwapState.encode(message.twap, writer.uint32(10).fork()).join()
    }
    if (message.limitChase !== undefined) {
      LimitChaseState.encode(message.limitChase, writer.uint32(18).fork()).join()
    }
    if (message.trigger !== undefined) {
      TriggerState.encode(message.trigger, writer.uint32(26).fork()).join()
    }
    if (message.hedge !== undefined) {
      HedgeState.encode(message.hedge, writer.uint32(34).fork()).join()
    }
    if (message.rfq !== undefined) {
      RfqAlgoState.encode(message.rfq, writer.uint32(42).fork()).join()
    }
    if (message.advancedTwap !== undefined) {
      AdvancedTwapState.encode(message.advancedTwap, writer.uint32(50).fork()).join()
    }
    if (message.spreader !== undefined) {
      SpreaderState.encode(message.spreader, writer.uint32(58).fork()).join()
    }
    if (message.crossExchangeArb !== undefined) {
      CrossExchangeArbState.encode(message.crossExchangeArb, writer.uint32(66).fork()).join()
    }
    if (message.singleHedge !== undefined) {
      SingleHedgeState.encode(message.singleHedge, writer.uint32(74).fork()).join()
    }
    if (message.scale !== undefined) {
      ScaleState.encode(message.scale, writer.uint32(82).fork()).join()
    }
    if (message.optionsMm !== undefined) {
      OptionsMmState.encode(message.optionsMm, writer.uint32(90).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlgoData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAlgoData()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.twap = TwapState.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.limitChase = LimitChaseState.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.trigger = TriggerState.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.hedge = HedgeState.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.rfq = RfqAlgoState.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.advancedTwap = AdvancedTwapState.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.spreader = SpreaderState.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.crossExchangeArb = CrossExchangeArbState.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.singleHedge = SingleHedgeState.decode(reader, reader.uint32())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.scale = ScaleState.decode(reader, reader.uint32())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.optionsMm = OptionsMmState.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AlgoData {
    return {
      twap: isSet(object.twap) ? TwapState.fromJSON(object.twap) : undefined,
      limitChase: isSet(object.limitChase)
        ? LimitChaseState.fromJSON(object.limitChase)
        : isSet(object.limit_chase)
          ? LimitChaseState.fromJSON(object.limit_chase)
          : undefined,
      trigger: isSet(object.trigger) ? TriggerState.fromJSON(object.trigger) : undefined,
      hedge: isSet(object.hedge) ? HedgeState.fromJSON(object.hedge) : undefined,
      rfq: isSet(object.rfq) ? RfqAlgoState.fromJSON(object.rfq) : undefined,
      advancedTwap: isSet(object.advancedTwap)
        ? AdvancedTwapState.fromJSON(object.advancedTwap)
        : isSet(object.advanced_twap)
          ? AdvancedTwapState.fromJSON(object.advanced_twap)
          : undefined,
      spreader: isSet(object.spreader) ? SpreaderState.fromJSON(object.spreader) : undefined,
      crossExchangeArb: isSet(object.crossExchangeArb)
        ? CrossExchangeArbState.fromJSON(object.crossExchangeArb)
        : isSet(object.cross_exchange_arb)
          ? CrossExchangeArbState.fromJSON(object.cross_exchange_arb)
          : undefined,
      singleHedge: isSet(object.singleHedge)
        ? SingleHedgeState.fromJSON(object.singleHedge)
        : isSet(object.single_hedge)
          ? SingleHedgeState.fromJSON(object.single_hedge)
          : undefined,
      scale: isSet(object.scale) ? ScaleState.fromJSON(object.scale) : undefined,
      optionsMm: isSet(object.optionsMm)
        ? OptionsMmState.fromJSON(object.optionsMm)
        : isSet(object.options_mm)
          ? OptionsMmState.fromJSON(object.options_mm)
          : undefined,
    }
  },

  toJSON(message: AlgoData): unknown {
    const obj: any = {}
    if (message.twap !== undefined) {
      obj.twap = TwapState.toJSON(message.twap)
    }
    if (message.limitChase !== undefined) {
      obj.limitChase = LimitChaseState.toJSON(message.limitChase)
    }
    if (message.trigger !== undefined) {
      obj.trigger = TriggerState.toJSON(message.trigger)
    }
    if (message.hedge !== undefined) {
      obj.hedge = HedgeState.toJSON(message.hedge)
    }
    if (message.rfq !== undefined) {
      obj.rfq = RfqAlgoState.toJSON(message.rfq)
    }
    if (message.advancedTwap !== undefined) {
      obj.advancedTwap = AdvancedTwapState.toJSON(message.advancedTwap)
    }
    if (message.spreader !== undefined) {
      obj.spreader = SpreaderState.toJSON(message.spreader)
    }
    if (message.crossExchangeArb !== undefined) {
      obj.crossExchangeArb = CrossExchangeArbState.toJSON(message.crossExchangeArb)
    }
    if (message.singleHedge !== undefined) {
      obj.singleHedge = SingleHedgeState.toJSON(message.singleHedge)
    }
    if (message.scale !== undefined) {
      obj.scale = ScaleState.toJSON(message.scale)
    }
    if (message.optionsMm !== undefined) {
      obj.optionsMm = OptionsMmState.toJSON(message.optionsMm)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AlgoData>, I>>(base?: I): AlgoData {
    return AlgoData.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AlgoData>, I>>(object: I): AlgoData {
    const message = createBaseAlgoData()
    message.twap =
      object.twap !== undefined && object.twap !== null
        ? TwapState.fromPartial(object.twap)
        : undefined
    message.limitChase =
      object.limitChase !== undefined && object.limitChase !== null
        ? LimitChaseState.fromPartial(object.limitChase)
        : undefined
    message.trigger =
      object.trigger !== undefined && object.trigger !== null
        ? TriggerState.fromPartial(object.trigger)
        : undefined
    message.hedge =
      object.hedge !== undefined && object.hedge !== null
        ? HedgeState.fromPartial(object.hedge)
        : undefined
    message.rfq =
      object.rfq !== undefined && object.rfq !== null
        ? RfqAlgoState.fromPartial(object.rfq)
        : undefined
    message.advancedTwap =
      object.advancedTwap !== undefined && object.advancedTwap !== null
        ? AdvancedTwapState.fromPartial(object.advancedTwap)
        : undefined
    message.spreader =
      object.spreader !== undefined && object.spreader !== null
        ? SpreaderState.fromPartial(object.spreader)
        : undefined
    message.crossExchangeArb =
      object.crossExchangeArb !== undefined && object.crossExchangeArb !== null
        ? CrossExchangeArbState.fromPartial(object.crossExchangeArb)
        : undefined
    message.singleHedge =
      object.singleHedge !== undefined && object.singleHedge !== null
        ? SingleHedgeState.fromPartial(object.singleHedge)
        : undefined
    message.scale =
      object.scale !== undefined && object.scale !== null
        ? ScaleState.fromPartial(object.scale)
        : undefined
    message.optionsMm =
      object.optionsMm !== undefined && object.optionsMm !== null
        ? OptionsMmState.fromPartial(object.optionsMm)
        : undefined
    return message
  },
}

function createBaseHedgeAlgoParams(): HedgeAlgoParams {
  return {
    accountId: '',
    exchange: 0,
    tradeVenue: 0,
    scope: undefined,
    deltaBands: undefined,
    positiveGammaTreatment: undefined,
    hedgeInstrument: undefined,
    replaceOverlapping: undefined,
    passiveTtlMs: undefined,
    maxSlippageBp: undefined,
    fundingSwitchBp: undefined,
    deltaStream: undefined,
    interval: undefined,
  }
}

export const HedgeAlgoParams: MessageFns<HedgeAlgoParams> = {
  encode(message: HedgeAlgoParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(24).int32(message.tradeVenue)
    }
    if (message.scope !== undefined) {
      HedgeScopeResolved.encode(message.scope, writer.uint32(34).fork()).join()
    }
    if (message.deltaBands !== undefined) {
      HedgeDeltaBandsResolved.encode(message.deltaBands, writer.uint32(42).fork()).join()
    }
    if (message.positiveGammaTreatment !== undefined) {
      writer.uint32(48).bool(message.positiveGammaTreatment)
    }
    if (message.hedgeInstrument !== undefined) {
      writer.uint32(58).string(message.hedgeInstrument)
    }
    if (message.replaceOverlapping !== undefined) {
      writer.uint32(80).bool(message.replaceOverlapping)
    }
    if (message.passiveTtlMs !== undefined) {
      writer.uint32(88).int64(message.passiveTtlMs)
    }
    if (message.maxSlippageBp !== undefined) {
      writer.uint32(98).string(message.maxSlippageBp)
    }
    if (message.fundingSwitchBp !== undefined) {
      writer.uint32(106).string(message.fundingSwitchBp)
    }
    if (message.deltaStream !== undefined) {
      DeltaStreamHedgeMode.encode(message.deltaStream, writer.uint32(66).fork()).join()
    }
    if (message.interval !== undefined) {
      IntervalHedgeMode.encode(message.interval, writer.uint32(74).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HedgeAlgoParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHedgeAlgoParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.scope = HedgeScopeResolved.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.deltaBands = HedgeDeltaBandsResolved.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.positiveGammaTreatment = reader.bool()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.hedgeInstrument = reader.string()
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.replaceOverlapping = reader.bool()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.passiveTtlMs = reader.int64().toString()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.maxSlippageBp = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.fundingSwitchBp = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.deltaStream = DeltaStreamHedgeMode.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.interval = IntervalHedgeMode.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HedgeAlgoParams {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      scope: isSet(object.scope) ? HedgeScopeResolved.fromJSON(object.scope) : undefined,
      deltaBands: isSet(object.deltaBands)
        ? HedgeDeltaBandsResolved.fromJSON(object.deltaBands)
        : isSet(object.delta_bands)
          ? HedgeDeltaBandsResolved.fromJSON(object.delta_bands)
          : undefined,
      positiveGammaTreatment: isSet(object.positiveGammaTreatment)
        ? globalThis.Boolean(object.positiveGammaTreatment)
        : isSet(object.positive_gamma_treatment)
          ? globalThis.Boolean(object.positive_gamma_treatment)
          : undefined,
      hedgeInstrument: isSet(object.hedgeInstrument)
        ? globalThis.String(object.hedgeInstrument)
        : isSet(object.hedge_instrument)
          ? globalThis.String(object.hedge_instrument)
          : undefined,
      replaceOverlapping: isSet(object.replaceOverlapping)
        ? globalThis.Boolean(object.replaceOverlapping)
        : isSet(object.replace_overlapping)
          ? globalThis.Boolean(object.replace_overlapping)
          : undefined,
      passiveTtlMs: isSet(object.passiveTtlMs)
        ? globalThis.String(object.passiveTtlMs)
        : isSet(object.passive_ttl_ms)
          ? globalThis.String(object.passive_ttl_ms)
          : undefined,
      maxSlippageBp: isSet(object.maxSlippageBp)
        ? globalThis.String(object.maxSlippageBp)
        : isSet(object.max_slippage_bp)
          ? globalThis.String(object.max_slippage_bp)
          : undefined,
      fundingSwitchBp: isSet(object.fundingSwitchBp)
        ? globalThis.String(object.fundingSwitchBp)
        : isSet(object.funding_switch_bp)
          ? globalThis.String(object.funding_switch_bp)
          : undefined,
      deltaStream: isSet(object.deltaStream)
        ? DeltaStreamHedgeMode.fromJSON(object.deltaStream)
        : isSet(object.delta_stream)
          ? DeltaStreamHedgeMode.fromJSON(object.delta_stream)
          : undefined,
      interval: isSet(object.interval) ? IntervalHedgeMode.fromJSON(object.interval) : undefined,
    }
  },

  toJSON(message: HedgeAlgoParams): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.scope !== undefined) {
      obj.scope = HedgeScopeResolved.toJSON(message.scope)
    }
    if (message.deltaBands !== undefined) {
      obj.deltaBands = HedgeDeltaBandsResolved.toJSON(message.deltaBands)
    }
    if (message.positiveGammaTreatment !== undefined) {
      obj.positiveGammaTreatment = message.positiveGammaTreatment
    }
    if (message.hedgeInstrument !== undefined) {
      obj.hedgeInstrument = message.hedgeInstrument
    }
    if (message.replaceOverlapping !== undefined) {
      obj.replaceOverlapping = message.replaceOverlapping
    }
    if (message.passiveTtlMs !== undefined) {
      obj.passiveTtlMs = message.passiveTtlMs
    }
    if (message.maxSlippageBp !== undefined) {
      obj.maxSlippageBp = message.maxSlippageBp
    }
    if (message.fundingSwitchBp !== undefined) {
      obj.fundingSwitchBp = message.fundingSwitchBp
    }
    if (message.deltaStream !== undefined) {
      obj.deltaStream = DeltaStreamHedgeMode.toJSON(message.deltaStream)
    }
    if (message.interval !== undefined) {
      obj.interval = IntervalHedgeMode.toJSON(message.interval)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HedgeAlgoParams>, I>>(base?: I): HedgeAlgoParams {
    return HedgeAlgoParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HedgeAlgoParams>, I>>(object: I): HedgeAlgoParams {
    const message = createBaseHedgeAlgoParams()
    message.accountId = object.accountId ?? ''
    message.exchange = object.exchange ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.scope =
      object.scope !== undefined && object.scope !== null
        ? HedgeScopeResolved.fromPartial(object.scope)
        : undefined
    message.deltaBands =
      object.deltaBands !== undefined && object.deltaBands !== null
        ? HedgeDeltaBandsResolved.fromPartial(object.deltaBands)
        : undefined
    message.positiveGammaTreatment = object.positiveGammaTreatment ?? undefined
    message.hedgeInstrument = object.hedgeInstrument ?? undefined
    message.replaceOverlapping = object.replaceOverlapping ?? undefined
    message.passiveTtlMs = object.passiveTtlMs ?? undefined
    message.maxSlippageBp = object.maxSlippageBp ?? undefined
    message.fundingSwitchBp = object.fundingSwitchBp ?? undefined
    message.deltaStream =
      object.deltaStream !== undefined && object.deltaStream !== null
        ? DeltaStreamHedgeMode.fromPartial(object.deltaStream)
        : undefined
    message.interval =
      object.interval !== undefined && object.interval !== null
        ? IntervalHedgeMode.fromPartial(object.interval)
        : undefined
    return message
  },
}

function createBaseDeltaStreamHedgeMode(): DeltaStreamHedgeMode {
  return { minReevalMs: undefined }
}

export const DeltaStreamHedgeMode: MessageFns<DeltaStreamHedgeMode> = {
  encode(message: DeltaStreamHedgeMode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.minReevalMs !== undefined) {
      writer.uint32(8).int64(message.minReevalMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeltaStreamHedgeMode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeltaStreamHedgeMode()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.minReevalMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeltaStreamHedgeMode {
    return {
      minReevalMs: isSet(object.minReevalMs)
        ? globalThis.String(object.minReevalMs)
        : isSet(object.min_reeval_ms)
          ? globalThis.String(object.min_reeval_ms)
          : undefined,
    }
  },

  toJSON(message: DeltaStreamHedgeMode): unknown {
    const obj: any = {}
    if (message.minReevalMs !== undefined) {
      obj.minReevalMs = message.minReevalMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeltaStreamHedgeMode>, I>>(base?: I): DeltaStreamHedgeMode {
    return DeltaStreamHedgeMode.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeltaStreamHedgeMode>, I>>(
    object: I
  ): DeltaStreamHedgeMode {
    const message = createBaseDeltaStreamHedgeMode()
    message.minReevalMs = object.minReevalMs ?? undefined
    return message
  },
}

function createBaseIntervalHedgeMode(): IntervalHedgeMode {
  return { intervalSeconds: '0' }
}

export const IntervalHedgeMode: MessageFns<IntervalHedgeMode> = {
  encode(message: IntervalHedgeMode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.intervalSeconds !== '0') {
      writer.uint32(8).int64(message.intervalSeconds)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntervalHedgeMode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseIntervalHedgeMode()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.intervalSeconds = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): IntervalHedgeMode {
    return {
      intervalSeconds: isSet(object.intervalSeconds)
        ? globalThis.String(object.intervalSeconds)
        : isSet(object.interval_seconds)
          ? globalThis.String(object.interval_seconds)
          : '0',
    }
  },

  toJSON(message: IntervalHedgeMode): unknown {
    const obj: any = {}
    if (message.intervalSeconds !== '0') {
      obj.intervalSeconds = message.intervalSeconds
    }
    return obj
  },

  create<I extends Exact<DeepPartial<IntervalHedgeMode>, I>>(base?: I): IntervalHedgeMode {
    return IntervalHedgeMode.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<IntervalHedgeMode>, I>>(object: I): IntervalHedgeMode {
    const message = createBaseIntervalHedgeMode()
    message.intervalSeconds = object.intervalSeconds ?? '0'
    return message
  },
}

function createBaseHedgeScopeResolved(): HedgeScopeResolved {
  return { portfolioUnderlying: undefined, positionGroup: undefined }
}

export const HedgeScopeResolved: MessageFns<HedgeScopeResolved> = {
  encode(message: HedgeScopeResolved, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.portfolioUnderlying !== undefined) {
      AssetRef.encode(message.portfolioUnderlying, writer.uint32(10).fork()).join()
    }
    if (message.positionGroup !== undefined) {
      HedgePositionGroupResolved.encode(message.positionGroup, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HedgeScopeResolved {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHedgeScopeResolved()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.portfolioUnderlying = AssetRef.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.positionGroup = HedgePositionGroupResolved.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HedgeScopeResolved {
    return {
      portfolioUnderlying: isSet(object.portfolioUnderlying)
        ? AssetRef.fromJSON(object.portfolioUnderlying)
        : isSet(object.portfolio_underlying)
          ? AssetRef.fromJSON(object.portfolio_underlying)
          : undefined,
      positionGroup: isSet(object.positionGroup)
        ? HedgePositionGroupResolved.fromJSON(object.positionGroup)
        : isSet(object.position_group)
          ? HedgePositionGroupResolved.fromJSON(object.position_group)
          : undefined,
    }
  },

  toJSON(message: HedgeScopeResolved): unknown {
    const obj: any = {}
    if (message.portfolioUnderlying !== undefined) {
      obj.portfolioUnderlying = AssetRef.toJSON(message.portfolioUnderlying)
    }
    if (message.positionGroup !== undefined) {
      obj.positionGroup = HedgePositionGroupResolved.toJSON(message.positionGroup)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HedgeScopeResolved>, I>>(base?: I): HedgeScopeResolved {
    return HedgeScopeResolved.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HedgeScopeResolved>, I>>(object: I): HedgeScopeResolved {
    const message = createBaseHedgeScopeResolved()
    message.portfolioUnderlying =
      object.portfolioUnderlying !== undefined && object.portfolioUnderlying !== null
        ? AssetRef.fromPartial(object.portfolioUnderlying)
        : undefined
    message.positionGroup =
      object.positionGroup !== undefined && object.positionGroup !== null
        ? HedgePositionGroupResolved.fromPartial(object.positionGroup)
        : undefined
    return message
  },
}

function createBaseHedgePositionGroupResolved(): HedgePositionGroupResolved {
  return { positionSymbols: [], label: undefined }
}

export const HedgePositionGroupResolved: MessageFns<HedgePositionGroupResolved> = {
  encode(
    message: HedgePositionGroupResolved,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.positionSymbols) {
      writer.uint32(10).string(v!)
    }
    if (message.label !== undefined) {
      writer.uint32(18).string(message.label)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HedgePositionGroupResolved {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHedgePositionGroupResolved()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.positionSymbols.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.label = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HedgePositionGroupResolved {
    return {
      positionSymbols: globalThis.Array.isArray(object?.positionSymbols)
        ? object.positionSymbols.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.position_symbols)
          ? object.position_symbols.map((e: any) => globalThis.String(e))
          : [],
      label: isSet(object.label) ? globalThis.String(object.label) : undefined,
    }
  },

  toJSON(message: HedgePositionGroupResolved): unknown {
    const obj: any = {}
    if (message.positionSymbols?.length) {
      obj.positionSymbols = message.positionSymbols
    }
    if (message.label !== undefined) {
      obj.label = message.label
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HedgePositionGroupResolved>, I>>(
    base?: I
  ): HedgePositionGroupResolved {
    return HedgePositionGroupResolved.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HedgePositionGroupResolved>, I>>(
    object: I
  ): HedgePositionGroupResolved {
    const message = createBaseHedgePositionGroupResolved()
    message.positionSymbols = object.positionSymbols?.map((e) => e) || []
    message.label = object.label ?? undefined
    return message
  },
}

function createBaseHedgeDeltaBandsResolved(): HedgeDeltaBandsResolved {
  return {
    acceptable: undefined,
    maxLowPriority: undefined,
    maxMediumPriority: undefined,
    maxHighPriority: undefined,
    minLowPriority: undefined,
    minMediumPriority: undefined,
    minHighPriority: undefined,
    denomination: 0,
  }
}

export const HedgeDeltaBandsResolved: MessageFns<HedgeDeltaBandsResolved> = {
  encode(
    message: HedgeDeltaBandsResolved,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.acceptable !== undefined) {
      HedgeBand.encode(message.acceptable, writer.uint32(10).fork()).join()
    }
    if (message.maxLowPriority !== undefined) {
      HedgePriorityBand.encode(message.maxLowPriority, writer.uint32(18).fork()).join()
    }
    if (message.maxMediumPriority !== undefined) {
      HedgePriorityBand.encode(message.maxMediumPriority, writer.uint32(26).fork()).join()
    }
    if (message.maxHighPriority !== undefined) {
      HedgePriorityBand.encode(message.maxHighPriority, writer.uint32(34).fork()).join()
    }
    if (message.minLowPriority !== undefined) {
      HedgePriorityBand.encode(message.minLowPriority, writer.uint32(42).fork()).join()
    }
    if (message.minMediumPriority !== undefined) {
      HedgePriorityBand.encode(message.minMediumPriority, writer.uint32(50).fork()).join()
    }
    if (message.minHighPriority !== undefined) {
      HedgePriorityBand.encode(message.minHighPriority, writer.uint32(58).fork()).join()
    }
    if (message.denomination !== 0) {
      writer.uint32(64).int32(message.denomination)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HedgeDeltaBandsResolved {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHedgeDeltaBandsResolved()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.acceptable = HedgeBand.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.maxLowPriority = HedgePriorityBand.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.maxMediumPriority = HedgePriorityBand.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.maxHighPriority = HedgePriorityBand.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.minLowPriority = HedgePriorityBand.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.minMediumPriority = HedgePriorityBand.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.minHighPriority = HedgePriorityBand.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HedgeDeltaBandsResolved {
    return {
      acceptable: isSet(object.acceptable) ? HedgeBand.fromJSON(object.acceptable) : undefined,
      maxLowPriority: isSet(object.maxLowPriority)
        ? HedgePriorityBand.fromJSON(object.maxLowPriority)
        : isSet(object.max_low_priority)
          ? HedgePriorityBand.fromJSON(object.max_low_priority)
          : undefined,
      maxMediumPriority: isSet(object.maxMediumPriority)
        ? HedgePriorityBand.fromJSON(object.maxMediumPriority)
        : isSet(object.max_medium_priority)
          ? HedgePriorityBand.fromJSON(object.max_medium_priority)
          : undefined,
      maxHighPriority: isSet(object.maxHighPriority)
        ? HedgePriorityBand.fromJSON(object.maxHighPriority)
        : isSet(object.max_high_priority)
          ? HedgePriorityBand.fromJSON(object.max_high_priority)
          : undefined,
      minLowPriority: isSet(object.minLowPriority)
        ? HedgePriorityBand.fromJSON(object.minLowPriority)
        : isSet(object.min_low_priority)
          ? HedgePriorityBand.fromJSON(object.min_low_priority)
          : undefined,
      minMediumPriority: isSet(object.minMediumPriority)
        ? HedgePriorityBand.fromJSON(object.minMediumPriority)
        : isSet(object.min_medium_priority)
          ? HedgePriorityBand.fromJSON(object.min_medium_priority)
          : undefined,
      minHighPriority: isSet(object.minHighPriority)
        ? HedgePriorityBand.fromJSON(object.minHighPriority)
        : isSet(object.min_high_priority)
          ? HedgePriorityBand.fromJSON(object.min_high_priority)
          : undefined,
      denomination: isSet(object.denomination)
        ? hedgeDeltaDenominationFromJSON(object.denomination)
        : 0,
    }
  },

  toJSON(message: HedgeDeltaBandsResolved): unknown {
    const obj: any = {}
    if (message.acceptable !== undefined) {
      obj.acceptable = HedgeBand.toJSON(message.acceptable)
    }
    if (message.maxLowPriority !== undefined) {
      obj.maxLowPriority = HedgePriorityBand.toJSON(message.maxLowPriority)
    }
    if (message.maxMediumPriority !== undefined) {
      obj.maxMediumPriority = HedgePriorityBand.toJSON(message.maxMediumPriority)
    }
    if (message.maxHighPriority !== undefined) {
      obj.maxHighPriority = HedgePriorityBand.toJSON(message.maxHighPriority)
    }
    if (message.minLowPriority !== undefined) {
      obj.minLowPriority = HedgePriorityBand.toJSON(message.minLowPriority)
    }
    if (message.minMediumPriority !== undefined) {
      obj.minMediumPriority = HedgePriorityBand.toJSON(message.minMediumPriority)
    }
    if (message.minHighPriority !== undefined) {
      obj.minHighPriority = HedgePriorityBand.toJSON(message.minHighPriority)
    }
    if (message.denomination !== 0) {
      obj.denomination = hedgeDeltaDenominationToJSON(message.denomination)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HedgeDeltaBandsResolved>, I>>(
    base?: I
  ): HedgeDeltaBandsResolved {
    return HedgeDeltaBandsResolved.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HedgeDeltaBandsResolved>, I>>(
    object: I
  ): HedgeDeltaBandsResolved {
    const message = createBaseHedgeDeltaBandsResolved()
    message.acceptable =
      object.acceptable !== undefined && object.acceptable !== null
        ? HedgeBand.fromPartial(object.acceptable)
        : undefined
    message.maxLowPriority =
      object.maxLowPriority !== undefined && object.maxLowPriority !== null
        ? HedgePriorityBand.fromPartial(object.maxLowPriority)
        : undefined
    message.maxMediumPriority =
      object.maxMediumPriority !== undefined && object.maxMediumPriority !== null
        ? HedgePriorityBand.fromPartial(object.maxMediumPriority)
        : undefined
    message.maxHighPriority =
      object.maxHighPriority !== undefined && object.maxHighPriority !== null
        ? HedgePriorityBand.fromPartial(object.maxHighPriority)
        : undefined
    message.minLowPriority =
      object.minLowPriority !== undefined && object.minLowPriority !== null
        ? HedgePriorityBand.fromPartial(object.minLowPriority)
        : undefined
    message.minMediumPriority =
      object.minMediumPriority !== undefined && object.minMediumPriority !== null
        ? HedgePriorityBand.fromPartial(object.minMediumPriority)
        : undefined
    message.minHighPriority =
      object.minHighPriority !== undefined && object.minHighPriority !== null
        ? HedgePriorityBand.fromPartial(object.minHighPriority)
        : undefined
    message.denomination = object.denomination ?? 0
    return message
  },
}

function createBaseHedgeBand(): HedgeBand {
  return { from: '', to: '', target: '' }
}

export const HedgeBand: MessageFns<HedgeBand> = {
  encode(message: HedgeBand, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.from !== '') {
      writer.uint32(10).string(message.from)
    }
    if (message.to !== '') {
      writer.uint32(18).string(message.to)
    }
    if (message.target !== '') {
      writer.uint32(26).string(message.target)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HedgeBand {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHedgeBand()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.from = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.to = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.target = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HedgeBand {
    return {
      from: isSet(object.from) ? globalThis.String(object.from) : '',
      to: isSet(object.to) ? globalThis.String(object.to) : '',
      target: isSet(object.target) ? globalThis.String(object.target) : '',
    }
  },

  toJSON(message: HedgeBand): unknown {
    const obj: any = {}
    if (message.from !== '') {
      obj.from = message.from
    }
    if (message.to !== '') {
      obj.to = message.to
    }
    if (message.target !== '') {
      obj.target = message.target
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HedgeBand>, I>>(base?: I): HedgeBand {
    return HedgeBand.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HedgeBand>, I>>(object: I): HedgeBand {
    const message = createBaseHedgeBand()
    message.from = object.from ?? ''
    message.to = object.to ?? ''
    message.target = object.target ?? ''
    return message
  },
}

function createBaseHedgePriorityBand(): HedgePriorityBand {
  return { from: '', to: '', target: '', mechanism: 0, twapDurationSeconds: undefined }
}

export const HedgePriorityBand: MessageFns<HedgePriorityBand> = {
  encode(message: HedgePriorityBand, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.from !== '') {
      writer.uint32(10).string(message.from)
    }
    if (message.to !== '') {
      writer.uint32(18).string(message.to)
    }
    if (message.target !== '') {
      writer.uint32(26).string(message.target)
    }
    if (message.mechanism !== 0) {
      writer.uint32(32).int32(message.mechanism)
    }
    if (message.twapDurationSeconds !== undefined) {
      writer.uint32(40).int64(message.twapDurationSeconds)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HedgePriorityBand {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHedgePriorityBand()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.from = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.to = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.target = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.mechanism = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.twapDurationSeconds = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HedgePriorityBand {
    return {
      from: isSet(object.from) ? globalThis.String(object.from) : '',
      to: isSet(object.to) ? globalThis.String(object.to) : '',
      target: isSet(object.target) ? globalThis.String(object.target) : '',
      mechanism: isSet(object.mechanism) ? hedgeMechanismFromJSON(object.mechanism) : 0,
      twapDurationSeconds: isSet(object.twapDurationSeconds)
        ? globalThis.String(object.twapDurationSeconds)
        : isSet(object.twap_duration_seconds)
          ? globalThis.String(object.twap_duration_seconds)
          : undefined,
    }
  },

  toJSON(message: HedgePriorityBand): unknown {
    const obj: any = {}
    if (message.from !== '') {
      obj.from = message.from
    }
    if (message.to !== '') {
      obj.to = message.to
    }
    if (message.target !== '') {
      obj.target = message.target
    }
    if (message.mechanism !== 0) {
      obj.mechanism = hedgeMechanismToJSON(message.mechanism)
    }
    if (message.twapDurationSeconds !== undefined) {
      obj.twapDurationSeconds = message.twapDurationSeconds
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HedgePriorityBand>, I>>(base?: I): HedgePriorityBand {
    return HedgePriorityBand.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HedgePriorityBand>, I>>(object: I): HedgePriorityBand {
    const message = createBaseHedgePriorityBand()
    message.from = object.from ?? ''
    message.to = object.to ?? ''
    message.target = object.target ?? ''
    message.mechanism = object.mechanism ?? 0
    message.twapDurationSeconds = object.twapDurationSeconds ?? undefined
    return message
  },
}

function createBaseHedgeState(): HedgeState {
  return {
    id: '',
    accountId: '',
    hedgeInstrument: '',
    scope: undefined,
    deltaBands: undefined,
    denomination: 0,
    currentDelta: '',
    currentGamma: '',
    activeBand: '',
    activeChildAlgoId: undefined,
    positiveGammaTreatment: false,
    createdAt: '0',
    updatedAt: '0',
    exchange: 0,
    tradeVenue: 0,
    inlineCounter: 0,
    deltaStream: undefined,
    interval: undefined,
  }
}

export const HedgeState: MessageFns<HedgeState> = {
  encode(message: HedgeState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== '') {
      writer.uint32(10).string(message.id)
    }
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    if (message.hedgeInstrument !== '') {
      writer.uint32(26).string(message.hedgeInstrument)
    }
    if (message.scope !== undefined) {
      HedgeScopeResolved.encode(message.scope, writer.uint32(34).fork()).join()
    }
    if (message.deltaBands !== undefined) {
      HedgeDeltaBandsResolved.encode(message.deltaBands, writer.uint32(42).fork()).join()
    }
    if (message.denomination !== 0) {
      writer.uint32(48).int32(message.denomination)
    }
    if (message.currentDelta !== '') {
      writer.uint32(58).string(message.currentDelta)
    }
    if (message.currentGamma !== '') {
      writer.uint32(66).string(message.currentGamma)
    }
    if (message.activeBand !== '') {
      writer.uint32(74).string(message.activeBand)
    }
    if (message.activeChildAlgoId !== undefined) {
      writer.uint32(82).string(message.activeChildAlgoId)
    }
    if (message.positiveGammaTreatment !== false) {
      writer.uint32(88).bool(message.positiveGammaTreatment)
    }
    if (message.createdAt !== '0') {
      writer.uint32(96).int64(message.createdAt)
    }
    if (message.updatedAt !== '0') {
      writer.uint32(104).int64(message.updatedAt)
    }
    if (message.exchange !== 0) {
      writer.uint32(112).int32(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(120).int32(message.tradeVenue)
    }
    if (message.inlineCounter !== 0) {
      writer.uint32(144).int32(message.inlineCounter)
    }
    if (message.deltaStream !== undefined) {
      DeltaStreamHedgeMode.encode(message.deltaStream, writer.uint32(130).fork()).join()
    }
    if (message.interval !== undefined) {
      IntervalHedgeMode.encode(message.interval, writer.uint32(138).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HedgeState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHedgeState()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.hedgeInstrument = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.scope = HedgeScopeResolved.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.deltaBands = HedgeDeltaBandsResolved.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.currentDelta = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.currentGamma = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.activeBand = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.activeChildAlgoId = reader.string()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.positiveGammaTreatment = reader.bool()
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.updatedAt = reader.int64().toString()
          continue
        }
        case 14: {
          if (tag !== 112) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 18: {
          if (tag !== 144) {
            break
          }

          message.inlineCounter = reader.int32()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.deltaStream = DeltaStreamHedgeMode.decode(reader, reader.uint32())
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.interval = IntervalHedgeMode.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HedgeState {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      hedgeInstrument: isSet(object.hedgeInstrument)
        ? globalThis.String(object.hedgeInstrument)
        : isSet(object.hedge_instrument)
          ? globalThis.String(object.hedge_instrument)
          : '',
      scope: isSet(object.scope) ? HedgeScopeResolved.fromJSON(object.scope) : undefined,
      deltaBands: isSet(object.deltaBands)
        ? HedgeDeltaBandsResolved.fromJSON(object.deltaBands)
        : isSet(object.delta_bands)
          ? HedgeDeltaBandsResolved.fromJSON(object.delta_bands)
          : undefined,
      denomination: isSet(object.denomination)
        ? hedgeDeltaDenominationFromJSON(object.denomination)
        : 0,
      currentDelta: isSet(object.currentDelta)
        ? globalThis.String(object.currentDelta)
        : isSet(object.current_delta)
          ? globalThis.String(object.current_delta)
          : '',
      currentGamma: isSet(object.currentGamma)
        ? globalThis.String(object.currentGamma)
        : isSet(object.current_gamma)
          ? globalThis.String(object.current_gamma)
          : '',
      activeBand: isSet(object.activeBand)
        ? globalThis.String(object.activeBand)
        : isSet(object.active_band)
          ? globalThis.String(object.active_band)
          : '',
      activeChildAlgoId: isSet(object.activeChildAlgoId)
        ? globalThis.String(object.activeChildAlgoId)
        : isSet(object.active_child_algo_id)
          ? globalThis.String(object.active_child_algo_id)
          : undefined,
      positiveGammaTreatment: isSet(object.positiveGammaTreatment)
        ? globalThis.Boolean(object.positiveGammaTreatment)
        : isSet(object.positive_gamma_treatment)
          ? globalThis.Boolean(object.positive_gamma_treatment)
          : false,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      inlineCounter: isSet(object.inlineCounter)
        ? globalThis.Number(object.inlineCounter)
        : isSet(object.inline_counter)
          ? globalThis.Number(object.inline_counter)
          : 0,
      deltaStream: isSet(object.deltaStream)
        ? DeltaStreamHedgeMode.fromJSON(object.deltaStream)
        : isSet(object.delta_stream)
          ? DeltaStreamHedgeMode.fromJSON(object.delta_stream)
          : undefined,
      interval: isSet(object.interval) ? IntervalHedgeMode.fromJSON(object.interval) : undefined,
    }
  },

  toJSON(message: HedgeState): unknown {
    const obj: any = {}
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.hedgeInstrument !== '') {
      obj.hedgeInstrument = message.hedgeInstrument
    }
    if (message.scope !== undefined) {
      obj.scope = HedgeScopeResolved.toJSON(message.scope)
    }
    if (message.deltaBands !== undefined) {
      obj.deltaBands = HedgeDeltaBandsResolved.toJSON(message.deltaBands)
    }
    if (message.denomination !== 0) {
      obj.denomination = hedgeDeltaDenominationToJSON(message.denomination)
    }
    if (message.currentDelta !== '') {
      obj.currentDelta = message.currentDelta
    }
    if (message.currentGamma !== '') {
      obj.currentGamma = message.currentGamma
    }
    if (message.activeBand !== '') {
      obj.activeBand = message.activeBand
    }
    if (message.activeChildAlgoId !== undefined) {
      obj.activeChildAlgoId = message.activeChildAlgoId
    }
    if (message.positiveGammaTreatment !== false) {
      obj.positiveGammaTreatment = message.positiveGammaTreatment
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.updatedAt !== '0') {
      obj.updatedAt = message.updatedAt
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.inlineCounter !== 0) {
      obj.inlineCounter = Math.round(message.inlineCounter)
    }
    if (message.deltaStream !== undefined) {
      obj.deltaStream = DeltaStreamHedgeMode.toJSON(message.deltaStream)
    }
    if (message.interval !== undefined) {
      obj.interval = IntervalHedgeMode.toJSON(message.interval)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HedgeState>, I>>(base?: I): HedgeState {
    return HedgeState.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HedgeState>, I>>(object: I): HedgeState {
    const message = createBaseHedgeState()
    message.id = object.id ?? ''
    message.accountId = object.accountId ?? ''
    message.hedgeInstrument = object.hedgeInstrument ?? ''
    message.scope =
      object.scope !== undefined && object.scope !== null
        ? HedgeScopeResolved.fromPartial(object.scope)
        : undefined
    message.deltaBands =
      object.deltaBands !== undefined && object.deltaBands !== null
        ? HedgeDeltaBandsResolved.fromPartial(object.deltaBands)
        : undefined
    message.denomination = object.denomination ?? 0
    message.currentDelta = object.currentDelta ?? ''
    message.currentGamma = object.currentGamma ?? ''
    message.activeBand = object.activeBand ?? ''
    message.activeChildAlgoId = object.activeChildAlgoId ?? undefined
    message.positiveGammaTreatment = object.positiveGammaTreatment ?? false
    message.createdAt = object.createdAt ?? '0'
    message.updatedAt = object.updatedAt ?? '0'
    message.exchange = object.exchange ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.inlineCounter = object.inlineCounter ?? 0
    message.deltaStream =
      object.deltaStream !== undefined && object.deltaStream !== null
        ? DeltaStreamHedgeMode.fromPartial(object.deltaStream)
        : undefined
    message.interval =
      object.interval !== undefined && object.interval !== null
        ? IntervalHedgeMode.fromPartial(object.interval)
        : undefined
    return message
  },
}

function createBaseTriggerState(): TriggerState {
  return {
    id: '',
    accountId: '',
    triggerId: '',
    registrationId: '',
    trigger: undefined,
    dispatch: [],
    dispatchStatus: 0,
    createdAt: '0',
    updatedAt: '0',
    firedAtMs: undefined,
    lastError: undefined,
    exchange: 0,
    tradeVenue: 0,
  }
}

export const TriggerState: MessageFns<TriggerState> = {
  encode(message: TriggerState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== '') {
      writer.uint32(10).string(message.id)
    }
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    if (message.triggerId !== '') {
      writer.uint32(26).string(message.triggerId)
    }
    if (message.registrationId !== '') {
      writer.uint32(34).string(message.registrationId)
    }
    if (message.trigger !== undefined) {
      Trigger.encode(message.trigger, writer.uint32(42).fork()).join()
    }
    for (const v of message.dispatch) {
      TriggerDispatchEnvelope.encode(v!, writer.uint32(50).fork()).join()
    }
    if (message.dispatchStatus !== 0) {
      writer.uint32(56).int32(message.dispatchStatus)
    }
    if (message.createdAt !== '0') {
      writer.uint32(64).int64(message.createdAt)
    }
    if (message.updatedAt !== '0') {
      writer.uint32(72).int64(message.updatedAt)
    }
    if (message.firedAtMs !== undefined) {
      writer.uint32(80).int64(message.firedAtMs)
    }
    if (message.lastError !== undefined) {
      writer.uint32(90).string(message.lastError)
    }
    if (message.exchange !== 0) {
      writer.uint32(96).int32(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(104).int32(message.tradeVenue)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TriggerState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTriggerState()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.triggerId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.registrationId = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.trigger = Trigger.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.dispatch.push(TriggerDispatchEnvelope.decode(reader, reader.uint32()))
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.dispatchStatus = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.updatedAt = reader.int64().toString()
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.firedAtMs = reader.int64().toString()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.lastError = reader.string()
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TriggerState {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      triggerId: isSet(object.triggerId)
        ? globalThis.String(object.triggerId)
        : isSet(object.trigger_id)
          ? globalThis.String(object.trigger_id)
          : '',
      registrationId: isSet(object.registrationId)
        ? globalThis.String(object.registrationId)
        : isSet(object.registration_id)
          ? globalThis.String(object.registration_id)
          : '',
      trigger: isSet(object.trigger) ? Trigger.fromJSON(object.trigger) : undefined,
      dispatch: globalThis.Array.isArray(object?.dispatch)
        ? object.dispatch.map((e: any) => TriggerDispatchEnvelope.fromJSON(e))
        : [],
      dispatchStatus: isSet(object.dispatchStatus)
        ? triggerDispatchStatusFromJSON(object.dispatchStatus)
        : isSet(object.dispatch_status)
          ? triggerDispatchStatusFromJSON(object.dispatch_status)
          : 0,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : '0',
      firedAtMs: isSet(object.firedAtMs)
        ? globalThis.String(object.firedAtMs)
        : isSet(object.fired_at_ms)
          ? globalThis.String(object.fired_at_ms)
          : undefined,
      lastError: isSet(object.lastError)
        ? globalThis.String(object.lastError)
        : isSet(object.last_error)
          ? globalThis.String(object.last_error)
          : undefined,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
    }
  },

  toJSON(message: TriggerState): unknown {
    const obj: any = {}
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.triggerId !== '') {
      obj.triggerId = message.triggerId
    }
    if (message.registrationId !== '') {
      obj.registrationId = message.registrationId
    }
    if (message.trigger !== undefined) {
      obj.trigger = Trigger.toJSON(message.trigger)
    }
    if (message.dispatch?.length) {
      obj.dispatch = message.dispatch.map((e) => TriggerDispatchEnvelope.toJSON(e))
    }
    if (message.dispatchStatus !== 0) {
      obj.dispatchStatus = triggerDispatchStatusToJSON(message.dispatchStatus)
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.updatedAt !== '0') {
      obj.updatedAt = message.updatedAt
    }
    if (message.firedAtMs !== undefined) {
      obj.firedAtMs = message.firedAtMs
    }
    if (message.lastError !== undefined) {
      obj.lastError = message.lastError
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TriggerState>, I>>(base?: I): TriggerState {
    return TriggerState.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TriggerState>, I>>(object: I): TriggerState {
    const message = createBaseTriggerState()
    message.id = object.id ?? ''
    message.accountId = object.accountId ?? ''
    message.triggerId = object.triggerId ?? ''
    message.registrationId = object.registrationId ?? ''
    message.trigger =
      object.trigger !== undefined && object.trigger !== null
        ? Trigger.fromPartial(object.trigger)
        : undefined
    message.dispatch = object.dispatch?.map((e) => TriggerDispatchEnvelope.fromPartial(e)) || []
    message.dispatchStatus = object.dispatchStatus ?? 0
    message.createdAt = object.createdAt ?? '0'
    message.updatedAt = object.updatedAt ?? '0'
    message.firedAtMs = object.firedAtMs ?? undefined
    message.lastError = object.lastError ?? undefined
    message.exchange = object.exchange ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    return message
  },
}

function createBaseLimitChaseState(): LimitChaseState {
  return {
    id: '',
    accountId: '',
    symbol: '',
    totalQuantity: '',
    filledQuantity: '',
    direction: 0,
    denomination: 0,
    exchange: 0,
    activeOrderId: undefined,
    activePrice: undefined,
    tradeVenue: 0,
    reduceOnly: undefined,
    validForSeconds: undefined,
    catchup: undefined,
    expiresAt: undefined,
    nextCounter: 0,
  }
}

export const LimitChaseState: MessageFns<LimitChaseState> = {
  encode(message: LimitChaseState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== '') {
      writer.uint32(10).string(message.id)
    }
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    if (message.symbol !== '') {
      writer.uint32(26).string(message.symbol)
    }
    if (message.totalQuantity !== '') {
      writer.uint32(34).string(message.totalQuantity)
    }
    if (message.filledQuantity !== '') {
      writer.uint32(42).string(message.filledQuantity)
    }
    if (message.direction !== 0) {
      writer.uint32(48).int32(message.direction)
    }
    if (message.denomination !== 0) {
      writer.uint32(56).int32(message.denomination)
    }
    if (message.exchange !== 0) {
      writer.uint32(64).int32(message.exchange)
    }
    if (message.activeOrderId !== undefined) {
      writer.uint32(74).string(message.activeOrderId)
    }
    if (message.activePrice !== undefined) {
      writer.uint32(82).string(message.activePrice)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(88).int32(message.tradeVenue)
    }
    if (message.reduceOnly !== undefined) {
      writer.uint32(96).bool(message.reduceOnly)
    }
    if (message.validForSeconds !== undefined) {
      writer.uint32(104).int64(message.validForSeconds)
    }
    if (message.catchup !== undefined) {
      TwapCadence.encode(message.catchup, writer.uint32(114).fork()).join()
    }
    if (message.expiresAt !== undefined) {
      writer.uint32(120).int64(message.expiresAt)
    }
    if (message.nextCounter !== 0) {
      writer.uint32(128).int32(message.nextCounter)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LimitChaseState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLimitChaseState()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.totalQuantity = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.filledQuantity = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.direction = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.activeOrderId = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.activePrice = reader.string()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.reduceOnly = reader.bool()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.validForSeconds = reader.int64().toString()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.catchup = TwapCadence.decode(reader, reader.uint32())
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.expiresAt = reader.int64().toString()
          continue
        }
        case 16: {
          if (tag !== 128) {
            break
          }

          message.nextCounter = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LimitChaseState {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      totalQuantity: isSet(object.totalQuantity)
        ? globalThis.String(object.totalQuantity)
        : isSet(object.total_quantity)
          ? globalThis.String(object.total_quantity)
          : '',
      filledQuantity: isSet(object.filledQuantity)
        ? globalThis.String(object.filledQuantity)
        : isSet(object.filled_quantity)
          ? globalThis.String(object.filled_quantity)
          : '',
      direction: isSet(object.direction) ? orderSideFromJSON(object.direction) : 0,
      denomination: isSet(object.denomination) ? denominationFromJSON(object.denomination) : 0,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      activeOrderId: isSet(object.activeOrderId)
        ? globalThis.String(object.activeOrderId)
        : isSet(object.active_order_id)
          ? globalThis.String(object.active_order_id)
          : undefined,
      activePrice: isSet(object.activePrice)
        ? globalThis.String(object.activePrice)
        : isSet(object.active_price)
          ? globalThis.String(object.active_price)
          : undefined,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      reduceOnly: isSet(object.reduceOnly)
        ? globalThis.Boolean(object.reduceOnly)
        : isSet(object.reduce_only)
          ? globalThis.Boolean(object.reduce_only)
          : undefined,
      validForSeconds: isSet(object.validForSeconds)
        ? globalThis.String(object.validForSeconds)
        : isSet(object.valid_for_seconds)
          ? globalThis.String(object.valid_for_seconds)
          : undefined,
      catchup: isSet(object.catchup) ? TwapCadence.fromJSON(object.catchup) : undefined,
      expiresAt: isSet(object.expiresAt)
        ? globalThis.String(object.expiresAt)
        : isSet(object.expires_at)
          ? globalThis.String(object.expires_at)
          : undefined,
      nextCounter: isSet(object.nextCounter)
        ? globalThis.Number(object.nextCounter)
        : isSet(object.next_counter)
          ? globalThis.Number(object.next_counter)
          : 0,
    }
  },

  toJSON(message: LimitChaseState): unknown {
    const obj: any = {}
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.totalQuantity !== '') {
      obj.totalQuantity = message.totalQuantity
    }
    if (message.filledQuantity !== '') {
      obj.filledQuantity = message.filledQuantity
    }
    if (message.direction !== 0) {
      obj.direction = orderSideToJSON(message.direction)
    }
    if (message.denomination !== 0) {
      obj.denomination = denominationToJSON(message.denomination)
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.activeOrderId !== undefined) {
      obj.activeOrderId = message.activeOrderId
    }
    if (message.activePrice !== undefined) {
      obj.activePrice = message.activePrice
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.reduceOnly !== undefined) {
      obj.reduceOnly = message.reduceOnly
    }
    if (message.validForSeconds !== undefined) {
      obj.validForSeconds = message.validForSeconds
    }
    if (message.catchup !== undefined) {
      obj.catchup = TwapCadence.toJSON(message.catchup)
    }
    if (message.expiresAt !== undefined) {
      obj.expiresAt = message.expiresAt
    }
    if (message.nextCounter !== 0) {
      obj.nextCounter = Math.round(message.nextCounter)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LimitChaseState>, I>>(base?: I): LimitChaseState {
    return LimitChaseState.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LimitChaseState>, I>>(object: I): LimitChaseState {
    const message = createBaseLimitChaseState()
    message.id = object.id ?? ''
    message.accountId = object.accountId ?? ''
    message.symbol = object.symbol ?? ''
    message.totalQuantity = object.totalQuantity ?? ''
    message.filledQuantity = object.filledQuantity ?? ''
    message.direction = object.direction ?? 0
    message.denomination = object.denomination ?? 0
    message.exchange = object.exchange ?? 0
    message.activeOrderId = object.activeOrderId ?? undefined
    message.activePrice = object.activePrice ?? undefined
    message.tradeVenue = object.tradeVenue ?? 0
    message.reduceOnly = object.reduceOnly ?? undefined
    message.validForSeconds = object.validForSeconds ?? undefined
    message.catchup =
      object.catchup !== undefined && object.catchup !== null
        ? TwapCadence.fromPartial(object.catchup)
        : undefined
    message.expiresAt = object.expiresAt ?? undefined
    message.nextCounter = object.nextCounter ?? 0
    return message
  },
}

function createBaseTwapState(): TwapState {
  return {
    symbol: '',
    remainingQuantity: '',
    frequency: undefined,
    orderSize: undefined,
    direction: 0,
    nextExecutionTime: '0',
    totalQuantity: '',
    accountId: '',
    id: '',
    denomination: 0,
    orderCounter: 0,
    exchange: 0,
    tradeVenue: 0,
    limitPrice: undefined,
    reduceOnly: undefined,
  }
}

export const TwapState: MessageFns<TwapState> = {
  encode(message: TwapState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.remainingQuantity !== '') {
      writer.uint32(18).string(message.remainingQuantity)
    }
    if (message.frequency !== undefined) {
      Frequency.encode(message.frequency, writer.uint32(26).fork()).join()
    }
    if (message.orderSize !== undefined) {
      OrderSize.encode(message.orderSize, writer.uint32(34).fork()).join()
    }
    if (message.direction !== 0) {
      writer.uint32(48).int32(message.direction)
    }
    if (message.nextExecutionTime !== '0') {
      writer.uint32(56).int64(message.nextExecutionTime)
    }
    if (message.totalQuantity !== '') {
      writer.uint32(66).string(message.totalQuantity)
    }
    if (message.accountId !== '') {
      writer.uint32(74).string(message.accountId)
    }
    if (message.id !== '') {
      writer.uint32(82).string(message.id)
    }
    if (message.denomination !== 0) {
      writer.uint32(88).int32(message.denomination)
    }
    if (message.orderCounter !== 0) {
      writer.uint32(96).int32(message.orderCounter)
    }
    if (message.exchange !== 0) {
      writer.uint32(104).int32(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(112).int32(message.tradeVenue)
    }
    if (message.limitPrice !== undefined) {
      writer.uint32(122).string(message.limitPrice)
    }
    if (message.reduceOnly !== undefined) {
      writer.uint32(128).bool(message.reduceOnly)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TwapState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTwapState()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.remainingQuantity = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.frequency = Frequency.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.orderSize = OrderSize.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.direction = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.nextExecutionTime = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.totalQuantity = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.orderCounter = reader.int32()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 14: {
          if (tag !== 112) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.limitPrice = reader.string()
          continue
        }
        case 16: {
          if (tag !== 128) {
            break
          }

          message.reduceOnly = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TwapState {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      remainingQuantity: isSet(object.remainingQuantity)
        ? globalThis.String(object.remainingQuantity)
        : isSet(object.remaining_quantity)
          ? globalThis.String(object.remaining_quantity)
          : '',
      frequency: isSet(object.frequency) ? Frequency.fromJSON(object.frequency) : undefined,
      orderSize: isSet(object.orderSize)
        ? OrderSize.fromJSON(object.orderSize)
        : isSet(object.order_size)
          ? OrderSize.fromJSON(object.order_size)
          : undefined,
      direction: isSet(object.direction) ? orderSideFromJSON(object.direction) : 0,
      nextExecutionTime: isSet(object.nextExecutionTime)
        ? globalThis.String(object.nextExecutionTime)
        : isSet(object.next_execution_time)
          ? globalThis.String(object.next_execution_time)
          : '0',
      totalQuantity: isSet(object.totalQuantity)
        ? globalThis.String(object.totalQuantity)
        : isSet(object.total_quantity)
          ? globalThis.String(object.total_quantity)
          : '',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      denomination: isSet(object.denomination) ? denominationFromJSON(object.denomination) : 0,
      orderCounter: isSet(object.orderCounter)
        ? globalThis.Number(object.orderCounter)
        : isSet(object.order_counter)
          ? globalThis.Number(object.order_counter)
          : 0,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      limitPrice: isSet(object.limitPrice)
        ? globalThis.String(object.limitPrice)
        : isSet(object.limit_price)
          ? globalThis.String(object.limit_price)
          : undefined,
      reduceOnly: isSet(object.reduceOnly)
        ? globalThis.Boolean(object.reduceOnly)
        : isSet(object.reduce_only)
          ? globalThis.Boolean(object.reduce_only)
          : undefined,
    }
  },

  toJSON(message: TwapState): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.remainingQuantity !== '') {
      obj.remainingQuantity = message.remainingQuantity
    }
    if (message.frequency !== undefined) {
      obj.frequency = Frequency.toJSON(message.frequency)
    }
    if (message.orderSize !== undefined) {
      obj.orderSize = OrderSize.toJSON(message.orderSize)
    }
    if (message.direction !== 0) {
      obj.direction = orderSideToJSON(message.direction)
    }
    if (message.nextExecutionTime !== '0') {
      obj.nextExecutionTime = message.nextExecutionTime
    }
    if (message.totalQuantity !== '') {
      obj.totalQuantity = message.totalQuantity
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.denomination !== 0) {
      obj.denomination = denominationToJSON(message.denomination)
    }
    if (message.orderCounter !== 0) {
      obj.orderCounter = Math.round(message.orderCounter)
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.limitPrice !== undefined) {
      obj.limitPrice = message.limitPrice
    }
    if (message.reduceOnly !== undefined) {
      obj.reduceOnly = message.reduceOnly
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TwapState>, I>>(base?: I): TwapState {
    return TwapState.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TwapState>, I>>(object: I): TwapState {
    const message = createBaseTwapState()
    message.symbol = object.symbol ?? ''
    message.remainingQuantity = object.remainingQuantity ?? ''
    message.frequency =
      object.frequency !== undefined && object.frequency !== null
        ? Frequency.fromPartial(object.frequency)
        : undefined
    message.orderSize =
      object.orderSize !== undefined && object.orderSize !== null
        ? OrderSize.fromPartial(object.orderSize)
        : undefined
    message.direction = object.direction ?? 0
    message.nextExecutionTime = object.nextExecutionTime ?? '0'
    message.totalQuantity = object.totalQuantity ?? ''
    message.accountId = object.accountId ?? ''
    message.id = object.id ?? ''
    message.denomination = object.denomination ?? 0
    message.orderCounter = object.orderCounter ?? 0
    message.exchange = object.exchange ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.limitPrice = object.limitPrice ?? undefined
    message.reduceOnly = object.reduceOnly ?? undefined
    return message
  },
}

function createBaseSingleHedgeAlgoParams(): SingleHedgeAlgoParams {
  return {
    accountId: '',
    exchange: 0,
    tradeVenue: 0,
    scope: undefined,
    hedgeInstrument: undefined,
    target: undefined,
    denomination: 0,
    execution: 0,
    preview: [],
    twapDurationSeconds: undefined,
    autoTwapBaseThreshold: undefined,
    autoTwapQuoteThreshold: undefined,
  }
}

export const SingleHedgeAlgoParams: MessageFns<SingleHedgeAlgoParams> = {
  encode(message: SingleHedgeAlgoParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(24).int32(message.tradeVenue)
    }
    if (message.scope !== undefined) {
      HedgeScopeResolved.encode(message.scope, writer.uint32(34).fork()).join()
    }
    if (message.hedgeInstrument !== undefined) {
      writer.uint32(42).string(message.hedgeInstrument)
    }
    if (message.target !== undefined) {
      writer.uint32(50).string(message.target)
    }
    if (message.denomination !== 0) {
      writer.uint32(56).int32(message.denomination)
    }
    if (message.execution !== 0) {
      writer.uint32(64).int32(message.execution)
    }
    for (const v of message.preview) {
      SingleHedgeLegPreview.encode(v!, writer.uint32(74).fork()).join()
    }
    if (message.twapDurationSeconds !== undefined) {
      writer.uint32(80).int64(message.twapDurationSeconds)
    }
    if (message.autoTwapBaseThreshold !== undefined) {
      writer.uint32(90).string(message.autoTwapBaseThreshold)
    }
    if (message.autoTwapQuoteThreshold !== undefined) {
      writer.uint32(98).string(message.autoTwapQuoteThreshold)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SingleHedgeAlgoParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSingleHedgeAlgoParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.scope = HedgeScopeResolved.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.hedgeInstrument = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.target = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.execution = reader.int32() as any
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.preview.push(SingleHedgeLegPreview.decode(reader, reader.uint32()))
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.twapDurationSeconds = reader.int64().toString()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.autoTwapBaseThreshold = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.autoTwapQuoteThreshold = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SingleHedgeAlgoParams {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      scope: isSet(object.scope) ? HedgeScopeResolved.fromJSON(object.scope) : undefined,
      hedgeInstrument: isSet(object.hedgeInstrument)
        ? globalThis.String(object.hedgeInstrument)
        : isSet(object.hedge_instrument)
          ? globalThis.String(object.hedge_instrument)
          : undefined,
      target: isSet(object.target) ? globalThis.String(object.target) : undefined,
      denomination: isSet(object.denomination)
        ? hedgeDeltaDenominationFromJSON(object.denomination)
        : 0,
      execution: isSet(object.execution) ? singleHedgeExecutionFromJSON(object.execution) : 0,
      preview: globalThis.Array.isArray(object?.preview)
        ? object.preview.map((e: any) => SingleHedgeLegPreview.fromJSON(e))
        : [],
      twapDurationSeconds: isSet(object.twapDurationSeconds)
        ? globalThis.String(object.twapDurationSeconds)
        : isSet(object.twap_duration_seconds)
          ? globalThis.String(object.twap_duration_seconds)
          : undefined,
      autoTwapBaseThreshold: isSet(object.autoTwapBaseThreshold)
        ? globalThis.String(object.autoTwapBaseThreshold)
        : isSet(object.auto_twap_base_threshold)
          ? globalThis.String(object.auto_twap_base_threshold)
          : undefined,
      autoTwapQuoteThreshold: isSet(object.autoTwapQuoteThreshold)
        ? globalThis.String(object.autoTwapQuoteThreshold)
        : isSet(object.auto_twap_quote_threshold)
          ? globalThis.String(object.auto_twap_quote_threshold)
          : undefined,
    }
  },

  toJSON(message: SingleHedgeAlgoParams): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.scope !== undefined) {
      obj.scope = HedgeScopeResolved.toJSON(message.scope)
    }
    if (message.hedgeInstrument !== undefined) {
      obj.hedgeInstrument = message.hedgeInstrument
    }
    if (message.target !== undefined) {
      obj.target = message.target
    }
    if (message.denomination !== 0) {
      obj.denomination = hedgeDeltaDenominationToJSON(message.denomination)
    }
    if (message.execution !== 0) {
      obj.execution = singleHedgeExecutionToJSON(message.execution)
    }
    if (message.preview?.length) {
      obj.preview = message.preview.map((e) => SingleHedgeLegPreview.toJSON(e))
    }
    if (message.twapDurationSeconds !== undefined) {
      obj.twapDurationSeconds = message.twapDurationSeconds
    }
    if (message.autoTwapBaseThreshold !== undefined) {
      obj.autoTwapBaseThreshold = message.autoTwapBaseThreshold
    }
    if (message.autoTwapQuoteThreshold !== undefined) {
      obj.autoTwapQuoteThreshold = message.autoTwapQuoteThreshold
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SingleHedgeAlgoParams>, I>>(base?: I): SingleHedgeAlgoParams {
    return SingleHedgeAlgoParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SingleHedgeAlgoParams>, I>>(
    object: I
  ): SingleHedgeAlgoParams {
    const message = createBaseSingleHedgeAlgoParams()
    message.accountId = object.accountId ?? ''
    message.exchange = object.exchange ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.scope =
      object.scope !== undefined && object.scope !== null
        ? HedgeScopeResolved.fromPartial(object.scope)
        : undefined
    message.hedgeInstrument = object.hedgeInstrument ?? undefined
    message.target = object.target ?? undefined
    message.denomination = object.denomination ?? 0
    message.execution = object.execution ?? 0
    message.preview = object.preview?.map((e) => SingleHedgeLegPreview.fromPartial(e)) || []
    message.twapDurationSeconds = object.twapDurationSeconds ?? undefined
    message.autoTwapBaseThreshold = object.autoTwapBaseThreshold ?? undefined
    message.autoTwapQuoteThreshold = object.autoTwapQuoteThreshold ?? undefined
    return message
  },
}

function createBaseSingleHedgeLegPreview(): SingleHedgeLegPreview {
  return {
    underlying: '',
    hedgeInstrument: '',
    delta: '',
    side: 0,
    quantity: '',
    execution: 0,
    computedAtMs: '0',
  }
}

export const SingleHedgeLegPreview: MessageFns<SingleHedgeLegPreview> = {
  encode(message: SingleHedgeLegPreview, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.underlying !== '') {
      writer.uint32(10).string(message.underlying)
    }
    if (message.hedgeInstrument !== '') {
      writer.uint32(18).string(message.hedgeInstrument)
    }
    if (message.delta !== '') {
      writer.uint32(26).string(message.delta)
    }
    if (message.side !== 0) {
      writer.uint32(32).int32(message.side)
    }
    if (message.quantity !== '') {
      writer.uint32(42).string(message.quantity)
    }
    if (message.execution !== 0) {
      writer.uint32(48).int32(message.execution)
    }
    if (message.computedAtMs !== '0') {
      writer.uint32(56).int64(message.computedAtMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SingleHedgeLegPreview {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSingleHedgeLegPreview()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.hedgeInstrument = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.delta = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.execution = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.computedAtMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SingleHedgeLegPreview {
    return {
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      hedgeInstrument: isSet(object.hedgeInstrument)
        ? globalThis.String(object.hedgeInstrument)
        : isSet(object.hedge_instrument)
          ? globalThis.String(object.hedge_instrument)
          : '',
      delta: isSet(object.delta) ? globalThis.String(object.delta) : '',
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      execution: isSet(object.execution) ? singleHedgeExecutionFromJSON(object.execution) : 0,
      computedAtMs: isSet(object.computedAtMs)
        ? globalThis.String(object.computedAtMs)
        : isSet(object.computed_at_ms)
          ? globalThis.String(object.computed_at_ms)
          : '0',
    }
  },

  toJSON(message: SingleHedgeLegPreview): unknown {
    const obj: any = {}
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.hedgeInstrument !== '') {
      obj.hedgeInstrument = message.hedgeInstrument
    }
    if (message.delta !== '') {
      obj.delta = message.delta
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.execution !== 0) {
      obj.execution = singleHedgeExecutionToJSON(message.execution)
    }
    if (message.computedAtMs !== '0') {
      obj.computedAtMs = message.computedAtMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SingleHedgeLegPreview>, I>>(base?: I): SingleHedgeLegPreview {
    return SingleHedgeLegPreview.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SingleHedgeLegPreview>, I>>(
    object: I
  ): SingleHedgeLegPreview {
    const message = createBaseSingleHedgeLegPreview()
    message.underlying = object.underlying ?? ''
    message.hedgeInstrument = object.hedgeInstrument ?? ''
    message.delta = object.delta ?? ''
    message.side = object.side ?? 0
    message.quantity = object.quantity ?? ''
    message.execution = object.execution ?? 0
    message.computedAtMs = object.computedAtMs ?? '0'
    return message
  },
}

function createBaseSingleHedgeState(): SingleHedgeState {
  return { params: undefined, legs: [] }
}

export const SingleHedgeState: MessageFns<SingleHedgeState> = {
  encode(message: SingleHedgeState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.params !== undefined) {
      SingleHedgeAlgoParams.encode(message.params, writer.uint32(10).fork()).join()
    }
    for (const v of message.legs) {
      SingleHedgeLeg.encode(v!, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SingleHedgeState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSingleHedgeState()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.params = SingleHedgeAlgoParams.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.legs.push(SingleHedgeLeg.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SingleHedgeState {
    return {
      params: isSet(object.params) ? SingleHedgeAlgoParams.fromJSON(object.params) : undefined,
      legs: globalThis.Array.isArray(object?.legs)
        ? object.legs.map((e: any) => SingleHedgeLeg.fromJSON(e))
        : [],
    }
  },

  toJSON(message: SingleHedgeState): unknown {
    const obj: any = {}
    if (message.params !== undefined) {
      obj.params = SingleHedgeAlgoParams.toJSON(message.params)
    }
    if (message.legs?.length) {
      obj.legs = message.legs.map((e) => SingleHedgeLeg.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SingleHedgeState>, I>>(base?: I): SingleHedgeState {
    return SingleHedgeState.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SingleHedgeState>, I>>(object: I): SingleHedgeState {
    const message = createBaseSingleHedgeState()
    message.params =
      object.params !== undefined && object.params !== null
        ? SingleHedgeAlgoParams.fromPartial(object.params)
        : undefined
    message.legs = object.legs?.map((e) => SingleHedgeLeg.fromPartial(e)) || []
    return message
  },
}

function createBaseSingleHedgeLeg(): SingleHedgeLeg {
  return {
    underlying: '',
    hedgeInstrument: '',
    deltaBefore: '',
    side: 0,
    quantity: '',
    execution: 0,
    childAlgoId: undefined,
    orderLabel: undefined,
    filled: '',
    deltaAfter: undefined,
    status: 0,
    reason: undefined,
  }
}

export const SingleHedgeLeg: MessageFns<SingleHedgeLeg> = {
  encode(message: SingleHedgeLeg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.underlying !== '') {
      writer.uint32(10).string(message.underlying)
    }
    if (message.hedgeInstrument !== '') {
      writer.uint32(18).string(message.hedgeInstrument)
    }
    if (message.deltaBefore !== '') {
      writer.uint32(26).string(message.deltaBefore)
    }
    if (message.side !== 0) {
      writer.uint32(32).int32(message.side)
    }
    if (message.quantity !== '') {
      writer.uint32(42).string(message.quantity)
    }
    if (message.execution !== 0) {
      writer.uint32(48).int32(message.execution)
    }
    if (message.childAlgoId !== undefined) {
      writer.uint32(58).string(message.childAlgoId)
    }
    if (message.orderLabel !== undefined) {
      writer.uint32(66).string(message.orderLabel)
    }
    if (message.filled !== '') {
      writer.uint32(74).string(message.filled)
    }
    if (message.deltaAfter !== undefined) {
      writer.uint32(82).string(message.deltaAfter)
    }
    if (message.status !== 0) {
      writer.uint32(88).int32(message.status)
    }
    if (message.reason !== undefined) {
      writer.uint32(98).string(message.reason)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SingleHedgeLeg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSingleHedgeLeg()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.hedgeInstrument = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.deltaBefore = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.execution = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.childAlgoId = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.orderLabel = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.filled = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.deltaAfter = reader.string()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.status = reader.int32() as any
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.reason = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SingleHedgeLeg {
    return {
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
      hedgeInstrument: isSet(object.hedgeInstrument)
        ? globalThis.String(object.hedgeInstrument)
        : isSet(object.hedge_instrument)
          ? globalThis.String(object.hedge_instrument)
          : '',
      deltaBefore: isSet(object.deltaBefore)
        ? globalThis.String(object.deltaBefore)
        : isSet(object.delta_before)
          ? globalThis.String(object.delta_before)
          : '',
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      execution: isSet(object.execution) ? singleHedgeExecutionFromJSON(object.execution) : 0,
      childAlgoId: isSet(object.childAlgoId)
        ? globalThis.String(object.childAlgoId)
        : isSet(object.child_algo_id)
          ? globalThis.String(object.child_algo_id)
          : undefined,
      orderLabel: isSet(object.orderLabel)
        ? globalThis.String(object.orderLabel)
        : isSet(object.order_label)
          ? globalThis.String(object.order_label)
          : undefined,
      filled: isSet(object.filled) ? globalThis.String(object.filled) : '',
      deltaAfter: isSet(object.deltaAfter)
        ? globalThis.String(object.deltaAfter)
        : isSet(object.delta_after)
          ? globalThis.String(object.delta_after)
          : undefined,
      status: isSet(object.status) ? singleHedgeLegStatusFromJSON(object.status) : 0,
      reason: isSet(object.reason) ? globalThis.String(object.reason) : undefined,
    }
  },

  toJSON(message: SingleHedgeLeg): unknown {
    const obj: any = {}
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    if (message.hedgeInstrument !== '') {
      obj.hedgeInstrument = message.hedgeInstrument
    }
    if (message.deltaBefore !== '') {
      obj.deltaBefore = message.deltaBefore
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.execution !== 0) {
      obj.execution = singleHedgeExecutionToJSON(message.execution)
    }
    if (message.childAlgoId !== undefined) {
      obj.childAlgoId = message.childAlgoId
    }
    if (message.orderLabel !== undefined) {
      obj.orderLabel = message.orderLabel
    }
    if (message.filled !== '') {
      obj.filled = message.filled
    }
    if (message.deltaAfter !== undefined) {
      obj.deltaAfter = message.deltaAfter
    }
    if (message.status !== 0) {
      obj.status = singleHedgeLegStatusToJSON(message.status)
    }
    if (message.reason !== undefined) {
      obj.reason = message.reason
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SingleHedgeLeg>, I>>(base?: I): SingleHedgeLeg {
    return SingleHedgeLeg.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SingleHedgeLeg>, I>>(object: I): SingleHedgeLeg {
    const message = createBaseSingleHedgeLeg()
    message.underlying = object.underlying ?? ''
    message.hedgeInstrument = object.hedgeInstrument ?? ''
    message.deltaBefore = object.deltaBefore ?? ''
    message.side = object.side ?? 0
    message.quantity = object.quantity ?? ''
    message.execution = object.execution ?? 0
    message.childAlgoId = object.childAlgoId ?? undefined
    message.orderLabel = object.orderLabel ?? undefined
    message.filled = object.filled ?? ''
    message.deltaAfter = object.deltaAfter ?? undefined
    message.status = object.status ?? 0
    message.reason = object.reason ?? undefined
    return message
  },
}

function createBaseScaleAlgoParams(): ScaleAlgoParams {
  return {
    accountId: '',
    symbol: '',
    orderSide: 0,
    quantity: '',
    denomination: 0,
    exchange: 0,
    tradeVenue: 0,
    orderCount: 0,
    startPrice: undefined,
    endPrice: undefined,
    sizeRatio: undefined,
    reduceOnly: undefined,
    postOnly: undefined,
  }
}

export const ScaleAlgoParams: MessageFns<ScaleAlgoParams> = {
  encode(message: ScaleAlgoParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.orderSide !== 0) {
      writer.uint32(24).int32(message.orderSide)
    }
    if (message.quantity !== '') {
      writer.uint32(34).string(message.quantity)
    }
    if (message.denomination !== 0) {
      writer.uint32(40).int32(message.denomination)
    }
    if (message.exchange !== 0) {
      writer.uint32(48).int32(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(56).int32(message.tradeVenue)
    }
    if (message.orderCount !== 0) {
      writer.uint32(64).uint32(message.orderCount)
    }
    if (message.startPrice !== undefined) {
      ScalePriceBound.encode(message.startPrice, writer.uint32(74).fork()).join()
    }
    if (message.endPrice !== undefined) {
      ScalePriceBound.encode(message.endPrice, writer.uint32(82).fork()).join()
    }
    if (message.sizeRatio !== undefined) {
      writer.uint32(90).string(message.sizeRatio)
    }
    if (message.reduceOnly !== undefined) {
      writer.uint32(96).bool(message.reduceOnly)
    }
    if (message.postOnly !== undefined) {
      writer.uint32(104).bool(message.postOnly)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScaleAlgoParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseScaleAlgoParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.orderSide = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.orderCount = reader.uint32()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.startPrice = ScalePriceBound.decode(reader, reader.uint32())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.endPrice = ScalePriceBound.decode(reader, reader.uint32())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.sizeRatio = reader.string()
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.reduceOnly = reader.bool()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.postOnly = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ScaleAlgoParams {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      orderSide: isSet(object.orderSide)
        ? orderSideFromJSON(object.orderSide)
        : isSet(object.order_side)
          ? orderSideFromJSON(object.order_side)
          : 0,
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      denomination: isSet(object.denomination) ? denominationFromJSON(object.denomination) : 0,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      orderCount: isSet(object.orderCount)
        ? globalThis.Number(object.orderCount)
        : isSet(object.order_count)
          ? globalThis.Number(object.order_count)
          : 0,
      startPrice: isSet(object.startPrice)
        ? ScalePriceBound.fromJSON(object.startPrice)
        : isSet(object.start_price)
          ? ScalePriceBound.fromJSON(object.start_price)
          : undefined,
      endPrice: isSet(object.endPrice)
        ? ScalePriceBound.fromJSON(object.endPrice)
        : isSet(object.end_price)
          ? ScalePriceBound.fromJSON(object.end_price)
          : undefined,
      sizeRatio: isSet(object.sizeRatio)
        ? globalThis.String(object.sizeRatio)
        : isSet(object.size_ratio)
          ? globalThis.String(object.size_ratio)
          : undefined,
      reduceOnly: isSet(object.reduceOnly)
        ? globalThis.Boolean(object.reduceOnly)
        : isSet(object.reduce_only)
          ? globalThis.Boolean(object.reduce_only)
          : undefined,
      postOnly: isSet(object.postOnly)
        ? globalThis.Boolean(object.postOnly)
        : isSet(object.post_only)
          ? globalThis.Boolean(object.post_only)
          : undefined,
    }
  },

  toJSON(message: ScaleAlgoParams): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.orderSide !== 0) {
      obj.orderSide = orderSideToJSON(message.orderSide)
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.denomination !== 0) {
      obj.denomination = denominationToJSON(message.denomination)
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.orderCount !== 0) {
      obj.orderCount = Math.round(message.orderCount)
    }
    if (message.startPrice !== undefined) {
      obj.startPrice = ScalePriceBound.toJSON(message.startPrice)
    }
    if (message.endPrice !== undefined) {
      obj.endPrice = ScalePriceBound.toJSON(message.endPrice)
    }
    if (message.sizeRatio !== undefined) {
      obj.sizeRatio = message.sizeRatio
    }
    if (message.reduceOnly !== undefined) {
      obj.reduceOnly = message.reduceOnly
    }
    if (message.postOnly !== undefined) {
      obj.postOnly = message.postOnly
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ScaleAlgoParams>, I>>(base?: I): ScaleAlgoParams {
    return ScaleAlgoParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ScaleAlgoParams>, I>>(object: I): ScaleAlgoParams {
    const message = createBaseScaleAlgoParams()
    message.accountId = object.accountId ?? ''
    message.symbol = object.symbol ?? ''
    message.orderSide = object.orderSide ?? 0
    message.quantity = object.quantity ?? ''
    message.denomination = object.denomination ?? 0
    message.exchange = object.exchange ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.orderCount = object.orderCount ?? 0
    message.startPrice =
      object.startPrice !== undefined && object.startPrice !== null
        ? ScalePriceBound.fromPartial(object.startPrice)
        : undefined
    message.endPrice =
      object.endPrice !== undefined && object.endPrice !== null
        ? ScalePriceBound.fromPartial(object.endPrice)
        : undefined
    message.sizeRatio = object.sizeRatio ?? undefined
    message.reduceOnly = object.reduceOnly ?? undefined
    message.postOnly = object.postOnly ?? undefined
    return message
  },
}

function createBaseScalePriceBound(): ScalePriceBound {
  return { absolute: undefined, relative: undefined }
}

export const ScalePriceBound: MessageFns<ScalePriceBound> = {
  encode(message: ScalePriceBound, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.absolute !== undefined) {
      writer.uint32(10).string(message.absolute)
    }
    if (message.relative !== undefined) {
      RelativeLimitPrice.encode(message.relative, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScalePriceBound {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseScalePriceBound()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.absolute = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.relative = RelativeLimitPrice.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ScalePriceBound {
    return {
      absolute: isSet(object.absolute) ? globalThis.String(object.absolute) : undefined,
      relative: isSet(object.relative) ? RelativeLimitPrice.fromJSON(object.relative) : undefined,
    }
  },

  toJSON(message: ScalePriceBound): unknown {
    const obj: any = {}
    if (message.absolute !== undefined) {
      obj.absolute = message.absolute
    }
    if (message.relative !== undefined) {
      obj.relative = RelativeLimitPrice.toJSON(message.relative)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ScalePriceBound>, I>>(base?: I): ScalePriceBound {
    return ScalePriceBound.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ScalePriceBound>, I>>(object: I): ScalePriceBound {
    const message = createBaseScalePriceBound()
    message.absolute = object.absolute ?? undefined
    message.relative =
      object.relative !== undefined && object.relative !== null
        ? RelativeLimitPrice.fromPartial(object.relative)
        : undefined
    return message
  },
}

function createBaseScaleState(): ScaleState {
  return { params: undefined, levels: [], referencePrice: '', executedQuantity: '' }
}

export const ScaleState: MessageFns<ScaleState> = {
  encode(message: ScaleState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.params !== undefined) {
      ScaleAlgoParams.encode(message.params, writer.uint32(10).fork()).join()
    }
    for (const v of message.levels) {
      ScaleLevel.encode(v!, writer.uint32(18).fork()).join()
    }
    if (message.referencePrice !== '') {
      writer.uint32(26).string(message.referencePrice)
    }
    if (message.executedQuantity !== '') {
      writer.uint32(34).string(message.executedQuantity)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScaleState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseScaleState()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.params = ScaleAlgoParams.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.levels.push(ScaleLevel.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.referencePrice = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.executedQuantity = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ScaleState {
    return {
      params: isSet(object.params) ? ScaleAlgoParams.fromJSON(object.params) : undefined,
      levels: globalThis.Array.isArray(object?.levels)
        ? object.levels.map((e: any) => ScaleLevel.fromJSON(e))
        : [],
      referencePrice: isSet(object.referencePrice)
        ? globalThis.String(object.referencePrice)
        : isSet(object.reference_price)
          ? globalThis.String(object.reference_price)
          : '',
      executedQuantity: isSet(object.executedQuantity)
        ? globalThis.String(object.executedQuantity)
        : isSet(object.executed_quantity)
          ? globalThis.String(object.executed_quantity)
          : '',
    }
  },

  toJSON(message: ScaleState): unknown {
    const obj: any = {}
    if (message.params !== undefined) {
      obj.params = ScaleAlgoParams.toJSON(message.params)
    }
    if (message.levels?.length) {
      obj.levels = message.levels.map((e) => ScaleLevel.toJSON(e))
    }
    if (message.referencePrice !== '') {
      obj.referencePrice = message.referencePrice
    }
    if (message.executedQuantity !== '') {
      obj.executedQuantity = message.executedQuantity
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ScaleState>, I>>(base?: I): ScaleState {
    return ScaleState.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ScaleState>, I>>(object: I): ScaleState {
    const message = createBaseScaleState()
    message.params =
      object.params !== undefined && object.params !== null
        ? ScaleAlgoParams.fromPartial(object.params)
        : undefined
    message.levels = object.levels?.map((e) => ScaleLevel.fromPartial(e)) || []
    message.referencePrice = object.referencePrice ?? ''
    message.executedQuantity = object.executedQuantity ?? ''
    return message
  },
}

function createBaseScaleLevel(): ScaleLevel {
  return {
    index: 0,
    price: '',
    quantity: '',
    label: '',
    status: 0,
    filledQuantity: '',
    reason: undefined,
  }
}

export const ScaleLevel: MessageFns<ScaleLevel> = {
  encode(message: ScaleLevel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.index !== 0) {
      writer.uint32(8).uint32(message.index)
    }
    if (message.price !== '') {
      writer.uint32(18).string(message.price)
    }
    if (message.quantity !== '') {
      writer.uint32(26).string(message.quantity)
    }
    if (message.label !== '') {
      writer.uint32(34).string(message.label)
    }
    if (message.status !== 0) {
      writer.uint32(40).int32(message.status)
    }
    if (message.filledQuantity !== '') {
      writer.uint32(50).string(message.filledQuantity)
    }
    if (message.reason !== undefined) {
      writer.uint32(58).string(message.reason)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScaleLevel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseScaleLevel()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.index = reader.uint32()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.status = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.filledQuantity = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.reason = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ScaleLevel {
    return {
      index: isSet(object.index) ? globalThis.Number(object.index) : 0,
      price: isSet(object.price) ? globalThis.String(object.price) : '',
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      status: isSet(object.status) ? scaleLevelStatusFromJSON(object.status) : 0,
      filledQuantity: isSet(object.filledQuantity)
        ? globalThis.String(object.filledQuantity)
        : isSet(object.filled_quantity)
          ? globalThis.String(object.filled_quantity)
          : '',
      reason: isSet(object.reason) ? globalThis.String(object.reason) : undefined,
    }
  },

  toJSON(message: ScaleLevel): unknown {
    const obj: any = {}
    if (message.index !== 0) {
      obj.index = Math.round(message.index)
    }
    if (message.price !== '') {
      obj.price = message.price
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.status !== 0) {
      obj.status = scaleLevelStatusToJSON(message.status)
    }
    if (message.filledQuantity !== '') {
      obj.filledQuantity = message.filledQuantity
    }
    if (message.reason !== undefined) {
      obj.reason = message.reason
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ScaleLevel>, I>>(base?: I): ScaleLevel {
    return ScaleLevel.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ScaleLevel>, I>>(object: I): ScaleLevel {
    const message = createBaseScaleLevel()
    message.index = object.index ?? 0
    message.price = object.price ?? ''
    message.quantity = object.quantity ?? ''
    message.label = object.label ?? ''
    message.status = object.status ?? 0
    message.filledQuantity = object.filledQuantity ?? ''
    message.reason = object.reason ?? undefined
    return message
  },
}

function createBaseUpdateAlgo(): UpdateAlgo {
  return {
    accountId: '',
    algoId: '',
    optionsMm: undefined,
    hedge: undefined,
    confirmLoosening: undefined,
    correlationId: undefined,
  }
}

export const UpdateAlgo: MessageFns<UpdateAlgo> = {
  encode(message: UpdateAlgo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.algoId !== '') {
      writer.uint32(18).string(message.algoId)
    }
    if (message.optionsMm !== undefined) {
      OptionsMmAlgoParams.encode(message.optionsMm, writer.uint32(26).fork()).join()
    }
    if (message.hedge !== undefined) {
      HedgeAlgoParams.encode(message.hedge, writer.uint32(58).fork()).join()
    }
    if (message.confirmLoosening !== undefined) {
      writer.uint32(40).bool(message.confirmLoosening)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(50).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateAlgo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUpdateAlgo()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.algoId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.optionsMm = OptionsMmAlgoParams.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.hedge = HedgeAlgoParams.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.confirmLoosening = reader.bool()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UpdateAlgo {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      algoId: isSet(object.algoId)
        ? globalThis.String(object.algoId)
        : isSet(object.algo_id)
          ? globalThis.String(object.algo_id)
          : '',
      optionsMm: isSet(object.optionsMm)
        ? OptionsMmAlgoParams.fromJSON(object.optionsMm)
        : isSet(object.options_mm)
          ? OptionsMmAlgoParams.fromJSON(object.options_mm)
          : undefined,
      hedge: isSet(object.hedge) ? HedgeAlgoParams.fromJSON(object.hedge) : undefined,
      confirmLoosening: isSet(object.confirmLoosening)
        ? globalThis.Boolean(object.confirmLoosening)
        : isSet(object.confirm_loosening)
          ? globalThis.Boolean(object.confirm_loosening)
          : undefined,
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: UpdateAlgo): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.algoId !== '') {
      obj.algoId = message.algoId
    }
    if (message.optionsMm !== undefined) {
      obj.optionsMm = OptionsMmAlgoParams.toJSON(message.optionsMm)
    }
    if (message.hedge !== undefined) {
      obj.hedge = HedgeAlgoParams.toJSON(message.hedge)
    }
    if (message.confirmLoosening !== undefined) {
      obj.confirmLoosening = message.confirmLoosening
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UpdateAlgo>, I>>(base?: I): UpdateAlgo {
    return UpdateAlgo.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UpdateAlgo>, I>>(object: I): UpdateAlgo {
    const message = createBaseUpdateAlgo()
    message.accountId = object.accountId ?? ''
    message.algoId = object.algoId ?? ''
    message.optionsMm =
      object.optionsMm !== undefined && object.optionsMm !== null
        ? OptionsMmAlgoParams.fromPartial(object.optionsMm)
        : undefined
    message.hedge =
      object.hedge !== undefined && object.hedge !== null
        ? HedgeAlgoParams.fromPartial(object.hedge)
        : undefined
    message.confirmLoosening = object.confirmLoosening ?? undefined
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseOptionsMmTenorValues(): OptionsMmTenorValues {
  return { w1: '', m1: '', m3: '', long: '' }
}

export const OptionsMmTenorValues: MessageFns<OptionsMmTenorValues> = {
  encode(message: OptionsMmTenorValues, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.w1 !== '') {
      writer.uint32(10).string(message.w1)
    }
    if (message.m1 !== '') {
      writer.uint32(18).string(message.m1)
    }
    if (message.m3 !== '') {
      writer.uint32(26).string(message.m3)
    }
    if (message.long !== '') {
      writer.uint32(34).string(message.long)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmTenorValues {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmTenorValues()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.w1 = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.m1 = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.m3 = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.long = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmTenorValues {
    return {
      w1: isSet(object.w1) ? globalThis.String(object.w1) : '',
      m1: isSet(object.m1) ? globalThis.String(object.m1) : '',
      m3: isSet(object.m3) ? globalThis.String(object.m3) : '',
      long: isSet(object.long) ? globalThis.String(object.long) : '',
    }
  },

  toJSON(message: OptionsMmTenorValues): unknown {
    const obj: any = {}
    if (message.w1 !== '') {
      obj.w1 = message.w1
    }
    if (message.m1 !== '') {
      obj.m1 = message.m1
    }
    if (message.m3 !== '') {
      obj.m3 = message.m3
    }
    if (message.long !== '') {
      obj.long = message.long
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmTenorValues>, I>>(base?: I): OptionsMmTenorValues {
    return OptionsMmTenorValues.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmTenorValues>, I>>(
    object: I
  ): OptionsMmTenorValues {
    const message = createBaseOptionsMmTenorValues()
    message.w1 = object.w1 ?? ''
    message.m1 = object.m1 ?? ''
    message.m3 = object.m3 ?? ''
    message.long = object.long ?? ''
    return message
  },
}

function createBaseOptionsMmCurvePoint(): OptionsMmCurvePoint {
  return { key: '', value: '' }
}

export const OptionsMmCurvePoint: MessageFns<OptionsMmCurvePoint> = {
  encode(message: OptionsMmCurvePoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmCurvePoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmCurvePoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmCurvePoint {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
    }
  },

  toJSON(message: OptionsMmCurvePoint): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmCurvePoint>, I>>(base?: I): OptionsMmCurvePoint {
    return OptionsMmCurvePoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmCurvePoint>, I>>(
    object: I
  ): OptionsMmCurvePoint {
    const message = createBaseOptionsMmCurvePoint()
    message.key = object.key ?? ''
    message.value = object.value ?? ''
    return message
  },
}

function createBaseOptionsMmCurve(): OptionsMmCurve {
  return { points: [] }
}

export const OptionsMmCurve: MessageFns<OptionsMmCurve> = {
  encode(message: OptionsMmCurve, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.points) {
      OptionsMmCurvePoint.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmCurve {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmCurve()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.points.push(OptionsMmCurvePoint.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmCurve {
    return {
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => OptionsMmCurvePoint.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OptionsMmCurve): unknown {
    const obj: any = {}
    if (message.points?.length) {
      obj.points = message.points.map((e) => OptionsMmCurvePoint.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmCurve>, I>>(base?: I): OptionsMmCurve {
    return OptionsMmCurve.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmCurve>, I>>(object: I): OptionsMmCurve {
    const message = createBaseOptionsMmCurve()
    message.points = object.points?.map((e) => OptionsMmCurvePoint.fromPartial(e)) || []
    return message
  },
}

function createBaseOptionsMmMatrixCell(): OptionsMmMatrixCell {
  return { deltaBucket: '', value: '' }
}

export const OptionsMmMatrixCell: MessageFns<OptionsMmMatrixCell> = {
  encode(message: OptionsMmMatrixCell, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deltaBucket !== '') {
      writer.uint32(10).string(message.deltaBucket)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmMatrixCell {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmMatrixCell()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.deltaBucket = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmMatrixCell {
    return {
      deltaBucket: isSet(object.deltaBucket)
        ? globalThis.String(object.deltaBucket)
        : isSet(object.delta_bucket)
          ? globalThis.String(object.delta_bucket)
          : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
    }
  },

  toJSON(message: OptionsMmMatrixCell): unknown {
    const obj: any = {}
    if (message.deltaBucket !== '') {
      obj.deltaBucket = message.deltaBucket
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmMatrixCell>, I>>(base?: I): OptionsMmMatrixCell {
    return OptionsMmMatrixCell.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmMatrixCell>, I>>(
    object: I
  ): OptionsMmMatrixCell {
    const message = createBaseOptionsMmMatrixCell()
    message.deltaBucket = object.deltaBucket ?? ''
    message.value = object.value ?? ''
    return message
  },
}

function createBaseOptionsMmMatrixRow(): OptionsMmMatrixRow {
  return { tenor: '', cells: [] }
}

export const OptionsMmMatrixRow: MessageFns<OptionsMmMatrixRow> = {
  encode(message: OptionsMmMatrixRow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tenor !== '') {
      writer.uint32(10).string(message.tenor)
    }
    for (const v of message.cells) {
      OptionsMmMatrixCell.encode(v!, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmMatrixRow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmMatrixRow()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.tenor = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.cells.push(OptionsMmMatrixCell.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmMatrixRow {
    return {
      tenor: isSet(object.tenor) ? globalThis.String(object.tenor) : '',
      cells: globalThis.Array.isArray(object?.cells)
        ? object.cells.map((e: any) => OptionsMmMatrixCell.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OptionsMmMatrixRow): unknown {
    const obj: any = {}
    if (message.tenor !== '') {
      obj.tenor = message.tenor
    }
    if (message.cells?.length) {
      obj.cells = message.cells.map((e) => OptionsMmMatrixCell.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmMatrixRow>, I>>(base?: I): OptionsMmMatrixRow {
    return OptionsMmMatrixRow.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmMatrixRow>, I>>(object: I): OptionsMmMatrixRow {
    const message = createBaseOptionsMmMatrixRow()
    message.tenor = object.tenor ?? ''
    message.cells = object.cells?.map((e) => OptionsMmMatrixCell.fromPartial(e)) || []
    return message
  },
}

function createBaseOptionsMmMatrix(): OptionsMmMatrix {
  return { rows: [] }
}

export const OptionsMmMatrix: MessageFns<OptionsMmMatrix> = {
  encode(message: OptionsMmMatrix, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.rows) {
      OptionsMmMatrixRow.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmMatrix {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmMatrix()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.rows.push(OptionsMmMatrixRow.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmMatrix {
    return {
      rows: globalThis.Array.isArray(object?.rows)
        ? object.rows.map((e: any) => OptionsMmMatrixRow.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OptionsMmMatrix): unknown {
    const obj: any = {}
    if (message.rows?.length) {
      obj.rows = message.rows.map((e) => OptionsMmMatrixRow.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmMatrix>, I>>(base?: I): OptionsMmMatrix {
    return OptionsMmMatrix.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmMatrix>, I>>(object: I): OptionsMmMatrix {
    const message = createBaseOptionsMmMatrix()
    message.rows = object.rows?.map((e) => OptionsMmMatrixRow.fromPartial(e)) || []
    return message
  },
}

function createBaseOptionsMmExpiryValue(): OptionsMmExpiryValue {
  return { expirationTsMs: '0', value: '' }
}

export const OptionsMmExpiryValue: MessageFns<OptionsMmExpiryValue> = {
  encode(message: OptionsMmExpiryValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.expirationTsMs !== '0') {
      writer.uint32(8).int64(message.expirationTsMs)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmExpiryValue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmExpiryValue()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.expirationTsMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmExpiryValue {
    return {
      expirationTsMs: isSet(object.expirationTsMs)
        ? globalThis.String(object.expirationTsMs)
        : isSet(object.expiration_ts_ms)
          ? globalThis.String(object.expiration_ts_ms)
          : '0',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
    }
  },

  toJSON(message: OptionsMmExpiryValue): unknown {
    const obj: any = {}
    if (message.expirationTsMs !== '0') {
      obj.expirationTsMs = message.expirationTsMs
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmExpiryValue>, I>>(base?: I): OptionsMmExpiryValue {
    return OptionsMmExpiryValue.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmExpiryValue>, I>>(
    object: I
  ): OptionsMmExpiryValue {
    const message = createBaseOptionsMmExpiryValue()
    message.expirationTsMs = object.expirationTsMs ?? '0'
    message.value = object.value ?? ''
    return message
  },
}

function createBaseOptionsMmPerExpiry(): OptionsMmPerExpiry {
  return { defaultValue: '', overrides: [] }
}

export const OptionsMmPerExpiry: MessageFns<OptionsMmPerExpiry> = {
  encode(message: OptionsMmPerExpiry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.defaultValue !== '') {
      writer.uint32(10).string(message.defaultValue)
    }
    for (const v of message.overrides) {
      OptionsMmExpiryValue.encode(v!, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmPerExpiry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmPerExpiry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.defaultValue = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.overrides.push(OptionsMmExpiryValue.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmPerExpiry {
    return {
      defaultValue: isSet(object.defaultValue)
        ? globalThis.String(object.defaultValue)
        : isSet(object.default_value)
          ? globalThis.String(object.default_value)
          : '',
      overrides: globalThis.Array.isArray(object?.overrides)
        ? object.overrides.map((e: any) => OptionsMmExpiryValue.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OptionsMmPerExpiry): unknown {
    const obj: any = {}
    if (message.defaultValue !== '') {
      obj.defaultValue = message.defaultValue
    }
    if (message.overrides?.length) {
      obj.overrides = message.overrides.map((e) => OptionsMmExpiryValue.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmPerExpiry>, I>>(base?: I): OptionsMmPerExpiry {
    return OptionsMmPerExpiry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmPerExpiry>, I>>(object: I): OptionsMmPerExpiry {
    const message = createBaseOptionsMmPerExpiry()
    message.defaultValue = object.defaultValue ?? ''
    message.overrides = object.overrides?.map((e) => OptionsMmExpiryValue.fromPartial(e)) || []
    return message
  },
}

function createBaseOptionsMmRange(): OptionsMmRange {
  return { min: '', max: '' }
}

export const OptionsMmRange: MessageFns<OptionsMmRange> = {
  encode(message: OptionsMmRange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.min !== '') {
      writer.uint32(10).string(message.min)
    }
    if (message.max !== '') {
      writer.uint32(18).string(message.max)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmRange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmRange()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.min = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.max = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmRange {
    return {
      min: isSet(object.min) ? globalThis.String(object.min) : '',
      max: isSet(object.max) ? globalThis.String(object.max) : '',
    }
  },

  toJSON(message: OptionsMmRange): unknown {
    const obj: any = {}
    if (message.min !== '') {
      obj.min = message.min
    }
    if (message.max !== '') {
      obj.max = message.max
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmRange>, I>>(base?: I): OptionsMmRange {
    return OptionsMmRange.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmRange>, I>>(object: I): OptionsMmRange {
    const message = createBaseOptionsMmRange()
    message.min = object.min ?? ''
    message.max = object.max ?? ''
    return message
  },
}

function createBaseOptionsMmExpiryRange(): OptionsMmExpiryRange {
  return { expirationTsMs: '0', range: undefined }
}

export const OptionsMmExpiryRange: MessageFns<OptionsMmExpiryRange> = {
  encode(message: OptionsMmExpiryRange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.expirationTsMs !== '0') {
      writer.uint32(8).int64(message.expirationTsMs)
    }
    if (message.range !== undefined) {
      OptionsMmRange.encode(message.range, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmExpiryRange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmExpiryRange()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.expirationTsMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.range = OptionsMmRange.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmExpiryRange {
    return {
      expirationTsMs: isSet(object.expirationTsMs)
        ? globalThis.String(object.expirationTsMs)
        : isSet(object.expiration_ts_ms)
          ? globalThis.String(object.expiration_ts_ms)
          : '0',
      range: isSet(object.range) ? OptionsMmRange.fromJSON(object.range) : undefined,
    }
  },

  toJSON(message: OptionsMmExpiryRange): unknown {
    const obj: any = {}
    if (message.expirationTsMs !== '0') {
      obj.expirationTsMs = message.expirationTsMs
    }
    if (message.range !== undefined) {
      obj.range = OptionsMmRange.toJSON(message.range)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmExpiryRange>, I>>(base?: I): OptionsMmExpiryRange {
    return OptionsMmExpiryRange.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmExpiryRange>, I>>(
    object: I
  ): OptionsMmExpiryRange {
    const message = createBaseOptionsMmExpiryRange()
    message.expirationTsMs = object.expirationTsMs ?? '0'
    message.range =
      object.range !== undefined && object.range !== null
        ? OptionsMmRange.fromPartial(object.range)
        : undefined
    return message
  },
}

function createBaseOptionsMmPerExpiryRange(): OptionsMmPerExpiryRange {
  return { defaultRange: undefined, overrides: [] }
}

export const OptionsMmPerExpiryRange: MessageFns<OptionsMmPerExpiryRange> = {
  encode(
    message: OptionsMmPerExpiryRange,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.defaultRange !== undefined) {
      OptionsMmRange.encode(message.defaultRange, writer.uint32(10).fork()).join()
    }
    for (const v of message.overrides) {
      OptionsMmExpiryRange.encode(v!, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmPerExpiryRange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmPerExpiryRange()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.defaultRange = OptionsMmRange.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.overrides.push(OptionsMmExpiryRange.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmPerExpiryRange {
    return {
      defaultRange: isSet(object.defaultRange)
        ? OptionsMmRange.fromJSON(object.defaultRange)
        : isSet(object.default_range)
          ? OptionsMmRange.fromJSON(object.default_range)
          : undefined,
      overrides: globalThis.Array.isArray(object?.overrides)
        ? object.overrides.map((e: any) => OptionsMmExpiryRange.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OptionsMmPerExpiryRange): unknown {
    const obj: any = {}
    if (message.defaultRange !== undefined) {
      obj.defaultRange = OptionsMmRange.toJSON(message.defaultRange)
    }
    if (message.overrides?.length) {
      obj.overrides = message.overrides.map((e) => OptionsMmExpiryRange.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmPerExpiryRange>, I>>(
    base?: I
  ): OptionsMmPerExpiryRange {
    return OptionsMmPerExpiryRange.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmPerExpiryRange>, I>>(
    object: I
  ): OptionsMmPerExpiryRange {
    const message = createBaseOptionsMmPerExpiryRange()
    message.defaultRange =
      object.defaultRange !== undefined && object.defaultRange !== null
        ? OptionsMmRange.fromPartial(object.defaultRange)
        : undefined
    message.overrides = object.overrides?.map((e) => OptionsMmExpiryRange.fromPartial(e)) || []
    return message
  },
}

function createBaseOptionsMmScoped(): OptionsMmScoped {
  return { perExpiry: '', total: '' }
}

export const OptionsMmScoped: MessageFns<OptionsMmScoped> = {
  encode(message: OptionsMmScoped, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.perExpiry !== '') {
      writer.uint32(10).string(message.perExpiry)
    }
    if (message.total !== '') {
      writer.uint32(18).string(message.total)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmScoped {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmScoped()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.perExpiry = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.total = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmScoped {
    return {
      perExpiry: isSet(object.perExpiry)
        ? globalThis.String(object.perExpiry)
        : isSet(object.per_expiry)
          ? globalThis.String(object.per_expiry)
          : '',
      total: isSet(object.total) ? globalThis.String(object.total) : '',
    }
  },

  toJSON(message: OptionsMmScoped): unknown {
    const obj: any = {}
    if (message.perExpiry !== '') {
      obj.perExpiry = message.perExpiry
    }
    if (message.total !== '') {
      obj.total = message.total
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmScoped>, I>>(base?: I): OptionsMmScoped {
    return OptionsMmScoped.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmScoped>, I>>(object: I): OptionsMmScoped {
    const message = createBaseOptionsMmScoped()
    message.perExpiry = object.perExpiry ?? ''
    message.total = object.total ?? ''
    return message
  },
}

function createBaseOptionsMmReference(): OptionsMmReference {
  return { venue: 0, chain: '', sourceKind: '' }
}

export const OptionsMmReference: MessageFns<OptionsMmReference> = {
  encode(message: OptionsMmReference, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.venue !== 0) {
      writer.uint32(8).int32(message.venue)
    }
    if (message.chain !== '') {
      writer.uint32(18).string(message.chain)
    }
    if (message.sourceKind !== '') {
      writer.uint32(26).string(message.sourceKind)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmReference {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmReference()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.venue = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.chain = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.sourceKind = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmReference {
    return {
      venue: isSet(object.venue) ? exchangeFromJSON(object.venue) : 0,
      chain: isSet(object.chain) ? globalThis.String(object.chain) : '',
      sourceKind: isSet(object.sourceKind)
        ? globalThis.String(object.sourceKind)
        : isSet(object.source_kind)
          ? globalThis.String(object.source_kind)
          : '',
    }
  },

  toJSON(message: OptionsMmReference): unknown {
    const obj: any = {}
    if (message.venue !== 0) {
      obj.venue = exchangeToJSON(message.venue)
    }
    if (message.chain !== '') {
      obj.chain = message.chain
    }
    if (message.sourceKind !== '') {
      obj.sourceKind = message.sourceKind
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmReference>, I>>(base?: I): OptionsMmReference {
    return OptionsMmReference.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmReference>, I>>(object: I): OptionsMmReference {
    const message = createBaseOptionsMmReference()
    message.venue = object.venue ?? 0
    message.chain = object.chain ?? ''
    message.sourceKind = object.sourceKind ?? ''
    return message
  },
}

function createBaseOptionsMmQuote(): OptionsMmQuote {
  return {
    venue: 0,
    chain: '',
    expiriesMode: 0,
    expiryWhitelist: [],
    autoQuoteNewExpiries: false,
    newExpiryWarmupMin: 0,
    minTenorH: '',
    maxTenorD: '',
    stopBeforeExpiryH: undefined,
    settlementDaySizeMult: '',
    callDeltaRange: undefined,
    putDeltaRange: undefined,
    minEdgeAfterFee: '',
    layeringLevels: 0,
    layerStepVolpts: '',
    layerSizeMult: '',
  }
}

export const OptionsMmQuote: MessageFns<OptionsMmQuote> = {
  encode(message: OptionsMmQuote, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.venue !== 0) {
      writer.uint32(8).int32(message.venue)
    }
    if (message.chain !== '') {
      writer.uint32(18).string(message.chain)
    }
    if (message.expiriesMode !== 0) {
      writer.uint32(24).int32(message.expiriesMode)
    }
    writer.uint32(34).fork()
    for (const v of message.expiryWhitelist) {
      writer.int64(v)
    }
    writer.join()
    if (message.autoQuoteNewExpiries !== false) {
      writer.uint32(40).bool(message.autoQuoteNewExpiries)
    }
    if (message.newExpiryWarmupMin !== 0) {
      writer.uint32(48).uint32(message.newExpiryWarmupMin)
    }
    if (message.minTenorH !== '') {
      writer.uint32(58).string(message.minTenorH)
    }
    if (message.maxTenorD !== '') {
      writer.uint32(66).string(message.maxTenorD)
    }
    if (message.stopBeforeExpiryH !== undefined) {
      OptionsMmPerExpiry.encode(message.stopBeforeExpiryH, writer.uint32(74).fork()).join()
    }
    if (message.settlementDaySizeMult !== '') {
      writer.uint32(82).string(message.settlementDaySizeMult)
    }
    if (message.callDeltaRange !== undefined) {
      OptionsMmPerExpiryRange.encode(message.callDeltaRange, writer.uint32(90).fork()).join()
    }
    if (message.putDeltaRange !== undefined) {
      OptionsMmPerExpiryRange.encode(message.putDeltaRange, writer.uint32(98).fork()).join()
    }
    if (message.minEdgeAfterFee !== '') {
      writer.uint32(106).string(message.minEdgeAfterFee)
    }
    if (message.layeringLevels !== 0) {
      writer.uint32(112).uint32(message.layeringLevels)
    }
    if (message.layerStepVolpts !== '') {
      writer.uint32(122).string(message.layerStepVolpts)
    }
    if (message.layerSizeMult !== '') {
      writer.uint32(130).string(message.layerSizeMult)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmQuote {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmQuote()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.venue = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.chain = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.expiriesMode = reader.int32() as any
          continue
        }
        case 4: {
          if (tag === 32) {
            message.expiryWhitelist.push(reader.int64().toString())

            continue
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.expiryWhitelist.push(reader.int64().toString())
            }

            continue
          }

          break
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.autoQuoteNewExpiries = reader.bool()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.newExpiryWarmupMin = reader.uint32()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.minTenorH = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.maxTenorD = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.stopBeforeExpiryH = OptionsMmPerExpiry.decode(reader, reader.uint32())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.settlementDaySizeMult = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.callDeltaRange = OptionsMmPerExpiryRange.decode(reader, reader.uint32())
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.putDeltaRange = OptionsMmPerExpiryRange.decode(reader, reader.uint32())
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.minEdgeAfterFee = reader.string()
          continue
        }
        case 14: {
          if (tag !== 112) {
            break
          }

          message.layeringLevels = reader.uint32()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.layerStepVolpts = reader.string()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.layerSizeMult = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmQuote {
    return {
      venue: isSet(object.venue) ? exchangeFromJSON(object.venue) : 0,
      chain: isSet(object.chain) ? globalThis.String(object.chain) : '',
      expiriesMode: isSet(object.expiriesMode)
        ? optionsMmExpiriesModeFromJSON(object.expiriesMode)
        : isSet(object.expiries_mode)
          ? optionsMmExpiriesModeFromJSON(object.expiries_mode)
          : 0,
      expiryWhitelist: globalThis.Array.isArray(object?.expiryWhitelist)
        ? object.expiryWhitelist.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.expiry_whitelist)
          ? object.expiry_whitelist.map((e: any) => globalThis.String(e))
          : [],
      autoQuoteNewExpiries: isSet(object.autoQuoteNewExpiries)
        ? globalThis.Boolean(object.autoQuoteNewExpiries)
        : isSet(object.auto_quote_new_expiries)
          ? globalThis.Boolean(object.auto_quote_new_expiries)
          : false,
      newExpiryWarmupMin: isSet(object.newExpiryWarmupMin)
        ? globalThis.Number(object.newExpiryWarmupMin)
        : isSet(object.new_expiry_warmup_min)
          ? globalThis.Number(object.new_expiry_warmup_min)
          : 0,
      minTenorH: isSet(object.minTenorH)
        ? globalThis.String(object.minTenorH)
        : isSet(object.min_tenor_h)
          ? globalThis.String(object.min_tenor_h)
          : '',
      maxTenorD: isSet(object.maxTenorD)
        ? globalThis.String(object.maxTenorD)
        : isSet(object.max_tenor_d)
          ? globalThis.String(object.max_tenor_d)
          : '',
      stopBeforeExpiryH: isSet(object.stopBeforeExpiryH)
        ? OptionsMmPerExpiry.fromJSON(object.stopBeforeExpiryH)
        : isSet(object.stop_before_expiry_h)
          ? OptionsMmPerExpiry.fromJSON(object.stop_before_expiry_h)
          : undefined,
      settlementDaySizeMult: isSet(object.settlementDaySizeMult)
        ? globalThis.String(object.settlementDaySizeMult)
        : isSet(object.settlement_day_size_mult)
          ? globalThis.String(object.settlement_day_size_mult)
          : '',
      callDeltaRange: isSet(object.callDeltaRange)
        ? OptionsMmPerExpiryRange.fromJSON(object.callDeltaRange)
        : isSet(object.call_delta_range)
          ? OptionsMmPerExpiryRange.fromJSON(object.call_delta_range)
          : undefined,
      putDeltaRange: isSet(object.putDeltaRange)
        ? OptionsMmPerExpiryRange.fromJSON(object.putDeltaRange)
        : isSet(object.put_delta_range)
          ? OptionsMmPerExpiryRange.fromJSON(object.put_delta_range)
          : undefined,
      minEdgeAfterFee: isSet(object.minEdgeAfterFee)
        ? globalThis.String(object.minEdgeAfterFee)
        : isSet(object.min_edge_after_fee)
          ? globalThis.String(object.min_edge_after_fee)
          : '',
      layeringLevels: isSet(object.layeringLevels)
        ? globalThis.Number(object.layeringLevels)
        : isSet(object.layering_levels)
          ? globalThis.Number(object.layering_levels)
          : 0,
      layerStepVolpts: isSet(object.layerStepVolpts)
        ? globalThis.String(object.layerStepVolpts)
        : isSet(object.layer_step_volpts)
          ? globalThis.String(object.layer_step_volpts)
          : '',
      layerSizeMult: isSet(object.layerSizeMult)
        ? globalThis.String(object.layerSizeMult)
        : isSet(object.layer_size_mult)
          ? globalThis.String(object.layer_size_mult)
          : '',
    }
  },

  toJSON(message: OptionsMmQuote): unknown {
    const obj: any = {}
    if (message.venue !== 0) {
      obj.venue = exchangeToJSON(message.venue)
    }
    if (message.chain !== '') {
      obj.chain = message.chain
    }
    if (message.expiriesMode !== 0) {
      obj.expiriesMode = optionsMmExpiriesModeToJSON(message.expiriesMode)
    }
    if (message.expiryWhitelist?.length) {
      obj.expiryWhitelist = message.expiryWhitelist
    }
    if (message.autoQuoteNewExpiries !== false) {
      obj.autoQuoteNewExpiries = message.autoQuoteNewExpiries
    }
    if (message.newExpiryWarmupMin !== 0) {
      obj.newExpiryWarmupMin = Math.round(message.newExpiryWarmupMin)
    }
    if (message.minTenorH !== '') {
      obj.minTenorH = message.minTenorH
    }
    if (message.maxTenorD !== '') {
      obj.maxTenorD = message.maxTenorD
    }
    if (message.stopBeforeExpiryH !== undefined) {
      obj.stopBeforeExpiryH = OptionsMmPerExpiry.toJSON(message.stopBeforeExpiryH)
    }
    if (message.settlementDaySizeMult !== '') {
      obj.settlementDaySizeMult = message.settlementDaySizeMult
    }
    if (message.callDeltaRange !== undefined) {
      obj.callDeltaRange = OptionsMmPerExpiryRange.toJSON(message.callDeltaRange)
    }
    if (message.putDeltaRange !== undefined) {
      obj.putDeltaRange = OptionsMmPerExpiryRange.toJSON(message.putDeltaRange)
    }
    if (message.minEdgeAfterFee !== '') {
      obj.minEdgeAfterFee = message.minEdgeAfterFee
    }
    if (message.layeringLevels !== 0) {
      obj.layeringLevels = Math.round(message.layeringLevels)
    }
    if (message.layerStepVolpts !== '') {
      obj.layerStepVolpts = message.layerStepVolpts
    }
    if (message.layerSizeMult !== '') {
      obj.layerSizeMult = message.layerSizeMult
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmQuote>, I>>(base?: I): OptionsMmQuote {
    return OptionsMmQuote.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmQuote>, I>>(object: I): OptionsMmQuote {
    const message = createBaseOptionsMmQuote()
    message.venue = object.venue ?? 0
    message.chain = object.chain ?? ''
    message.expiriesMode = object.expiriesMode ?? 0
    message.expiryWhitelist = object.expiryWhitelist?.map((e) => e) || []
    message.autoQuoteNewExpiries = object.autoQuoteNewExpiries ?? false
    message.newExpiryWarmupMin = object.newExpiryWarmupMin ?? 0
    message.minTenorH = object.minTenorH ?? ''
    message.maxTenorD = object.maxTenorD ?? ''
    message.stopBeforeExpiryH =
      object.stopBeforeExpiryH !== undefined && object.stopBeforeExpiryH !== null
        ? OptionsMmPerExpiry.fromPartial(object.stopBeforeExpiryH)
        : undefined
    message.settlementDaySizeMult = object.settlementDaySizeMult ?? ''
    message.callDeltaRange =
      object.callDeltaRange !== undefined && object.callDeltaRange !== null
        ? OptionsMmPerExpiryRange.fromPartial(object.callDeltaRange)
        : undefined
    message.putDeltaRange =
      object.putDeltaRange !== undefined && object.putDeltaRange !== null
        ? OptionsMmPerExpiryRange.fromPartial(object.putDeltaRange)
        : undefined
    message.minEdgeAfterFee = object.minEdgeAfterFee ?? ''
    message.layeringLevels = object.layeringLevels ?? 0
    message.layerStepVolpts = object.layerStepVolpts ?? ''
    message.layerSizeMult = object.layerSizeMult ?? ''
    return message
  },
}

function createBaseOptionsMmCapital(): OptionsMmCapital {
  return { allocatedUsd: '', assetClass: 0, imOwnBookOnly: false }
}

export const OptionsMmCapital: MessageFns<OptionsMmCapital> = {
  encode(message: OptionsMmCapital, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.allocatedUsd !== '') {
      writer.uint32(10).string(message.allocatedUsd)
    }
    if (message.assetClass !== 0) {
      writer.uint32(16).int32(message.assetClass)
    }
    if (message.imOwnBookOnly !== false) {
      writer.uint32(24).bool(message.imOwnBookOnly)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmCapital {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmCapital()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.allocatedUsd = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.assetClass = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.imOwnBookOnly = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmCapital {
    return {
      allocatedUsd: isSet(object.allocatedUsd)
        ? globalThis.String(object.allocatedUsd)
        : isSet(object.allocated_usd)
          ? globalThis.String(object.allocated_usd)
          : '',
      assetClass: isSet(object.assetClass)
        ? optionsMmAssetClassFromJSON(object.assetClass)
        : isSet(object.asset_class)
          ? optionsMmAssetClassFromJSON(object.asset_class)
          : 0,
      imOwnBookOnly: isSet(object.imOwnBookOnly)
        ? globalThis.Boolean(object.imOwnBookOnly)
        : isSet(object.im_own_book_only)
          ? globalThis.Boolean(object.im_own_book_only)
          : false,
    }
  },

  toJSON(message: OptionsMmCapital): unknown {
    const obj: any = {}
    if (message.allocatedUsd !== '') {
      obj.allocatedUsd = message.allocatedUsd
    }
    if (message.assetClass !== 0) {
      obj.assetClass = optionsMmAssetClassToJSON(message.assetClass)
    }
    if (message.imOwnBookOnly !== false) {
      obj.imOwnBookOnly = message.imOwnBookOnly
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmCapital>, I>>(base?: I): OptionsMmCapital {
    return OptionsMmCapital.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmCapital>, I>>(object: I): OptionsMmCapital {
    const message = createBaseOptionsMmCapital()
    message.allocatedUsd = object.allocatedUsd ?? ''
    message.assetClass = object.assetClass ?? 0
    message.imOwnBookOnly = object.imOwnBookOnly ?? false
    return message
  },
}

function createBaseOptionsMmMapping(): OptionsMmMapping {
  return {
    validate: '',
    volBasisVolpts: undefined,
    skewTiltVolpts: '',
    volBiasVolpts: [],
    moneynessMode: '',
    weekendVarianceWeight: '',
    marksExtraEdgeVolpts: '',
  }
}

export const OptionsMmMapping: MessageFns<OptionsMmMapping> = {
  encode(message: OptionsMmMapping, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.validate !== '') {
      writer.uint32(10).string(message.validate)
    }
    if (message.volBasisVolpts !== undefined) {
      OptionsMmTenorValues.encode(message.volBasisVolpts, writer.uint32(18).fork()).join()
    }
    if (message.skewTiltVolpts !== '') {
      writer.uint32(26).string(message.skewTiltVolpts)
    }
    for (const v of message.volBiasVolpts) {
      OptionsMmExpiryValue.encode(v!, writer.uint32(34).fork()).join()
    }
    if (message.moneynessMode !== '') {
      writer.uint32(42).string(message.moneynessMode)
    }
    if (message.weekendVarianceWeight !== '') {
      writer.uint32(50).string(message.weekendVarianceWeight)
    }
    if (message.marksExtraEdgeVolpts !== '') {
      writer.uint32(58).string(message.marksExtraEdgeVolpts)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmMapping {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmMapping()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.validate = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.volBasisVolpts = OptionsMmTenorValues.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.skewTiltVolpts = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.volBiasVolpts.push(OptionsMmExpiryValue.decode(reader, reader.uint32()))
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.moneynessMode = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.weekendVarianceWeight = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.marksExtraEdgeVolpts = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmMapping {
    return {
      validate: isSet(object.validate) ? globalThis.String(object.validate) : '',
      volBasisVolpts: isSet(object.volBasisVolpts)
        ? OptionsMmTenorValues.fromJSON(object.volBasisVolpts)
        : isSet(object.vol_basis_volpts)
          ? OptionsMmTenorValues.fromJSON(object.vol_basis_volpts)
          : undefined,
      skewTiltVolpts: isSet(object.skewTiltVolpts)
        ? globalThis.String(object.skewTiltVolpts)
        : isSet(object.skew_tilt_volpts)
          ? globalThis.String(object.skew_tilt_volpts)
          : '',
      volBiasVolpts: globalThis.Array.isArray(object?.volBiasVolpts)
        ? object.volBiasVolpts.map((e: any) => OptionsMmExpiryValue.fromJSON(e))
        : globalThis.Array.isArray(object?.vol_bias_volpts)
          ? object.vol_bias_volpts.map((e: any) => OptionsMmExpiryValue.fromJSON(e))
          : [],
      moneynessMode: isSet(object.moneynessMode)
        ? globalThis.String(object.moneynessMode)
        : isSet(object.moneyness_mode)
          ? globalThis.String(object.moneyness_mode)
          : '',
      weekendVarianceWeight: isSet(object.weekendVarianceWeight)
        ? globalThis.String(object.weekendVarianceWeight)
        : isSet(object.weekend_variance_weight)
          ? globalThis.String(object.weekend_variance_weight)
          : '',
      marksExtraEdgeVolpts: isSet(object.marksExtraEdgeVolpts)
        ? globalThis.String(object.marksExtraEdgeVolpts)
        : isSet(object.marks_extra_edge_volpts)
          ? globalThis.String(object.marks_extra_edge_volpts)
          : '',
    }
  },

  toJSON(message: OptionsMmMapping): unknown {
    const obj: any = {}
    if (message.validate !== '') {
      obj.validate = message.validate
    }
    if (message.volBasisVolpts !== undefined) {
      obj.volBasisVolpts = OptionsMmTenorValues.toJSON(message.volBasisVolpts)
    }
    if (message.skewTiltVolpts !== '') {
      obj.skewTiltVolpts = message.skewTiltVolpts
    }
    if (message.volBiasVolpts?.length) {
      obj.volBiasVolpts = message.volBiasVolpts.map((e) => OptionsMmExpiryValue.toJSON(e))
    }
    if (message.moneynessMode !== '') {
      obj.moneynessMode = message.moneynessMode
    }
    if (message.weekendVarianceWeight !== '') {
      obj.weekendVarianceWeight = message.weekendVarianceWeight
    }
    if (message.marksExtraEdgeVolpts !== '') {
      obj.marksExtraEdgeVolpts = message.marksExtraEdgeVolpts
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmMapping>, I>>(base?: I): OptionsMmMapping {
    return OptionsMmMapping.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmMapping>, I>>(object: I): OptionsMmMapping {
    const message = createBaseOptionsMmMapping()
    message.validate = object.validate ?? ''
    message.volBasisVolpts =
      object.volBasisVolpts !== undefined && object.volBasisVolpts !== null
        ? OptionsMmTenorValues.fromPartial(object.volBasisVolpts)
        : undefined
    message.skewTiltVolpts = object.skewTiltVolpts ?? ''
    message.volBiasVolpts =
      object.volBiasVolpts?.map((e) => OptionsMmExpiryValue.fromPartial(e)) || []
    message.moneynessMode = object.moneynessMode ?? ''
    message.weekendVarianceWeight = object.weekendVarianceWeight ?? ''
    message.marksExtraEdgeVolpts = object.marksExtraEdgeVolpts ?? ''
    return message
  },
}

function createBaseOptionsMmFx(): OptionsMmFx {
  return { maxAgeS: 0, volWindowD: 0, corrWindowD: 0 }
}

export const OptionsMmFx: MessageFns<OptionsMmFx> = {
  encode(message: OptionsMmFx, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.maxAgeS !== 0) {
      writer.uint32(8).uint32(message.maxAgeS)
    }
    if (message.volWindowD !== 0) {
      writer.uint32(16).uint32(message.volWindowD)
    }
    if (message.corrWindowD !== 0) {
      writer.uint32(24).uint32(message.corrWindowD)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmFx {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmFx()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.maxAgeS = reader.uint32()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.volWindowD = reader.uint32()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.corrWindowD = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmFx {
    return {
      maxAgeS: isSet(object.maxAgeS)
        ? globalThis.Number(object.maxAgeS)
        : isSet(object.max_age_s)
          ? globalThis.Number(object.max_age_s)
          : 0,
      volWindowD: isSet(object.volWindowD)
        ? globalThis.Number(object.volWindowD)
        : isSet(object.vol_window_d)
          ? globalThis.Number(object.vol_window_d)
          : 0,
      corrWindowD: isSet(object.corrWindowD)
        ? globalThis.Number(object.corrWindowD)
        : isSet(object.corr_window_d)
          ? globalThis.Number(object.corr_window_d)
          : 0,
    }
  },

  toJSON(message: OptionsMmFx): unknown {
    const obj: any = {}
    if (message.maxAgeS !== 0) {
      obj.maxAgeS = Math.round(message.maxAgeS)
    }
    if (message.volWindowD !== 0) {
      obj.volWindowD = Math.round(message.volWindowD)
    }
    if (message.corrWindowD !== 0) {
      obj.corrWindowD = Math.round(message.corrWindowD)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmFx>, I>>(base?: I): OptionsMmFx {
    return OptionsMmFx.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmFx>, I>>(object: I): OptionsMmFx {
    const message = createBaseOptionsMmFx()
    message.maxAgeS = object.maxAgeS ?? 0
    message.volWindowD = object.volWindowD ?? 0
    message.corrWindowD = object.corrWindowD ?? 0
    return message
  },
}

function createBaseOptionsMmClosedHours(): OptionsMmClosedHours {
  return {
    detection: '',
    surfaceMode: '',
    spreadMult: undefined,
    stalenessWidenPerH: '',
    spreadMultCap: '',
    sizeMult: '',
    maxSurfaceAgeH: '',
    reopenBlendS: '',
    reopenWarmupS: '',
  }
}

export const OptionsMmClosedHours: MessageFns<OptionsMmClosedHours> = {
  encode(message: OptionsMmClosedHours, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.detection !== '') {
      writer.uint32(10).string(message.detection)
    }
    if (message.surfaceMode !== '') {
      writer.uint32(18).string(message.surfaceMode)
    }
    if (message.spreadMult !== undefined) {
      OptionsMmCurve.encode(message.spreadMult, writer.uint32(26).fork()).join()
    }
    if (message.stalenessWidenPerH !== '') {
      writer.uint32(34).string(message.stalenessWidenPerH)
    }
    if (message.spreadMultCap !== '') {
      writer.uint32(42).string(message.spreadMultCap)
    }
    if (message.sizeMult !== '') {
      writer.uint32(50).string(message.sizeMult)
    }
    if (message.maxSurfaceAgeH !== '') {
      writer.uint32(58).string(message.maxSurfaceAgeH)
    }
    if (message.reopenBlendS !== '') {
      writer.uint32(66).string(message.reopenBlendS)
    }
    if (message.reopenWarmupS !== '') {
      writer.uint32(74).string(message.reopenWarmupS)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmClosedHours {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmClosedHours()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.detection = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.surfaceMode = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.spreadMult = OptionsMmCurve.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.stalenessWidenPerH = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.spreadMultCap = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.sizeMult = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.maxSurfaceAgeH = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.reopenBlendS = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.reopenWarmupS = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmClosedHours {
    return {
      detection: isSet(object.detection) ? globalThis.String(object.detection) : '',
      surfaceMode: isSet(object.surfaceMode)
        ? globalThis.String(object.surfaceMode)
        : isSet(object.surface_mode)
          ? globalThis.String(object.surface_mode)
          : '',
      spreadMult: isSet(object.spreadMult)
        ? OptionsMmCurve.fromJSON(object.spreadMult)
        : isSet(object.spread_mult)
          ? OptionsMmCurve.fromJSON(object.spread_mult)
          : undefined,
      stalenessWidenPerH: isSet(object.stalenessWidenPerH)
        ? globalThis.String(object.stalenessWidenPerH)
        : isSet(object.staleness_widen_per_h)
          ? globalThis.String(object.staleness_widen_per_h)
          : '',
      spreadMultCap: isSet(object.spreadMultCap)
        ? globalThis.String(object.spreadMultCap)
        : isSet(object.spread_mult_cap)
          ? globalThis.String(object.spread_mult_cap)
          : '',
      sizeMult: isSet(object.sizeMult)
        ? globalThis.String(object.sizeMult)
        : isSet(object.size_mult)
          ? globalThis.String(object.size_mult)
          : '',
      maxSurfaceAgeH: isSet(object.maxSurfaceAgeH)
        ? globalThis.String(object.maxSurfaceAgeH)
        : isSet(object.max_surface_age_h)
          ? globalThis.String(object.max_surface_age_h)
          : '',
      reopenBlendS: isSet(object.reopenBlendS)
        ? globalThis.String(object.reopenBlendS)
        : isSet(object.reopen_blend_s)
          ? globalThis.String(object.reopen_blend_s)
          : '',
      reopenWarmupS: isSet(object.reopenWarmupS)
        ? globalThis.String(object.reopenWarmupS)
        : isSet(object.reopen_warmup_s)
          ? globalThis.String(object.reopen_warmup_s)
          : '',
    }
  },

  toJSON(message: OptionsMmClosedHours): unknown {
    const obj: any = {}
    if (message.detection !== '') {
      obj.detection = message.detection
    }
    if (message.surfaceMode !== '') {
      obj.surfaceMode = message.surfaceMode
    }
    if (message.spreadMult !== undefined) {
      obj.spreadMult = OptionsMmCurve.toJSON(message.spreadMult)
    }
    if (message.stalenessWidenPerH !== '') {
      obj.stalenessWidenPerH = message.stalenessWidenPerH
    }
    if (message.spreadMultCap !== '') {
      obj.spreadMultCap = message.spreadMultCap
    }
    if (message.sizeMult !== '') {
      obj.sizeMult = message.sizeMult
    }
    if (message.maxSurfaceAgeH !== '') {
      obj.maxSurfaceAgeH = message.maxSurfaceAgeH
    }
    if (message.reopenBlendS !== '') {
      obj.reopenBlendS = message.reopenBlendS
    }
    if (message.reopenWarmupS !== '') {
      obj.reopenWarmupS = message.reopenWarmupS
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmClosedHours>, I>>(base?: I): OptionsMmClosedHours {
    return OptionsMmClosedHours.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmClosedHours>, I>>(
    object: I
  ): OptionsMmClosedHours {
    const message = createBaseOptionsMmClosedHours()
    message.detection = object.detection ?? ''
    message.surfaceMode = object.surfaceMode ?? ''
    message.spreadMult =
      object.spreadMult !== undefined && object.spreadMult !== null
        ? OptionsMmCurve.fromPartial(object.spreadMult)
        : undefined
    message.stalenessWidenPerH = object.stalenessWidenPerH ?? ''
    message.spreadMultCap = object.spreadMultCap ?? ''
    message.sizeMult = object.sizeMult ?? ''
    message.maxSurfaceAgeH = object.maxSurfaceAgeH ?? ''
    message.reopenBlendS = object.reopenBlendS ?? ''
    message.reopenWarmupS = object.reopenWarmupS ?? ''
    return message
  },
}

function createBaseOptionsMmUniverse(): OptionsMmUniverse {
  return { minLiveInstruments: 0 }
}

export const OptionsMmUniverse: MessageFns<OptionsMmUniverse> = {
  encode(message: OptionsMmUniverse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.minLiveInstruments !== 0) {
      writer.uint32(8).uint32(message.minLiveInstruments)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmUniverse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmUniverse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.minLiveInstruments = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmUniverse {
    return {
      minLiveInstruments: isSet(object.minLiveInstruments)
        ? globalThis.Number(object.minLiveInstruments)
        : isSet(object.min_live_instruments)
          ? globalThis.Number(object.min_live_instruments)
          : 0,
    }
  },

  toJSON(message: OptionsMmUniverse): unknown {
    const obj: any = {}
    if (message.minLiveInstruments !== 0) {
      obj.minLiveInstruments = Math.round(message.minLiveInstruments)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmUniverse>, I>>(base?: I): OptionsMmUniverse {
    return OptionsMmUniverse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmUniverse>, I>>(object: I): OptionsMmUniverse {
    const message = createBaseOptionsMmUniverse()
    message.minLiveInstruments = object.minLiveInstruments ?? 0
    return message
  },
}

function createBaseOptionsMmSpreads(): OptionsMmSpreads {
  return {
    baseVolpts: undefined,
    deltaMult: undefined,
    minPremiumTicks: 0,
    maxVolpts: '',
    feeFloor: false,
  }
}

export const OptionsMmSpreads: MessageFns<OptionsMmSpreads> = {
  encode(message: OptionsMmSpreads, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseVolpts !== undefined) {
      OptionsMmMatrix.encode(message.baseVolpts, writer.uint32(10).fork()).join()
    }
    if (message.deltaMult !== undefined) {
      OptionsMmCurve.encode(message.deltaMult, writer.uint32(18).fork()).join()
    }
    if (message.minPremiumTicks !== 0) {
      writer.uint32(24).uint32(message.minPremiumTicks)
    }
    if (message.maxVolpts !== '') {
      writer.uint32(34).string(message.maxVolpts)
    }
    if (message.feeFloor !== false) {
      writer.uint32(40).bool(message.feeFloor)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmSpreads {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmSpreads()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.baseVolpts = OptionsMmMatrix.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.deltaMult = OptionsMmCurve.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.minPremiumTicks = reader.uint32()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.maxVolpts = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.feeFloor = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmSpreads {
    return {
      baseVolpts: isSet(object.baseVolpts)
        ? OptionsMmMatrix.fromJSON(object.baseVolpts)
        : isSet(object.base_volpts)
          ? OptionsMmMatrix.fromJSON(object.base_volpts)
          : undefined,
      deltaMult: isSet(object.deltaMult)
        ? OptionsMmCurve.fromJSON(object.deltaMult)
        : isSet(object.delta_mult)
          ? OptionsMmCurve.fromJSON(object.delta_mult)
          : undefined,
      minPremiumTicks: isSet(object.minPremiumTicks)
        ? globalThis.Number(object.minPremiumTicks)
        : isSet(object.min_premium_ticks)
          ? globalThis.Number(object.min_premium_ticks)
          : 0,
      maxVolpts: isSet(object.maxVolpts)
        ? globalThis.String(object.maxVolpts)
        : isSet(object.max_volpts)
          ? globalThis.String(object.max_volpts)
          : '',
      feeFloor: isSet(object.feeFloor)
        ? globalThis.Boolean(object.feeFloor)
        : isSet(object.fee_floor)
          ? globalThis.Boolean(object.fee_floor)
          : false,
    }
  },

  toJSON(message: OptionsMmSpreads): unknown {
    const obj: any = {}
    if (message.baseVolpts !== undefined) {
      obj.baseVolpts = OptionsMmMatrix.toJSON(message.baseVolpts)
    }
    if (message.deltaMult !== undefined) {
      obj.deltaMult = OptionsMmCurve.toJSON(message.deltaMult)
    }
    if (message.minPremiumTicks !== 0) {
      obj.minPremiumTicks = Math.round(message.minPremiumTicks)
    }
    if (message.maxVolpts !== '') {
      obj.maxVolpts = message.maxVolpts
    }
    if (message.feeFloor !== false) {
      obj.feeFloor = message.feeFloor
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmSpreads>, I>>(base?: I): OptionsMmSpreads {
    return OptionsMmSpreads.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmSpreads>, I>>(object: I): OptionsMmSpreads {
    const message = createBaseOptionsMmSpreads()
    message.baseVolpts =
      object.baseVolpts !== undefined && object.baseVolpts !== null
        ? OptionsMmMatrix.fromPartial(object.baseVolpts)
        : undefined
    message.deltaMult =
      object.deltaMult !== undefined && object.deltaMult !== null
        ? OptionsMmCurve.fromPartial(object.deltaMult)
        : undefined
    message.minPremiumTicks = object.minPremiumTicks ?? 0
    message.maxVolpts = object.maxVolpts ?? ''
    message.feeFloor = object.feeFloor ?? false
    return message
  },
}

function createBaseOptionsMmSizing(): OptionsMmSizing {
  return {
    mode: 0,
    vegaPerQuotePct: '',
    deltaMult: undefined,
    quoteDeltaMaxPct: undefined,
    inventoryAsym: false,
  }
}

export const OptionsMmSizing: MessageFns<OptionsMmSizing> = {
  encode(message: OptionsMmSizing, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mode !== 0) {
      writer.uint32(8).int32(message.mode)
    }
    if (message.vegaPerQuotePct !== '') {
      writer.uint32(18).string(message.vegaPerQuotePct)
    }
    if (message.deltaMult !== undefined) {
      OptionsMmCurve.encode(message.deltaMult, writer.uint32(26).fork()).join()
    }
    if (message.quoteDeltaMaxPct !== undefined) {
      OptionsMmPerExpiry.encode(message.quoteDeltaMaxPct, writer.uint32(34).fork()).join()
    }
    if (message.inventoryAsym !== false) {
      writer.uint32(40).bool(message.inventoryAsym)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmSizing {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmSizing()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.mode = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.vegaPerQuotePct = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.deltaMult = OptionsMmCurve.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.quoteDeltaMaxPct = OptionsMmPerExpiry.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.inventoryAsym = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmSizing {
    return {
      mode: isSet(object.mode) ? optionsMmSizeModeFromJSON(object.mode) : 0,
      vegaPerQuotePct: isSet(object.vegaPerQuotePct)
        ? globalThis.String(object.vegaPerQuotePct)
        : isSet(object.vega_per_quote_pct)
          ? globalThis.String(object.vega_per_quote_pct)
          : '',
      deltaMult: isSet(object.deltaMult)
        ? OptionsMmCurve.fromJSON(object.deltaMult)
        : isSet(object.delta_mult)
          ? OptionsMmCurve.fromJSON(object.delta_mult)
          : undefined,
      quoteDeltaMaxPct: isSet(object.quoteDeltaMaxPct)
        ? OptionsMmPerExpiry.fromJSON(object.quoteDeltaMaxPct)
        : isSet(object.quote_delta_max_pct)
          ? OptionsMmPerExpiry.fromJSON(object.quote_delta_max_pct)
          : undefined,
      inventoryAsym: isSet(object.inventoryAsym)
        ? globalThis.Boolean(object.inventoryAsym)
        : isSet(object.inventory_asym)
          ? globalThis.Boolean(object.inventory_asym)
          : false,
    }
  },

  toJSON(message: OptionsMmSizing): unknown {
    const obj: any = {}
    if (message.mode !== 0) {
      obj.mode = optionsMmSizeModeToJSON(message.mode)
    }
    if (message.vegaPerQuotePct !== '') {
      obj.vegaPerQuotePct = message.vegaPerQuotePct
    }
    if (message.deltaMult !== undefined) {
      obj.deltaMult = OptionsMmCurve.toJSON(message.deltaMult)
    }
    if (message.quoteDeltaMaxPct !== undefined) {
      obj.quoteDeltaMaxPct = OptionsMmPerExpiry.toJSON(message.quoteDeltaMaxPct)
    }
    if (message.inventoryAsym !== false) {
      obj.inventoryAsym = message.inventoryAsym
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmSizing>, I>>(base?: I): OptionsMmSizing {
    return OptionsMmSizing.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmSizing>, I>>(object: I): OptionsMmSizing {
    const message = createBaseOptionsMmSizing()
    message.mode = object.mode ?? 0
    message.vegaPerQuotePct = object.vegaPerQuotePct ?? ''
    message.deltaMult =
      object.deltaMult !== undefined && object.deltaMult !== null
        ? OptionsMmCurve.fromPartial(object.deltaMult)
        : undefined
    message.quoteDeltaMaxPct =
      object.quoteDeltaMaxPct !== undefined && object.quoteDeltaMaxPct !== null
        ? OptionsMmPerExpiry.fromPartial(object.quoteDeltaMaxPct)
        : undefined
    message.inventoryAsym = object.inventoryAsym ?? false
    return message
  },
}

function createBaseOptionsMmOms(): OptionsMmOms {
  return {
    makerOnly: false,
    requoteTolVolpts: '',
    requoteTolTicks: 0,
    requoteTolSizePct: '',
    minRequoteIntervalMs: 0,
    jitterPct: '',
    maxOpenOrders: undefined,
    deadmanTtlMs: undefined,
    deadmanArmTimeoutMs: 0,
    fullRequoteMaxS: '',
    outboundQueueDepth: undefined,
    publishRetries: 0,
    publishTimeoutMs: 0,
    journalDir: '',
    journalRetentionDays: 0,
  }
}

export const OptionsMmOms: MessageFns<OptionsMmOms> = {
  encode(message: OptionsMmOms, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.makerOnly !== false) {
      writer.uint32(8).bool(message.makerOnly)
    }
    if (message.requoteTolVolpts !== '') {
      writer.uint32(18).string(message.requoteTolVolpts)
    }
    if (message.requoteTolTicks !== 0) {
      writer.uint32(24).uint32(message.requoteTolTicks)
    }
    if (message.requoteTolSizePct !== '') {
      writer.uint32(34).string(message.requoteTolSizePct)
    }
    if (message.minRequoteIntervalMs !== 0) {
      writer.uint32(40).uint32(message.minRequoteIntervalMs)
    }
    if (message.jitterPct !== '') {
      writer.uint32(50).string(message.jitterPct)
    }
    if (message.maxOpenOrders !== undefined) {
      writer.uint32(56).uint32(message.maxOpenOrders)
    }
    if (message.deadmanTtlMs !== undefined) {
      writer.uint32(64).uint32(message.deadmanTtlMs)
    }
    if (message.deadmanArmTimeoutMs !== 0) {
      writer.uint32(72).uint32(message.deadmanArmTimeoutMs)
    }
    if (message.fullRequoteMaxS !== '') {
      writer.uint32(82).string(message.fullRequoteMaxS)
    }
    if (message.outboundQueueDepth !== undefined) {
      writer.uint32(88).uint32(message.outboundQueueDepth)
    }
    if (message.publishRetries !== 0) {
      writer.uint32(96).uint32(message.publishRetries)
    }
    if (message.publishTimeoutMs !== 0) {
      writer.uint32(104).uint32(message.publishTimeoutMs)
    }
    if (message.journalDir !== '') {
      writer.uint32(114).string(message.journalDir)
    }
    if (message.journalRetentionDays !== 0) {
      writer.uint32(120).uint32(message.journalRetentionDays)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmOms {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmOms()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.makerOnly = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.requoteTolVolpts = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.requoteTolTicks = reader.uint32()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.requoteTolSizePct = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.minRequoteIntervalMs = reader.uint32()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.jitterPct = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.maxOpenOrders = reader.uint32()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.deadmanTtlMs = reader.uint32()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.deadmanArmTimeoutMs = reader.uint32()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.fullRequoteMaxS = reader.string()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.outboundQueueDepth = reader.uint32()
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.publishRetries = reader.uint32()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.publishTimeoutMs = reader.uint32()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.journalDir = reader.string()
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.journalRetentionDays = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmOms {
    return {
      makerOnly: isSet(object.makerOnly)
        ? globalThis.Boolean(object.makerOnly)
        : isSet(object.maker_only)
          ? globalThis.Boolean(object.maker_only)
          : false,
      requoteTolVolpts: isSet(object.requoteTolVolpts)
        ? globalThis.String(object.requoteTolVolpts)
        : isSet(object.requote_tol_volpts)
          ? globalThis.String(object.requote_tol_volpts)
          : '',
      requoteTolTicks: isSet(object.requoteTolTicks)
        ? globalThis.Number(object.requoteTolTicks)
        : isSet(object.requote_tol_ticks)
          ? globalThis.Number(object.requote_tol_ticks)
          : 0,
      requoteTolSizePct: isSet(object.requoteTolSizePct)
        ? globalThis.String(object.requoteTolSizePct)
        : isSet(object.requote_tol_size_pct)
          ? globalThis.String(object.requote_tol_size_pct)
          : '',
      minRequoteIntervalMs: isSet(object.minRequoteIntervalMs)
        ? globalThis.Number(object.minRequoteIntervalMs)
        : isSet(object.min_requote_interval_ms)
          ? globalThis.Number(object.min_requote_interval_ms)
          : 0,
      jitterPct: isSet(object.jitterPct)
        ? globalThis.String(object.jitterPct)
        : isSet(object.jitter_pct)
          ? globalThis.String(object.jitter_pct)
          : '',
      maxOpenOrders: isSet(object.maxOpenOrders)
        ? globalThis.Number(object.maxOpenOrders)
        : isSet(object.max_open_orders)
          ? globalThis.Number(object.max_open_orders)
          : undefined,
      deadmanTtlMs: isSet(object.deadmanTtlMs)
        ? globalThis.Number(object.deadmanTtlMs)
        : isSet(object.deadman_ttl_ms)
          ? globalThis.Number(object.deadman_ttl_ms)
          : undefined,
      deadmanArmTimeoutMs: isSet(object.deadmanArmTimeoutMs)
        ? globalThis.Number(object.deadmanArmTimeoutMs)
        : isSet(object.deadman_arm_timeout_ms)
          ? globalThis.Number(object.deadman_arm_timeout_ms)
          : 0,
      fullRequoteMaxS: isSet(object.fullRequoteMaxS)
        ? globalThis.String(object.fullRequoteMaxS)
        : isSet(object.full_requote_max_s)
          ? globalThis.String(object.full_requote_max_s)
          : '',
      outboundQueueDepth: isSet(object.outboundQueueDepth)
        ? globalThis.Number(object.outboundQueueDepth)
        : isSet(object.outbound_queue_depth)
          ? globalThis.Number(object.outbound_queue_depth)
          : undefined,
      publishRetries: isSet(object.publishRetries)
        ? globalThis.Number(object.publishRetries)
        : isSet(object.publish_retries)
          ? globalThis.Number(object.publish_retries)
          : 0,
      publishTimeoutMs: isSet(object.publishTimeoutMs)
        ? globalThis.Number(object.publishTimeoutMs)
        : isSet(object.publish_timeout_ms)
          ? globalThis.Number(object.publish_timeout_ms)
          : 0,
      journalDir: isSet(object.journalDir)
        ? globalThis.String(object.journalDir)
        : isSet(object.journal_dir)
          ? globalThis.String(object.journal_dir)
          : '',
      journalRetentionDays: isSet(object.journalRetentionDays)
        ? globalThis.Number(object.journalRetentionDays)
        : isSet(object.journal_retention_days)
          ? globalThis.Number(object.journal_retention_days)
          : 0,
    }
  },

  toJSON(message: OptionsMmOms): unknown {
    const obj: any = {}
    if (message.makerOnly !== false) {
      obj.makerOnly = message.makerOnly
    }
    if (message.requoteTolVolpts !== '') {
      obj.requoteTolVolpts = message.requoteTolVolpts
    }
    if (message.requoteTolTicks !== 0) {
      obj.requoteTolTicks = Math.round(message.requoteTolTicks)
    }
    if (message.requoteTolSizePct !== '') {
      obj.requoteTolSizePct = message.requoteTolSizePct
    }
    if (message.minRequoteIntervalMs !== 0) {
      obj.minRequoteIntervalMs = Math.round(message.minRequoteIntervalMs)
    }
    if (message.jitterPct !== '') {
      obj.jitterPct = message.jitterPct
    }
    if (message.maxOpenOrders !== undefined) {
      obj.maxOpenOrders = Math.round(message.maxOpenOrders)
    }
    if (message.deadmanTtlMs !== undefined) {
      obj.deadmanTtlMs = Math.round(message.deadmanTtlMs)
    }
    if (message.deadmanArmTimeoutMs !== 0) {
      obj.deadmanArmTimeoutMs = Math.round(message.deadmanArmTimeoutMs)
    }
    if (message.fullRequoteMaxS !== '') {
      obj.fullRequoteMaxS = message.fullRequoteMaxS
    }
    if (message.outboundQueueDepth !== undefined) {
      obj.outboundQueueDepth = Math.round(message.outboundQueueDepth)
    }
    if (message.publishRetries !== 0) {
      obj.publishRetries = Math.round(message.publishRetries)
    }
    if (message.publishTimeoutMs !== 0) {
      obj.publishTimeoutMs = Math.round(message.publishTimeoutMs)
    }
    if (message.journalDir !== '') {
      obj.journalDir = message.journalDir
    }
    if (message.journalRetentionDays !== 0) {
      obj.journalRetentionDays = Math.round(message.journalRetentionDays)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmOms>, I>>(base?: I): OptionsMmOms {
    return OptionsMmOms.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmOms>, I>>(object: I): OptionsMmOms {
    const message = createBaseOptionsMmOms()
    message.makerOnly = object.makerOnly ?? false
    message.requoteTolVolpts = object.requoteTolVolpts ?? ''
    message.requoteTolTicks = object.requoteTolTicks ?? 0
    message.requoteTolSizePct = object.requoteTolSizePct ?? ''
    message.minRequoteIntervalMs = object.minRequoteIntervalMs ?? 0
    message.jitterPct = object.jitterPct ?? ''
    message.maxOpenOrders = object.maxOpenOrders ?? undefined
    message.deadmanTtlMs = object.deadmanTtlMs ?? undefined
    message.deadmanArmTimeoutMs = object.deadmanArmTimeoutMs ?? 0
    message.fullRequoteMaxS = object.fullRequoteMaxS ?? ''
    message.outboundQueueDepth = object.outboundQueueDepth ?? undefined
    message.publishRetries = object.publishRetries ?? 0
    message.publishTimeoutMs = object.publishTimeoutMs ?? 0
    message.journalDir = object.journalDir ?? ''
    message.journalRetentionDays = object.journalRetentionDays ?? 0
    return message
  },
}

function createBaseOptionsMmMmp(): OptionsMmMmp {
  return { intervalMs: 0, frozenMs: 0, qtyLimitMult: '', deltaLimitPct: '' }
}

export const OptionsMmMmp: MessageFns<OptionsMmMmp> = {
  encode(message: OptionsMmMmp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.intervalMs !== 0) {
      writer.uint32(8).uint32(message.intervalMs)
    }
    if (message.frozenMs !== 0) {
      writer.uint32(16).uint32(message.frozenMs)
    }
    if (message.qtyLimitMult !== '') {
      writer.uint32(26).string(message.qtyLimitMult)
    }
    if (message.deltaLimitPct !== '') {
      writer.uint32(34).string(message.deltaLimitPct)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmMmp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmMmp()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.intervalMs = reader.uint32()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.frozenMs = reader.uint32()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.qtyLimitMult = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.deltaLimitPct = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmMmp {
    return {
      intervalMs: isSet(object.intervalMs)
        ? globalThis.Number(object.intervalMs)
        : isSet(object.interval_ms)
          ? globalThis.Number(object.interval_ms)
          : 0,
      frozenMs: isSet(object.frozenMs)
        ? globalThis.Number(object.frozenMs)
        : isSet(object.frozen_ms)
          ? globalThis.Number(object.frozen_ms)
          : 0,
      qtyLimitMult: isSet(object.qtyLimitMult)
        ? globalThis.String(object.qtyLimitMult)
        : isSet(object.qty_limit_mult)
          ? globalThis.String(object.qty_limit_mult)
          : '',
      deltaLimitPct: isSet(object.deltaLimitPct)
        ? globalThis.String(object.deltaLimitPct)
        : isSet(object.delta_limit_pct)
          ? globalThis.String(object.delta_limit_pct)
          : '',
    }
  },

  toJSON(message: OptionsMmMmp): unknown {
    const obj: any = {}
    if (message.intervalMs !== 0) {
      obj.intervalMs = Math.round(message.intervalMs)
    }
    if (message.frozenMs !== 0) {
      obj.frozenMs = Math.round(message.frozenMs)
    }
    if (message.qtyLimitMult !== '') {
      obj.qtyLimitMult = message.qtyLimitMult
    }
    if (message.deltaLimitPct !== '') {
      obj.deltaLimitPct = message.deltaLimitPct
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmMmp>, I>>(base?: I): OptionsMmMmp {
    return OptionsMmMmp.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmMmp>, I>>(object: I): OptionsMmMmp {
    const message = createBaseOptionsMmMmp()
    message.intervalMs = object.intervalMs ?? 0
    message.frozenMs = object.frozenMs ?? 0
    message.qtyLimitMult = object.qtyLimitMult ?? ''
    message.deltaLimitPct = object.deltaLimitPct ?? ''
    return message
  },
}

function createBaseOptionsMmSkew(): OptionsMmSkew {
  return {
    gainVolpts: '',
    microGain: undefined,
    microCapVolpts: '',
    markoutThresholdBp: '',
    markoutWidenVolpts: '',
  }
}

export const OptionsMmSkew: MessageFns<OptionsMmSkew> = {
  encode(message: OptionsMmSkew, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.gainVolpts !== '') {
      writer.uint32(10).string(message.gainVolpts)
    }
    if (message.microGain !== undefined) {
      OptionsMmCurve.encode(message.microGain, writer.uint32(18).fork()).join()
    }
    if (message.microCapVolpts !== '') {
      writer.uint32(26).string(message.microCapVolpts)
    }
    if (message.markoutThresholdBp !== '') {
      writer.uint32(34).string(message.markoutThresholdBp)
    }
    if (message.markoutWidenVolpts !== '') {
      writer.uint32(42).string(message.markoutWidenVolpts)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmSkew {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmSkew()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.gainVolpts = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.microGain = OptionsMmCurve.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.microCapVolpts = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.markoutThresholdBp = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.markoutWidenVolpts = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmSkew {
    return {
      gainVolpts: isSet(object.gainVolpts)
        ? globalThis.String(object.gainVolpts)
        : isSet(object.gain_volpts)
          ? globalThis.String(object.gain_volpts)
          : '',
      microGain: isSet(object.microGain)
        ? OptionsMmCurve.fromJSON(object.microGain)
        : isSet(object.micro_gain)
          ? OptionsMmCurve.fromJSON(object.micro_gain)
          : undefined,
      microCapVolpts: isSet(object.microCapVolpts)
        ? globalThis.String(object.microCapVolpts)
        : isSet(object.micro_cap_volpts)
          ? globalThis.String(object.micro_cap_volpts)
          : '',
      markoutThresholdBp: isSet(object.markoutThresholdBp)
        ? globalThis.String(object.markoutThresholdBp)
        : isSet(object.markout_threshold_bp)
          ? globalThis.String(object.markout_threshold_bp)
          : '',
      markoutWidenVolpts: isSet(object.markoutWidenVolpts)
        ? globalThis.String(object.markoutWidenVolpts)
        : isSet(object.markout_widen_volpts)
          ? globalThis.String(object.markout_widen_volpts)
          : '',
    }
  },

  toJSON(message: OptionsMmSkew): unknown {
    const obj: any = {}
    if (message.gainVolpts !== '') {
      obj.gainVolpts = message.gainVolpts
    }
    if (message.microGain !== undefined) {
      obj.microGain = OptionsMmCurve.toJSON(message.microGain)
    }
    if (message.microCapVolpts !== '') {
      obj.microCapVolpts = message.microCapVolpts
    }
    if (message.markoutThresholdBp !== '') {
      obj.markoutThresholdBp = message.markoutThresholdBp
    }
    if (message.markoutWidenVolpts !== '') {
      obj.markoutWidenVolpts = message.markoutWidenVolpts
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmSkew>, I>>(base?: I): OptionsMmSkew {
    return OptionsMmSkew.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmSkew>, I>>(object: I): OptionsMmSkew {
    const message = createBaseOptionsMmSkew()
    message.gainVolpts = object.gainVolpts ?? ''
    message.microGain =
      object.microGain !== undefined && object.microGain !== null
        ? OptionsMmCurve.fromPartial(object.microGain)
        : undefined
    message.microCapVolpts = object.microCapVolpts ?? ''
    message.markoutThresholdBp = object.markoutThresholdBp ?? ''
    message.markoutWidenVolpts = object.markoutWidenVolpts ?? ''
    return message
  },
}

function createBaseOptionsMmProtection(): OptionsMmProtection {
  return {
    movePct: '',
    moveWindowMin: 0,
    pauseMin: 0,
    rvolVolpts: '',
    rvolWindowMin: 0,
    rvolWiden: '',
    latencyP99Ms: 0,
    latencyWiden: '',
    latencyMaxMs: 0,
    refSpreadRatio: '',
    fitDivergenceVolpts: '',
    fitDivergencePersistS: 0,
    hedgeFeedTimeoutS: 0,
    fundingAbsBp8h: '',
  }
}

export const OptionsMmProtection: MessageFns<OptionsMmProtection> = {
  encode(message: OptionsMmProtection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.movePct !== '') {
      writer.uint32(10).string(message.movePct)
    }
    if (message.moveWindowMin !== 0) {
      writer.uint32(16).uint32(message.moveWindowMin)
    }
    if (message.pauseMin !== 0) {
      writer.uint32(24).uint32(message.pauseMin)
    }
    if (message.rvolVolpts !== '') {
      writer.uint32(34).string(message.rvolVolpts)
    }
    if (message.rvolWindowMin !== 0) {
      writer.uint32(40).uint32(message.rvolWindowMin)
    }
    if (message.rvolWiden !== '') {
      writer.uint32(50).string(message.rvolWiden)
    }
    if (message.latencyP99Ms !== 0) {
      writer.uint32(56).uint32(message.latencyP99Ms)
    }
    if (message.latencyWiden !== '') {
      writer.uint32(66).string(message.latencyWiden)
    }
    if (message.latencyMaxMs !== 0) {
      writer.uint32(72).uint32(message.latencyMaxMs)
    }
    if (message.refSpreadRatio !== '') {
      writer.uint32(82).string(message.refSpreadRatio)
    }
    if (message.fitDivergenceVolpts !== '') {
      writer.uint32(90).string(message.fitDivergenceVolpts)
    }
    if (message.fitDivergencePersistS !== 0) {
      writer.uint32(96).uint32(message.fitDivergencePersistS)
    }
    if (message.hedgeFeedTimeoutS !== 0) {
      writer.uint32(104).uint32(message.hedgeFeedTimeoutS)
    }
    if (message.fundingAbsBp8h !== '') {
      writer.uint32(114).string(message.fundingAbsBp8h)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmProtection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmProtection()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.movePct = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.moveWindowMin = reader.uint32()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.pauseMin = reader.uint32()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.rvolVolpts = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.rvolWindowMin = reader.uint32()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.rvolWiden = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.latencyP99Ms = reader.uint32()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.latencyWiden = reader.string()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.latencyMaxMs = reader.uint32()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.refSpreadRatio = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.fitDivergenceVolpts = reader.string()
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.fitDivergencePersistS = reader.uint32()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.hedgeFeedTimeoutS = reader.uint32()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.fundingAbsBp8h = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmProtection {
    return {
      movePct: isSet(object.movePct)
        ? globalThis.String(object.movePct)
        : isSet(object.move_pct)
          ? globalThis.String(object.move_pct)
          : '',
      moveWindowMin: isSet(object.moveWindowMin)
        ? globalThis.Number(object.moveWindowMin)
        : isSet(object.move_window_min)
          ? globalThis.Number(object.move_window_min)
          : 0,
      pauseMin: isSet(object.pauseMin)
        ? globalThis.Number(object.pauseMin)
        : isSet(object.pause_min)
          ? globalThis.Number(object.pause_min)
          : 0,
      rvolVolpts: isSet(object.rvolVolpts)
        ? globalThis.String(object.rvolVolpts)
        : isSet(object.rvol_volpts)
          ? globalThis.String(object.rvol_volpts)
          : '',
      rvolWindowMin: isSet(object.rvolWindowMin)
        ? globalThis.Number(object.rvolWindowMin)
        : isSet(object.rvol_window_min)
          ? globalThis.Number(object.rvol_window_min)
          : 0,
      rvolWiden: isSet(object.rvolWiden)
        ? globalThis.String(object.rvolWiden)
        : isSet(object.rvol_widen)
          ? globalThis.String(object.rvol_widen)
          : '',
      latencyP99Ms: isSet(object.latencyP99Ms)
        ? globalThis.Number(object.latencyP99Ms)
        : isSet(object.latency_p99_ms)
          ? globalThis.Number(object.latency_p99_ms)
          : 0,
      latencyWiden: isSet(object.latencyWiden)
        ? globalThis.String(object.latencyWiden)
        : isSet(object.latency_widen)
          ? globalThis.String(object.latency_widen)
          : '',
      latencyMaxMs: isSet(object.latencyMaxMs)
        ? globalThis.Number(object.latencyMaxMs)
        : isSet(object.latency_max_ms)
          ? globalThis.Number(object.latency_max_ms)
          : 0,
      refSpreadRatio: isSet(object.refSpreadRatio)
        ? globalThis.String(object.refSpreadRatio)
        : isSet(object.ref_spread_ratio)
          ? globalThis.String(object.ref_spread_ratio)
          : '',
      fitDivergenceVolpts: isSet(object.fitDivergenceVolpts)
        ? globalThis.String(object.fitDivergenceVolpts)
        : isSet(object.fit_divergence_volpts)
          ? globalThis.String(object.fit_divergence_volpts)
          : '',
      fitDivergencePersistS: isSet(object.fitDivergencePersistS)
        ? globalThis.Number(object.fitDivergencePersistS)
        : isSet(object.fit_divergence_persist_s)
          ? globalThis.Number(object.fit_divergence_persist_s)
          : 0,
      hedgeFeedTimeoutS: isSet(object.hedgeFeedTimeoutS)
        ? globalThis.Number(object.hedgeFeedTimeoutS)
        : isSet(object.hedge_feed_timeout_s)
          ? globalThis.Number(object.hedge_feed_timeout_s)
          : 0,
      fundingAbsBp8h: isSet(object.fundingAbsBp8h)
        ? globalThis.String(object.fundingAbsBp8h)
        : isSet(object.funding_abs_bp_8h)
          ? globalThis.String(object.funding_abs_bp_8h)
          : '',
    }
  },

  toJSON(message: OptionsMmProtection): unknown {
    const obj: any = {}
    if (message.movePct !== '') {
      obj.movePct = message.movePct
    }
    if (message.moveWindowMin !== 0) {
      obj.moveWindowMin = Math.round(message.moveWindowMin)
    }
    if (message.pauseMin !== 0) {
      obj.pauseMin = Math.round(message.pauseMin)
    }
    if (message.rvolVolpts !== '') {
      obj.rvolVolpts = message.rvolVolpts
    }
    if (message.rvolWindowMin !== 0) {
      obj.rvolWindowMin = Math.round(message.rvolWindowMin)
    }
    if (message.rvolWiden !== '') {
      obj.rvolWiden = message.rvolWiden
    }
    if (message.latencyP99Ms !== 0) {
      obj.latencyP99Ms = Math.round(message.latencyP99Ms)
    }
    if (message.latencyWiden !== '') {
      obj.latencyWiden = message.latencyWiden
    }
    if (message.latencyMaxMs !== 0) {
      obj.latencyMaxMs = Math.round(message.latencyMaxMs)
    }
    if (message.refSpreadRatio !== '') {
      obj.refSpreadRatio = message.refSpreadRatio
    }
    if (message.fitDivergenceVolpts !== '') {
      obj.fitDivergenceVolpts = message.fitDivergenceVolpts
    }
    if (message.fitDivergencePersistS !== 0) {
      obj.fitDivergencePersistS = Math.round(message.fitDivergencePersistS)
    }
    if (message.hedgeFeedTimeoutS !== 0) {
      obj.hedgeFeedTimeoutS = Math.round(message.hedgeFeedTimeoutS)
    }
    if (message.fundingAbsBp8h !== '') {
      obj.fundingAbsBp8h = message.fundingAbsBp8h
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmProtection>, I>>(base?: I): OptionsMmProtection {
    return OptionsMmProtection.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmProtection>, I>>(
    object: I
  ): OptionsMmProtection {
    const message = createBaseOptionsMmProtection()
    message.movePct = object.movePct ?? ''
    message.moveWindowMin = object.moveWindowMin ?? 0
    message.pauseMin = object.pauseMin ?? 0
    message.rvolVolpts = object.rvolVolpts ?? ''
    message.rvolWindowMin = object.rvolWindowMin ?? 0
    message.rvolWiden = object.rvolWiden ?? ''
    message.latencyP99Ms = object.latencyP99Ms ?? 0
    message.latencyWiden = object.latencyWiden ?? ''
    message.latencyMaxMs = object.latencyMaxMs ?? 0
    message.refSpreadRatio = object.refSpreadRatio ?? ''
    message.fitDivergenceVolpts = object.fitDivergenceVolpts ?? ''
    message.fitDivergencePersistS = object.fitDivergencePersistS ?? 0
    message.hedgeFeedTimeoutS = object.hedgeFeedTimeoutS ?? 0
    message.fundingAbsBp8h = object.fundingAbsBp8h ?? ''
    return message
  },
}

function createBaseOptionsMmFlow(): OptionsMmFlow {
  return {
    maxFillsWindow: 0,
    maxFillsInstrument: 0,
    windowMin: 0,
    sameSideGuard: 0,
    markoutWindowsS: [],
    markoutPauseBp: '',
    markoutPauseFills: 0,
  }
}

export const OptionsMmFlow: MessageFns<OptionsMmFlow> = {
  encode(message: OptionsMmFlow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.maxFillsWindow !== 0) {
      writer.uint32(8).uint32(message.maxFillsWindow)
    }
    if (message.maxFillsInstrument !== 0) {
      writer.uint32(16).uint32(message.maxFillsInstrument)
    }
    if (message.windowMin !== 0) {
      writer.uint32(24).uint32(message.windowMin)
    }
    if (message.sameSideGuard !== 0) {
      writer.uint32(32).uint32(message.sameSideGuard)
    }
    writer.uint32(42).fork()
    for (const v of message.markoutWindowsS) {
      writer.uint32(v)
    }
    writer.join()
    if (message.markoutPauseBp !== '') {
      writer.uint32(50).string(message.markoutPauseBp)
    }
    if (message.markoutPauseFills !== 0) {
      writer.uint32(56).uint32(message.markoutPauseFills)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmFlow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmFlow()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.maxFillsWindow = reader.uint32()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.maxFillsInstrument = reader.uint32()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.windowMin = reader.uint32()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.sameSideGuard = reader.uint32()
          continue
        }
        case 5: {
          if (tag === 40) {
            message.markoutWindowsS.push(reader.uint32())

            continue
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos
            while (reader.pos < end2) {
              message.markoutWindowsS.push(reader.uint32())
            }

            continue
          }

          break
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.markoutPauseBp = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.markoutPauseFills = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmFlow {
    return {
      maxFillsWindow: isSet(object.maxFillsWindow)
        ? globalThis.Number(object.maxFillsWindow)
        : isSet(object.max_fills_window)
          ? globalThis.Number(object.max_fills_window)
          : 0,
      maxFillsInstrument: isSet(object.maxFillsInstrument)
        ? globalThis.Number(object.maxFillsInstrument)
        : isSet(object.max_fills_instrument)
          ? globalThis.Number(object.max_fills_instrument)
          : 0,
      windowMin: isSet(object.windowMin)
        ? globalThis.Number(object.windowMin)
        : isSet(object.window_min)
          ? globalThis.Number(object.window_min)
          : 0,
      sameSideGuard: isSet(object.sameSideGuard)
        ? globalThis.Number(object.sameSideGuard)
        : isSet(object.same_side_guard)
          ? globalThis.Number(object.same_side_guard)
          : 0,
      markoutWindowsS: globalThis.Array.isArray(object?.markoutWindowsS)
        ? object.markoutWindowsS.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.markout_windows_s)
          ? object.markout_windows_s.map((e: any) => globalThis.Number(e))
          : [],
      markoutPauseBp: isSet(object.markoutPauseBp)
        ? globalThis.String(object.markoutPauseBp)
        : isSet(object.markout_pause_bp)
          ? globalThis.String(object.markout_pause_bp)
          : '',
      markoutPauseFills: isSet(object.markoutPauseFills)
        ? globalThis.Number(object.markoutPauseFills)
        : isSet(object.markout_pause_fills)
          ? globalThis.Number(object.markout_pause_fills)
          : 0,
    }
  },

  toJSON(message: OptionsMmFlow): unknown {
    const obj: any = {}
    if (message.maxFillsWindow !== 0) {
      obj.maxFillsWindow = Math.round(message.maxFillsWindow)
    }
    if (message.maxFillsInstrument !== 0) {
      obj.maxFillsInstrument = Math.round(message.maxFillsInstrument)
    }
    if (message.windowMin !== 0) {
      obj.windowMin = Math.round(message.windowMin)
    }
    if (message.sameSideGuard !== 0) {
      obj.sameSideGuard = Math.round(message.sameSideGuard)
    }
    if (message.markoutWindowsS?.length) {
      obj.markoutWindowsS = message.markoutWindowsS.map((e) => Math.round(e))
    }
    if (message.markoutPauseBp !== '') {
      obj.markoutPauseBp = message.markoutPauseBp
    }
    if (message.markoutPauseFills !== 0) {
      obj.markoutPauseFills = Math.round(message.markoutPauseFills)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmFlow>, I>>(base?: I): OptionsMmFlow {
    return OptionsMmFlow.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmFlow>, I>>(object: I): OptionsMmFlow {
    const message = createBaseOptionsMmFlow()
    message.maxFillsWindow = object.maxFillsWindow ?? 0
    message.maxFillsInstrument = object.maxFillsInstrument ?? 0
    message.windowMin = object.windowMin ?? 0
    message.sameSideGuard = object.sameSideGuard ?? 0
    message.markoutWindowsS = object.markoutWindowsS?.map((e) => e) || []
    message.markoutPauseBp = object.markoutPauseBp ?? ''
    message.markoutPauseFills = object.markoutPauseFills ?? 0
    return message
  },
}

function createBaseOptionsMmRisk(): OptionsMmRisk {
  return {
    scaleWithEquity: false,
    deltaMaxPct: undefined,
    deltaMinPct: undefined,
    gammaMaxPct: undefined,
    gammaMinPct: undefined,
    vegaMaxPct: undefined,
    vegaMinPct: undefined,
    thetaMaxPct: undefined,
    thetaMinPct: undefined,
    notionalMaxMult: undefined,
    imMaxPct: '',
    mmBufferPct: '',
    stressLossMaxPct: '',
    stressSpotShockPct: '',
    stressVolShockVolpts: '',
    softPct: '',
    killPct: '',
    breachGraceS: 0,
    dailyLossMaxPct: '',
    derateLossPct: '',
    stuckOrderS: 0,
    reconMismatchFrames: 0,
    deltaGapMaxPct: '',
    deltaGapPersistS: 0,
  }
}

export const OptionsMmRisk: MessageFns<OptionsMmRisk> = {
  encode(message: OptionsMmRisk, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.scaleWithEquity !== false) {
      writer.uint32(8).bool(message.scaleWithEquity)
    }
    if (message.deltaMaxPct !== undefined) {
      OptionsMmScoped.encode(message.deltaMaxPct, writer.uint32(18).fork()).join()
    }
    if (message.deltaMinPct !== undefined) {
      OptionsMmScoped.encode(message.deltaMinPct, writer.uint32(26).fork()).join()
    }
    if (message.gammaMaxPct !== undefined) {
      OptionsMmScoped.encode(message.gammaMaxPct, writer.uint32(34).fork()).join()
    }
    if (message.gammaMinPct !== undefined) {
      OptionsMmScoped.encode(message.gammaMinPct, writer.uint32(42).fork()).join()
    }
    if (message.vegaMaxPct !== undefined) {
      OptionsMmScoped.encode(message.vegaMaxPct, writer.uint32(50).fork()).join()
    }
    if (message.vegaMinPct !== undefined) {
      OptionsMmScoped.encode(message.vegaMinPct, writer.uint32(58).fork()).join()
    }
    if (message.thetaMaxPct !== undefined) {
      OptionsMmScoped.encode(message.thetaMaxPct, writer.uint32(66).fork()).join()
    }
    if (message.thetaMinPct !== undefined) {
      OptionsMmScoped.encode(message.thetaMinPct, writer.uint32(74).fork()).join()
    }
    if (message.notionalMaxMult !== undefined) {
      OptionsMmScoped.encode(message.notionalMaxMult, writer.uint32(82).fork()).join()
    }
    if (message.imMaxPct !== '') {
      writer.uint32(90).string(message.imMaxPct)
    }
    if (message.mmBufferPct !== '') {
      writer.uint32(98).string(message.mmBufferPct)
    }
    if (message.stressLossMaxPct !== '') {
      writer.uint32(106).string(message.stressLossMaxPct)
    }
    if (message.stressSpotShockPct !== '') {
      writer.uint32(114).string(message.stressSpotShockPct)
    }
    if (message.stressVolShockVolpts !== '') {
      writer.uint32(122).string(message.stressVolShockVolpts)
    }
    if (message.softPct !== '') {
      writer.uint32(130).string(message.softPct)
    }
    if (message.killPct !== '') {
      writer.uint32(138).string(message.killPct)
    }
    if (message.breachGraceS !== 0) {
      writer.uint32(144).uint32(message.breachGraceS)
    }
    if (message.dailyLossMaxPct !== '') {
      writer.uint32(154).string(message.dailyLossMaxPct)
    }
    if (message.derateLossPct !== '') {
      writer.uint32(162).string(message.derateLossPct)
    }
    if (message.stuckOrderS !== 0) {
      writer.uint32(168).uint32(message.stuckOrderS)
    }
    if (message.reconMismatchFrames !== 0) {
      writer.uint32(176).uint32(message.reconMismatchFrames)
    }
    if (message.deltaGapMaxPct !== '') {
      writer.uint32(186).string(message.deltaGapMaxPct)
    }
    if (message.deltaGapPersistS !== 0) {
      writer.uint32(192).uint32(message.deltaGapPersistS)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmRisk {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmRisk()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.scaleWithEquity = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.deltaMaxPct = OptionsMmScoped.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.deltaMinPct = OptionsMmScoped.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.gammaMaxPct = OptionsMmScoped.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.gammaMinPct = OptionsMmScoped.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.vegaMaxPct = OptionsMmScoped.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.vegaMinPct = OptionsMmScoped.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.thetaMaxPct = OptionsMmScoped.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.thetaMinPct = OptionsMmScoped.decode(reader, reader.uint32())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.notionalMaxMult = OptionsMmScoped.decode(reader, reader.uint32())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.imMaxPct = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.mmBufferPct = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.stressLossMaxPct = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.stressSpotShockPct = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.stressVolShockVolpts = reader.string()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.softPct = reader.string()
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.killPct = reader.string()
          continue
        }
        case 18: {
          if (tag !== 144) {
            break
          }

          message.breachGraceS = reader.uint32()
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.dailyLossMaxPct = reader.string()
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.derateLossPct = reader.string()
          continue
        }
        case 21: {
          if (tag !== 168) {
            break
          }

          message.stuckOrderS = reader.uint32()
          continue
        }
        case 22: {
          if (tag !== 176) {
            break
          }

          message.reconMismatchFrames = reader.uint32()
          continue
        }
        case 23: {
          if (tag !== 186) {
            break
          }

          message.deltaGapMaxPct = reader.string()
          continue
        }
        case 24: {
          if (tag !== 192) {
            break
          }

          message.deltaGapPersistS = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmRisk {
    return {
      scaleWithEquity: isSet(object.scaleWithEquity)
        ? globalThis.Boolean(object.scaleWithEquity)
        : isSet(object.scale_with_equity)
          ? globalThis.Boolean(object.scale_with_equity)
          : false,
      deltaMaxPct: isSet(object.deltaMaxPct)
        ? OptionsMmScoped.fromJSON(object.deltaMaxPct)
        : isSet(object.delta_max_pct)
          ? OptionsMmScoped.fromJSON(object.delta_max_pct)
          : undefined,
      deltaMinPct: isSet(object.deltaMinPct)
        ? OptionsMmScoped.fromJSON(object.deltaMinPct)
        : isSet(object.delta_min_pct)
          ? OptionsMmScoped.fromJSON(object.delta_min_pct)
          : undefined,
      gammaMaxPct: isSet(object.gammaMaxPct)
        ? OptionsMmScoped.fromJSON(object.gammaMaxPct)
        : isSet(object.gamma_max_pct)
          ? OptionsMmScoped.fromJSON(object.gamma_max_pct)
          : undefined,
      gammaMinPct: isSet(object.gammaMinPct)
        ? OptionsMmScoped.fromJSON(object.gammaMinPct)
        : isSet(object.gamma_min_pct)
          ? OptionsMmScoped.fromJSON(object.gamma_min_pct)
          : undefined,
      vegaMaxPct: isSet(object.vegaMaxPct)
        ? OptionsMmScoped.fromJSON(object.vegaMaxPct)
        : isSet(object.vega_max_pct)
          ? OptionsMmScoped.fromJSON(object.vega_max_pct)
          : undefined,
      vegaMinPct: isSet(object.vegaMinPct)
        ? OptionsMmScoped.fromJSON(object.vegaMinPct)
        : isSet(object.vega_min_pct)
          ? OptionsMmScoped.fromJSON(object.vega_min_pct)
          : undefined,
      thetaMaxPct: isSet(object.thetaMaxPct)
        ? OptionsMmScoped.fromJSON(object.thetaMaxPct)
        : isSet(object.theta_max_pct)
          ? OptionsMmScoped.fromJSON(object.theta_max_pct)
          : undefined,
      thetaMinPct: isSet(object.thetaMinPct)
        ? OptionsMmScoped.fromJSON(object.thetaMinPct)
        : isSet(object.theta_min_pct)
          ? OptionsMmScoped.fromJSON(object.theta_min_pct)
          : undefined,
      notionalMaxMult: isSet(object.notionalMaxMult)
        ? OptionsMmScoped.fromJSON(object.notionalMaxMult)
        : isSet(object.notional_max_mult)
          ? OptionsMmScoped.fromJSON(object.notional_max_mult)
          : undefined,
      imMaxPct: isSet(object.imMaxPct)
        ? globalThis.String(object.imMaxPct)
        : isSet(object.im_max_pct)
          ? globalThis.String(object.im_max_pct)
          : '',
      mmBufferPct: isSet(object.mmBufferPct)
        ? globalThis.String(object.mmBufferPct)
        : isSet(object.mm_buffer_pct)
          ? globalThis.String(object.mm_buffer_pct)
          : '',
      stressLossMaxPct: isSet(object.stressLossMaxPct)
        ? globalThis.String(object.stressLossMaxPct)
        : isSet(object.stress_loss_max_pct)
          ? globalThis.String(object.stress_loss_max_pct)
          : '',
      stressSpotShockPct: isSet(object.stressSpotShockPct)
        ? globalThis.String(object.stressSpotShockPct)
        : isSet(object.stress_spot_shock_pct)
          ? globalThis.String(object.stress_spot_shock_pct)
          : '',
      stressVolShockVolpts: isSet(object.stressVolShockVolpts)
        ? globalThis.String(object.stressVolShockVolpts)
        : isSet(object.stress_vol_shock_volpts)
          ? globalThis.String(object.stress_vol_shock_volpts)
          : '',
      softPct: isSet(object.softPct)
        ? globalThis.String(object.softPct)
        : isSet(object.soft_pct)
          ? globalThis.String(object.soft_pct)
          : '',
      killPct: isSet(object.killPct)
        ? globalThis.String(object.killPct)
        : isSet(object.kill_pct)
          ? globalThis.String(object.kill_pct)
          : '',
      breachGraceS: isSet(object.breachGraceS)
        ? globalThis.Number(object.breachGraceS)
        : isSet(object.breach_grace_s)
          ? globalThis.Number(object.breach_grace_s)
          : 0,
      dailyLossMaxPct: isSet(object.dailyLossMaxPct)
        ? globalThis.String(object.dailyLossMaxPct)
        : isSet(object.daily_loss_max_pct)
          ? globalThis.String(object.daily_loss_max_pct)
          : '',
      derateLossPct: isSet(object.derateLossPct)
        ? globalThis.String(object.derateLossPct)
        : isSet(object.derate_loss_pct)
          ? globalThis.String(object.derate_loss_pct)
          : '',
      stuckOrderS: isSet(object.stuckOrderS)
        ? globalThis.Number(object.stuckOrderS)
        : isSet(object.stuck_order_s)
          ? globalThis.Number(object.stuck_order_s)
          : 0,
      reconMismatchFrames: isSet(object.reconMismatchFrames)
        ? globalThis.Number(object.reconMismatchFrames)
        : isSet(object.recon_mismatch_frames)
          ? globalThis.Number(object.recon_mismatch_frames)
          : 0,
      deltaGapMaxPct: isSet(object.deltaGapMaxPct)
        ? globalThis.String(object.deltaGapMaxPct)
        : isSet(object.delta_gap_max_pct)
          ? globalThis.String(object.delta_gap_max_pct)
          : '',
      deltaGapPersistS: isSet(object.deltaGapPersistS)
        ? globalThis.Number(object.deltaGapPersistS)
        : isSet(object.delta_gap_persist_s)
          ? globalThis.Number(object.delta_gap_persist_s)
          : 0,
    }
  },

  toJSON(message: OptionsMmRisk): unknown {
    const obj: any = {}
    if (message.scaleWithEquity !== false) {
      obj.scaleWithEquity = message.scaleWithEquity
    }
    if (message.deltaMaxPct !== undefined) {
      obj.deltaMaxPct = OptionsMmScoped.toJSON(message.deltaMaxPct)
    }
    if (message.deltaMinPct !== undefined) {
      obj.deltaMinPct = OptionsMmScoped.toJSON(message.deltaMinPct)
    }
    if (message.gammaMaxPct !== undefined) {
      obj.gammaMaxPct = OptionsMmScoped.toJSON(message.gammaMaxPct)
    }
    if (message.gammaMinPct !== undefined) {
      obj.gammaMinPct = OptionsMmScoped.toJSON(message.gammaMinPct)
    }
    if (message.vegaMaxPct !== undefined) {
      obj.vegaMaxPct = OptionsMmScoped.toJSON(message.vegaMaxPct)
    }
    if (message.vegaMinPct !== undefined) {
      obj.vegaMinPct = OptionsMmScoped.toJSON(message.vegaMinPct)
    }
    if (message.thetaMaxPct !== undefined) {
      obj.thetaMaxPct = OptionsMmScoped.toJSON(message.thetaMaxPct)
    }
    if (message.thetaMinPct !== undefined) {
      obj.thetaMinPct = OptionsMmScoped.toJSON(message.thetaMinPct)
    }
    if (message.notionalMaxMult !== undefined) {
      obj.notionalMaxMult = OptionsMmScoped.toJSON(message.notionalMaxMult)
    }
    if (message.imMaxPct !== '') {
      obj.imMaxPct = message.imMaxPct
    }
    if (message.mmBufferPct !== '') {
      obj.mmBufferPct = message.mmBufferPct
    }
    if (message.stressLossMaxPct !== '') {
      obj.stressLossMaxPct = message.stressLossMaxPct
    }
    if (message.stressSpotShockPct !== '') {
      obj.stressSpotShockPct = message.stressSpotShockPct
    }
    if (message.stressVolShockVolpts !== '') {
      obj.stressVolShockVolpts = message.stressVolShockVolpts
    }
    if (message.softPct !== '') {
      obj.softPct = message.softPct
    }
    if (message.killPct !== '') {
      obj.killPct = message.killPct
    }
    if (message.breachGraceS !== 0) {
      obj.breachGraceS = Math.round(message.breachGraceS)
    }
    if (message.dailyLossMaxPct !== '') {
      obj.dailyLossMaxPct = message.dailyLossMaxPct
    }
    if (message.derateLossPct !== '') {
      obj.derateLossPct = message.derateLossPct
    }
    if (message.stuckOrderS !== 0) {
      obj.stuckOrderS = Math.round(message.stuckOrderS)
    }
    if (message.reconMismatchFrames !== 0) {
      obj.reconMismatchFrames = Math.round(message.reconMismatchFrames)
    }
    if (message.deltaGapMaxPct !== '') {
      obj.deltaGapMaxPct = message.deltaGapMaxPct
    }
    if (message.deltaGapPersistS !== 0) {
      obj.deltaGapPersistS = Math.round(message.deltaGapPersistS)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmRisk>, I>>(base?: I): OptionsMmRisk {
    return OptionsMmRisk.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmRisk>, I>>(object: I): OptionsMmRisk {
    const message = createBaseOptionsMmRisk()
    message.scaleWithEquity = object.scaleWithEquity ?? false
    message.deltaMaxPct =
      object.deltaMaxPct !== undefined && object.deltaMaxPct !== null
        ? OptionsMmScoped.fromPartial(object.deltaMaxPct)
        : undefined
    message.deltaMinPct =
      object.deltaMinPct !== undefined && object.deltaMinPct !== null
        ? OptionsMmScoped.fromPartial(object.deltaMinPct)
        : undefined
    message.gammaMaxPct =
      object.gammaMaxPct !== undefined && object.gammaMaxPct !== null
        ? OptionsMmScoped.fromPartial(object.gammaMaxPct)
        : undefined
    message.gammaMinPct =
      object.gammaMinPct !== undefined && object.gammaMinPct !== null
        ? OptionsMmScoped.fromPartial(object.gammaMinPct)
        : undefined
    message.vegaMaxPct =
      object.vegaMaxPct !== undefined && object.vegaMaxPct !== null
        ? OptionsMmScoped.fromPartial(object.vegaMaxPct)
        : undefined
    message.vegaMinPct =
      object.vegaMinPct !== undefined && object.vegaMinPct !== null
        ? OptionsMmScoped.fromPartial(object.vegaMinPct)
        : undefined
    message.thetaMaxPct =
      object.thetaMaxPct !== undefined && object.thetaMaxPct !== null
        ? OptionsMmScoped.fromPartial(object.thetaMaxPct)
        : undefined
    message.thetaMinPct =
      object.thetaMinPct !== undefined && object.thetaMinPct !== null
        ? OptionsMmScoped.fromPartial(object.thetaMinPct)
        : undefined
    message.notionalMaxMult =
      object.notionalMaxMult !== undefined && object.notionalMaxMult !== null
        ? OptionsMmScoped.fromPartial(object.notionalMaxMult)
        : undefined
    message.imMaxPct = object.imMaxPct ?? ''
    message.mmBufferPct = object.mmBufferPct ?? ''
    message.stressLossMaxPct = object.stressLossMaxPct ?? ''
    message.stressSpotShockPct = object.stressSpotShockPct ?? ''
    message.stressVolShockVolpts = object.stressVolShockVolpts ?? ''
    message.softPct = object.softPct ?? ''
    message.killPct = object.killPct ?? ''
    message.breachGraceS = object.breachGraceS ?? 0
    message.dailyLossMaxPct = object.dailyLossMaxPct ?? ''
    message.derateLossPct = object.derateLossPct ?? ''
    message.stuckOrderS = object.stuckOrderS ?? 0
    message.reconMismatchFrames = object.reconMismatchFrames ?? 0
    message.deltaGapMaxPct = object.deltaGapMaxPct ?? ''
    message.deltaGapPersistS = object.deltaGapPersistS ?? 0
    return message
  },
}

function createBaseOptionsMmHedge(): OptionsMmHedge {
  return {
    enabled: false,
    instrument: '',
    bandDeltaPct: '',
    targetRatio: '',
    minIntervalS: 0,
    passiveTtlS: 0,
    maxSlippageBp: '',
    maxFillToDecisionMs: 0,
    fundingSwitchBp: '',
  }
}

export const OptionsMmHedge: MessageFns<OptionsMmHedge> = {
  encode(message: OptionsMmHedge, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== false) {
      writer.uint32(8).bool(message.enabled)
    }
    if (message.instrument !== '') {
      writer.uint32(18).string(message.instrument)
    }
    if (message.bandDeltaPct !== '') {
      writer.uint32(26).string(message.bandDeltaPct)
    }
    if (message.targetRatio !== '') {
      writer.uint32(34).string(message.targetRatio)
    }
    if (message.minIntervalS !== 0) {
      writer.uint32(40).uint32(message.minIntervalS)
    }
    if (message.passiveTtlS !== 0) {
      writer.uint32(48).uint32(message.passiveTtlS)
    }
    if (message.maxSlippageBp !== '') {
      writer.uint32(58).string(message.maxSlippageBp)
    }
    if (message.maxFillToDecisionMs !== 0) {
      writer.uint32(64).uint32(message.maxFillToDecisionMs)
    }
    if (message.fundingSwitchBp !== '') {
      writer.uint32(74).string(message.fundingSwitchBp)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmHedge {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmHedge()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.enabled = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.instrument = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.bandDeltaPct = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.targetRatio = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.minIntervalS = reader.uint32()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.passiveTtlS = reader.uint32()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.maxSlippageBp = reader.string()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.maxFillToDecisionMs = reader.uint32()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.fundingSwitchBp = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmHedge {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      instrument: isSet(object.instrument) ? globalThis.String(object.instrument) : '',
      bandDeltaPct: isSet(object.bandDeltaPct)
        ? globalThis.String(object.bandDeltaPct)
        : isSet(object.band_delta_pct)
          ? globalThis.String(object.band_delta_pct)
          : '',
      targetRatio: isSet(object.targetRatio)
        ? globalThis.String(object.targetRatio)
        : isSet(object.target_ratio)
          ? globalThis.String(object.target_ratio)
          : '',
      minIntervalS: isSet(object.minIntervalS)
        ? globalThis.Number(object.minIntervalS)
        : isSet(object.min_interval_s)
          ? globalThis.Number(object.min_interval_s)
          : 0,
      passiveTtlS: isSet(object.passiveTtlS)
        ? globalThis.Number(object.passiveTtlS)
        : isSet(object.passive_ttl_s)
          ? globalThis.Number(object.passive_ttl_s)
          : 0,
      maxSlippageBp: isSet(object.maxSlippageBp)
        ? globalThis.String(object.maxSlippageBp)
        : isSet(object.max_slippage_bp)
          ? globalThis.String(object.max_slippage_bp)
          : '',
      maxFillToDecisionMs: isSet(object.maxFillToDecisionMs)
        ? globalThis.Number(object.maxFillToDecisionMs)
        : isSet(object.max_fill_to_decision_ms)
          ? globalThis.Number(object.max_fill_to_decision_ms)
          : 0,
      fundingSwitchBp: isSet(object.fundingSwitchBp)
        ? globalThis.String(object.fundingSwitchBp)
        : isSet(object.funding_switch_bp)
          ? globalThis.String(object.funding_switch_bp)
          : '',
    }
  },

  toJSON(message: OptionsMmHedge): unknown {
    const obj: any = {}
    if (message.enabled !== false) {
      obj.enabled = message.enabled
    }
    if (message.instrument !== '') {
      obj.instrument = message.instrument
    }
    if (message.bandDeltaPct !== '') {
      obj.bandDeltaPct = message.bandDeltaPct
    }
    if (message.targetRatio !== '') {
      obj.targetRatio = message.targetRatio
    }
    if (message.minIntervalS !== 0) {
      obj.minIntervalS = Math.round(message.minIntervalS)
    }
    if (message.passiveTtlS !== 0) {
      obj.passiveTtlS = Math.round(message.passiveTtlS)
    }
    if (message.maxSlippageBp !== '') {
      obj.maxSlippageBp = message.maxSlippageBp
    }
    if (message.maxFillToDecisionMs !== 0) {
      obj.maxFillToDecisionMs = Math.round(message.maxFillToDecisionMs)
    }
    if (message.fundingSwitchBp !== '') {
      obj.fundingSwitchBp = message.fundingSwitchBp
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmHedge>, I>>(base?: I): OptionsMmHedge {
    return OptionsMmHedge.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmHedge>, I>>(object: I): OptionsMmHedge {
    const message = createBaseOptionsMmHedge()
    message.enabled = object.enabled ?? false
    message.instrument = object.instrument ?? ''
    message.bandDeltaPct = object.bandDeltaPct ?? ''
    message.targetRatio = object.targetRatio ?? ''
    message.minIntervalS = object.minIntervalS ?? 0
    message.passiveTtlS = object.passiveTtlS ?? 0
    message.maxSlippageBp = object.maxSlippageBp ?? ''
    message.maxFillToDecisionMs = object.maxFillToDecisionMs ?? 0
    message.fundingSwitchBp = object.fundingSwitchBp ?? ''
    return message
  },
}

function createBaseOptionsMmEventWindow(): OptionsMmEventWindow {
  return {
    name: '',
    source: '',
    tier: 0,
    startMs: '0',
    endMs: '0',
    rampInMin: 0,
    pauseStartMin: undefined,
    pauseEndMin: undefined,
    spreadMult: '',
    sizeMult: '',
    rampOutMin: 0,
  }
}

export const OptionsMmEventWindow: MessageFns<OptionsMmEventWindow> = {
  encode(message: OptionsMmEventWindow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== '') {
      writer.uint32(10).string(message.name)
    }
    if (message.source !== '') {
      writer.uint32(18).string(message.source)
    }
    if (message.tier !== 0) {
      writer.uint32(24).int32(message.tier)
    }
    if (message.startMs !== '0') {
      writer.uint32(32).int64(message.startMs)
    }
    if (message.endMs !== '0') {
      writer.uint32(40).int64(message.endMs)
    }
    if (message.rampInMin !== 0) {
      writer.uint32(48).uint32(message.rampInMin)
    }
    if (message.pauseStartMin !== undefined) {
      writer.uint32(56).int32(message.pauseStartMin)
    }
    if (message.pauseEndMin !== undefined) {
      writer.uint32(64).int32(message.pauseEndMin)
    }
    if (message.spreadMult !== '') {
      writer.uint32(74).string(message.spreadMult)
    }
    if (message.sizeMult !== '') {
      writer.uint32(82).string(message.sizeMult)
    }
    if (message.rampOutMin !== 0) {
      writer.uint32(88).uint32(message.rampOutMin)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmEventWindow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmEventWindow()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.source = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.tier = reader.int32()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.startMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.endMs = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.rampInMin = reader.uint32()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.pauseStartMin = reader.int32()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.pauseEndMin = reader.int32()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.spreadMult = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.sizeMult = reader.string()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.rampOutMin = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmEventWindow {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      source: isSet(object.source) ? globalThis.String(object.source) : '',
      tier: isSet(object.tier) ? globalThis.Number(object.tier) : 0,
      startMs: isSet(object.startMs)
        ? globalThis.String(object.startMs)
        : isSet(object.start_ms)
          ? globalThis.String(object.start_ms)
          : '0',
      endMs: isSet(object.endMs)
        ? globalThis.String(object.endMs)
        : isSet(object.end_ms)
          ? globalThis.String(object.end_ms)
          : '0',
      rampInMin: isSet(object.rampInMin)
        ? globalThis.Number(object.rampInMin)
        : isSet(object.ramp_in_min)
          ? globalThis.Number(object.ramp_in_min)
          : 0,
      pauseStartMin: isSet(object.pauseStartMin)
        ? globalThis.Number(object.pauseStartMin)
        : isSet(object.pause_start_min)
          ? globalThis.Number(object.pause_start_min)
          : undefined,
      pauseEndMin: isSet(object.pauseEndMin)
        ? globalThis.Number(object.pauseEndMin)
        : isSet(object.pause_end_min)
          ? globalThis.Number(object.pause_end_min)
          : undefined,
      spreadMult: isSet(object.spreadMult)
        ? globalThis.String(object.spreadMult)
        : isSet(object.spread_mult)
          ? globalThis.String(object.spread_mult)
          : '',
      sizeMult: isSet(object.sizeMult)
        ? globalThis.String(object.sizeMult)
        : isSet(object.size_mult)
          ? globalThis.String(object.size_mult)
          : '',
      rampOutMin: isSet(object.rampOutMin)
        ? globalThis.Number(object.rampOutMin)
        : isSet(object.ramp_out_min)
          ? globalThis.Number(object.ramp_out_min)
          : 0,
    }
  },

  toJSON(message: OptionsMmEventWindow): unknown {
    const obj: any = {}
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.source !== '') {
      obj.source = message.source
    }
    if (message.tier !== 0) {
      obj.tier = Math.round(message.tier)
    }
    if (message.startMs !== '0') {
      obj.startMs = message.startMs
    }
    if (message.endMs !== '0') {
      obj.endMs = message.endMs
    }
    if (message.rampInMin !== 0) {
      obj.rampInMin = Math.round(message.rampInMin)
    }
    if (message.pauseStartMin !== undefined) {
      obj.pauseStartMin = Math.round(message.pauseStartMin)
    }
    if (message.pauseEndMin !== undefined) {
      obj.pauseEndMin = Math.round(message.pauseEndMin)
    }
    if (message.spreadMult !== '') {
      obj.spreadMult = message.spreadMult
    }
    if (message.sizeMult !== '') {
      obj.sizeMult = message.sizeMult
    }
    if (message.rampOutMin !== 0) {
      obj.rampOutMin = Math.round(message.rampOutMin)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmEventWindow>, I>>(base?: I): OptionsMmEventWindow {
    return OptionsMmEventWindow.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmEventWindow>, I>>(
    object: I
  ): OptionsMmEventWindow {
    const message = createBaseOptionsMmEventWindow()
    message.name = object.name ?? ''
    message.source = object.source ?? ''
    message.tier = object.tier ?? 0
    message.startMs = object.startMs ?? '0'
    message.endMs = object.endMs ?? '0'
    message.rampInMin = object.rampInMin ?? 0
    message.pauseStartMin = object.pauseStartMin ?? undefined
    message.pauseEndMin = object.pauseEndMin ?? undefined
    message.spreadMult = object.spreadMult ?? ''
    message.sizeMult = object.sizeMult ?? ''
    message.rampOutMin = object.rampOutMin ?? 0
    return message
  },
}

function createBaseOptionsMmEventTierDefault(): OptionsMmEventTierDefault {
  return {
    tier: 0,
    spreadMult: '',
    sizeMult: '',
    pauseStartMin: undefined,
    pauseEndMin: undefined,
    rampInMin: 0,
    rampOutMin: 0,
  }
}

export const OptionsMmEventTierDefault: MessageFns<OptionsMmEventTierDefault> = {
  encode(
    message: OptionsMmEventTierDefault,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.tier !== 0) {
      writer.uint32(8).int32(message.tier)
    }
    if (message.spreadMult !== '') {
      writer.uint32(18).string(message.spreadMult)
    }
    if (message.sizeMult !== '') {
      writer.uint32(26).string(message.sizeMult)
    }
    if (message.pauseStartMin !== undefined) {
      writer.uint32(32).int32(message.pauseStartMin)
    }
    if (message.pauseEndMin !== undefined) {
      writer.uint32(40).int32(message.pauseEndMin)
    }
    if (message.rampInMin !== 0) {
      writer.uint32(48).uint32(message.rampInMin)
    }
    if (message.rampOutMin !== 0) {
      writer.uint32(56).uint32(message.rampOutMin)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmEventTierDefault {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmEventTierDefault()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.tier = reader.int32()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.spreadMult = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.sizeMult = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.pauseStartMin = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.pauseEndMin = reader.int32()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.rampInMin = reader.uint32()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.rampOutMin = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmEventTierDefault {
    return {
      tier: isSet(object.tier) ? globalThis.Number(object.tier) : 0,
      spreadMult: isSet(object.spreadMult)
        ? globalThis.String(object.spreadMult)
        : isSet(object.spread_mult)
          ? globalThis.String(object.spread_mult)
          : '',
      sizeMult: isSet(object.sizeMult)
        ? globalThis.String(object.sizeMult)
        : isSet(object.size_mult)
          ? globalThis.String(object.size_mult)
          : '',
      pauseStartMin: isSet(object.pauseStartMin)
        ? globalThis.Number(object.pauseStartMin)
        : isSet(object.pause_start_min)
          ? globalThis.Number(object.pause_start_min)
          : undefined,
      pauseEndMin: isSet(object.pauseEndMin)
        ? globalThis.Number(object.pauseEndMin)
        : isSet(object.pause_end_min)
          ? globalThis.Number(object.pause_end_min)
          : undefined,
      rampInMin: isSet(object.rampInMin)
        ? globalThis.Number(object.rampInMin)
        : isSet(object.ramp_in_min)
          ? globalThis.Number(object.ramp_in_min)
          : 0,
      rampOutMin: isSet(object.rampOutMin)
        ? globalThis.Number(object.rampOutMin)
        : isSet(object.ramp_out_min)
          ? globalThis.Number(object.ramp_out_min)
          : 0,
    }
  },

  toJSON(message: OptionsMmEventTierDefault): unknown {
    const obj: any = {}
    if (message.tier !== 0) {
      obj.tier = Math.round(message.tier)
    }
    if (message.spreadMult !== '') {
      obj.spreadMult = message.spreadMult
    }
    if (message.sizeMult !== '') {
      obj.sizeMult = message.sizeMult
    }
    if (message.pauseStartMin !== undefined) {
      obj.pauseStartMin = Math.round(message.pauseStartMin)
    }
    if (message.pauseEndMin !== undefined) {
      obj.pauseEndMin = Math.round(message.pauseEndMin)
    }
    if (message.rampInMin !== 0) {
      obj.rampInMin = Math.round(message.rampInMin)
    }
    if (message.rampOutMin !== 0) {
      obj.rampOutMin = Math.round(message.rampOutMin)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmEventTierDefault>, I>>(
    base?: I
  ): OptionsMmEventTierDefault {
    return OptionsMmEventTierDefault.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmEventTierDefault>, I>>(
    object: I
  ): OptionsMmEventTierDefault {
    const message = createBaseOptionsMmEventTierDefault()
    message.tier = object.tier ?? 0
    message.spreadMult = object.spreadMult ?? ''
    message.sizeMult = object.sizeMult ?? ''
    message.pauseStartMin = object.pauseStartMin ?? undefined
    message.pauseEndMin = object.pauseEndMin ?? undefined
    message.rampInMin = object.rampInMin ?? 0
    message.rampOutMin = object.rampOutMin ?? 0
    return message
  },
}

function createBaseOptionsMmEvents(): OptionsMmEvents {
  return {
    windows: [],
    tierDefaults: [],
    autoEvents: [],
    calendarPollMin: 0,
    closedHoursTier1Pause: false,
  }
}

export const OptionsMmEvents: MessageFns<OptionsMmEvents> = {
  encode(message: OptionsMmEvents, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.windows) {
      OptionsMmEventWindow.encode(v!, writer.uint32(10).fork()).join()
    }
    for (const v of message.tierDefaults) {
      OptionsMmEventTierDefault.encode(v!, writer.uint32(18).fork()).join()
    }
    for (const v of message.autoEvents) {
      writer.uint32(26).string(v!)
    }
    if (message.calendarPollMin !== 0) {
      writer.uint32(32).uint32(message.calendarPollMin)
    }
    if (message.closedHoursTier1Pause !== false) {
      writer.uint32(40).bool(message.closedHoursTier1Pause)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmEvents {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmEvents()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.windows.push(OptionsMmEventWindow.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.tierDefaults.push(OptionsMmEventTierDefault.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.autoEvents.push(reader.string())
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.calendarPollMin = reader.uint32()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.closedHoursTier1Pause = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmEvents {
    return {
      windows: globalThis.Array.isArray(object?.windows)
        ? object.windows.map((e: any) => OptionsMmEventWindow.fromJSON(e))
        : [],
      tierDefaults: globalThis.Array.isArray(object?.tierDefaults)
        ? object.tierDefaults.map((e: any) => OptionsMmEventTierDefault.fromJSON(e))
        : globalThis.Array.isArray(object?.tier_defaults)
          ? object.tier_defaults.map((e: any) => OptionsMmEventTierDefault.fromJSON(e))
          : [],
      autoEvents: globalThis.Array.isArray(object?.autoEvents)
        ? object.autoEvents.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.auto_events)
          ? object.auto_events.map((e: any) => globalThis.String(e))
          : [],
      calendarPollMin: isSet(object.calendarPollMin)
        ? globalThis.Number(object.calendarPollMin)
        : isSet(object.calendar_poll_min)
          ? globalThis.Number(object.calendar_poll_min)
          : 0,
      closedHoursTier1Pause: isSet(object.closedHoursTier1Pause)
        ? globalThis.Boolean(object.closedHoursTier1Pause)
        : isSet(object.closed_hours_tier1_pause)
          ? globalThis.Boolean(object.closed_hours_tier1_pause)
          : false,
    }
  },

  toJSON(message: OptionsMmEvents): unknown {
    const obj: any = {}
    if (message.windows?.length) {
      obj.windows = message.windows.map((e) => OptionsMmEventWindow.toJSON(e))
    }
    if (message.tierDefaults?.length) {
      obj.tierDefaults = message.tierDefaults.map((e) => OptionsMmEventTierDefault.toJSON(e))
    }
    if (message.autoEvents?.length) {
      obj.autoEvents = message.autoEvents
    }
    if (message.calendarPollMin !== 0) {
      obj.calendarPollMin = Math.round(message.calendarPollMin)
    }
    if (message.closedHoursTier1Pause !== false) {
      obj.closedHoursTier1Pause = message.closedHoursTier1Pause
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmEvents>, I>>(base?: I): OptionsMmEvents {
    return OptionsMmEvents.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmEvents>, I>>(object: I): OptionsMmEvents {
    const message = createBaseOptionsMmEvents()
    message.windows = object.windows?.map((e) => OptionsMmEventWindow.fromPartial(e)) || []
    message.tierDefaults =
      object.tierDefaults?.map((e) => OptionsMmEventTierDefault.fromPartial(e)) || []
    message.autoEvents = object.autoEvents?.map((e) => e) || []
    message.calendarPollMin = object.calendarPollMin ?? 0
    message.closedHoursTier1Pause = object.closedHoursTier1Pause ?? false
    return message
  },
}

function createBaseOptionsMmModeParams(): OptionsMmModeParams {
  return { mode: 0, warmupMinS: 0, configHistoryMax: 0 }
}

export const OptionsMmModeParams: MessageFns<OptionsMmModeParams> = {
  encode(message: OptionsMmModeParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mode !== 0) {
      writer.uint32(8).int32(message.mode)
    }
    if (message.warmupMinS !== 0) {
      writer.uint32(16).uint32(message.warmupMinS)
    }
    if (message.configHistoryMax !== 0) {
      writer.uint32(24).uint32(message.configHistoryMax)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmModeParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmModeParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.mode = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.warmupMinS = reader.uint32()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.configHistoryMax = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmModeParams {
    return {
      mode: isSet(object.mode) ? optionsMmModeFromJSON(object.mode) : 0,
      warmupMinS: isSet(object.warmupMinS)
        ? globalThis.Number(object.warmupMinS)
        : isSet(object.warmup_min_s)
          ? globalThis.Number(object.warmup_min_s)
          : 0,
      configHistoryMax: isSet(object.configHistoryMax)
        ? globalThis.Number(object.configHistoryMax)
        : isSet(object.config_history_max)
          ? globalThis.Number(object.config_history_max)
          : 0,
    }
  },

  toJSON(message: OptionsMmModeParams): unknown {
    const obj: any = {}
    if (message.mode !== 0) {
      obj.mode = optionsMmModeToJSON(message.mode)
    }
    if (message.warmupMinS !== 0) {
      obj.warmupMinS = Math.round(message.warmupMinS)
    }
    if (message.configHistoryMax !== 0) {
      obj.configHistoryMax = Math.round(message.configHistoryMax)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmModeParams>, I>>(base?: I): OptionsMmModeParams {
    return OptionsMmModeParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmModeParams>, I>>(
    object: I
  ): OptionsMmModeParams {
    const message = createBaseOptionsMmModeParams()
    message.mode = object.mode ?? 0
    message.warmupMinS = object.warmupMinS ?? 0
    message.configHistoryMax = object.configHistoryMax ?? 0
    return message
  },
}

function createBaseOptionsMmAlgoParams(): OptionsMmAlgoParams {
  return {
    reference: undefined,
    quote: undefined,
    capital: undefined,
    mapping: undefined,
    fx: undefined,
    closed: undefined,
    universe: undefined,
    spreads: undefined,
    sizing: undefined,
    oms: undefined,
    mmp: undefined,
    skew: undefined,
    protection: undefined,
    flow: undefined,
    risk: undefined,
    hedge: undefined,
    events: undefined,
    mode: undefined,
    accountId: '',
    tradeVenue: 0,
  }
}

export const OptionsMmAlgoParams: MessageFns<OptionsMmAlgoParams> = {
  encode(message: OptionsMmAlgoParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reference !== undefined) {
      OptionsMmReference.encode(message.reference, writer.uint32(10).fork()).join()
    }
    if (message.quote !== undefined) {
      OptionsMmQuote.encode(message.quote, writer.uint32(18).fork()).join()
    }
    if (message.capital !== undefined) {
      OptionsMmCapital.encode(message.capital, writer.uint32(26).fork()).join()
    }
    if (message.mapping !== undefined) {
      OptionsMmMapping.encode(message.mapping, writer.uint32(34).fork()).join()
    }
    if (message.fx !== undefined) {
      OptionsMmFx.encode(message.fx, writer.uint32(42).fork()).join()
    }
    if (message.closed !== undefined) {
      OptionsMmClosedHours.encode(message.closed, writer.uint32(50).fork()).join()
    }
    if (message.universe !== undefined) {
      OptionsMmUniverse.encode(message.universe, writer.uint32(58).fork()).join()
    }
    if (message.spreads !== undefined) {
      OptionsMmSpreads.encode(message.spreads, writer.uint32(66).fork()).join()
    }
    if (message.sizing !== undefined) {
      OptionsMmSizing.encode(message.sizing, writer.uint32(74).fork()).join()
    }
    if (message.oms !== undefined) {
      OptionsMmOms.encode(message.oms, writer.uint32(82).fork()).join()
    }
    if (message.mmp !== undefined) {
      OptionsMmMmp.encode(message.mmp, writer.uint32(90).fork()).join()
    }
    if (message.skew !== undefined) {
      OptionsMmSkew.encode(message.skew, writer.uint32(98).fork()).join()
    }
    if (message.protection !== undefined) {
      OptionsMmProtection.encode(message.protection, writer.uint32(106).fork()).join()
    }
    if (message.flow !== undefined) {
      OptionsMmFlow.encode(message.flow, writer.uint32(114).fork()).join()
    }
    if (message.risk !== undefined) {
      OptionsMmRisk.encode(message.risk, writer.uint32(122).fork()).join()
    }
    if (message.hedge !== undefined) {
      OptionsMmHedge.encode(message.hedge, writer.uint32(130).fork()).join()
    }
    if (message.events !== undefined) {
      OptionsMmEvents.encode(message.events, writer.uint32(138).fork()).join()
    }
    if (message.mode !== undefined) {
      OptionsMmModeParams.encode(message.mode, writer.uint32(146).fork()).join()
    }
    if (message.accountId !== '') {
      writer.uint32(154).string(message.accountId)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(160).int32(message.tradeVenue)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmAlgoParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmAlgoParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.reference = OptionsMmReference.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.quote = OptionsMmQuote.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.capital = OptionsMmCapital.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.mapping = OptionsMmMapping.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.fx = OptionsMmFx.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.closed = OptionsMmClosedHours.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.universe = OptionsMmUniverse.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.spreads = OptionsMmSpreads.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.sizing = OptionsMmSizing.decode(reader, reader.uint32())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.oms = OptionsMmOms.decode(reader, reader.uint32())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.mmp = OptionsMmMmp.decode(reader, reader.uint32())
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.skew = OptionsMmSkew.decode(reader, reader.uint32())
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.protection = OptionsMmProtection.decode(reader, reader.uint32())
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.flow = OptionsMmFlow.decode(reader, reader.uint32())
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.risk = OptionsMmRisk.decode(reader, reader.uint32())
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.hedge = OptionsMmHedge.decode(reader, reader.uint32())
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.events = OptionsMmEvents.decode(reader, reader.uint32())
          continue
        }
        case 18: {
          if (tag !== 146) {
            break
          }

          message.mode = OptionsMmModeParams.decode(reader, reader.uint32())
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 20: {
          if (tag !== 160) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmAlgoParams {
    return {
      reference: isSet(object.reference)
        ? OptionsMmReference.fromJSON(object.reference)
        : undefined,
      quote: isSet(object.quote) ? OptionsMmQuote.fromJSON(object.quote) : undefined,
      capital: isSet(object.capital) ? OptionsMmCapital.fromJSON(object.capital) : undefined,
      mapping: isSet(object.mapping) ? OptionsMmMapping.fromJSON(object.mapping) : undefined,
      fx: isSet(object.fx) ? OptionsMmFx.fromJSON(object.fx) : undefined,
      closed: isSet(object.closed) ? OptionsMmClosedHours.fromJSON(object.closed) : undefined,
      universe: isSet(object.universe) ? OptionsMmUniverse.fromJSON(object.universe) : undefined,
      spreads: isSet(object.spreads) ? OptionsMmSpreads.fromJSON(object.spreads) : undefined,
      sizing: isSet(object.sizing) ? OptionsMmSizing.fromJSON(object.sizing) : undefined,
      oms: isSet(object.oms) ? OptionsMmOms.fromJSON(object.oms) : undefined,
      mmp: isSet(object.mmp) ? OptionsMmMmp.fromJSON(object.mmp) : undefined,
      skew: isSet(object.skew) ? OptionsMmSkew.fromJSON(object.skew) : undefined,
      protection: isSet(object.protection)
        ? OptionsMmProtection.fromJSON(object.protection)
        : undefined,
      flow: isSet(object.flow) ? OptionsMmFlow.fromJSON(object.flow) : undefined,
      risk: isSet(object.risk) ? OptionsMmRisk.fromJSON(object.risk) : undefined,
      hedge: isSet(object.hedge) ? OptionsMmHedge.fromJSON(object.hedge) : undefined,
      events: isSet(object.events) ? OptionsMmEvents.fromJSON(object.events) : undefined,
      mode: isSet(object.mode) ? OptionsMmModeParams.fromJSON(object.mode) : undefined,
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
    }
  },

  toJSON(message: OptionsMmAlgoParams): unknown {
    const obj: any = {}
    if (message.reference !== undefined) {
      obj.reference = OptionsMmReference.toJSON(message.reference)
    }
    if (message.quote !== undefined) {
      obj.quote = OptionsMmQuote.toJSON(message.quote)
    }
    if (message.capital !== undefined) {
      obj.capital = OptionsMmCapital.toJSON(message.capital)
    }
    if (message.mapping !== undefined) {
      obj.mapping = OptionsMmMapping.toJSON(message.mapping)
    }
    if (message.fx !== undefined) {
      obj.fx = OptionsMmFx.toJSON(message.fx)
    }
    if (message.closed !== undefined) {
      obj.closed = OptionsMmClosedHours.toJSON(message.closed)
    }
    if (message.universe !== undefined) {
      obj.universe = OptionsMmUniverse.toJSON(message.universe)
    }
    if (message.spreads !== undefined) {
      obj.spreads = OptionsMmSpreads.toJSON(message.spreads)
    }
    if (message.sizing !== undefined) {
      obj.sizing = OptionsMmSizing.toJSON(message.sizing)
    }
    if (message.oms !== undefined) {
      obj.oms = OptionsMmOms.toJSON(message.oms)
    }
    if (message.mmp !== undefined) {
      obj.mmp = OptionsMmMmp.toJSON(message.mmp)
    }
    if (message.skew !== undefined) {
      obj.skew = OptionsMmSkew.toJSON(message.skew)
    }
    if (message.protection !== undefined) {
      obj.protection = OptionsMmProtection.toJSON(message.protection)
    }
    if (message.flow !== undefined) {
      obj.flow = OptionsMmFlow.toJSON(message.flow)
    }
    if (message.risk !== undefined) {
      obj.risk = OptionsMmRisk.toJSON(message.risk)
    }
    if (message.hedge !== undefined) {
      obj.hedge = OptionsMmHedge.toJSON(message.hedge)
    }
    if (message.events !== undefined) {
      obj.events = OptionsMmEvents.toJSON(message.events)
    }
    if (message.mode !== undefined) {
      obj.mode = OptionsMmModeParams.toJSON(message.mode)
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmAlgoParams>, I>>(base?: I): OptionsMmAlgoParams {
    return OptionsMmAlgoParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmAlgoParams>, I>>(
    object: I
  ): OptionsMmAlgoParams {
    const message = createBaseOptionsMmAlgoParams()
    message.reference =
      object.reference !== undefined && object.reference !== null
        ? OptionsMmReference.fromPartial(object.reference)
        : undefined
    message.quote =
      object.quote !== undefined && object.quote !== null
        ? OptionsMmQuote.fromPartial(object.quote)
        : undefined
    message.capital =
      object.capital !== undefined && object.capital !== null
        ? OptionsMmCapital.fromPartial(object.capital)
        : undefined
    message.mapping =
      object.mapping !== undefined && object.mapping !== null
        ? OptionsMmMapping.fromPartial(object.mapping)
        : undefined
    message.fx =
      object.fx !== undefined && object.fx !== null ? OptionsMmFx.fromPartial(object.fx) : undefined
    message.closed =
      object.closed !== undefined && object.closed !== null
        ? OptionsMmClosedHours.fromPartial(object.closed)
        : undefined
    message.universe =
      object.universe !== undefined && object.universe !== null
        ? OptionsMmUniverse.fromPartial(object.universe)
        : undefined
    message.spreads =
      object.spreads !== undefined && object.spreads !== null
        ? OptionsMmSpreads.fromPartial(object.spreads)
        : undefined
    message.sizing =
      object.sizing !== undefined && object.sizing !== null
        ? OptionsMmSizing.fromPartial(object.sizing)
        : undefined
    message.oms =
      object.oms !== undefined && object.oms !== null
        ? OptionsMmOms.fromPartial(object.oms)
        : undefined
    message.mmp =
      object.mmp !== undefined && object.mmp !== null
        ? OptionsMmMmp.fromPartial(object.mmp)
        : undefined
    message.skew =
      object.skew !== undefined && object.skew !== null
        ? OptionsMmSkew.fromPartial(object.skew)
        : undefined
    message.protection =
      object.protection !== undefined && object.protection !== null
        ? OptionsMmProtection.fromPartial(object.protection)
        : undefined
    message.flow =
      object.flow !== undefined && object.flow !== null
        ? OptionsMmFlow.fromPartial(object.flow)
        : undefined
    message.risk =
      object.risk !== undefined && object.risk !== null
        ? OptionsMmRisk.fromPartial(object.risk)
        : undefined
    message.hedge =
      object.hedge !== undefined && object.hedge !== null
        ? OptionsMmHedge.fromPartial(object.hedge)
        : undefined
    message.events =
      object.events !== undefined && object.events !== null
        ? OptionsMmEvents.fromPartial(object.events)
        : undefined
    message.mode =
      object.mode !== undefined && object.mode !== null
        ? OptionsMmModeParams.fromPartial(object.mode)
        : undefined
    message.accountId = object.accountId ?? ''
    message.tradeVenue = object.tradeVenue ?? 0
    return message
  },
}

function createBaseOptionsMmSides(): OptionsMmSides {
  return { expirationTsMs: '0', sides: '' }
}

export const OptionsMmSides: MessageFns<OptionsMmSides> = {
  encode(message: OptionsMmSides, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.expirationTsMs !== '0') {
      writer.uint32(8).int64(message.expirationTsMs)
    }
    if (message.sides !== '') {
      writer.uint32(18).string(message.sides)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmSides {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmSides()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.expirationTsMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.sides = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmSides {
    return {
      expirationTsMs: isSet(object.expirationTsMs)
        ? globalThis.String(object.expirationTsMs)
        : isSet(object.expiration_ts_ms)
          ? globalThis.String(object.expiration_ts_ms)
          : '0',
      sides: isSet(object.sides) ? globalThis.String(object.sides) : '',
    }
  },

  toJSON(message: OptionsMmSides): unknown {
    const obj: any = {}
    if (message.expirationTsMs !== '0') {
      obj.expirationTsMs = message.expirationTsMs
    }
    if (message.sides !== '') {
      obj.sides = message.sides
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmSides>, I>>(base?: I): OptionsMmSides {
    return OptionsMmSides.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmSides>, I>>(object: I): OptionsMmSides {
    const message = createBaseOptionsMmSides()
    message.expirationTsMs = object.expirationTsMs ?? '0'
    message.sides = object.sides ?? ''
    return message
  },
}

function createBaseOptionsMmRestrictions(): OptionsMmRestrictions {
  return { closedMarket: false, sides: [], sizeMult: '', spreadMult: '', reduceOnly: [] }
}

export const OptionsMmRestrictions: MessageFns<OptionsMmRestrictions> = {
  encode(message: OptionsMmRestrictions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.closedMarket !== false) {
      writer.uint32(8).bool(message.closedMarket)
    }
    for (const v of message.sides) {
      OptionsMmSides.encode(v!, writer.uint32(18).fork()).join()
    }
    if (message.sizeMult !== '') {
      writer.uint32(26).string(message.sizeMult)
    }
    if (message.spreadMult !== '') {
      writer.uint32(34).string(message.spreadMult)
    }
    for (const v of message.reduceOnly) {
      writer.uint32(42).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmRestrictions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmRestrictions()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.closedMarket = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.sides.push(OptionsMmSides.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.sizeMult = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.spreadMult = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.reduceOnly.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmRestrictions {
    return {
      closedMarket: isSet(object.closedMarket)
        ? globalThis.Boolean(object.closedMarket)
        : isSet(object.closed_market)
          ? globalThis.Boolean(object.closed_market)
          : false,
      sides: globalThis.Array.isArray(object?.sides)
        ? object.sides.map((e: any) => OptionsMmSides.fromJSON(e))
        : [],
      sizeMult: isSet(object.sizeMult)
        ? globalThis.String(object.sizeMult)
        : isSet(object.size_mult)
          ? globalThis.String(object.size_mult)
          : '',
      spreadMult: isSet(object.spreadMult)
        ? globalThis.String(object.spreadMult)
        : isSet(object.spread_mult)
          ? globalThis.String(object.spread_mult)
          : '',
      reduceOnly: globalThis.Array.isArray(object?.reduceOnly)
        ? object.reduceOnly.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.reduce_only)
          ? object.reduce_only.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: OptionsMmRestrictions): unknown {
    const obj: any = {}
    if (message.closedMarket !== false) {
      obj.closedMarket = message.closedMarket
    }
    if (message.sides?.length) {
      obj.sides = message.sides.map((e) => OptionsMmSides.toJSON(e))
    }
    if (message.sizeMult !== '') {
      obj.sizeMult = message.sizeMult
    }
    if (message.spreadMult !== '') {
      obj.spreadMult = message.spreadMult
    }
    if (message.reduceOnly?.length) {
      obj.reduceOnly = message.reduceOnly
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmRestrictions>, I>>(base?: I): OptionsMmRestrictions {
    return OptionsMmRestrictions.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmRestrictions>, I>>(
    object: I
  ): OptionsMmRestrictions {
    const message = createBaseOptionsMmRestrictions()
    message.closedMarket = object.closedMarket ?? false
    message.sides = object.sides?.map((e) => OptionsMmSides.fromPartial(e)) || []
    message.sizeMult = object.sizeMult ?? ''
    message.spreadMult = object.spreadMult ?? ''
    message.reduceOnly = object.reduceOnly?.map((e) => e) || []
    return message
  },
}

function createBaseOptionsMmQuoteRow(): OptionsMmQuoteRow {
  return {
    symbol: '',
    strike: '',
    right: '',
    fairIv: '',
    bidIv: undefined,
    askIv: undefined,
    bidPrice: undefined,
    askPrice: undefined,
    bidSize: undefined,
    askSize: undefined,
    workingBidOrderId: undefined,
    workingAskOrderId: undefined,
    level: 0,
  }
}

export const OptionsMmQuoteRow: MessageFns<OptionsMmQuoteRow> = {
  encode(message: OptionsMmQuoteRow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.strike !== '') {
      writer.uint32(18).string(message.strike)
    }
    if (message.right !== '') {
      writer.uint32(26).string(message.right)
    }
    if (message.fairIv !== '') {
      writer.uint32(34).string(message.fairIv)
    }
    if (message.bidIv !== undefined) {
      writer.uint32(42).string(message.bidIv)
    }
    if (message.askIv !== undefined) {
      writer.uint32(50).string(message.askIv)
    }
    if (message.bidPrice !== undefined) {
      writer.uint32(58).string(message.bidPrice)
    }
    if (message.askPrice !== undefined) {
      writer.uint32(66).string(message.askPrice)
    }
    if (message.bidSize !== undefined) {
      writer.uint32(74).string(message.bidSize)
    }
    if (message.askSize !== undefined) {
      writer.uint32(82).string(message.askSize)
    }
    if (message.workingBidOrderId !== undefined) {
      writer.uint32(90).string(message.workingBidOrderId)
    }
    if (message.workingAskOrderId !== undefined) {
      writer.uint32(98).string(message.workingAskOrderId)
    }
    if (message.level !== 0) {
      writer.uint32(104).uint32(message.level)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmQuoteRow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmQuoteRow()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.strike = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.right = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.fairIv = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.bidIv = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.askIv = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.bidPrice = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.askPrice = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.bidSize = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.askSize = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.workingBidOrderId = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.workingAskOrderId = reader.string()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.level = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmQuoteRow {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      strike: isSet(object.strike) ? globalThis.String(object.strike) : '',
      right: isSet(object.right) ? globalThis.String(object.right) : '',
      fairIv: isSet(object.fairIv)
        ? globalThis.String(object.fairIv)
        : isSet(object.fair_iv)
          ? globalThis.String(object.fair_iv)
          : '',
      bidIv: isSet(object.bidIv)
        ? globalThis.String(object.bidIv)
        : isSet(object.bid_iv)
          ? globalThis.String(object.bid_iv)
          : undefined,
      askIv: isSet(object.askIv)
        ? globalThis.String(object.askIv)
        : isSet(object.ask_iv)
          ? globalThis.String(object.ask_iv)
          : undefined,
      bidPrice: isSet(object.bidPrice)
        ? globalThis.String(object.bidPrice)
        : isSet(object.bid_price)
          ? globalThis.String(object.bid_price)
          : undefined,
      askPrice: isSet(object.askPrice)
        ? globalThis.String(object.askPrice)
        : isSet(object.ask_price)
          ? globalThis.String(object.ask_price)
          : undefined,
      bidSize: isSet(object.bidSize)
        ? globalThis.String(object.bidSize)
        : isSet(object.bid_size)
          ? globalThis.String(object.bid_size)
          : undefined,
      askSize: isSet(object.askSize)
        ? globalThis.String(object.askSize)
        : isSet(object.ask_size)
          ? globalThis.String(object.ask_size)
          : undefined,
      workingBidOrderId: isSet(object.workingBidOrderId)
        ? globalThis.String(object.workingBidOrderId)
        : isSet(object.working_bid_order_id)
          ? globalThis.String(object.working_bid_order_id)
          : undefined,
      workingAskOrderId: isSet(object.workingAskOrderId)
        ? globalThis.String(object.workingAskOrderId)
        : isSet(object.working_ask_order_id)
          ? globalThis.String(object.working_ask_order_id)
          : undefined,
      level: isSet(object.level) ? globalThis.Number(object.level) : 0,
    }
  },

  toJSON(message: OptionsMmQuoteRow): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.strike !== '') {
      obj.strike = message.strike
    }
    if (message.right !== '') {
      obj.right = message.right
    }
    if (message.fairIv !== '') {
      obj.fairIv = message.fairIv
    }
    if (message.bidIv !== undefined) {
      obj.bidIv = message.bidIv
    }
    if (message.askIv !== undefined) {
      obj.askIv = message.askIv
    }
    if (message.bidPrice !== undefined) {
      obj.bidPrice = message.bidPrice
    }
    if (message.askPrice !== undefined) {
      obj.askPrice = message.askPrice
    }
    if (message.bidSize !== undefined) {
      obj.bidSize = message.bidSize
    }
    if (message.askSize !== undefined) {
      obj.askSize = message.askSize
    }
    if (message.workingBidOrderId !== undefined) {
      obj.workingBidOrderId = message.workingBidOrderId
    }
    if (message.workingAskOrderId !== undefined) {
      obj.workingAskOrderId = message.workingAskOrderId
    }
    if (message.level !== 0) {
      obj.level = Math.round(message.level)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmQuoteRow>, I>>(base?: I): OptionsMmQuoteRow {
    return OptionsMmQuoteRow.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmQuoteRow>, I>>(object: I): OptionsMmQuoteRow {
    const message = createBaseOptionsMmQuoteRow()
    message.symbol = object.symbol ?? ''
    message.strike = object.strike ?? ''
    message.right = object.right ?? ''
    message.fairIv = object.fairIv ?? ''
    message.bidIv = object.bidIv ?? undefined
    message.askIv = object.askIv ?? undefined
    message.bidPrice = object.bidPrice ?? undefined
    message.askPrice = object.askPrice ?? undefined
    message.bidSize = object.bidSize ?? undefined
    message.askSize = object.askSize ?? undefined
    message.workingBidOrderId = object.workingBidOrderId ?? undefined
    message.workingAskOrderId = object.workingAskOrderId ?? undefined
    message.level = object.level ?? 0
    return message
  },
}

function createBaseOptionsMmExpiryQuoteState(): OptionsMmExpiryQuoteState {
  return {
    expirationTsMs: '0',
    forward: undefined,
    unquotableReason: undefined,
    sides: '',
    quotes: [],
  }
}

export const OptionsMmExpiryQuoteState: MessageFns<OptionsMmExpiryQuoteState> = {
  encode(
    message: OptionsMmExpiryQuoteState,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.expirationTsMs !== '0') {
      writer.uint32(8).int64(message.expirationTsMs)
    }
    if (message.forward !== undefined) {
      writer.uint32(18).string(message.forward)
    }
    if (message.unquotableReason !== undefined) {
      writer.uint32(26).string(message.unquotableReason)
    }
    if (message.sides !== '') {
      writer.uint32(34).string(message.sides)
    }
    for (const v of message.quotes) {
      OptionsMmQuoteRow.encode(v!, writer.uint32(42).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmExpiryQuoteState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmExpiryQuoteState()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.expirationTsMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.forward = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.unquotableReason = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.sides = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.quotes.push(OptionsMmQuoteRow.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmExpiryQuoteState {
    return {
      expirationTsMs: isSet(object.expirationTsMs)
        ? globalThis.String(object.expirationTsMs)
        : isSet(object.expiration_ts_ms)
          ? globalThis.String(object.expiration_ts_ms)
          : '0',
      forward: isSet(object.forward) ? globalThis.String(object.forward) : undefined,
      unquotableReason: isSet(object.unquotableReason)
        ? globalThis.String(object.unquotableReason)
        : isSet(object.unquotable_reason)
          ? globalThis.String(object.unquotable_reason)
          : undefined,
      sides: isSet(object.sides) ? globalThis.String(object.sides) : '',
      quotes: globalThis.Array.isArray(object?.quotes)
        ? object.quotes.map((e: any) => OptionsMmQuoteRow.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OptionsMmExpiryQuoteState): unknown {
    const obj: any = {}
    if (message.expirationTsMs !== '0') {
      obj.expirationTsMs = message.expirationTsMs
    }
    if (message.forward !== undefined) {
      obj.forward = message.forward
    }
    if (message.unquotableReason !== undefined) {
      obj.unquotableReason = message.unquotableReason
    }
    if (message.sides !== '') {
      obj.sides = message.sides
    }
    if (message.quotes?.length) {
      obj.quotes = message.quotes.map((e) => OptionsMmQuoteRow.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmExpiryQuoteState>, I>>(
    base?: I
  ): OptionsMmExpiryQuoteState {
    return OptionsMmExpiryQuoteState.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmExpiryQuoteState>, I>>(
    object: I
  ): OptionsMmExpiryQuoteState {
    const message = createBaseOptionsMmExpiryQuoteState()
    message.expirationTsMs = object.expirationTsMs ?? '0'
    message.forward = object.forward ?? undefined
    message.unquotableReason = object.unquotableReason ?? undefined
    message.sides = object.sides ?? ''
    message.quotes = object.quotes?.map((e) => OptionsMmQuoteRow.fromPartial(e)) || []
    return message
  },
}

function createBaseOptionsMmGreeks(): OptionsMmGreeks {
  return {
    scope: '',
    source: '',
    deltaUsd: '',
    gammaUsd: '',
    vegaUsd: '',
    thetaUsd: '',
    notionalUsd: '',
  }
}

export const OptionsMmGreeks: MessageFns<OptionsMmGreeks> = {
  encode(message: OptionsMmGreeks, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.scope !== '') {
      writer.uint32(10).string(message.scope)
    }
    if (message.source !== '') {
      writer.uint32(18).string(message.source)
    }
    if (message.deltaUsd !== '') {
      writer.uint32(26).string(message.deltaUsd)
    }
    if (message.gammaUsd !== '') {
      writer.uint32(34).string(message.gammaUsd)
    }
    if (message.vegaUsd !== '') {
      writer.uint32(42).string(message.vegaUsd)
    }
    if (message.thetaUsd !== '') {
      writer.uint32(50).string(message.thetaUsd)
    }
    if (message.notionalUsd !== '') {
      writer.uint32(58).string(message.notionalUsd)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmGreeks {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmGreeks()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.scope = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.source = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.deltaUsd = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.gammaUsd = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.vegaUsd = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.thetaUsd = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.notionalUsd = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmGreeks {
    return {
      scope: isSet(object.scope) ? globalThis.String(object.scope) : '',
      source: isSet(object.source) ? globalThis.String(object.source) : '',
      deltaUsd: isSet(object.deltaUsd)
        ? globalThis.String(object.deltaUsd)
        : isSet(object.delta_usd)
          ? globalThis.String(object.delta_usd)
          : '',
      gammaUsd: isSet(object.gammaUsd)
        ? globalThis.String(object.gammaUsd)
        : isSet(object.gamma_usd)
          ? globalThis.String(object.gamma_usd)
          : '',
      vegaUsd: isSet(object.vegaUsd)
        ? globalThis.String(object.vegaUsd)
        : isSet(object.vega_usd)
          ? globalThis.String(object.vega_usd)
          : '',
      thetaUsd: isSet(object.thetaUsd)
        ? globalThis.String(object.thetaUsd)
        : isSet(object.theta_usd)
          ? globalThis.String(object.theta_usd)
          : '',
      notionalUsd: isSet(object.notionalUsd)
        ? globalThis.String(object.notionalUsd)
        : isSet(object.notional_usd)
          ? globalThis.String(object.notional_usd)
          : '',
    }
  },

  toJSON(message: OptionsMmGreeks): unknown {
    const obj: any = {}
    if (message.scope !== '') {
      obj.scope = message.scope
    }
    if (message.source !== '') {
      obj.source = message.source
    }
    if (message.deltaUsd !== '') {
      obj.deltaUsd = message.deltaUsd
    }
    if (message.gammaUsd !== '') {
      obj.gammaUsd = message.gammaUsd
    }
    if (message.vegaUsd !== '') {
      obj.vegaUsd = message.vegaUsd
    }
    if (message.thetaUsd !== '') {
      obj.thetaUsd = message.thetaUsd
    }
    if (message.notionalUsd !== '') {
      obj.notionalUsd = message.notionalUsd
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmGreeks>, I>>(base?: I): OptionsMmGreeks {
    return OptionsMmGreeks.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmGreeks>, I>>(object: I): OptionsMmGreeks {
    const message = createBaseOptionsMmGreeks()
    message.scope = object.scope ?? ''
    message.source = object.source ?? ''
    message.deltaUsd = object.deltaUsd ?? ''
    message.gammaUsd = object.gammaUsd ?? ''
    message.vegaUsd = object.vegaUsd ?? ''
    message.thetaUsd = object.thetaUsd ?? ''
    message.notionalUsd = object.notionalUsd ?? ''
    return message
  },
}

function createBaseOptionsMmUtilisation(): OptionsMmUtilisation {
  return { greek: '', scope: '', position: '', reserved: '' }
}

export const OptionsMmUtilisation: MessageFns<OptionsMmUtilisation> = {
  encode(message: OptionsMmUtilisation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.greek !== '') {
      writer.uint32(10).string(message.greek)
    }
    if (message.scope !== '') {
      writer.uint32(18).string(message.scope)
    }
    if (message.position !== '') {
      writer.uint32(26).string(message.position)
    }
    if (message.reserved !== '') {
      writer.uint32(34).string(message.reserved)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmUtilisation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmUtilisation()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.greek = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.scope = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.position = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.reserved = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmUtilisation {
    return {
      greek: isSet(object.greek) ? globalThis.String(object.greek) : '',
      scope: isSet(object.scope) ? globalThis.String(object.scope) : '',
      position: isSet(object.position) ? globalThis.String(object.position) : '',
      reserved: isSet(object.reserved) ? globalThis.String(object.reserved) : '',
    }
  },

  toJSON(message: OptionsMmUtilisation): unknown {
    const obj: any = {}
    if (message.greek !== '') {
      obj.greek = message.greek
    }
    if (message.scope !== '') {
      obj.scope = message.scope
    }
    if (message.position !== '') {
      obj.position = message.position
    }
    if (message.reserved !== '') {
      obj.reserved = message.reserved
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmUtilisation>, I>>(base?: I): OptionsMmUtilisation {
    return OptionsMmUtilisation.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmUtilisation>, I>>(
    object: I
  ): OptionsMmUtilisation {
    const message = createBaseOptionsMmUtilisation()
    message.greek = object.greek ?? ''
    message.scope = object.scope ?? ''
    message.position = object.position ?? ''
    message.reserved = object.reserved ?? ''
    return message
  },
}

function createBaseOptionsMmMargin(): OptionsMmMargin {
  return { equityUsd: '', imUsd: '', mmUsd: '', imPctOfCapital: '', readAtMs: '0' }
}

export const OptionsMmMargin: MessageFns<OptionsMmMargin> = {
  encode(message: OptionsMmMargin, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.equityUsd !== '') {
      writer.uint32(10).string(message.equityUsd)
    }
    if (message.imUsd !== '') {
      writer.uint32(18).string(message.imUsd)
    }
    if (message.mmUsd !== '') {
      writer.uint32(26).string(message.mmUsd)
    }
    if (message.imPctOfCapital !== '') {
      writer.uint32(34).string(message.imPctOfCapital)
    }
    if (message.readAtMs !== '0') {
      writer.uint32(40).int64(message.readAtMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmMargin {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmMargin()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.equityUsd = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.imUsd = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.mmUsd = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.imPctOfCapital = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.readAtMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmMargin {
    return {
      equityUsd: isSet(object.equityUsd)
        ? globalThis.String(object.equityUsd)
        : isSet(object.equity_usd)
          ? globalThis.String(object.equity_usd)
          : '',
      imUsd: isSet(object.imUsd)
        ? globalThis.String(object.imUsd)
        : isSet(object.im_usd)
          ? globalThis.String(object.im_usd)
          : '',
      mmUsd: isSet(object.mmUsd)
        ? globalThis.String(object.mmUsd)
        : isSet(object.mm_usd)
          ? globalThis.String(object.mm_usd)
          : '',
      imPctOfCapital: isSet(object.imPctOfCapital)
        ? globalThis.String(object.imPctOfCapital)
        : isSet(object.im_pct_of_capital)
          ? globalThis.String(object.im_pct_of_capital)
          : '',
      readAtMs: isSet(object.readAtMs)
        ? globalThis.String(object.readAtMs)
        : isSet(object.read_at_ms)
          ? globalThis.String(object.read_at_ms)
          : '0',
    }
  },

  toJSON(message: OptionsMmMargin): unknown {
    const obj: any = {}
    if (message.equityUsd !== '') {
      obj.equityUsd = message.equityUsd
    }
    if (message.imUsd !== '') {
      obj.imUsd = message.imUsd
    }
    if (message.mmUsd !== '') {
      obj.mmUsd = message.mmUsd
    }
    if (message.imPctOfCapital !== '') {
      obj.imPctOfCapital = message.imPctOfCapital
    }
    if (message.readAtMs !== '0') {
      obj.readAtMs = message.readAtMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmMargin>, I>>(base?: I): OptionsMmMargin {
    return OptionsMmMargin.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmMargin>, I>>(object: I): OptionsMmMargin {
    const message = createBaseOptionsMmMargin()
    message.equityUsd = object.equityUsd ?? ''
    message.imUsd = object.imUsd ?? ''
    message.mmUsd = object.mmUsd ?? ''
    message.imPctOfCapital = object.imPctOfCapital ?? ''
    message.readAtMs = object.readAtMs ?? '0'
    return message
  },
}

function createBaseOptionsMmMarkout(): OptionsMmMarkout {
  return { windowS: 0, bp: '', fills: 0 }
}

export const OptionsMmMarkout: MessageFns<OptionsMmMarkout> = {
  encode(message: OptionsMmMarkout, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.windowS !== 0) {
      writer.uint32(8).uint32(message.windowS)
    }
    if (message.bp !== '') {
      writer.uint32(18).string(message.bp)
    }
    if (message.fills !== 0) {
      writer.uint32(24).uint32(message.fills)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmMarkout {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmMarkout()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.windowS = reader.uint32()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.bp = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.fills = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmMarkout {
    return {
      windowS: isSet(object.windowS)
        ? globalThis.Number(object.windowS)
        : isSet(object.window_s)
          ? globalThis.Number(object.window_s)
          : 0,
      bp: isSet(object.bp) ? globalThis.String(object.bp) : '',
      fills: isSet(object.fills) ? globalThis.Number(object.fills) : 0,
    }
  },

  toJSON(message: OptionsMmMarkout): unknown {
    const obj: any = {}
    if (message.windowS !== 0) {
      obj.windowS = Math.round(message.windowS)
    }
    if (message.bp !== '') {
      obj.bp = message.bp
    }
    if (message.fills !== 0) {
      obj.fills = Math.round(message.fills)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmMarkout>, I>>(base?: I): OptionsMmMarkout {
    return OptionsMmMarkout.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmMarkout>, I>>(object: I): OptionsMmMarkout {
    const message = createBaseOptionsMmMarkout()
    message.windowS = object.windowS ?? 0
    message.bp = object.bp ?? ''
    message.fills = object.fills ?? 0
    return message
  },
}

function createBaseOptionsMmFlowSummary(): OptionsMmFlowSummary {
  return { fillsInWindow: 0, markouts: [], dailyPnlUsd: '' }
}

export const OptionsMmFlowSummary: MessageFns<OptionsMmFlowSummary> = {
  encode(message: OptionsMmFlowSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fillsInWindow !== 0) {
      writer.uint32(8).uint32(message.fillsInWindow)
    }
    for (const v of message.markouts) {
      OptionsMmMarkout.encode(v!, writer.uint32(18).fork()).join()
    }
    if (message.dailyPnlUsd !== '') {
      writer.uint32(26).string(message.dailyPnlUsd)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmFlowSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmFlowSummary()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.fillsInWindow = reader.uint32()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.markouts.push(OptionsMmMarkout.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.dailyPnlUsd = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmFlowSummary {
    return {
      fillsInWindow: isSet(object.fillsInWindow)
        ? globalThis.Number(object.fillsInWindow)
        : isSet(object.fills_in_window)
          ? globalThis.Number(object.fills_in_window)
          : 0,
      markouts: globalThis.Array.isArray(object?.markouts)
        ? object.markouts.map((e: any) => OptionsMmMarkout.fromJSON(e))
        : [],
      dailyPnlUsd: isSet(object.dailyPnlUsd)
        ? globalThis.String(object.dailyPnlUsd)
        : isSet(object.daily_pnl_usd)
          ? globalThis.String(object.daily_pnl_usd)
          : '',
    }
  },

  toJSON(message: OptionsMmFlowSummary): unknown {
    const obj: any = {}
    if (message.fillsInWindow !== 0) {
      obj.fillsInWindow = Math.round(message.fillsInWindow)
    }
    if (message.markouts?.length) {
      obj.markouts = message.markouts.map((e) => OptionsMmMarkout.toJSON(e))
    }
    if (message.dailyPnlUsd !== '') {
      obj.dailyPnlUsd = message.dailyPnlUsd
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmFlowSummary>, I>>(base?: I): OptionsMmFlowSummary {
    return OptionsMmFlowSummary.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmFlowSummary>, I>>(
    object: I
  ): OptionsMmFlowSummary {
    const message = createBaseOptionsMmFlowSummary()
    message.fillsInWindow = object.fillsInWindow ?? 0
    message.markouts = object.markouts?.map((e) => OptionsMmMarkout.fromPartial(e)) || []
    message.dailyPnlUsd = object.dailyPnlUsd ?? ''
    return message
  },
}

function createBaseOptionsMmSurfaceHealth(): OptionsMmSurfaceHealth {
  return {
    inputsNewestTsMs: undefined,
    fittedAtMs: undefined,
    anchorMs: undefined,
    inputAgeS: '',
    closedMarket: false,
    expiries: 0,
    sourceKind: '',
    rvGuardVolpts: undefined,
  }
}

export const OptionsMmSurfaceHealth: MessageFns<OptionsMmSurfaceHealth> = {
  encode(message: OptionsMmSurfaceHealth, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.inputsNewestTsMs !== undefined) {
      writer.uint32(8).int64(message.inputsNewestTsMs)
    }
    if (message.fittedAtMs !== undefined) {
      writer.uint32(16).int64(message.fittedAtMs)
    }
    if (message.anchorMs !== undefined) {
      writer.uint32(24).int64(message.anchorMs)
    }
    if (message.inputAgeS !== '') {
      writer.uint32(34).string(message.inputAgeS)
    }
    if (message.closedMarket !== false) {
      writer.uint32(40).bool(message.closedMarket)
    }
    if (message.expiries !== 0) {
      writer.uint32(48).uint32(message.expiries)
    }
    if (message.sourceKind !== '') {
      writer.uint32(58).string(message.sourceKind)
    }
    if (message.rvGuardVolpts !== undefined) {
      writer.uint32(66).string(message.rvGuardVolpts)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmSurfaceHealth {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmSurfaceHealth()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.inputsNewestTsMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.fittedAtMs = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.anchorMs = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.inputAgeS = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.closedMarket = reader.bool()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.expiries = reader.uint32()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.sourceKind = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.rvGuardVolpts = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmSurfaceHealth {
    return {
      inputsNewestTsMs: isSet(object.inputsNewestTsMs)
        ? globalThis.String(object.inputsNewestTsMs)
        : isSet(object.inputs_newest_ts_ms)
          ? globalThis.String(object.inputs_newest_ts_ms)
          : undefined,
      fittedAtMs: isSet(object.fittedAtMs)
        ? globalThis.String(object.fittedAtMs)
        : isSet(object.fitted_at_ms)
          ? globalThis.String(object.fitted_at_ms)
          : undefined,
      anchorMs: isSet(object.anchorMs)
        ? globalThis.String(object.anchorMs)
        : isSet(object.anchor_ms)
          ? globalThis.String(object.anchor_ms)
          : undefined,
      inputAgeS: isSet(object.inputAgeS)
        ? globalThis.String(object.inputAgeS)
        : isSet(object.input_age_s)
          ? globalThis.String(object.input_age_s)
          : '',
      closedMarket: isSet(object.closedMarket)
        ? globalThis.Boolean(object.closedMarket)
        : isSet(object.closed_market)
          ? globalThis.Boolean(object.closed_market)
          : false,
      expiries: isSet(object.expiries) ? globalThis.Number(object.expiries) : 0,
      sourceKind: isSet(object.sourceKind)
        ? globalThis.String(object.sourceKind)
        : isSet(object.source_kind)
          ? globalThis.String(object.source_kind)
          : '',
      rvGuardVolpts: isSet(object.rvGuardVolpts)
        ? globalThis.String(object.rvGuardVolpts)
        : isSet(object.rv_guard_volpts)
          ? globalThis.String(object.rv_guard_volpts)
          : undefined,
    }
  },

  toJSON(message: OptionsMmSurfaceHealth): unknown {
    const obj: any = {}
    if (message.inputsNewestTsMs !== undefined) {
      obj.inputsNewestTsMs = message.inputsNewestTsMs
    }
    if (message.fittedAtMs !== undefined) {
      obj.fittedAtMs = message.fittedAtMs
    }
    if (message.anchorMs !== undefined) {
      obj.anchorMs = message.anchorMs
    }
    if (message.inputAgeS !== '') {
      obj.inputAgeS = message.inputAgeS
    }
    if (message.closedMarket !== false) {
      obj.closedMarket = message.closedMarket
    }
    if (message.expiries !== 0) {
      obj.expiries = Math.round(message.expiries)
    }
    if (message.sourceKind !== '') {
      obj.sourceKind = message.sourceKind
    }
    if (message.rvGuardVolpts !== undefined) {
      obj.rvGuardVolpts = message.rvGuardVolpts
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmSurfaceHealth>, I>>(
    base?: I
  ): OptionsMmSurfaceHealth {
    return OptionsMmSurfaceHealth.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmSurfaceHealth>, I>>(
    object: I
  ): OptionsMmSurfaceHealth {
    const message = createBaseOptionsMmSurfaceHealth()
    message.inputsNewestTsMs = object.inputsNewestTsMs ?? undefined
    message.fittedAtMs = object.fittedAtMs ?? undefined
    message.anchorMs = object.anchorMs ?? undefined
    message.inputAgeS = object.inputAgeS ?? ''
    message.closedMarket = object.closedMarket ?? false
    message.expiries = object.expiries ?? 0
    message.sourceKind = object.sourceKind ?? ''
    message.rvGuardVolpts = object.rvGuardVolpts ?? undefined
    return message
  },
}

function createBaseOptionsMmFieldChange(): OptionsMmFieldChange {
  return { name: '', previous: '', new: '', loosening: false }
}

export const OptionsMmFieldChange: MessageFns<OptionsMmFieldChange> = {
  encode(message: OptionsMmFieldChange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== '') {
      writer.uint32(10).string(message.name)
    }
    if (message.previous !== '') {
      writer.uint32(18).string(message.previous)
    }
    if (message.new !== '') {
      writer.uint32(26).string(message.new)
    }
    if (message.loosening !== false) {
      writer.uint32(32).bool(message.loosening)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmFieldChange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmFieldChange()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.previous = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.new = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.loosening = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmFieldChange {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      previous: isSet(object.previous) ? globalThis.String(object.previous) : '',
      new: isSet(object.new) ? globalThis.String(object.new) : '',
      loosening: isSet(object.loosening) ? globalThis.Boolean(object.loosening) : false,
    }
  },

  toJSON(message: OptionsMmFieldChange): unknown {
    const obj: any = {}
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.previous !== '') {
      obj.previous = message.previous
    }
    if (message.new !== '') {
      obj.new = message.new
    }
    if (message.loosening !== false) {
      obj.loosening = message.loosening
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmFieldChange>, I>>(base?: I): OptionsMmFieldChange {
    return OptionsMmFieldChange.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmFieldChange>, I>>(
    object: I
  ): OptionsMmFieldChange {
    const message = createBaseOptionsMmFieldChange()
    message.name = object.name ?? ''
    message.previous = object.previous ?? ''
    message.new = object.new ?? ''
    message.loosening = object.loosening ?? false
    return message
  },
}

function createBaseOptionsMmConfigHistoryEntry(): OptionsMmConfigHistoryEntry {
  return { version: '0', appliedAtMs: '0', changes: [] }
}

export const OptionsMmConfigHistoryEntry: MessageFns<OptionsMmConfigHistoryEntry> = {
  encode(
    message: OptionsMmConfigHistoryEntry,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.version !== '0') {
      writer.uint32(8).uint64(message.version)
    }
    if (message.appliedAtMs !== '0') {
      writer.uint32(16).int64(message.appliedAtMs)
    }
    for (const v of message.changes) {
      OptionsMmFieldChange.encode(v!, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmConfigHistoryEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmConfigHistoryEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.version = reader.uint64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.appliedAtMs = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.changes.push(OptionsMmFieldChange.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmConfigHistoryEntry {
    return {
      version: isSet(object.version) ? globalThis.String(object.version) : '0',
      appliedAtMs: isSet(object.appliedAtMs)
        ? globalThis.String(object.appliedAtMs)
        : isSet(object.applied_at_ms)
          ? globalThis.String(object.applied_at_ms)
          : '0',
      changes: globalThis.Array.isArray(object?.changes)
        ? object.changes.map((e: any) => OptionsMmFieldChange.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OptionsMmConfigHistoryEntry): unknown {
    const obj: any = {}
    if (message.version !== '0') {
      obj.version = message.version
    }
    if (message.appliedAtMs !== '0') {
      obj.appliedAtMs = message.appliedAtMs
    }
    if (message.changes?.length) {
      obj.changes = message.changes.map((e) => OptionsMmFieldChange.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmConfigHistoryEntry>, I>>(
    base?: I
  ): OptionsMmConfigHistoryEntry {
    return OptionsMmConfigHistoryEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmConfigHistoryEntry>, I>>(
    object: I
  ): OptionsMmConfigHistoryEntry {
    const message = createBaseOptionsMmConfigHistoryEntry()
    message.version = object.version ?? '0'
    message.appliedAtMs = object.appliedAtMs ?? '0'
    message.changes = object.changes?.map((e) => OptionsMmFieldChange.fromPartial(e)) || []
    return message
  },
}

function createBaseOptionsMmTransition(): OptionsMmTransition {
  return { atMs: '0', from: 0, to: 0, cause: '' }
}

export const OptionsMmTransition: MessageFns<OptionsMmTransition> = {
  encode(message: OptionsMmTransition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.atMs !== '0') {
      writer.uint32(8).int64(message.atMs)
    }
    if (message.from !== 0) {
      writer.uint32(16).int32(message.from)
    }
    if (message.to !== 0) {
      writer.uint32(24).int32(message.to)
    }
    if (message.cause !== '') {
      writer.uint32(34).string(message.cause)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmTransition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmTransition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.atMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.from = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.to = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.cause = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmTransition {
    return {
      atMs: isSet(object.atMs)
        ? globalThis.String(object.atMs)
        : isSet(object.at_ms)
          ? globalThis.String(object.at_ms)
          : '0',
      from: isSet(object.from) ? optionsMmLifecycleFromJSON(object.from) : 0,
      to: isSet(object.to) ? optionsMmLifecycleFromJSON(object.to) : 0,
      cause: isSet(object.cause) ? globalThis.String(object.cause) : '',
    }
  },

  toJSON(message: OptionsMmTransition): unknown {
    const obj: any = {}
    if (message.atMs !== '0') {
      obj.atMs = message.atMs
    }
    if (message.from !== 0) {
      obj.from = optionsMmLifecycleToJSON(message.from)
    }
    if (message.to !== 0) {
      obj.to = optionsMmLifecycleToJSON(message.to)
    }
    if (message.cause !== '') {
      obj.cause = message.cause
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmTransition>, I>>(base?: I): OptionsMmTransition {
    return OptionsMmTransition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmTransition>, I>>(
    object: I
  ): OptionsMmTransition {
    const message = createBaseOptionsMmTransition()
    message.atMs = object.atMs ?? '0'
    message.from = object.from ?? 0
    message.to = object.to ?? 0
    message.cause = object.cause ?? ''
    return message
  },
}

function createBaseOptionsMmCapabilities(): OptionsMmCapabilities {
  return {
    amendKeepsPriorityOnSizeDown: false,
    hasInPlaceAmend: false,
    hasCancelOnDisconnect: false,
    hasDcp: false,
    hasMmp: false,
    mmpEnabled: false,
    hasStp: false,
    ownerTag: '',
    maxOwnerTagLen: 0,
    openOrderCap: 0,
    openOrderCapSource: '',
    perInstrumentTps: '',
    perInstrumentBurst: 0,
    isMarketMakerTier: false,
    hasMarginSimulation: false,
    batchMax: 0,
    receivedAtMs: '0',
  }
}

export const OptionsMmCapabilities: MessageFns<OptionsMmCapabilities> = {
  encode(message: OptionsMmCapabilities, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.amendKeepsPriorityOnSizeDown !== false) {
      writer.uint32(8).bool(message.amendKeepsPriorityOnSizeDown)
    }
    if (message.hasInPlaceAmend !== false) {
      writer.uint32(16).bool(message.hasInPlaceAmend)
    }
    if (message.hasCancelOnDisconnect !== false) {
      writer.uint32(24).bool(message.hasCancelOnDisconnect)
    }
    if (message.hasDcp !== false) {
      writer.uint32(32).bool(message.hasDcp)
    }
    if (message.hasMmp !== false) {
      writer.uint32(40).bool(message.hasMmp)
    }
    if (message.mmpEnabled !== false) {
      writer.uint32(48).bool(message.mmpEnabled)
    }
    if (message.hasStp !== false) {
      writer.uint32(56).bool(message.hasStp)
    }
    if (message.ownerTag !== '') {
      writer.uint32(66).string(message.ownerTag)
    }
    if (message.maxOwnerTagLen !== 0) {
      writer.uint32(72).uint32(message.maxOwnerTagLen)
    }
    if (message.openOrderCap !== 0) {
      writer.uint32(80).uint32(message.openOrderCap)
    }
    if (message.openOrderCapSource !== '') {
      writer.uint32(90).string(message.openOrderCapSource)
    }
    if (message.perInstrumentTps !== '') {
      writer.uint32(98).string(message.perInstrumentTps)
    }
    if (message.perInstrumentBurst !== 0) {
      writer.uint32(104).uint32(message.perInstrumentBurst)
    }
    if (message.isMarketMakerTier !== false) {
      writer.uint32(112).bool(message.isMarketMakerTier)
    }
    if (message.hasMarginSimulation !== false) {
      writer.uint32(120).bool(message.hasMarginSimulation)
    }
    if (message.batchMax !== 0) {
      writer.uint32(128).uint32(message.batchMax)
    }
    if (message.receivedAtMs !== '0') {
      writer.uint32(136).int64(message.receivedAtMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmCapabilities {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmCapabilities()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.amendKeepsPriorityOnSizeDown = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.hasInPlaceAmend = reader.bool()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.hasCancelOnDisconnect = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.hasDcp = reader.bool()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.hasMmp = reader.bool()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.mmpEnabled = reader.bool()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.hasStp = reader.bool()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.ownerTag = reader.string()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.maxOwnerTagLen = reader.uint32()
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.openOrderCap = reader.uint32()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.openOrderCapSource = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.perInstrumentTps = reader.string()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.perInstrumentBurst = reader.uint32()
          continue
        }
        case 14: {
          if (tag !== 112) {
            break
          }

          message.isMarketMakerTier = reader.bool()
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.hasMarginSimulation = reader.bool()
          continue
        }
        case 16: {
          if (tag !== 128) {
            break
          }

          message.batchMax = reader.uint32()
          continue
        }
        case 17: {
          if (tag !== 136) {
            break
          }

          message.receivedAtMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmCapabilities {
    return {
      amendKeepsPriorityOnSizeDown: isSet(object.amendKeepsPriorityOnSizeDown)
        ? globalThis.Boolean(object.amendKeepsPriorityOnSizeDown)
        : isSet(object.amend_keeps_priority_on_size_down)
          ? globalThis.Boolean(object.amend_keeps_priority_on_size_down)
          : false,
      hasInPlaceAmend: isSet(object.hasInPlaceAmend)
        ? globalThis.Boolean(object.hasInPlaceAmend)
        : isSet(object.has_in_place_amend)
          ? globalThis.Boolean(object.has_in_place_amend)
          : false,
      hasCancelOnDisconnect: isSet(object.hasCancelOnDisconnect)
        ? globalThis.Boolean(object.hasCancelOnDisconnect)
        : isSet(object.has_cancel_on_disconnect)
          ? globalThis.Boolean(object.has_cancel_on_disconnect)
          : false,
      hasDcp: isSet(object.hasDcp)
        ? globalThis.Boolean(object.hasDcp)
        : isSet(object.has_dcp)
          ? globalThis.Boolean(object.has_dcp)
          : false,
      hasMmp: isSet(object.hasMmp)
        ? globalThis.Boolean(object.hasMmp)
        : isSet(object.has_mmp)
          ? globalThis.Boolean(object.has_mmp)
          : false,
      mmpEnabled: isSet(object.mmpEnabled)
        ? globalThis.Boolean(object.mmpEnabled)
        : isSet(object.mmp_enabled)
          ? globalThis.Boolean(object.mmp_enabled)
          : false,
      hasStp: isSet(object.hasStp)
        ? globalThis.Boolean(object.hasStp)
        : isSet(object.has_stp)
          ? globalThis.Boolean(object.has_stp)
          : false,
      ownerTag: isSet(object.ownerTag)
        ? globalThis.String(object.ownerTag)
        : isSet(object.owner_tag)
          ? globalThis.String(object.owner_tag)
          : '',
      maxOwnerTagLen: isSet(object.maxOwnerTagLen)
        ? globalThis.Number(object.maxOwnerTagLen)
        : isSet(object.max_owner_tag_len)
          ? globalThis.Number(object.max_owner_tag_len)
          : 0,
      openOrderCap: isSet(object.openOrderCap)
        ? globalThis.Number(object.openOrderCap)
        : isSet(object.open_order_cap)
          ? globalThis.Number(object.open_order_cap)
          : 0,
      openOrderCapSource: isSet(object.openOrderCapSource)
        ? globalThis.String(object.openOrderCapSource)
        : isSet(object.open_order_cap_source)
          ? globalThis.String(object.open_order_cap_source)
          : '',
      perInstrumentTps: isSet(object.perInstrumentTps)
        ? globalThis.String(object.perInstrumentTps)
        : isSet(object.per_instrument_tps)
          ? globalThis.String(object.per_instrument_tps)
          : '',
      perInstrumentBurst: isSet(object.perInstrumentBurst)
        ? globalThis.Number(object.perInstrumentBurst)
        : isSet(object.per_instrument_burst)
          ? globalThis.Number(object.per_instrument_burst)
          : 0,
      isMarketMakerTier: isSet(object.isMarketMakerTier)
        ? globalThis.Boolean(object.isMarketMakerTier)
        : isSet(object.is_market_maker_tier)
          ? globalThis.Boolean(object.is_market_maker_tier)
          : false,
      hasMarginSimulation: isSet(object.hasMarginSimulation)
        ? globalThis.Boolean(object.hasMarginSimulation)
        : isSet(object.has_margin_simulation)
          ? globalThis.Boolean(object.has_margin_simulation)
          : false,
      batchMax: isSet(object.batchMax)
        ? globalThis.Number(object.batchMax)
        : isSet(object.batch_max)
          ? globalThis.Number(object.batch_max)
          : 0,
      receivedAtMs: isSet(object.receivedAtMs)
        ? globalThis.String(object.receivedAtMs)
        : isSet(object.received_at_ms)
          ? globalThis.String(object.received_at_ms)
          : '0',
    }
  },

  toJSON(message: OptionsMmCapabilities): unknown {
    const obj: any = {}
    if (message.amendKeepsPriorityOnSizeDown !== false) {
      obj.amendKeepsPriorityOnSizeDown = message.amendKeepsPriorityOnSizeDown
    }
    if (message.hasInPlaceAmend !== false) {
      obj.hasInPlaceAmend = message.hasInPlaceAmend
    }
    if (message.hasCancelOnDisconnect !== false) {
      obj.hasCancelOnDisconnect = message.hasCancelOnDisconnect
    }
    if (message.hasDcp !== false) {
      obj.hasDcp = message.hasDcp
    }
    if (message.hasMmp !== false) {
      obj.hasMmp = message.hasMmp
    }
    if (message.mmpEnabled !== false) {
      obj.mmpEnabled = message.mmpEnabled
    }
    if (message.hasStp !== false) {
      obj.hasStp = message.hasStp
    }
    if (message.ownerTag !== '') {
      obj.ownerTag = message.ownerTag
    }
    if (message.maxOwnerTagLen !== 0) {
      obj.maxOwnerTagLen = Math.round(message.maxOwnerTagLen)
    }
    if (message.openOrderCap !== 0) {
      obj.openOrderCap = Math.round(message.openOrderCap)
    }
    if (message.openOrderCapSource !== '') {
      obj.openOrderCapSource = message.openOrderCapSource
    }
    if (message.perInstrumentTps !== '') {
      obj.perInstrumentTps = message.perInstrumentTps
    }
    if (message.perInstrumentBurst !== 0) {
      obj.perInstrumentBurst = Math.round(message.perInstrumentBurst)
    }
    if (message.isMarketMakerTier !== false) {
      obj.isMarketMakerTier = message.isMarketMakerTier
    }
    if (message.hasMarginSimulation !== false) {
      obj.hasMarginSimulation = message.hasMarginSimulation
    }
    if (message.batchMax !== 0) {
      obj.batchMax = Math.round(message.batchMax)
    }
    if (message.receivedAtMs !== '0') {
      obj.receivedAtMs = message.receivedAtMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmCapabilities>, I>>(base?: I): OptionsMmCapabilities {
    return OptionsMmCapabilities.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmCapabilities>, I>>(
    object: I
  ): OptionsMmCapabilities {
    const message = createBaseOptionsMmCapabilities()
    message.amendKeepsPriorityOnSizeDown = object.amendKeepsPriorityOnSizeDown ?? false
    message.hasInPlaceAmend = object.hasInPlaceAmend ?? false
    message.hasCancelOnDisconnect = object.hasCancelOnDisconnect ?? false
    message.hasDcp = object.hasDcp ?? false
    message.hasMmp = object.hasMmp ?? false
    message.mmpEnabled = object.mmpEnabled ?? false
    message.hasStp = object.hasStp ?? false
    message.ownerTag = object.ownerTag ?? ''
    message.maxOwnerTagLen = object.maxOwnerTagLen ?? 0
    message.openOrderCap = object.openOrderCap ?? 0
    message.openOrderCapSource = object.openOrderCapSource ?? ''
    message.perInstrumentTps = object.perInstrumentTps ?? ''
    message.perInstrumentBurst = object.perInstrumentBurst ?? 0
    message.isMarketMakerTier = object.isMarketMakerTier ?? false
    message.hasMarginSimulation = object.hasMarginSimulation ?? false
    message.batchMax = object.batchMax ?? 0
    message.receivedAtMs = object.receivedAtMs ?? '0'
    return message
  },
}

function createBaseOptionsMmShadowSummary(): OptionsMmShadowSummary {
  return { fillModel: 0, fills: '0', edgeUsd: '', markouts: [] }
}

export const OptionsMmShadowSummary: MessageFns<OptionsMmShadowSummary> = {
  encode(message: OptionsMmShadowSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fillModel !== 0) {
      writer.uint32(8).int32(message.fillModel)
    }
    if (message.fills !== '0') {
      writer.uint32(16).uint64(message.fills)
    }
    if (message.edgeUsd !== '') {
      writer.uint32(26).string(message.edgeUsd)
    }
    for (const v of message.markouts) {
      OptionsMmMarkout.encode(v!, writer.uint32(34).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmShadowSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmShadowSummary()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.fillModel = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.fills = reader.uint64().toString()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.edgeUsd = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.markouts.push(OptionsMmMarkout.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmShadowSummary {
    return {
      fillModel: isSet(object.fillModel)
        ? optionsMmFillModelFromJSON(object.fillModel)
        : isSet(object.fill_model)
          ? optionsMmFillModelFromJSON(object.fill_model)
          : 0,
      fills: isSet(object.fills) ? globalThis.String(object.fills) : '0',
      edgeUsd: isSet(object.edgeUsd)
        ? globalThis.String(object.edgeUsd)
        : isSet(object.edge_usd)
          ? globalThis.String(object.edge_usd)
          : '',
      markouts: globalThis.Array.isArray(object?.markouts)
        ? object.markouts.map((e: any) => OptionsMmMarkout.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OptionsMmShadowSummary): unknown {
    const obj: any = {}
    if (message.fillModel !== 0) {
      obj.fillModel = optionsMmFillModelToJSON(message.fillModel)
    }
    if (message.fills !== '0') {
      obj.fills = message.fills
    }
    if (message.edgeUsd !== '') {
      obj.edgeUsd = message.edgeUsd
    }
    if (message.markouts?.length) {
      obj.markouts = message.markouts.map((e) => OptionsMmMarkout.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmShadowSummary>, I>>(
    base?: I
  ): OptionsMmShadowSummary {
    return OptionsMmShadowSummary.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmShadowSummary>, I>>(
    object: I
  ): OptionsMmShadowSummary {
    const message = createBaseOptionsMmShadowSummary()
    message.fillModel = object.fillModel ?? 0
    message.fills = object.fills ?? '0'
    message.edgeUsd = object.edgeUsd ?? ''
    message.markouts = object.markouts?.map((e) => OptionsMmMarkout.fromPartial(e)) || []
    return message
  },
}

function createBaseOptionsMmPnl(): OptionsMmPnl {
  return {
    netUsd: '',
    edgeUsd: '',
    volUsd: '',
    deltaUsd: '',
    thetaUsd: '',
    feesUsd: '',
    fundingUsd: '',
    fxUsd: '',
    inventoryDeltaUsd: '',
    asOfMs: '0',
  }
}

export const OptionsMmPnl: MessageFns<OptionsMmPnl> = {
  encode(message: OptionsMmPnl, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.netUsd !== '') {
      writer.uint32(10).string(message.netUsd)
    }
    if (message.edgeUsd !== '') {
      writer.uint32(18).string(message.edgeUsd)
    }
    if (message.volUsd !== '') {
      writer.uint32(26).string(message.volUsd)
    }
    if (message.deltaUsd !== '') {
      writer.uint32(34).string(message.deltaUsd)
    }
    if (message.thetaUsd !== '') {
      writer.uint32(42).string(message.thetaUsd)
    }
    if (message.feesUsd !== '') {
      writer.uint32(50).string(message.feesUsd)
    }
    if (message.fundingUsd !== '') {
      writer.uint32(58).string(message.fundingUsd)
    }
    if (message.fxUsd !== '') {
      writer.uint32(66).string(message.fxUsd)
    }
    if (message.inventoryDeltaUsd !== '') {
      writer.uint32(74).string(message.inventoryDeltaUsd)
    }
    if (message.asOfMs !== '0') {
      writer.uint32(80).int64(message.asOfMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmPnl {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmPnl()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.netUsd = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.edgeUsd = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.volUsd = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.deltaUsd = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.thetaUsd = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.feesUsd = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.fundingUsd = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.fxUsd = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.inventoryDeltaUsd = reader.string()
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.asOfMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmPnl {
    return {
      netUsd: isSet(object.netUsd)
        ? globalThis.String(object.netUsd)
        : isSet(object.net_usd)
          ? globalThis.String(object.net_usd)
          : '',
      edgeUsd: isSet(object.edgeUsd)
        ? globalThis.String(object.edgeUsd)
        : isSet(object.edge_usd)
          ? globalThis.String(object.edge_usd)
          : '',
      volUsd: isSet(object.volUsd)
        ? globalThis.String(object.volUsd)
        : isSet(object.vol_usd)
          ? globalThis.String(object.vol_usd)
          : '',
      deltaUsd: isSet(object.deltaUsd)
        ? globalThis.String(object.deltaUsd)
        : isSet(object.delta_usd)
          ? globalThis.String(object.delta_usd)
          : '',
      thetaUsd: isSet(object.thetaUsd)
        ? globalThis.String(object.thetaUsd)
        : isSet(object.theta_usd)
          ? globalThis.String(object.theta_usd)
          : '',
      feesUsd: isSet(object.feesUsd)
        ? globalThis.String(object.feesUsd)
        : isSet(object.fees_usd)
          ? globalThis.String(object.fees_usd)
          : '',
      fundingUsd: isSet(object.fundingUsd)
        ? globalThis.String(object.fundingUsd)
        : isSet(object.funding_usd)
          ? globalThis.String(object.funding_usd)
          : '',
      fxUsd: isSet(object.fxUsd)
        ? globalThis.String(object.fxUsd)
        : isSet(object.fx_usd)
          ? globalThis.String(object.fx_usd)
          : '',
      inventoryDeltaUsd: isSet(object.inventoryDeltaUsd)
        ? globalThis.String(object.inventoryDeltaUsd)
        : isSet(object.inventory_delta_usd)
          ? globalThis.String(object.inventory_delta_usd)
          : '',
      asOfMs: isSet(object.asOfMs)
        ? globalThis.String(object.asOfMs)
        : isSet(object.as_of_ms)
          ? globalThis.String(object.as_of_ms)
          : '0',
    }
  },

  toJSON(message: OptionsMmPnl): unknown {
    const obj: any = {}
    if (message.netUsd !== '') {
      obj.netUsd = message.netUsd
    }
    if (message.edgeUsd !== '') {
      obj.edgeUsd = message.edgeUsd
    }
    if (message.volUsd !== '') {
      obj.volUsd = message.volUsd
    }
    if (message.deltaUsd !== '') {
      obj.deltaUsd = message.deltaUsd
    }
    if (message.thetaUsd !== '') {
      obj.thetaUsd = message.thetaUsd
    }
    if (message.feesUsd !== '') {
      obj.feesUsd = message.feesUsd
    }
    if (message.fundingUsd !== '') {
      obj.fundingUsd = message.fundingUsd
    }
    if (message.fxUsd !== '') {
      obj.fxUsd = message.fxUsd
    }
    if (message.inventoryDeltaUsd !== '') {
      obj.inventoryDeltaUsd = message.inventoryDeltaUsd
    }
    if (message.asOfMs !== '0') {
      obj.asOfMs = message.asOfMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmPnl>, I>>(base?: I): OptionsMmPnl {
    return OptionsMmPnl.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmPnl>, I>>(object: I): OptionsMmPnl {
    const message = createBaseOptionsMmPnl()
    message.netUsd = object.netUsd ?? ''
    message.edgeUsd = object.edgeUsd ?? ''
    message.volUsd = object.volUsd ?? ''
    message.deltaUsd = object.deltaUsd ?? ''
    message.thetaUsd = object.thetaUsd ?? ''
    message.feesUsd = object.feesUsd ?? ''
    message.fundingUsd = object.fundingUsd ?? ''
    message.fxUsd = object.fxUsd ?? ''
    message.inventoryDeltaUsd = object.inventoryDeltaUsd ?? ''
    message.asOfMs = object.asOfMs ?? '0'
    return message
  },
}

function createBaseOptionsMmState(): OptionsMmState {
  return {
    lifecycle: 0,
    derivedLabel: '',
    restrictions: undefined,
    sinceMs: '0',
    sessionGeneration: '0',
    expiries: [],
    greeks: [],
    utilisation: [],
    margin: undefined,
    stressWorstLossUsd: '',
    flow: undefined,
    surface: undefined,
    hedgeChildId: undefined,
    haltedResidualGreeks: undefined,
    configVersion: '0',
    params: undefined,
    configHistory: [],
    mode: 0,
    blockedReason: undefined,
    outboundQueueDepth: 0,
    causes: [],
    foreignOrders: 0,
    transitions: [],
    profile: 0,
    budgetShare: '',
    openOrdersReserved: 0,
    capabilities: undefined,
    shadow: [],
    capitalUsedUsd: '',
    returnOnAllocated: '',
    pnl: undefined,
    hedgeInstrument: undefined,
    budgetUsedLastS: 0,
    shadowResume: new Uint8Array(0),
  }
}

export const OptionsMmState: MessageFns<OptionsMmState> = {
  encode(message: OptionsMmState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.lifecycle !== 0) {
      writer.uint32(8).int32(message.lifecycle)
    }
    if (message.derivedLabel !== '') {
      writer.uint32(18).string(message.derivedLabel)
    }
    if (message.restrictions !== undefined) {
      OptionsMmRestrictions.encode(message.restrictions, writer.uint32(26).fork()).join()
    }
    if (message.sinceMs !== '0') {
      writer.uint32(32).int64(message.sinceMs)
    }
    if (message.sessionGeneration !== '0') {
      writer.uint32(40).uint64(message.sessionGeneration)
    }
    for (const v of message.expiries) {
      OptionsMmExpiryQuoteState.encode(v!, writer.uint32(50).fork()).join()
    }
    for (const v of message.greeks) {
      OptionsMmGreeks.encode(v!, writer.uint32(58).fork()).join()
    }
    for (const v of message.utilisation) {
      OptionsMmUtilisation.encode(v!, writer.uint32(66).fork()).join()
    }
    if (message.margin !== undefined) {
      OptionsMmMargin.encode(message.margin, writer.uint32(74).fork()).join()
    }
    if (message.stressWorstLossUsd !== '') {
      writer.uint32(82).string(message.stressWorstLossUsd)
    }
    if (message.flow !== undefined) {
      OptionsMmFlowSummary.encode(message.flow, writer.uint32(90).fork()).join()
    }
    if (message.surface !== undefined) {
      OptionsMmSurfaceHealth.encode(message.surface, writer.uint32(98).fork()).join()
    }
    if (message.hedgeChildId !== undefined) {
      writer.uint32(106).string(message.hedgeChildId)
    }
    if (message.haltedResidualGreeks !== undefined) {
      OptionsMmGreeks.encode(message.haltedResidualGreeks, writer.uint32(114).fork()).join()
    }
    if (message.configVersion !== '0') {
      writer.uint32(120).uint64(message.configVersion)
    }
    if (message.params !== undefined) {
      OptionsMmAlgoParams.encode(message.params, writer.uint32(130).fork()).join()
    }
    for (const v of message.configHistory) {
      OptionsMmConfigHistoryEntry.encode(v!, writer.uint32(138).fork()).join()
    }
    if (message.mode !== 0) {
      writer.uint32(144).int32(message.mode)
    }
    if (message.blockedReason !== undefined) {
      writer.uint32(154).string(message.blockedReason)
    }
    if (message.outboundQueueDepth !== 0) {
      writer.uint32(160).uint32(message.outboundQueueDepth)
    }
    for (const v of message.causes) {
      writer.uint32(170).string(v!)
    }
    if (message.foreignOrders !== 0) {
      writer.uint32(176).uint32(message.foreignOrders)
    }
    for (const v of message.transitions) {
      OptionsMmTransition.encode(v!, writer.uint32(186).fork()).join()
    }
    if (message.profile !== 0) {
      writer.uint32(192).int32(message.profile)
    }
    if (message.budgetShare !== '') {
      writer.uint32(202).string(message.budgetShare)
    }
    if (message.openOrdersReserved !== 0) {
      writer.uint32(208).uint32(message.openOrdersReserved)
    }
    if (message.capabilities !== undefined) {
      OptionsMmCapabilities.encode(message.capabilities, writer.uint32(218).fork()).join()
    }
    for (const v of message.shadow) {
      OptionsMmShadowSummary.encode(v!, writer.uint32(226).fork()).join()
    }
    if (message.capitalUsedUsd !== '') {
      writer.uint32(234).string(message.capitalUsedUsd)
    }
    if (message.returnOnAllocated !== '') {
      writer.uint32(242).string(message.returnOnAllocated)
    }
    if (message.pnl !== undefined) {
      OptionsMmPnl.encode(message.pnl, writer.uint32(250).fork()).join()
    }
    if (message.hedgeInstrument !== undefined) {
      writer.uint32(258).string(message.hedgeInstrument)
    }
    if (message.budgetUsedLastS !== 0) {
      writer.uint32(264).uint32(message.budgetUsedLastS)
    }
    if (message.shadowResume.length !== 0) {
      writer.uint32(274).bytes(message.shadowResume)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionsMmState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionsMmState()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.lifecycle = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.derivedLabel = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.restrictions = OptionsMmRestrictions.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.sinceMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.sessionGeneration = reader.uint64().toString()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.expiries.push(OptionsMmExpiryQuoteState.decode(reader, reader.uint32()))
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.greeks.push(OptionsMmGreeks.decode(reader, reader.uint32()))
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.utilisation.push(OptionsMmUtilisation.decode(reader, reader.uint32()))
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.margin = OptionsMmMargin.decode(reader, reader.uint32())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.stressWorstLossUsd = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.flow = OptionsMmFlowSummary.decode(reader, reader.uint32())
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.surface = OptionsMmSurfaceHealth.decode(reader, reader.uint32())
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.hedgeChildId = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.haltedResidualGreeks = OptionsMmGreeks.decode(reader, reader.uint32())
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.configVersion = reader.uint64().toString()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.params = OptionsMmAlgoParams.decode(reader, reader.uint32())
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.configHistory.push(OptionsMmConfigHistoryEntry.decode(reader, reader.uint32()))
          continue
        }
        case 18: {
          if (tag !== 144) {
            break
          }

          message.mode = reader.int32() as any
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.blockedReason = reader.string()
          continue
        }
        case 20: {
          if (tag !== 160) {
            break
          }

          message.outboundQueueDepth = reader.uint32()
          continue
        }
        case 21: {
          if (tag !== 170) {
            break
          }

          message.causes.push(reader.string())
          continue
        }
        case 22: {
          if (tag !== 176) {
            break
          }

          message.foreignOrders = reader.uint32()
          continue
        }
        case 23: {
          if (tag !== 186) {
            break
          }

          message.transitions.push(OptionsMmTransition.decode(reader, reader.uint32()))
          continue
        }
        case 24: {
          if (tag !== 192) {
            break
          }

          message.profile = reader.int32() as any
          continue
        }
        case 25: {
          if (tag !== 202) {
            break
          }

          message.budgetShare = reader.string()
          continue
        }
        case 26: {
          if (tag !== 208) {
            break
          }

          message.openOrdersReserved = reader.uint32()
          continue
        }
        case 27: {
          if (tag !== 218) {
            break
          }

          message.capabilities = OptionsMmCapabilities.decode(reader, reader.uint32())
          continue
        }
        case 28: {
          if (tag !== 226) {
            break
          }

          message.shadow.push(OptionsMmShadowSummary.decode(reader, reader.uint32()))
          continue
        }
        case 29: {
          if (tag !== 234) {
            break
          }

          message.capitalUsedUsd = reader.string()
          continue
        }
        case 30: {
          if (tag !== 242) {
            break
          }

          message.returnOnAllocated = reader.string()
          continue
        }
        case 31: {
          if (tag !== 250) {
            break
          }

          message.pnl = OptionsMmPnl.decode(reader, reader.uint32())
          continue
        }
        case 32: {
          if (tag !== 258) {
            break
          }

          message.hedgeInstrument = reader.string()
          continue
        }
        case 33: {
          if (tag !== 264) {
            break
          }

          message.budgetUsedLastS = reader.uint32()
          continue
        }
        case 34: {
          if (tag !== 274) {
            break
          }

          message.shadowResume = reader.bytes()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionsMmState {
    return {
      lifecycle: isSet(object.lifecycle) ? optionsMmLifecycleFromJSON(object.lifecycle) : 0,
      derivedLabel: isSet(object.derivedLabel)
        ? globalThis.String(object.derivedLabel)
        : isSet(object.derived_label)
          ? globalThis.String(object.derived_label)
          : '',
      restrictions: isSet(object.restrictions)
        ? OptionsMmRestrictions.fromJSON(object.restrictions)
        : undefined,
      sinceMs: isSet(object.sinceMs)
        ? globalThis.String(object.sinceMs)
        : isSet(object.since_ms)
          ? globalThis.String(object.since_ms)
          : '0',
      sessionGeneration: isSet(object.sessionGeneration)
        ? globalThis.String(object.sessionGeneration)
        : isSet(object.session_generation)
          ? globalThis.String(object.session_generation)
          : '0',
      expiries: globalThis.Array.isArray(object?.expiries)
        ? object.expiries.map((e: any) => OptionsMmExpiryQuoteState.fromJSON(e))
        : [],
      greeks: globalThis.Array.isArray(object?.greeks)
        ? object.greeks.map((e: any) => OptionsMmGreeks.fromJSON(e))
        : [],
      utilisation: globalThis.Array.isArray(object?.utilisation)
        ? object.utilisation.map((e: any) => OptionsMmUtilisation.fromJSON(e))
        : [],
      margin: isSet(object.margin) ? OptionsMmMargin.fromJSON(object.margin) : undefined,
      stressWorstLossUsd: isSet(object.stressWorstLossUsd)
        ? globalThis.String(object.stressWorstLossUsd)
        : isSet(object.stress_worst_loss_usd)
          ? globalThis.String(object.stress_worst_loss_usd)
          : '',
      flow: isSet(object.flow) ? OptionsMmFlowSummary.fromJSON(object.flow) : undefined,
      surface: isSet(object.surface) ? OptionsMmSurfaceHealth.fromJSON(object.surface) : undefined,
      hedgeChildId: isSet(object.hedgeChildId)
        ? globalThis.String(object.hedgeChildId)
        : isSet(object.hedge_child_id)
          ? globalThis.String(object.hedge_child_id)
          : undefined,
      haltedResidualGreeks: isSet(object.haltedResidualGreeks)
        ? OptionsMmGreeks.fromJSON(object.haltedResidualGreeks)
        : isSet(object.halted_residual_greeks)
          ? OptionsMmGreeks.fromJSON(object.halted_residual_greeks)
          : undefined,
      configVersion: isSet(object.configVersion)
        ? globalThis.String(object.configVersion)
        : isSet(object.config_version)
          ? globalThis.String(object.config_version)
          : '0',
      params: isSet(object.params) ? OptionsMmAlgoParams.fromJSON(object.params) : undefined,
      configHistory: globalThis.Array.isArray(object?.configHistory)
        ? object.configHistory.map((e: any) => OptionsMmConfigHistoryEntry.fromJSON(e))
        : globalThis.Array.isArray(object?.config_history)
          ? object.config_history.map((e: any) => OptionsMmConfigHistoryEntry.fromJSON(e))
          : [],
      mode: isSet(object.mode) ? optionsMmModeFromJSON(object.mode) : 0,
      blockedReason: isSet(object.blockedReason)
        ? globalThis.String(object.blockedReason)
        : isSet(object.blocked_reason)
          ? globalThis.String(object.blocked_reason)
          : undefined,
      outboundQueueDepth: isSet(object.outboundQueueDepth)
        ? globalThis.Number(object.outboundQueueDepth)
        : isSet(object.outbound_queue_depth)
          ? globalThis.Number(object.outbound_queue_depth)
          : 0,
      causes: globalThis.Array.isArray(object?.causes)
        ? object.causes.map((e: any) => globalThis.String(e))
        : [],
      foreignOrders: isSet(object.foreignOrders)
        ? globalThis.Number(object.foreignOrders)
        : isSet(object.foreign_orders)
          ? globalThis.Number(object.foreign_orders)
          : 0,
      transitions: globalThis.Array.isArray(object?.transitions)
        ? object.transitions.map((e: any) => OptionsMmTransition.fromJSON(e))
        : [],
      profile: isSet(object.profile) ? optionsMmProfileFromJSON(object.profile) : 0,
      budgetShare: isSet(object.budgetShare)
        ? globalThis.String(object.budgetShare)
        : isSet(object.budget_share)
          ? globalThis.String(object.budget_share)
          : '',
      openOrdersReserved: isSet(object.openOrdersReserved)
        ? globalThis.Number(object.openOrdersReserved)
        : isSet(object.open_orders_reserved)
          ? globalThis.Number(object.open_orders_reserved)
          : 0,
      capabilities: isSet(object.capabilities)
        ? OptionsMmCapabilities.fromJSON(object.capabilities)
        : undefined,
      shadow: globalThis.Array.isArray(object?.shadow)
        ? object.shadow.map((e: any) => OptionsMmShadowSummary.fromJSON(e))
        : [],
      capitalUsedUsd: isSet(object.capitalUsedUsd)
        ? globalThis.String(object.capitalUsedUsd)
        : isSet(object.capital_used_usd)
          ? globalThis.String(object.capital_used_usd)
          : '',
      returnOnAllocated: isSet(object.returnOnAllocated)
        ? globalThis.String(object.returnOnAllocated)
        : isSet(object.return_on_allocated)
          ? globalThis.String(object.return_on_allocated)
          : '',
      pnl: isSet(object.pnl) ? OptionsMmPnl.fromJSON(object.pnl) : undefined,
      hedgeInstrument: isSet(object.hedgeInstrument)
        ? globalThis.String(object.hedgeInstrument)
        : isSet(object.hedge_instrument)
          ? globalThis.String(object.hedge_instrument)
          : undefined,
      budgetUsedLastS: isSet(object.budgetUsedLastS)
        ? globalThis.Number(object.budgetUsedLastS)
        : isSet(object.budget_used_last_s)
          ? globalThis.Number(object.budget_used_last_s)
          : 0,
      shadowResume: isSet(object.shadowResume)
        ? bytesFromBase64(object.shadowResume)
        : isSet(object.shadow_resume)
          ? bytesFromBase64(object.shadow_resume)
          : new Uint8Array(0),
    }
  },

  toJSON(message: OptionsMmState): unknown {
    const obj: any = {}
    if (message.lifecycle !== 0) {
      obj.lifecycle = optionsMmLifecycleToJSON(message.lifecycle)
    }
    if (message.derivedLabel !== '') {
      obj.derivedLabel = message.derivedLabel
    }
    if (message.restrictions !== undefined) {
      obj.restrictions = OptionsMmRestrictions.toJSON(message.restrictions)
    }
    if (message.sinceMs !== '0') {
      obj.sinceMs = message.sinceMs
    }
    if (message.sessionGeneration !== '0') {
      obj.sessionGeneration = message.sessionGeneration
    }
    if (message.expiries?.length) {
      obj.expiries = message.expiries.map((e) => OptionsMmExpiryQuoteState.toJSON(e))
    }
    if (message.greeks?.length) {
      obj.greeks = message.greeks.map((e) => OptionsMmGreeks.toJSON(e))
    }
    if (message.utilisation?.length) {
      obj.utilisation = message.utilisation.map((e) => OptionsMmUtilisation.toJSON(e))
    }
    if (message.margin !== undefined) {
      obj.margin = OptionsMmMargin.toJSON(message.margin)
    }
    if (message.stressWorstLossUsd !== '') {
      obj.stressWorstLossUsd = message.stressWorstLossUsd
    }
    if (message.flow !== undefined) {
      obj.flow = OptionsMmFlowSummary.toJSON(message.flow)
    }
    if (message.surface !== undefined) {
      obj.surface = OptionsMmSurfaceHealth.toJSON(message.surface)
    }
    if (message.hedgeChildId !== undefined) {
      obj.hedgeChildId = message.hedgeChildId
    }
    if (message.haltedResidualGreeks !== undefined) {
      obj.haltedResidualGreeks = OptionsMmGreeks.toJSON(message.haltedResidualGreeks)
    }
    if (message.configVersion !== '0') {
      obj.configVersion = message.configVersion
    }
    if (message.params !== undefined) {
      obj.params = OptionsMmAlgoParams.toJSON(message.params)
    }
    if (message.configHistory?.length) {
      obj.configHistory = message.configHistory.map((e) => OptionsMmConfigHistoryEntry.toJSON(e))
    }
    if (message.mode !== 0) {
      obj.mode = optionsMmModeToJSON(message.mode)
    }
    if (message.blockedReason !== undefined) {
      obj.blockedReason = message.blockedReason
    }
    if (message.outboundQueueDepth !== 0) {
      obj.outboundQueueDepth = Math.round(message.outboundQueueDepth)
    }
    if (message.causes?.length) {
      obj.causes = message.causes
    }
    if (message.foreignOrders !== 0) {
      obj.foreignOrders = Math.round(message.foreignOrders)
    }
    if (message.transitions?.length) {
      obj.transitions = message.transitions.map((e) => OptionsMmTransition.toJSON(e))
    }
    if (message.profile !== 0) {
      obj.profile = optionsMmProfileToJSON(message.profile)
    }
    if (message.budgetShare !== '') {
      obj.budgetShare = message.budgetShare
    }
    if (message.openOrdersReserved !== 0) {
      obj.openOrdersReserved = Math.round(message.openOrdersReserved)
    }
    if (message.capabilities !== undefined) {
      obj.capabilities = OptionsMmCapabilities.toJSON(message.capabilities)
    }
    if (message.shadow?.length) {
      obj.shadow = message.shadow.map((e) => OptionsMmShadowSummary.toJSON(e))
    }
    if (message.capitalUsedUsd !== '') {
      obj.capitalUsedUsd = message.capitalUsedUsd
    }
    if (message.returnOnAllocated !== '') {
      obj.returnOnAllocated = message.returnOnAllocated
    }
    if (message.pnl !== undefined) {
      obj.pnl = OptionsMmPnl.toJSON(message.pnl)
    }
    if (message.hedgeInstrument !== undefined) {
      obj.hedgeInstrument = message.hedgeInstrument
    }
    if (message.budgetUsedLastS !== 0) {
      obj.budgetUsedLastS = Math.round(message.budgetUsedLastS)
    }
    if (message.shadowResume.length !== 0) {
      obj.shadowResume = base64FromBytes(message.shadowResume)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionsMmState>, I>>(base?: I): OptionsMmState {
    return OptionsMmState.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionsMmState>, I>>(object: I): OptionsMmState {
    const message = createBaseOptionsMmState()
    message.lifecycle = object.lifecycle ?? 0
    message.derivedLabel = object.derivedLabel ?? ''
    message.restrictions =
      object.restrictions !== undefined && object.restrictions !== null
        ? OptionsMmRestrictions.fromPartial(object.restrictions)
        : undefined
    message.sinceMs = object.sinceMs ?? '0'
    message.sessionGeneration = object.sessionGeneration ?? '0'
    message.expiries = object.expiries?.map((e) => OptionsMmExpiryQuoteState.fromPartial(e)) || []
    message.greeks = object.greeks?.map((e) => OptionsMmGreeks.fromPartial(e)) || []
    message.utilisation = object.utilisation?.map((e) => OptionsMmUtilisation.fromPartial(e)) || []
    message.margin =
      object.margin !== undefined && object.margin !== null
        ? OptionsMmMargin.fromPartial(object.margin)
        : undefined
    message.stressWorstLossUsd = object.stressWorstLossUsd ?? ''
    message.flow =
      object.flow !== undefined && object.flow !== null
        ? OptionsMmFlowSummary.fromPartial(object.flow)
        : undefined
    message.surface =
      object.surface !== undefined && object.surface !== null
        ? OptionsMmSurfaceHealth.fromPartial(object.surface)
        : undefined
    message.hedgeChildId = object.hedgeChildId ?? undefined
    message.haltedResidualGreeks =
      object.haltedResidualGreeks !== undefined && object.haltedResidualGreeks !== null
        ? OptionsMmGreeks.fromPartial(object.haltedResidualGreeks)
        : undefined
    message.configVersion = object.configVersion ?? '0'
    message.params =
      object.params !== undefined && object.params !== null
        ? OptionsMmAlgoParams.fromPartial(object.params)
        : undefined
    message.configHistory =
      object.configHistory?.map((e) => OptionsMmConfigHistoryEntry.fromPartial(e)) || []
    message.mode = object.mode ?? 0
    message.blockedReason = object.blockedReason ?? undefined
    message.outboundQueueDepth = object.outboundQueueDepth ?? 0
    message.causes = object.causes?.map((e) => e) || []
    message.foreignOrders = object.foreignOrders ?? 0
    message.transitions = object.transitions?.map((e) => OptionsMmTransition.fromPartial(e)) || []
    message.profile = object.profile ?? 0
    message.budgetShare = object.budgetShare ?? ''
    message.openOrdersReserved = object.openOrdersReserved ?? 0
    message.capabilities =
      object.capabilities !== undefined && object.capabilities !== null
        ? OptionsMmCapabilities.fromPartial(object.capabilities)
        : undefined
    message.shadow = object.shadow?.map((e) => OptionsMmShadowSummary.fromPartial(e)) || []
    message.capitalUsedUsd = object.capitalUsedUsd ?? ''
    message.returnOnAllocated = object.returnOnAllocated ?? ''
    message.pnl =
      object.pnl !== undefined && object.pnl !== null
        ? OptionsMmPnl.fromPartial(object.pnl)
        : undefined
    message.hedgeInstrument = object.hedgeInstrument ?? undefined
    message.budgetUsedLastS = object.budgetUsedLastS ?? 0
    message.shadowResume = object.shadowResume ?? new Uint8Array(0)
    return message
  },
}

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, 'base64'))
  } else {
    const bin = globalThis.atob(b64)
    const arr = new Uint8Array(bin.length)
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i)
    }
    return arr
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString('base64')
  } else {
    const bin: string[] = []
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte))
    })
    return globalThis.btoa(bin.join(''))
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never }

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter
  decode(input: BinaryReader | Uint8Array, length?: number): T
  fromJSON(object: any): T
  toJSON(message: T): unknown
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T
}
